import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
};

export type Account = {
  __typename?: 'Account';
  abbreviation: Scalars['String'];
  account_contacts: Array<AccountContact>;
  account_products: Array<AccountProduct>;
  account_resources: Array<AccountResource>;
  address: Scalars['String'];
  client_automatic_tax_calculation: Scalars['Boolean'];
  client_credit_days: Scalars['Int'];
  client_reconciliation_only: Scalars['Boolean'];
  client_require_credit_note: Scalars['Boolean'];
  client_require_supplement: Scalars['Boolean'];
  client_requires_invoice_code: Scalars['Boolean'];
  client_requires_tax: Scalars['Boolean'];
  compound_name: Scalars['String'];
  created_by?: Maybe<User>;
  created_by_id?: Maybe<Scalars['Int']>;
  exclude_from_balances_summary: Scalars['Boolean'];
  id: Scalars['Float'];
  is_client: Scalars['Boolean'];
  is_deletable: Scalars['Boolean'];
  is_informal_account: Scalars['Boolean'];
  is_own: Scalars['Boolean'];
  is_supplier: Scalars['Boolean'];
  monitor_supplier_expenses: Scalars['Boolean'];
  name: Scalars['String'];
  requires_order_request: Scalars['Boolean'];
  resource?: Maybe<Resource>;
  resource_id?: Maybe<Scalars['Int']>;
  rfc: Scalars['String'];
  similar_name_matches: Array<SimilarAccountName>;
  supplier_credit_days: Scalars['Int'];
  supplier_is_draft: Scalars['Boolean'];
  supplier_reconciliation_only: Scalars['Boolean'];
  supplier_recurring_expenses: Scalars['Boolean'];
  supplier_require_supplement: Scalars['Boolean'];
  supplier_requires_external_code: Scalars['Boolean'];
  supplier_requires_tax: Scalars['Boolean'];
  updated_by?: Maybe<User>;
  updated_by_id?: Maybe<Scalars['Int']>;
};

export type AccountContact = {
  __typename?: 'AccountContact';
  cellphone: Scalars['String'];
  email: Scalars['String'];
  first_name: Scalars['String'];
  fullname: Scalars['String'];
  id: Scalars['Float'];
  last_name: Scalars['String'];
};

export type AccountContactInput = {
  cellphone: Scalars['String'];
  email: Scalars['String'];
  first_name: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  last_name: Scalars['String'];
};

export type AccountProduct = {
  __typename?: 'AccountProduct';
  account_id?: Maybe<Scalars['Int']>;
  group_price: Scalars['Float'];
  group_weight: Scalars['Float'];
  id: Scalars['Int'];
  kilo_price: Scalars['Float'];
  product?: Maybe<Product>;
  product_id?: Maybe<Scalars['Int']>;
};

export type AccountProductInput = {
  group_price: Scalars['Float'];
  group_weight: Scalars['Float'];
  id?: InputMaybe<Scalars['Int']>;
  kilo_price: Scalars['Float'];
  product_id?: InputMaybe<Scalars['Int']>;
};

export type AccountResource = {
  __typename?: 'AccountResource';
  account_id?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  notes: Scalars['String'];
  resource?: Maybe<Resource>;
  resource_id?: Maybe<Scalars['Int']>;
  unit_price: Scalars['Float'];
};

export type AccountResourceInput = {
  id?: InputMaybe<Scalars['Int']>;
  notes: Scalars['String'];
  resource_id?: InputMaybe<Scalars['Int']>;
  unit_price: Scalars['Float'];
};

export type AccountTransactionItem = {
  __typename?: 'AccountTransactionItem';
  date: Scalars['DateTime'];
  id: Scalars['Int'];
  invoice_code?: Maybe<Scalars['Int']>;
  notes: Scalars['String'];
  order_code: Scalars['String'];
  receipt_type_id?: Maybe<Scalars['Int']>;
  total_with_tax: Scalars['Float'];
  transfer_receipts_total: Scalars['Float'];
  type: Scalars['String'];
};

export type AccountTransferItem = {
  __typename?: 'AccountTransferItem';
  amount: Scalars['Float'];
  notes: Scalars['String'];
  parent_date?: Maybe<Scalars['DateTime']>;
  parent_invoice_code?: Maybe<Scalars['Int']>;
  parent_order_code: Scalars['String'];
  parent_receipt_type_id?: Maybe<Scalars['Int']>;
  parent_type: Scalars['String'];
  transferred_date?: Maybe<Scalars['DateTime']>;
};

export type AccountUpsertInput = {
  abbreviation: Scalars['String'];
  account_contacts: Array<AccountContactInput>;
  account_products: Array<AccountProductInput>;
  account_resources: Array<AccountResourceInput>;
  address: Scalars['String'];
  client_automatic_tax_calculation: Scalars['Boolean'];
  client_credit_days: Scalars['Int'];
  client_reconciliation_only: Scalars['Boolean'];
  client_require_credit_note: Scalars['Boolean'];
  client_require_supplement: Scalars['Boolean'];
  client_requires_invoice_code: Scalars['Boolean'];
  client_requires_tax: Scalars['Boolean'];
  id?: InputMaybe<Scalars['Int']>;
  is_client: Scalars['Boolean'];
  is_supplier: Scalars['Boolean'];
  monitor_supplier_expenses: Scalars['Boolean'];
  name: Scalars['String'];
  requires_order_request: Scalars['Boolean'];
  resource_id?: InputMaybe<Scalars['Int']>;
  rfc: Scalars['String'];
  supplier_credit_days: Scalars['Int'];
  supplier_is_draft: Scalars['Boolean'];
  supplier_reconciliation_only: Scalars['Boolean'];
  supplier_recurring_expenses: Scalars['Boolean'];
  supplier_require_supplement: Scalars['Boolean'];
  supplier_requires_external_code: Scalars['Boolean'];
  supplier_requires_tax: Scalars['Boolean'];
};

export enum AccountsSortableFields {
  Abbreviation = 'abbreviation',
  Name = 'name'
}

export type Activity = {
  __typename?: 'Activity';
  created_at?: Maybe<Scalars['DateTime']>;
  entity_id: Scalars['Int'];
  entity_name: ActivityEntityName;
  id: Scalars['Int'];
  new_data?: Maybe<Scalars['String']>;
  old_data?: Maybe<Scalars['String']>;
  snapshot_status: ActivitySnapshotStatus;
  title: Scalars['String'];
  type: ActivityTypeName;
  user?: Maybe<User>;
};

export enum ActivityEntityName {
  Account = 'ACCOUNT',
  AccountProduct = 'ACCOUNT_PRODUCT',
  Employee = 'EMPLOYEE',
  Expense = 'EXPENSE',
  ExpenseResource = 'EXPENSE_RESOURCE',
  Machine = 'MACHINE',
  OrderAdjustment = 'ORDER_ADJUSTMENT',
  OrderProduction = 'ORDER_PRODUCTION',
  OrderQuotation = 'ORDER_QUOTATION',
  OrderRequest = 'ORDER_REQUEST',
  OrderSale = 'ORDER_SALE',
  Product = 'PRODUCT',
  ProductionPlan = 'PRODUCTION_PLAN',
  Resource = 'RESOURCE',
  Transfer = 'TRANSFER',
  User = 'USER'
}

export enum ActivitySnapshotStatus {
  CaptureFailed = 'CAPTURE_FAILED',
  Complete = 'COMPLETE',
  Legacy = 'LEGACY',
  NotSupported = 'NOT_SUPPORTED'
}

export enum ActivityTypeName {
  Create = 'CREATE',
  Delete = 'DELETE',
  Update = 'UPDATE'
}

export type Branch = {
  __typename?: 'Branch';
  id: Scalars['Float'];
  name: Scalars['String'];
};

export type BranchInput = {
  name: Scalars['String'];
};

export enum ColumnOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type CreateUserInput = {
  email: Scalars['String'];
  first_name: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  last_name: Scalars['String'];
  login_disabled?: InputMaybe<Scalars['Boolean']>;
  mfa_enabled?: InputMaybe<Scalars['Boolean']>;
  password: Scalars['String'];
  roles: Array<RoleInput>;
};

export enum DateGroupBy {
  Day = 'day',
  Month = 'month',
  Year = 'year'
}

export type Employee = {
  __typename?: 'Employee';
  base_salary: Scalars['Float'];
  branch?: Maybe<Branch>;
  branch_id?: Maybe<Scalars['Int']>;
  created_by?: Maybe<User>;
  created_by_id?: Maybe<Scalars['Int']>;
  employee_category_id?: Maybe<Scalars['Int']>;
  first_name: Scalars['String'];
  fullname: Scalars['String'];
  hours_should_work: Scalars['Float'];
  id: Scalars['Float'];
  is_deletable: Scalars['Boolean'];
  is_inactive: Scalars['Boolean'];
  is_leader: Scalars['Float'];
  last_name: Scalars['String'];
  order_production_type?: Maybe<OrderProductionType>;
  order_production_type_id?: Maybe<Scalars['Int']>;
  updated_by?: Maybe<User>;
  updated_by_id?: Maybe<Scalars['Int']>;
};

export type EmployeeType = {
  __typename?: 'EmployeeType';
  id: Scalars['Float'];
  name: Scalars['String'];
};

export type EmployeeUpsertInput = {
  base_salary?: InputMaybe<Scalars['Float']>;
  branch_id?: InputMaybe<Scalars['Int']>;
  first_name: Scalars['String'];
  hours_should_work?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['Int']>;
  is_inactive: Scalars['Boolean'];
  is_leader: Scalars['Float'];
  last_name: Scalars['String'];
  order_production_type_id?: InputMaybe<Scalars['Int']>;
};

export type EmployeesRecord = {
  __typename?: 'EmployeesRecord';
  day?: Maybe<Scalars['Int']>;
  employee_id?: Maybe<Scalars['Int']>;
  employee_name?: Maybe<Scalars['String']>;
  groups: Scalars['Float'];
  hours?: Maybe<Scalars['Float']>;
  kilos: Scalars['Float'];
  machine_id?: Maybe<Scalars['Int']>;
  machine_name?: Maybe<Scalars['String']>;
  month?: Maybe<Scalars['Int']>;
  product_id?: Maybe<Scalars['Int']>;
  product_name?: Maybe<Scalars['String']>;
  year: Scalars['Int'];
};

export type EmployeesSummary = {
  __typename?: 'EmployeesSummary';
  Employees: Array<EmployeesRecord>;
};

export type EmployeesSummaryArgs = {
  date_group_by: DateGroupBy;
  month?: InputMaybe<Scalars['Int']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type Expense = {
  __typename?: 'Expense';
  account?: Maybe<Account>;
  account_id?: Maybe<Scalars['Int']>;
  canceled: Scalars['Boolean'];
  compound_external_code: Scalars['String'];
  created_by?: Maybe<User>;
  created_by_id?: Maybe<Scalars['Int']>;
  date: Scalars['DateTime'];
  expected_payment_date?: Maybe<Scalars['DateTime']>;
  expense_resources: Array<ExpenseResource>;
  external_code: Scalars['String'];
  generated_from_expense_id?: Maybe<Scalars['Int']>;
  id: Scalars['Float'];
  internal_code: Scalars['Int'];
  is_deletable: Scalars['Boolean'];
  is_draft: Scalars['Boolean'];
  is_editable: Scalars['Boolean'];
  locked: Scalars['Boolean'];
  non_tax_retained: Scalars['Float'];
  notes: Scalars['String'];
  receipt_type?: Maybe<ReceiptType>;
  receipt_type_id?: Maybe<Scalars['Int']>;
  reconciliation_only: Scalars['Boolean'];
  require_external_code: Scalars['Boolean'];
  require_supplement: Scalars['Boolean'];
  require_tax: Scalars['Boolean'];
  resources_total?: Maybe<Scalars['Float']>;
  subtotal: Scalars['Float'];
  supplement_code: Scalars['String'];
  tax: Scalars['Float'];
  tax_retained: Scalars['Float'];
  total_with_tax: Scalars['Float'];
  transfer_receipts: Array<TransferReceipt>;
  transfer_receipts_total: Scalars['Float'];
  transfer_receipts_total_no_adjustments: Scalars['Float'];
  updated_by?: Maybe<User>;
  updated_by_id?: Maybe<Scalars['Int']>;
};

export type ExpenseDetailsInput = {
  canceled: Scalars['Boolean'];
  expected_payment_date?: InputMaybe<Scalars['DateTime']>;
  expense_id: Scalars['Int'];
  external_code: Scalars['String'];
  is_draft: Scalars['Boolean'];
  notes: Scalars['String'];
  reconciliation_only: Scalars['Boolean'];
  require_external_code: Scalars['Boolean'];
  require_supplement: Scalars['Boolean'];
  supplement_code: Scalars['String'];
};

export type ExpenseExpenseResourceInput = {
  date?: InputMaybe<Scalars['DateTime']>;
  expense_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  notes: Scalars['String'];
  resource_id?: InputMaybe<Scalars['Int']>;
  unit_price?: InputMaybe<Scalars['Float']>;
  units: Scalars['Float'];
};

export type ExpenseResource = {
  __typename?: 'ExpenseResource';
  account?: Maybe<Account>;
  date?: Maybe<Scalars['DateTime']>;
  expense?: Maybe<Expense>;
  expense_id?: Maybe<Scalars['Int']>;
  id: Scalars['Float'];
  notes: Scalars['String'];
  resource?: Maybe<Resource>;
  resource_id?: Maybe<Scalars['Int']>;
  unit_price?: Maybe<Scalars['Float']>;
  units: Scalars['Float'];
};

export enum ExpenseResourcesPaginatedSortableFields {
  Name = 'name'
}

export type ExpenseUpsertInput = {
  account_id?: InputMaybe<Scalars['Int']>;
  canceled: Scalars['Boolean'];
  date: Scalars['DateTime'];
  expected_payment_date?: InputMaybe<Scalars['DateTime']>;
  expense_resources: Array<ExpenseExpenseResourceInput>;
  external_code: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  internal_code: Scalars['Int'];
  is_draft: Scalars['Boolean'];
  locked: Scalars['Boolean'];
  non_tax_retained: Scalars['Float'];
  notes: Scalars['String'];
  receipt_type_id?: InputMaybe<Scalars['Int']>;
  reconciliation_only: Scalars['Boolean'];
  require_external_code: Scalars['Boolean'];
  require_supplement: Scalars['Boolean'];
  require_tax: Scalars['Boolean'];
  resources_total?: InputMaybe<Scalars['Float']>;
  subtotal: Scalars['Float'];
  supplement_code: Scalars['String'];
  tax: Scalars['Float'];
  tax_retained: Scalars['Float'];
};

export type ExpensesRecord = {
  __typename?: 'ExpensesRecord';
  account_abbreviation?: Maybe<Scalars['String']>;
  account_id?: Maybe<Scalars['Int']>;
  account_name?: Maybe<Scalars['String']>;
  day?: Maybe<Scalars['Int']>;
  expense_external_code?: Maybe<Scalars['String']>;
  expense_id?: Maybe<Scalars['Int']>;
  month?: Maybe<Scalars['Int']>;
  non_tax_retained: Scalars['Float'];
  receipt_type_id?: Maybe<Scalars['Int']>;
  receipt_type_name?: Maybe<Scalars['String']>;
  resource_category_id?: Maybe<Scalars['Int']>;
  resource_category_name?: Maybe<Scalars['String']>;
  resource_id?: Maybe<Scalars['Int']>;
  resource_name?: Maybe<Scalars['String']>;
  tax: Scalars['Float'];
  tax_retained: Scalars['Float'];
  total: Scalars['Float'];
  total_with_tax: Scalars['Float'];
  units_sold: Scalars['Float'];
  year: Scalars['Int'];
};

export enum ExpensesSortableFields {
  Date = 'date'
}

export type ExpensesSummary = {
  __typename?: 'ExpensesSummary';
  expenses: Array<ExpensesRecord>;
};

export type ExpensesSummaryArgs = {
  date_group_by: DateGroupBy;
  entity_groups: Array<ExpensesSummaryEntitiesGroup>;
  include_canceled?: InputMaybe<Scalars['Boolean']>;
  include_reconciliation_only?: InputMaybe<Scalars['Boolean']>;
  month?: InputMaybe<Scalars['Int']>;
  year?: InputMaybe<Scalars['Int']>;
};

export enum ExpensesSummaryEntitiesGroup {
  Account = 'account',
  Expense = 'expense',
  Receipt = 'receipt',
  Resource = 'resource',
  ResourceCategory = 'resource_category'
}

export type GenerateRecurringExpenseInput = {
  date: Scalars['DateTime'];
  expected_payment_date?: InputMaybe<Scalars['DateTime']>;
  expense_resources: Array<GenerateRecurringExpenseResourceInput>;
  non_tax_retained: Scalars['Float'];
  source_expense_id: Scalars['Int'];
  tax: Scalars['Float'];
  tax_retained: Scalars['Float'];
};

export type GenerateRecurringExpenseResourceInput = {
  date?: InputMaybe<Scalars['DateTime']>;
  notes: Scalars['String'];
  resource_id?: InputMaybe<Scalars['Int']>;
  unit_price: Scalars['Float'];
  units: Scalars['Float'];
};

export type GenerateRecurringExpensesResult = {
  __typename?: 'GenerateRecurringExpensesResult';
  created_ids: Array<Scalars['Int']>;
  skipped_ids: Array<Scalars['Int']>;
};

export type InventoryMovement = {
  __typename?: 'InventoryMovement';
  affects_inventory: Scalars['Boolean'];
  balance_groups?: Maybe<Scalars['Float']>;
  balance_kilos?: Maybe<Scalars['Float']>;
  compound_order_code?: Maybe<Scalars['String']>;
  date: Scalars['DateTime'];
  groups: Scalars['Float'];
  kilos: Scalars['Float'];
  movement_type: Scalars['String'];
  order_code?: Maybe<Scalars['Int']>;
  order_id?: Maybe<Scalars['Int']>;
  order_sale_status_id?: Maybe<Scalars['Int']>;
  product_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type Machine = {
  __typename?: 'Machine';
  branch?: Maybe<Branch>;
  branch_id?: Maybe<Scalars['Int']>;
  completion: Scalars['Float'];
  consumes_input: Scalars['Boolean'];
  created_by?: Maybe<User>;
  created_by_id?: Maybe<Scalars['Int']>;
  discontinued: Scalars['Boolean'];
  id: Scalars['Float'];
  is_deletable: Scalars['Boolean'];
  machine_parts: Array<MachinePart>;
  machine_sections: Array<MachineSection>;
  month_production: Array<MachineDailyProduction>;
  name: Scalars['String'];
  order_production_type?: Maybe<OrderProductionType>;
  order_production_type_id?: Maybe<Scalars['Int']>;
  unassigned_parts: Array<MachinePart>;
  updated_by?: Maybe<User>;
  updated_by_id?: Maybe<Scalars['Int']>;
};


export type MachineMonth_ProductionArgs = {
  month?: InputMaybe<Scalars['Int']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type MachineCompatibility = {
  __typename?: 'MachineCompatibility';
  id: Scalars['Float'];
  is_current_spare?: Maybe<Scalars['Boolean']>;
  machine_part?: Maybe<MachinePart>;
  machine_part_id?: Maybe<Scalars['Int']>;
  spare?: Maybe<Spare>;
  spare_id?: Maybe<Scalars['Int']>;
};

export type MachineCompatibilityUpsertInput = {
  spare_id?: InputMaybe<Scalars['Int']>;
};

export type MachineConsumptionRate = {
  __typename?: 'MachineConsumptionRate';
  consumed_hours: Scalars['Float'];
  consumed_kilos: Scalars['Float'];
  machine_id: Scalars['Int'];
  packed_hours: Scalars['Float'];
  product_id?: Maybe<Scalars['Int']>;
  product_name?: Maybe<Scalars['String']>;
  runs: Scalars['Int'];
};

export type MachineDailyProduction = {
  __typename?: 'MachineDailyProduction';
  /** Month */
  day: Scalars['Float'];
  group_sum: Scalars['Float'];
  kilo_sum: Scalars['Float'];
  /** Month */
  month: Scalars['Float'];
  /** Dates */
  year: Scalars['Float'];
};

export type MachineHourlyRun = {
  __typename?: 'MachineHourlyRun';
  date?: Maybe<Scalars['DateTime']>;
  groups_produced: Scalars['Float'];
  hours_consumed: Scalars['Float'];
  hours_produced: Scalars['Float'];
  kilos_consumed: Scalars['Float'];
  kilos_produced: Scalars['Float'];
  order_production_id: Scalars['Int'];
  product_count: Scalars['Int'];
};

export type MachinePart = {
  __typename?: 'MachinePart';
  current_spare?: Maybe<Spare>;
  current_spare_id?: Maybe<Scalars['Int']>;
  current_spare_required_quantity?: Maybe<Scalars['Int']>;
  id: Scalars['Float'];
  is_deletable: Scalars['Boolean'];
  machine?: Maybe<Machine>;
  machine_compatibilities: Array<MachineCompatibility>;
  machine_id?: Maybe<Scalars['Int']>;
  machine_section?: Maybe<MachineSection>;
  machine_section_id?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type MachinePartUpsertInput = {
  current_spare_id?: InputMaybe<Scalars['Int']>;
  current_spare_required_quantity?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Float']>;
  machine_compatibilities: Array<MachineCompatibilityUpsertInput>;
  machine_id?: InputMaybe<Scalars['Int']>;
  machine_section_id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type MachineProduct = {
  __typename?: 'MachineProduct';
  description: Scalars['String'];
  id: Scalars['Int'];
};

export type MachineProductEmployeeRun = {
  __typename?: 'MachineProductEmployeeRun';
  branch_id?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['DateTime']>;
  employee_id: Scalars['Int'];
  employee_name: Scalars['String'];
  hours?: Maybe<Scalars['Float']>;
  kilos: Scalars['Float'];
  order_production_id: Scalars['Int'];
  order_production_type_id?: Maybe<Scalars['Int']>;
  product_count: Scalars['Int'];
  product_description: Scalars['String'];
  product_id: Scalars['Int'];
  waste_share: Scalars['Float'];
};

export type MachineProductPerformanceSummary = {
  __typename?: 'MachineProductPerformanceSummary';
  groups: Scalars['Float'];
  hours: Scalars['Float'];
  kilos: Scalars['Float'];
  last_run_date?: Maybe<Scalars['DateTime']>;
  product_description: Scalars['String'];
  product_id: Scalars['Int'];
  runs: Scalars['Int'];
  waste_share_total: Scalars['Float'];
};

export type MachineProductRate = {
  __typename?: 'MachineProductRate';
  all_groups: Scalars['Float'];
  all_groups_rate_mean?: Maybe<Scalars['Float']>;
  all_groups_rate_n: Scalars['Int'];
  all_groups_rate_std?: Maybe<Scalars['Float']>;
  all_hours: Scalars['Float'];
  all_kilos: Scalars['Float'];
  all_kilos_rate_mean?: Maybe<Scalars['Float']>;
  all_kilos_rate_n: Scalars['Int'];
  all_kilos_rate_std?: Maybe<Scalars['Float']>;
  all_runs: Scalars['Int'];
  all_waste: Scalars['Float'];
  machine_id: Scalars['Int'];
  product_id?: Maybe<Scalars['Int']>;
};

export type MachineProductRatePairInput = {
  machineId: Scalars['Int'];
  productId?: InputMaybe<Scalars['Int']>;
};

export type MachineSection = {
  __typename?: 'MachineSection';
  id: Scalars['Float'];
  is_deletable: Scalars['Boolean'];
  machine_id?: Maybe<Scalars['Int']>;
  machine_parts: Array<MachinePart>;
  name: Scalars['String'];
};

export type MachineSectionUpsertInput = {
  id?: InputMaybe<Scalars['Int']>;
  machine_id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type MachineUpsertInput = {
  branch_id?: InputMaybe<Scalars['Int']>;
  consumes_input: Scalars['Boolean'];
  discontinued: Scalars['Boolean'];
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  order_production_type_id?: InputMaybe<Scalars['Int']>;
};

export type MaterialBalanceExceptions = {
  __typename?: 'MaterialBalanceExceptions';
  products_packed: Array<MaterialBalanceProductOrigin>;
  runs_without_consumption: Array<MaterialBalanceRunException>;
  runs_without_production: Array<MaterialBalanceRunException>;
};

export type MaterialBalanceExceptionsArgs = {
  branch_id?: InputMaybe<Scalars['Int']>;
  month?: InputMaybe<Scalars['Int']>;
  year: Scalars['Int'];
};

export enum MaterialBalanceGroupBy {
  Day = 'day',
  Month = 'month',
  Week = 'week'
}

export type MaterialBalanceMachineArgs = {
  branch_id?: InputMaybe<Scalars['Int']>;
  month?: InputMaybe<Scalars['Int']>;
  week?: InputMaybe<Scalars['Int']>;
  year: Scalars['Int'];
};

export type MaterialBalanceMachineRecord = {
  __typename?: 'MaterialBalanceMachineRecord';
  difference_percentage?: Maybe<Scalars['Float']>;
  kilos_consumed: Scalars['Float'];
  kilos_difference: Scalars['Float'];
  kilos_produced: Scalars['Float'];
  machine_id?: Maybe<Scalars['Int']>;
  machine_name?: Maybe<Scalars['String']>;
};

export type MaterialBalanceProductOrigin = {
  __typename?: 'MaterialBalanceProductOrigin';
  kilos_cut: Scalars['Float'];
  kilos_packed: Scalars['Float'];
  kilos_sold: Scalars['Float'];
  product_description?: Maybe<Scalars['String']>;
  product_id: Scalars['Int'];
};

export type MaterialBalanceRecord = {
  __typename?: 'MaterialBalanceRecord';
  branch_id?: Maybe<Scalars['Int']>;
  branch_name?: Maybe<Scalars['String']>;
  day?: Maybe<Scalars['Int']>;
  difference_percentage?: Maybe<Scalars['Float']>;
  kilos_consumed: Scalars['Float'];
  kilos_difference: Scalars['Float'];
  kilos_produced: Scalars['Float'];
  kilos_waste: Scalars['Float'];
  month?: Maybe<Scalars['Int']>;
  runs_count: Scalars['Int'];
  runs_without_consumption: Scalars['Int'];
  runs_without_production: Scalars['Int'];
  week?: Maybe<Scalars['Int']>;
  year: Scalars['Int'];
};

export type MaterialBalanceRunException = {
  __typename?: 'MaterialBalanceRunException';
  branch_name?: Maybe<Scalars['String']>;
  kilos_consumed: Scalars['Float'];
  kilos_produced: Scalars['Float'];
  kilos_waste: Scalars['Float'];
  machine_names?: Maybe<Scalars['String']>;
  order_production_id: Scalars['Int'];
  shift?: Maybe<Scalars['Int']>;
  start_date: Scalars['String'];
};

export type MaterialBalanceSummaryArgs = {
  branch_id?: InputMaybe<Scalars['Int']>;
  group_by: MaterialBalanceGroupBy;
  month?: InputMaybe<Scalars['Int']>;
  year: Scalars['Int'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptOrderQuotation: OrderQuotation;
  createBranch: Branch;
  createUser: User;
  deleteAccount: Scalars['Boolean'];
  deleteEmployee: Scalars['Boolean'];
  deleteExpense: Scalars['Boolean'];
  deleteMachine: Scalars['Boolean'];
  deleteMachinePart: Scalars['Boolean'];
  deleteMachineSection: Scalars['Boolean'];
  deleteOrderAdjustment: Scalars['Boolean'];
  deleteOrderProduction: Scalars['Boolean'];
  deleteOrderQuotation: Scalars['Boolean'];
  deleteOrderRequest: Scalars['Boolean'];
  deleteOrderSale: Scalars['Boolean'];
  deletePayrollEntry: Scalars['Boolean'];
  deletePayrollPeriod: Scalars['Boolean'];
  deleteProduct: Scalars['Boolean'];
  deleteProductionPlan: Scalars['Boolean'];
  deleteResource: Scalars['Boolean'];
  deleteSpare: Scalars['Boolean'];
  deleteSpareCategory: Scalars['Boolean'];
  deleteSpareOperation: Scalars['Boolean'];
  deleteTransfer: Scalars['Boolean'];
  generateRecurringExpenses: GenerateRecurringExpensesResult;
  linkOrderQuotationProduct: OrderQuotation;
  resetUserPassword?: Maybe<User>;
  setDarkMode: UserConfig;
  updateExpenseDetails: Expense;
  updateOrderQuotationStatus: OrderQuotation;
  updateOrderRequestDetails: OrderRequest;
  updateOrderRequestPriorities: Scalars['Boolean'];
  updateOrderRequestStatus: OrderRequest;
  updateOrderSaleDetails: OrderSale;
  updateOrderSaleStatus: OrderSale;
  updateUser: User;
  upsertAccount: Account;
  upsertEmployee: Employee;
  upsertExpense: Expense;
  upsertMachine: Machine;
  upsertMachinePart: MachinePart;
  upsertMachineSection: MachineSection;
  upsertOrderAdjustment: OrderAdjustment;
  upsertOrderProduction: OrderProduction;
  upsertOrderQuotation: OrderQuotation;
  upsertOrderRequest: OrderRequest;
  upsertOrderSale: OrderSale;
  upsertPayrollEntry: PayrollEntry;
  upsertPayrollPeriod: PayrollPeriod;
  upsertProduct: Product;
  upsertProductionPlan: ProductionPlan;
  upsertResource: Resource;
  upsertSpare: Spare;
  upsertSpareAdjustment: SpareOperation;
  upsertSpareCategory: SpareCategory;
  upsertSpareWithdrawal: SpareOperation;
  upsertTransfer: Transfer;
};


export type MutationAcceptOrderQuotationArgs = {
  OrderQuotationId: Scalars['Int'];
};


export type MutationCreateBranchArgs = {
  BranchInput: BranchInput;
};


export type MutationCreateUserArgs = {
  CreateUserInput: CreateUserInput;
};


export type MutationDeleteAccountArgs = {
  AccountId: Scalars['Float'];
};


export type MutationDeleteEmployeeArgs = {
  EmployeeId: Scalars['Float'];
};


export type MutationDeleteExpenseArgs = {
  ExpenseId: Scalars['Float'];
};


export type MutationDeleteMachineArgs = {
  MachineId: Scalars['Float'];
};


export type MutationDeleteMachinePartArgs = {
  MachinePartId: Scalars['Float'];
};


export type MutationDeleteMachineSectionArgs = {
  MachineSectionId: Scalars['Float'];
};


export type MutationDeleteOrderAdjustmentArgs = {
  OrderAdjustmentId: Scalars['Float'];
};


export type MutationDeleteOrderProductionArgs = {
  OrderProductionId: Scalars['Float'];
};


export type MutationDeleteOrderQuotationArgs = {
  OrderQuotationId: Scalars['Float'];
};


export type MutationDeleteOrderRequestArgs = {
  OrderRequestId: Scalars['Float'];
};


export type MutationDeleteOrderSaleArgs = {
  OrderSaleId: Scalars['Float'];
};


export type MutationDeletePayrollEntryArgs = {
  PayrollEntryId: Scalars['Int'];
};


export type MutationDeletePayrollPeriodArgs = {
  PayrollPeriodId: Scalars['Int'];
};


export type MutationDeleteProductArgs = {
  ProductId: Scalars['Float'];
};


export type MutationDeleteProductionPlanArgs = {
  ProductionPlanId: Scalars['Int'];
};


export type MutationDeleteResourceArgs = {
  ResourceId: Scalars['Float'];
};


export type MutationDeleteSpareArgs = {
  SpareId: Scalars['Float'];
};


export type MutationDeleteSpareCategoryArgs = {
  SpareCategoryId: Scalars['Float'];
};


export type MutationDeleteSpareOperationArgs = {
  SpareOperationId: Scalars['Float'];
};


export type MutationDeleteTransferArgs = {
  TransferId: Scalars['Float'];
};


export type MutationGenerateRecurringExpensesArgs = {
  input: Array<GenerateRecurringExpenseInput>;
};


export type MutationLinkOrderQuotationProductArgs = {
  OrderQuotationProductId: Scalars['Int'];
  ProductId: Scalars['Int'];
};


export type MutationResetUserPasswordArgs = {
  UserId: Scalars['Float'];
};


export type MutationSetDarkModeArgs = {
  dark_mode: Scalars['Boolean'];
};


export type MutationUpdateExpenseDetailsArgs = {
  ExpenseDetailsInput: ExpenseDetailsInput;
};


export type MutationUpdateOrderQuotationStatusArgs = {
  OrderQuotationId: Scalars['Int'];
  OrderQuotationStatusId: Scalars['Int'];
};


export type MutationUpdateOrderRequestDetailsArgs = {
  OrderRequestDetailsInput: OrderRequestDetailsInput;
};


export type MutationUpdateOrderRequestPrioritiesArgs = {
  OrderRequestPrioritiesInput: Array<OrderRequestPriorityInput>;
};


export type MutationUpdateOrderRequestStatusArgs = {
  OrderRequestId: Scalars['Int'];
  OrderRequestStatusId: Scalars['Int'];
};


export type MutationUpdateOrderSaleDetailsArgs = {
  OrderSaleDetailsInput: OrderSaleDetailsInput;
};


export type MutationUpdateOrderSaleStatusArgs = {
  OrderSaleId: Scalars['Int'];
  OrderSaleStatusId: Scalars['Int'];
};


export type MutationUpdateUserArgs = {
  UpdateUserInput: UpdateUserInput;
};


export type MutationUpsertAccountArgs = {
  AccountUpsertInput: AccountUpsertInput;
};


export type MutationUpsertEmployeeArgs = {
  EmployeeUpsertInput: EmployeeUpsertInput;
};


export type MutationUpsertExpenseArgs = {
  ExpenseUpsertInput: ExpenseUpsertInput;
};


export type MutationUpsertMachineArgs = {
  MachineUpsertInput: MachineUpsertInput;
};


export type MutationUpsertMachinePartArgs = {
  MachinePartUpsertInput: MachinePartUpsertInput;
};


export type MutationUpsertMachineSectionArgs = {
  MachineSectionUpsertInput: MachineSectionUpsertInput;
};


export type MutationUpsertOrderAdjustmentArgs = {
  OrderAdjustmentInput: OrderAdjustmentInput;
};


export type MutationUpsertOrderProductionArgs = {
  OrderProductionInput: OrderProductionInput;
};


export type MutationUpsertOrderQuotationArgs = {
  OrderQuotationInput: OrderQuotationInput;
};


export type MutationUpsertOrderRequestArgs = {
  OrderRequestInput: OrderRequestInput;
};


export type MutationUpsertOrderSaleArgs = {
  OrderSaleInput: OrderSaleInput;
};


export type MutationUpsertPayrollEntryArgs = {
  PayrollEntryInput: PayrollEntryInput;
};


export type MutationUpsertPayrollPeriodArgs = {
  PayrollPeriodInput: PayrollPeriodInput;
};


export type MutationUpsertProductArgs = {
  ProductUpsertInput: ProductUpsertInput;
};


export type MutationUpsertProductionPlanArgs = {
  ProductionPlanUpsertInput: ProductionPlanUpsertInput;
};


export type MutationUpsertResourceArgs = {
  ResourceUpsertInput: ResourceUpsertInput;
};


export type MutationUpsertSpareArgs = {
  SpareUpsertInput: SpareUpsertInput;
};


export type MutationUpsertSpareAdjustmentArgs = {
  SpareAdjustmentUpsertInput: SpareAdjustmentUpsertInput;
};


export type MutationUpsertSpareCategoryArgs = {
  SpareCategoryUpsertInput: SpareCategoryUpsertInput;
};


export type MutationUpsertSpareWithdrawalArgs = {
  SpareWithdrawalUpsertInput: SpareWithdrawalUpsertInput;
};


export type MutationUpsertTransferArgs = {
  TransferUpsertInput: TransferUpsertInput;
};

export type OptimizedRequestProduct = {
  __typename?: 'OptimizedRequestProduct';
  account_name: Scalars['String'];
  order_code?: Maybe<Scalars['Int']>;
  order_production_type_id?: Maybe<Scalars['Int']>;
  order_request_date?: Maybe<Scalars['DateTime']>;
  order_request_estimated_delivery_date?: Maybe<Scalars['DateTime']>;
  order_request_groups?: Maybe<Scalars['Float']>;
  order_request_id?: Maybe<Scalars['Int']>;
  order_request_kilos?: Maybe<Scalars['Float']>;
  order_request_status_id?: Maybe<Scalars['Int']>;
  order_request_status_name: Scalars['String'];
  order_sale_committed_groups?: Maybe<Scalars['Float']>;
  order_sale_committed_kilos?: Maybe<Scalars['Float']>;
  order_sale_delivered_groups?: Maybe<Scalars['Float']>;
  order_sale_delivered_kilos?: Maybe<Scalars['Float']>;
  order_sale_remaining_groups?: Maybe<Scalars['Float']>;
  order_sale_remaining_kilos?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
  product_calibre?: Maybe<Scalars['Float']>;
  product_description?: Maybe<Scalars['String']>;
  product_id?: Maybe<Scalars['Int']>;
  product_width?: Maybe<Scalars['Float']>;
};

export type OrderAdjustment = {
  __typename?: 'OrderAdjustment';
  created_by?: Maybe<User>;
  created_by_id?: Maybe<Scalars['Int']>;
  date: Scalars['DateTime'];
  id: Scalars['Float'];
  is_deletable: Scalars['Boolean'];
  order_adjustment_products: Array<OrderAdjustmentProduct>;
  order_adjustment_type?: Maybe<OrderAdjustmentType>;
  order_adjustment_type_id?: Maybe<Scalars['Int']>;
  order_sale?: Maybe<OrderSale>;
  order_sale_adjustment_products: Array<OrderAdjustmentProduct>;
  order_sale_id?: Maybe<Scalars['Int']>;
  order_sale_products: Array<OrderSaleProduct>;
  updated_at?: Maybe<Scalars['DateTime']>;
  updated_by?: Maybe<User>;
  updated_by_id?: Maybe<Scalars['Int']>;
};

export type OrderAdjustmentInput = {
  date: Scalars['DateTime'];
  id?: InputMaybe<Scalars['Int']>;
  order_adjustment_products: Array<OrderAdjustmentProductInput>;
  order_adjustment_type_id?: InputMaybe<Scalars['Int']>;
  order_sale_id?: InputMaybe<Scalars['Int']>;
};

export type OrderAdjustmentProduct = {
  __typename?: 'OrderAdjustmentProduct';
  group_weight: Scalars['Float'];
  groups: Scalars['Float'];
  id: Scalars['Float'];
  kilos: Scalars['Float'];
  order_adjustment?: Maybe<OrderAdjustment>;
  order_adjustment_id?: Maybe<Scalars['Int']>;
  product?: Maybe<Product>;
  product_id?: Maybe<Scalars['Int']>;
};

export type OrderAdjustmentProductInput = {
  group_weight: Scalars['Float'];
  groups: Scalars['Float'];
  id?: InputMaybe<Scalars['Int']>;
  kilos: Scalars['Float'];
  product_id?: InputMaybe<Scalars['Int']>;
};

export type OrderAdjustmentType = {
  __typename?: 'OrderAdjustmentType';
  id: Scalars['Float'];
  name: Scalars['String'];
};

export type OrderProduction = {
  __typename?: 'OrderProduction';
  branch?: Maybe<Branch>;
  branch_id?: Maybe<Scalars['Int']>;
  created_by?: Maybe<User>;
  created_by_id?: Maybe<Scalars['Int']>;
  id: Scalars['Float'];
  is_deletable: Scalars['Boolean'];
  order_production_employees: Array<OrderProductionEmployee>;
  order_production_products: Array<OrderProductionProduct>;
  order_production_products_consumed: Array<OrderProductionProductConsumed>;
  order_production_type?: Maybe<OrderProductionType>;
  order_production_type_id?: Maybe<Scalars['Int']>;
  shift?: Maybe<Scalars['Int']>;
  start_date: Scalars['DateTime'];
  updated_at?: Maybe<Scalars['DateTime']>;
  updated_by?: Maybe<User>;
  updated_by_id?: Maybe<Scalars['Int']>;
  waste: Scalars['Float'];
};

export type OrderProductionEmployee = {
  __typename?: 'OrderProductionEmployee';
  employee?: Maybe<Employee>;
  employee_id?: Maybe<Scalars['Int']>;
  id: Scalars['Float'];
  is_leader: Scalars['Float'];
  order_production_id?: Maybe<Scalars['Int']>;
};

export type OrderProductionEmployeeInput = {
  employee_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_leader: Scalars['Float'];
};

export type OrderProductionInput = {
  branch_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  order_production_employees: Array<OrderProductionEmployeeInput>;
  order_production_products: Array<OrderProductionProductInput>;
  order_production_products_consumed: Array<OrderProductionProductConsumedInput>;
  order_production_type_id?: InputMaybe<Scalars['Int']>;
  shift?: InputMaybe<Scalars['Int']>;
  start_date: Scalars['DateTime'];
  waste: Scalars['Float'];
};

export type OrderProductionProduct = {
  __typename?: 'OrderProductionProduct';
  group_weight: Scalars['Float'];
  groups: Scalars['Float'];
  hours?: Maybe<Scalars['Float']>;
  id: Scalars['Float'];
  kilos: Scalars['Float'];
  machine?: Maybe<Machine>;
  machine_id: Scalars['Int'];
  order_production?: Maybe<OrderProduction>;
  order_production_id?: Maybe<Scalars['Int']>;
  product?: Maybe<Product>;
  product_id?: Maybe<Scalars['Int']>;
};

export type OrderProductionProductConsumed = {
  __typename?: 'OrderProductionProductConsumed';
  group_weight: Scalars['Float'];
  groups: Scalars['Float'];
  hours?: Maybe<Scalars['Float']>;
  id: Scalars['Float'];
  kilos: Scalars['Float'];
  machine?: Maybe<Machine>;
  machine_id: Scalars['Int'];
  order_production?: Maybe<OrderProduction>;
  order_production_id?: Maybe<Scalars['Int']>;
  product?: Maybe<Product>;
  product_id?: Maybe<Scalars['Int']>;
};

export type OrderProductionProductConsumedInput = {
  group_weight: Scalars['Float'];
  groups: Scalars['Float'];
  hours?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['Int']>;
  kilos: Scalars['Float'];
  machine_id: Scalars['Int'];
  product_id?: InputMaybe<Scalars['Int']>;
};

export type OrderProductionProductInput = {
  group_weight: Scalars['Float'];
  groups: Scalars['Float'];
  hours?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['Int']>;
  kilos: Scalars['Float'];
  machine_id: Scalars['Int'];
  product_id?: InputMaybe<Scalars['Int']>;
};

export type OrderProductionType = {
  __typename?: 'OrderProductionType';
  id: Scalars['Float'];
  month_production: Array<OrderProductionTypeDailyProduction>;
  name: Scalars['String'];
};


export type OrderProductionTypeMonth_ProductionArgs = {
  BranchId?: InputMaybe<Scalars['Int']>;
  month?: InputMaybe<Scalars['Int']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type OrderProductionTypeDailyProduction = {
  __typename?: 'OrderProductionTypeDailyProduction';
  /** Month */
  day: Scalars['Float'];
  group_sum: Scalars['Float'];
  kilo_sum: Scalars['Float'];
  /** Month */
  month: Scalars['Float'];
  /** Dates */
  year: Scalars['Float'];
};

export type OrderQuotation = {
  __typename?: 'OrderQuotation';
  acceptance_complete: Scalars['Boolean'];
  account?: Maybe<Account>;
  account_id?: Maybe<Scalars['Int']>;
  account_products_updated_at?: Maybe<Scalars['DateTime']>;
  catalog_step_done: Scalars['Boolean'];
  created_by?: Maybe<User>;
  created_by_id?: Maybe<Scalars['Int']>;
  date: Scalars['DateTime'];
  estimated_delivery_date?: Maybe<Scalars['DateTime']>;
  expiration_date?: Maybe<Scalars['DateTime']>;
  id: Scalars['Float'];
  is_acceptable: Scalars['Boolean'];
  is_deletable: Scalars['Boolean'];
  is_editable: Scalars['Boolean'];
  is_expired: Scalars['Boolean'];
  notes: Scalars['String'];
  order_code: Scalars['Float'];
  order_quotation_products: Array<OrderQuotationProduct>;
  order_quotation_status?: Maybe<OrderQuotationStatus>;
  order_quotation_status_id?: Maybe<Scalars['Int']>;
  order_request?: Maybe<OrderRequest>;
  order_request_completed_at?: Maybe<Scalars['DateTime']>;
  order_request_step_done: Scalars['Boolean'];
  order_request_step_state: OrderQuotationPedidoStepState;
  payment_terms: Scalars['String'];
  products_total: Scalars['Float'];
  require_tax: Scalars['Boolean'];
  status_step_done: Scalars['Boolean'];
  subtotal: Scalars['Float'];
  tax: Scalars['Float'];
  total: Scalars['Float'];
  updated_at?: Maybe<Scalars['DateTime']>;
  updated_by?: Maybe<User>;
  updated_by_id?: Maybe<Scalars['Int']>;
};

export enum OrderQuotationCatalogAction {
  Actualizar = 'ACTUALIZAR',
  Agregar = 'AGREGAR',
  SinCambio = 'SIN_CAMBIO'
}

export type OrderQuotationCatalogChange = {
  __typename?: 'OrderQuotationCatalogChange';
  action: OrderQuotationCatalogAction;
  current_group_price?: Maybe<Scalars['Float']>;
  current_kilo_price?: Maybe<Scalars['Float']>;
  description: Scalars['String'];
  product_id: Scalars['Int'];
  proposed_group_price: Scalars['Float'];
  proposed_kilo_price: Scalars['Float'];
};

export type OrderQuotationCatalogPreview = {
  __typename?: 'OrderQuotationCatalogPreview';
  blocking_reasons: Array<Scalars['String']>;
  changes: Array<OrderQuotationCatalogChange>;
  is_acceptable: Scalars['Boolean'];
};

export type OrderQuotationInput = {
  account_id?: InputMaybe<Scalars['Int']>;
  date: Scalars['DateTime'];
  estimated_delivery_date?: InputMaybe<Scalars['DateTime']>;
  expiration_date?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  notes: Scalars['String'];
  order_code: Scalars['Float'];
  order_quotation_products: Array<OrderQuotationProductInput>;
  payment_terms: Scalars['String'];
  require_tax: Scalars['Boolean'];
};

export enum OrderQuotationPedidoStepState {
  Completed = 'COMPLETED',
  CreatedIncomplete = 'CREATED_INCOMPLETE',
  NotCreated = 'NOT_CREATED'
}

export type OrderQuotationProduct = {
  __typename?: 'OrderQuotationProduct';
  group_price: Scalars['Float'];
  group_weight: Scalars['Float'];
  groups: Scalars['Float'];
  id: Scalars['Int'];
  kilo_price: Scalars['Float'];
  kilos: Scalars['Float'];
  order_quotation_id?: Maybe<Scalars['Int']>;
  product?: Maybe<Product>;
  product_id?: Maybe<Scalars['Int']>;
  proposed_description: Scalars['String'];
};

export type OrderQuotationProductInput = {
  group_price: Scalars['Float'];
  group_weight: Scalars['Float'];
  groups: Scalars['Float'];
  id?: InputMaybe<Scalars['Int']>;
  kilo_price: Scalars['Float'];
  kilos: Scalars['Float'];
  product_id?: InputMaybe<Scalars['Int']>;
  proposed_description: Scalars['String'];
};

export type OrderQuotationStatus = {
  __typename?: 'OrderQuotationStatus';
  id: Scalars['Float'];
  name: Scalars['String'];
};

export enum OrderQuotationsSortableFields {
  Date = 'date',
  EstimatedDeliveryDate = 'estimated_delivery_date',
  ExpirationDate = 'expiration_date',
  OrderCode = 'order_code'
}

export type OrderRequest = {
  __typename?: 'OrderRequest';
  account?: Maybe<Account>;
  account_id?: Maybe<Scalars['Int']>;
  created_by?: Maybe<User>;
  created_by_id?: Maybe<Scalars['Int']>;
  date: Scalars['DateTime'];
  estimated_delivery_date?: Maybe<Scalars['DateTime']>;
  id: Scalars['Float'];
  is_deletable: Scalars['Boolean'];
  is_editable: Scalars['Boolean'];
  notes: Scalars['String'];
  order_code: Scalars['Float'];
  order_request_products: Array<OrderRequestProduct>;
  order_request_remaining_products: Array<OrderRequestProduct>;
  order_request_status?: Maybe<OrderRequestStatus>;
  order_request_status_id?: Maybe<Scalars['Int']>;
  order_sale_sold_products: Array<OrderSaleProduct>;
  products_total: Scalars['Float'];
  updated_at?: Maybe<Scalars['DateTime']>;
  updated_by?: Maybe<User>;
  updated_by_id?: Maybe<Scalars['Int']>;
};

export type OrderRequestDetailsInput = {
  estimated_delivery_date?: InputMaybe<Scalars['DateTime']>;
  notes?: InputMaybe<Scalars['String']>;
  order_request_id: Scalars['Int'];
};

export type OrderRequestInput = {
  account_id?: InputMaybe<Scalars['Int']>;
  date: Scalars['DateTime'];
  estimated_delivery_date?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  notes: Scalars['String'];
  order_code: Scalars['Float'];
  order_request_products: Array<OrderRequestProductInput>;
};

export type OrderRequestPriorityInput = {
  order_request_id: Scalars['Int'];
  priority: Scalars['Float'];
};

export type OrderRequestProduct = {
  __typename?: 'OrderRequestProduct';
  group_price: Scalars['Float'];
  group_weight: Scalars['Float'];
  groups: Scalars['Float'];
  id: Scalars['Int'];
  kilo_price: Scalars['Float'];
  kilos: Scalars['Float'];
  order_request?: Maybe<OrderRequest>;
  order_request_id?: Maybe<Scalars['Int']>;
  product: Product;
  product_id?: Maybe<Scalars['Int']>;
  total: Scalars['Float'];
};

export type OrderRequestProductInput = {
  group_price: Scalars['Float'];
  group_weight: Scalars['Float'];
  groups: Scalars['Float'];
  id?: InputMaybe<Scalars['Int']>;
  kilo_price: Scalars['Float'];
  kilos: Scalars['Float'];
  product_id?: InputMaybe<Scalars['Int']>;
};

export type OrderRequestStatus = {
  __typename?: 'OrderRequestStatus';
  id: Scalars['Float'];
  name: Scalars['String'];
};

export type OrderRequestSummary = {
  __typename?: 'OrderRequestSummary';
  records: Array<OrderRequestSummaryRecord>;
};

export type OrderRequestSummaryArgs = {
  include_reconciliation_only?: InputMaybe<Scalars['Boolean']>;
  month?: InputMaybe<Scalars['Int']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type OrderRequestSummaryRecord = {
  __typename?: 'OrderRequestSummaryRecord';
  account_abbreviation?: Maybe<Scalars['String']>;
  account_id?: Maybe<Scalars['Int']>;
  account_name?: Maybe<Scalars['String']>;
  calibre?: Maybe<Scalars['Float']>;
  date?: Maybe<Scalars['DateTime']>;
  groups_requested: Scalars['Float'];
  groups_sold: Scalars['Float'];
  kilos_requested: Scalars['Float'];
  kilos_sold: Scalars['Float'];
  length?: Maybe<Scalars['Float']>;
  order_code?: Maybe<Scalars['Int']>;
  order_production_type_id?: Maybe<Scalars['Int']>;
  order_production_type_name?: Maybe<Scalars['String']>;
  order_request_id?: Maybe<Scalars['Int']>;
  product_category_id?: Maybe<Scalars['Int']>;
  product_category_name?: Maybe<Scalars['String']>;
  product_id?: Maybe<Scalars['Int']>;
  product_material_id?: Maybe<Scalars['Int']>;
  product_material_name?: Maybe<Scalars['String']>;
  product_name?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Float']>;
};

export enum OrderRequestsSortableFields {
  Date = 'date',
  EstimatedDeliveryDate = 'estimated_delivery_date',
  OrderCode = 'order_code'
}

export type OrderSale = {
  __typename?: 'OrderSale';
  account?: Maybe<Account>;
  account_id?: Maybe<Scalars['Float']>;
  automatic_tax_calculation: Scalars['Boolean'];
  canceled: Scalars['Boolean'];
  compound_order_code: Scalars['String'];
  created_by?: Maybe<User>;
  created_by_id?: Maybe<Scalars['Int']>;
  credit_note_amount: Scalars['Float'];
  credit_note_code: Scalars['String'];
  date: Scalars['DateTime'];
  expected_payment_date?: Maybe<Scalars['DateTime']>;
  id: Scalars['Float'];
  invoice_code: Scalars['Float'];
  is_deletable: Scalars['Boolean'];
  is_editable: Scalars['Boolean'];
  net_subtotal: Scalars['Float'];
  net_tax: Scalars['Float'];
  net_total_with_tax: Scalars['Float'];
  notes: Scalars['String'];
  order_adjustment_products: Array<OrderAdjustmentProduct>;
  order_code: Scalars['Float'];
  order_request?: Maybe<OrderRequest>;
  order_request_id?: Maybe<Scalars['Int']>;
  order_sale_products: Array<OrderSaleProduct>;
  order_sale_status?: Maybe<OrderSaleStatus>;
  order_sale_status_id?: Maybe<Scalars['Int']>;
  receipt_type?: Maybe<ReceiptType>;
  receipt_type_id?: Maybe<Scalars['Int']>;
  reconciliation_only: Scalars['Boolean'];
  require_credit_note: Scalars['Boolean'];
  require_invoice_code: Scalars['Boolean'];
  require_supplement: Scalars['Boolean'];
  require_tax: Scalars['Boolean'];
  subtotal: Scalars['Float'];
  supplement_code: Scalars['String'];
  tax: Scalars['Float'];
  total_with_tax: Scalars['Float'];
  transfer_receipts: Array<TransferReceipt>;
  transfer_receipts_total: Scalars['Float'];
  transfer_receipts_total_no_adjustments: Scalars['Float'];
  updated_at?: Maybe<Scalars['DateTime']>;
  updated_by?: Maybe<User>;
  updated_by_id?: Maybe<Scalars['Int']>;
};

export type OrderSaleDetailsInput = {
  canceled?: InputMaybe<Scalars['Boolean']>;
  credit_note_amount?: InputMaybe<Scalars['Float']>;
  credit_note_code?: InputMaybe<Scalars['String']>;
  expected_payment_date?: InputMaybe<Scalars['DateTime']>;
  notes?: InputMaybe<Scalars['String']>;
  order_sale_id: Scalars['Int'];
  require_credit_note?: InputMaybe<Scalars['Boolean']>;
  require_supplement?: InputMaybe<Scalars['Boolean']>;
  supplement_code?: InputMaybe<Scalars['String']>;
};

export type OrderSaleInput = {
  account_id?: InputMaybe<Scalars['Int']>;
  automatic_tax_calculation: Scalars['Boolean'];
  canceled: Scalars['Boolean'];
  credit_note_amount: Scalars['Float'];
  credit_note_code: Scalars['String'];
  date: Scalars['DateTime'];
  expected_payment_date?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  invoice_code: Scalars['Float'];
  notes: Scalars['String'];
  order_code: Scalars['Float'];
  order_request_id?: InputMaybe<Scalars['Int']>;
  order_sale_products: Array<OrderSaleProductInput>;
  receipt_type_id: Scalars['Float'];
  reconciliation_only: Scalars['Boolean'];
  require_credit_note: Scalars['Boolean'];
  require_invoice_code: Scalars['Boolean'];
  require_supplement: Scalars['Boolean'];
  require_tax: Scalars['Boolean'];
  subtotal: Scalars['Float'];
  supplement_code: Scalars['String'];
  tax: Scalars['Float'];
};

export type OrderSaleProduct = {
  __typename?: 'OrderSaleProduct';
  group_price: Scalars['Float'];
  group_weight: Scalars['Float'];
  groups: Scalars['Float'];
  id: Scalars['Float'];
  kilo_price: Scalars['Float'];
  kilos: Scalars['Float'];
  order_sale?: Maybe<OrderSale>;
  order_sale_id?: Maybe<Scalars['Int']>;
  product?: Maybe<Product>;
  product_id?: Maybe<Scalars['Int']>;
  total: Scalars['Float'];
};

export type OrderSaleProductInput = {
  group_price: Scalars['Float'];
  group_weight: Scalars['Float'];
  groups: Scalars['Float'];
  id?: InputMaybe<Scalars['Int']>;
  kilo_price: Scalars['Float'];
  kilos: Scalars['Float'];
  product_id?: InputMaybe<Scalars['Int']>;
};

export type OrderSaleStatus = {
  __typename?: 'OrderSaleStatus';
  id: Scalars['Float'];
  name: Scalars['String'];
};

export enum OrderSalesSortableFields {
  Date = 'date',
  OrderCode = 'order_code',
  OrderRequest = 'order_request'
}

export type OwnAccountTransferSummary = {
  __typename?: 'OwnAccountTransferSummary';
  account?: Maybe<Account>;
  account_id?: Maybe<Scalars['Int']>;
  current_amount?: Maybe<Scalars['Float']>;
};

export type PaginatedAccounts = {
  __typename?: 'PaginatedAccounts';
  count: Scalars['Int'];
  docs: Array<Account>;
};

export type PaginatedActivities = {
  __typename?: 'PaginatedActivities';
  count: Scalars['Int'];
  docs: Array<Activity>;
};

export type PaginatedEmployees = {
  __typename?: 'PaginatedEmployees';
  count: Scalars['Int'];
  docs: Array<Employee>;
};

export enum PaginatedEmployeesSortableFields {
  FirstName = 'first_name',
  LastName = 'last_name'
}

export type PaginatedExpenseResources = {
  __typename?: 'PaginatedExpenseResources';
  count: Scalars['Int'];
  docs: Array<ExpenseResource>;
};

export type PaginatedExpenses = {
  __typename?: 'PaginatedExpenses';
  count: Scalars['Int'];
  docs: Array<Expense>;
};

export type PaginatedMachines = {
  __typename?: 'PaginatedMachines';
  count: Scalars['Int'];
  docs: Array<Machine>;
};

export type PaginatedOrderAdjustments = {
  __typename?: 'PaginatedOrderAdjustments';
  count: Scalars['Int'];
  docs: Array<OrderAdjustment>;
};

export type PaginatedOrderProductions = {
  __typename?: 'PaginatedOrderProductions';
  count: Scalars['Int'];
  docs: Array<OrderProduction>;
};

export type PaginatedOrderQuotations = {
  __typename?: 'PaginatedOrderQuotations';
  count: Scalars['Int'];
  docs: Array<OrderQuotation>;
};

export type PaginatedOrderRequests = {
  __typename?: 'PaginatedOrderRequests';
  count: Scalars['Int'];
  docs: Array<OrderRequest>;
};

export type PaginatedOrderSales = {
  __typename?: 'PaginatedOrderSales';
  count: Scalars['Int'];
  docs: Array<OrderSale>;
};

export type PaginatedProducts = {
  __typename?: 'PaginatedProducts';
  count: Scalars['Int'];
  docs: Array<Product>;
};

export type PaginatedResources = {
  __typename?: 'PaginatedResources';
  count: Scalars['Int'];
  docs: Array<Resource>;
};

export type PaginatedTransfers = {
  __typename?: 'PaginatedTransfers';
  count: Scalars['Int'];
  docs: Array<Transfer>;
};

export type PaymentRecord = {
  __typename?: 'PaymentRecord';
  receipt_type_id?: Maybe<Scalars['Int']>;
  receipt_type_name?: Maybe<Scalars['String']>;
  total: Scalars['Float'];
};

export type PayrollEntry = {
  __typename?: 'PayrollEntry';
  area: Scalars['String'];
  asistencia: Scalars['Float'];
  bd: Scalars['Float'];
  bonos: Scalars['Float'];
  bp: Scalars['Float'];
  control_bono_area: Scalars['Boolean'];
  control_deposito: Scalars['Boolean'];
  descuento_prestamos: Scalars['Float'];
  dias_festivos: Scalars['Float'];
  employee_id: Scalars['Int'];
  employee_name: Scalars['String'];
  entregas_especiales: Scalars['Float'];
  estatus: Scalars['String'];
  faltas: Scalars['Int'];
  fest_pay: Scalars['Float'];
  fonacot: Scalars['Float'];
  he: Scalars['Float'];
  he_effective: Scalars['Float'];
  he_override: Scalars['Boolean'];
  he_pay: Scalars['Float'];
  hn: Scalars['Float'];
  ht: Scalars['Float'];
  id: Scalars['Int'];
  infonavit: Scalars['Float'];
  is_leader: Scalars['Int'];
  jo: Scalars['Float'];
  observaciones: Scalars['String'];
  otros_mas: Scalars['Float'];
  otros_menos: Scalars['Float'];
  payroll_period_id: Scalars['Int'];
  prima_vac: Scalars['Float'];
  puntualidad: Scalars['Float'];
  retardos: Scalars['Int'];
  sueldo: Scalars['Float'];
  total: Scalars['Float'];
  total_minus: Scalars['Float'];
  total_plus: Scalars['Float'];
  updated_at?: Maybe<Scalars['DateTime']>;
  vac: Scalars['Float'];
  vac_pay: Scalars['Float'];
  viajes: Scalars['Float'];
};

export type PayrollEntryInput = {
  bd: Scalars['Float'];
  bonos: Scalars['Float'];
  control_bono_area: Scalars['Boolean'];
  control_deposito: Scalars['Boolean'];
  descuento_prestamos: Scalars['Float'];
  dias_festivos: Scalars['Float'];
  employee_id: Scalars['Int'];
  entregas_especiales: Scalars['Float'];
  estatus: Scalars['String'];
  faltas: Scalars['Int'];
  fonacot: Scalars['Float'];
  he: Scalars['Float'];
  he_override: Scalars['Boolean'];
  ht: Scalars['Float'];
  id?: InputMaybe<Scalars['Int']>;
  infonavit: Scalars['Float'];
  jo: Scalars['Float'];
  observaciones: Scalars['String'];
  otros_mas: Scalars['Float'];
  otros_menos: Scalars['Float'];
  payroll_period_id: Scalars['Int'];
  retardos: Scalars['Int'];
  sueldo: Scalars['Float'];
  vac: Scalars['Float'];
  viajes: Scalars['Float'];
};

export type PayrollPeriod = {
  __typename?: 'PayrollPeriod';
  branch_id?: Maybe<Scalars['Int']>;
  end_date?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  start_date?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  week_number: Scalars['Int'];
};

export type PayrollPeriodInput = {
  branch_id?: InputMaybe<Scalars['Int']>;
  end_date?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  start_date?: InputMaybe<Scalars['DateTime']>;
  week_number: Scalars['Int'];
};

export type Product = {
  __typename?: 'Product';
  calibre?: Maybe<Scalars['Float']>;
  code: Scalars['String'];
  compound_description: Scalars['String'];
  created_by?: Maybe<User>;
  created_by_id?: Maybe<Scalars['Int']>;
  current_group_price: Scalars['Float'];
  current_group_weight: Scalars['Float'];
  current_kilo_price: Scalars['Float'];
  discontinued: Scalars['Boolean'];
  external_description: Scalars['String'];
  id: Scalars['Float'];
  include_units_in_summary: Scalars['Boolean'];
  internal_description: Scalars['String'];
  is_deletable: Scalars['Boolean'];
  length?: Maybe<Scalars['Float']>;
  order_production_products: Array<OrderProductionProduct>;
  order_production_type?: Maybe<OrderProductionType>;
  order_production_type_id?: Maybe<Scalars['Int']>;
  pleat?: Maybe<Scalars['Float']>;
  product_category?: Maybe<ProductCategory>;
  product_category_id?: Maybe<Scalars['Int']>;
  product_material?: Maybe<ProductMaterial>;
  product_material_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  updated_by?: Maybe<User>;
  updated_by_id?: Maybe<Scalars['Int']>;
  width: Scalars['Float'];
};

export type ProductCategory = {
  __typename?: 'ProductCategory';
  id: Scalars['Float'];
  name: Scalars['String'];
  order_production_type_id?: Maybe<Scalars['Int']>;
};

export type ProductInventory = {
  __typename?: 'ProductInventory';
  groups?: Maybe<Scalars['Float']>;
  groups_committed?: Maybe<Scalars['Float']>;
  kilos?: Maybe<Scalars['Float']>;
  kilos_committed?: Maybe<Scalars['Float']>;
  last_update?: Maybe<Scalars['String']>;
  product?: Maybe<Product>;
  product_id?: Maybe<Scalars['Int']>;
};

export type ProductMachinePerformanceSummary = {
  __typename?: 'ProductMachinePerformanceSummary';
  groups: Scalars['Float'];
  hours: Scalars['Float'];
  kilos: Scalars['Float'];
  last_run_date?: Maybe<Scalars['DateTime']>;
  machine_id: Scalars['Int'];
  machine_name: Scalars['String'];
  runs: Scalars['Int'];
  waste_share_total: Scalars['Float'];
};

export type ProductMaterial = {
  __typename?: 'ProductMaterial';
  id: Scalars['Float'];
  name: Scalars['String'];
};

export type ProductUpsertInput = {
  calibre?: InputMaybe<Scalars['Float']>;
  code: Scalars['String'];
  current_group_price: Scalars['Float'];
  current_group_weight: Scalars['Float'];
  current_kilo_price: Scalars['Float'];
  discontinued: Scalars['Boolean'];
  external_description: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  include_units_in_summary: Scalars['Boolean'];
  internal_description: Scalars['String'];
  length?: InputMaybe<Scalars['Float']>;
  order_production_type_id?: InputMaybe<Scalars['Int']>;
  pleat?: InputMaybe<Scalars['Float']>;
  product_category_id?: InputMaybe<Scalars['Int']>;
  product_material_id?: InputMaybe<Scalars['Int']>;
  width: Scalars['Float'];
};

export type ProductWithRuns = {
  __typename?: 'ProductWithRuns';
  description: Scalars['String'];
  id: Scalars['Int'];
  product_category_name?: Maybe<Scalars['String']>;
};

export type ProductionPlan = {
  __typename?: 'ProductionPlan';
  branch?: Maybe<Branch>;
  branch_id?: Maybe<Scalars['Int']>;
  date: Scalars['DateTime'];
  id: Scalars['Float'];
  notes: Scalars['String'];
  product_notes: Scalars['String'];
  rows: Array<ProductionPlanRow>;
  shift: Scalars['Int'];
  shift_hours: Scalars['Float'];
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type ProductionPlanActual = {
  __typename?: 'ProductionPlanActual';
  groups: Scalars['Float'];
  kilos: Scalars['Float'];
  machine_id?: Maybe<Scalars['Int']>;
  product_id?: Maybe<Scalars['Int']>;
};

export type ProductionPlanRow = {
  __typename?: 'ProductionPlanRow';
  employees: Array<Employee>;
  id: Scalars['Float'];
  machine?: Maybe<Machine>;
  machine_id?: Maybe<Scalars['Int']>;
  notes: Scalars['String'];
  position: Scalars['Int'];
  production_plan_id?: Maybe<Scalars['Int']>;
  products: Array<ProductionPlanRowProduct>;
  shift_hours?: Maybe<Scalars['Float']>;
};

export type ProductionPlanRowInput = {
  employee_ids: Array<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  machine_id?: InputMaybe<Scalars['Int']>;
  notes: Scalars['String'];
  position: Scalars['Int'];
  products: Array<ProductionPlanRowProductInput>;
  shift_hours?: InputMaybe<Scalars['Float']>;
};

export type ProductionPlanRowProduct = {
  __typename?: 'ProductionPlanRowProduct';
  efficiency: Scalars['Float'];
  hours: Scalars['Float'];
  id: Scalars['Float'];
  position: Scalars['Int'];
  product?: Maybe<Product>;
  product_id?: Maybe<Scalars['Int']>;
  production_plan_row_id?: Maybe<Scalars['Int']>;
};

export type ProductionPlanRowProductInput = {
  efficiency: Scalars['Float'];
  hours: Scalars['Float'];
  id?: InputMaybe<Scalars['Int']>;
  position: Scalars['Int'];
  product_id?: InputMaybe<Scalars['Int']>;
};

export type ProductionPlanUpsertInput = {
  branch_id?: InputMaybe<Scalars['Int']>;
  date: Scalars['DateTime'];
  id?: InputMaybe<Scalars['Int']>;
  notes: Scalars['String'];
  product_notes: Scalars['String'];
  rows: Array<ProductionPlanRowInput>;
  shift: Scalars['Int'];
  shift_hours: Scalars['Float'];
};

export type ProductionRecord = {
  __typename?: 'ProductionRecord';
  branch_id?: Maybe<Scalars['Int']>;
  branch_name?: Maybe<Scalars['String']>;
  calibre?: Maybe<Scalars['Float']>;
  count_id?: Maybe<Scalars['Float']>;
  day?: Maybe<Scalars['Int']>;
  hours?: Maybe<Scalars['Float']>;
  kilos: Scalars['Float'];
  length?: Maybe<Scalars['Float']>;
  machine_id?: Maybe<Scalars['Int']>;
  machine_name?: Maybe<Scalars['String']>;
  machine_type_id?: Maybe<Scalars['Int']>;
  month: Scalars['Int'];
  order_production_type_id?: Maybe<Scalars['Int']>;
  order_production_type_name?: Maybe<Scalars['String']>;
  product_category_id?: Maybe<Scalars['Int']>;
  product_category_name?: Maybe<Scalars['String']>;
  product_description?: Maybe<Scalars['String']>;
  product_id?: Maybe<Scalars['Int']>;
  width?: Maybe<Scalars['Float']>;
  year: Scalars['Int'];
};

export type ProductionResourcesArgs = {
  date_group_by: DateGroupBy;
  month?: InputMaybe<Scalars['Int']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type ProductionResourcesRecord = {
  __typename?: 'ProductionResourcesRecord';
  day?: Maybe<Scalars['Int']>;
  employee_id?: Maybe<Scalars['Int']>;
  employee_name?: Maybe<Scalars['String']>;
  groups: Scalars['Float'];
  hours?: Maybe<Scalars['Float']>;
  kilos: Scalars['Float'];
  machine_id?: Maybe<Scalars['Int']>;
  machine_name?: Maybe<Scalars['String']>;
  month?: Maybe<Scalars['Int']>;
  product_id?: Maybe<Scalars['Int']>;
  product_name?: Maybe<Scalars['String']>;
  year: Scalars['Int'];
};

export type ProductionResourcesSummary = {
  __typename?: 'ProductionResourcesSummary';
  ProductionResources: Array<ProductionResourcesRecord>;
};

export type ProductionSummary = {
  __typename?: 'ProductionSummary';
  production: Array<ProductionRecord>;
  waste: Array<WasteRecord>;
};

export type ProductionSummaryArgs = {
  branch_id?: InputMaybe<Scalars['Int']>;
  date_group_by: DateGroupBy;
  entity_group?: InputMaybe<ProductionSummaryEntitiesGroup>;
  month?: InputMaybe<Scalars['Int']>;
  order_production_type_id?: InputMaybe<Scalars['Int']>;
  year: Scalars['Int'];
};

export enum ProductionSummaryEntitiesGroup {
  Machine = 'machine',
  ProductCategory = 'productCategory'
}

export enum ProductsSortableFields {
  ExternalDescription = 'external_description',
  InternalDescription = 'internal_description',
  OrderProductionTypeId = 'order_production_type_id',
  ProductCategoryId = 'product_category_id'
}

export type Query = {
  __typename?: 'Query';
  currentUser: User;
  getAccount?: Maybe<Account>;
  getAccountContacts: Array<AccountContact>;
  getAccountOpeningBalance: Scalars['Float'];
  getAccountProducts: Array<AccountProduct>;
  getAccountResources: Array<AccountResource>;
  getAccountTransactionHistory: Array<AccountTransactionItem>;
  getAccountTransfers: Array<AccountTransferItem>;
  getAccounts: Array<Account>;
  getActivity?: Maybe<Activity>;
  getBranches: Array<Branch>;
  getEmployee?: Maybe<Employee>;
  getEmployeeSummary: EmployeesSummary;
  getEmployeeTypes: Array<EmployeeType>;
  getEmployees: Array<Employee>;
  getEntityActivities: Array<Activity>;
  getExpense?: Maybe<Expense>;
  getExpenseMaxInternalCode: Scalars['Float'];
  getExpenseResource: ExpenseResource;
  getExpenseResources: Array<ExpenseResource>;
  getExpenses: Array<Expense>;
  getExpensesSummary: ExpensesSummary;
  getExpensesWithDisparities: Array<Expense>;
  getMachine?: Maybe<Machine>;
  getMachineCompatibilities: Array<MachineCompatibility>;
  getMachineConsumptionRates: Array<MachineConsumptionRate>;
  getMachineHourlyRuns: Array<MachineHourlyRun>;
  getMachinePart: MachinePart;
  getMachineParts: Array<MachinePart>;
  getMachineProducedProductIds: Array<Scalars['Int']>;
  getMachineProductEmployeeRuns: Array<MachineProductEmployeeRun>;
  getMachineProductPerformanceSummary: Array<MachineProductPerformanceSummary>;
  getMachineProductRates: Array<MachineProductRate>;
  getMachineProducts: Array<MachineProduct>;
  getMachineSection: MachineSection;
  getMachineSections: Array<MachineSection>;
  getMachines: Array<Machine>;
  getMaterialBalanceByMachine: Array<MaterialBalanceMachineRecord>;
  getMaterialBalanceExceptions: MaterialBalanceExceptions;
  getMaterialBalanceSummary: Array<MaterialBalanceRecord>;
  getOptimizedRequestProducts: Array<OptimizedRequestProduct>;
  getOrderAdjustment?: Maybe<OrderAdjustment>;
  getOrderAdjustmentType?: Maybe<OrderAdjustmentType>;
  getOrderAdjustmentTypes: Array<OrderAdjustmentType>;
  getOrderAdjustments: Array<OrderAdjustment>;
  getOrderProduction: OrderProduction;
  getOrderProductionEmployee: OrderProductionEmployee;
  getOrderProductionType: OrderProductionType;
  getOrderProductionTypes: Array<OrderProductionType>;
  getOrderQuotation?: Maybe<OrderQuotation>;
  getOrderQuotationCatalogChanges: OrderQuotationCatalogPreview;
  getOrderQuotationMaxOrderCode: Scalars['Float'];
  getOrderQuotations: Array<OrderQuotation>;
  getOrderRequest?: Maybe<OrderRequest>;
  getOrderRequestMaxOrderCode: Scalars['Float'];
  getOrderRequestProducts: Array<OrderRequestProduct>;
  getOrderRequestStatuses: Array<OrderRequestStatus>;
  getOrderRequestSummary: OrderRequestSummary;
  getOrderRequests: Array<OrderRequest>;
  getOrderSale?: Maybe<OrderSale>;
  getOrderSaleMaxOrderCode: Scalars['Float'];
  getOrderSaleStatuses: Array<OrderSaleStatus>;
  getOrderSales: Array<OrderSale>;
  getOrderSalesWithDisparities: Array<OrderSale>;
  getOwnAccountsTransferSummary: Array<OwnAccountTransferSummary>;
  getPayrollEntries: Array<PayrollEntry>;
  getPayrollEntry?: Maybe<PayrollEntry>;
  getPayrollPeriod?: Maybe<PayrollPeriod>;
  getPayrollPeriods: Array<PayrollPeriod>;
  getProduct: Product;
  getProductCategories: Array<ProductCategory>;
  getProductInventoryMovements: Array<InventoryMovement>;
  getProductMachinePerformanceSummary: Array<ProductMachinePerformanceSummary>;
  getProductMaterials: Array<ProductMaterial>;
  getProductionPlan?: Maybe<ProductionPlan>;
  getProductionPlanActuals: Array<ProductionPlanActual>;
  getProductionPlans: Array<ProductionPlan>;
  getProductionResourcesSummary: ProductionResourcesSummary;
  getProductionSummary: ProductionSummary;
  getProducts: Array<Product>;
  getProductsInventory: Array<ProductInventory>;
  getProductsWithRuns: Array<ProductWithRuns>;
  getReceiptTypes: Array<ReceiptType>;
  getRecurringExpenseCandidates: Array<RecurringExpenseCandidate>;
  getResource?: Maybe<Resource>;
  getResourceCategories: Array<ResourceCategory>;
  getResources: Array<Resource>;
  getRoles: Array<Role>;
  getSalesSummary: SalesSummary;
  getServerVersion?: Maybe<Scalars['String']>;
  getSimilarAccountNames: Array<SimilarAccountName>;
  getSpare: Spare;
  getSpareAdjustments: Array<SpareOperation>;
  getSpareCategories: Array<SpareCategory>;
  getSpareCategory: SpareCategory;
  getSpareOperation: SpareOperation;
  getSpareTransactions: Array<SpareTransaction>;
  getSpares: Array<Spare>;
  getThirdPartyAccountsTransferSummary: Array<ThirdPartyAccountTransferSummary>;
  getTransfer?: Maybe<Transfer>;
  getTransferReceipts: Array<TransferReceipt>;
  getTransferTypes: Array<TransferType>;
  getTransfers: Array<Transfer>;
  getTransfersSummary: TransfersSummary;
  getUser?: Maybe<User>;
  getWeeklyAuditRuns: Array<WeeklyAuditRun>;
  isEmailOccupied: Scalars['Boolean'];
  isExpenseInternalCodeOccupied: Scalars['Boolean'];
  isOrderQuotationCodeOccupied: Scalars['Boolean'];
  isOrderRequestCodeOccupied: Scalars['Boolean'];
  isOrderSaleCodeOccupied: Scalars['Boolean'];
  myConfig: UserConfig;
  paginatedAccounts: PaginatedAccounts;
  paginatedActivities: PaginatedActivities;
  paginatedEmployees: PaginatedEmployees;
  paginatedExpenseResources: PaginatedExpenseResources;
  paginatedExpenses: PaginatedExpenses;
  paginatedMachines: PaginatedMachines;
  paginatedOrderAdjustments: PaginatedOrderAdjustments;
  paginatedOrderProductions: PaginatedOrderProductions;
  paginatedOrderQuotations: PaginatedOrderQuotations;
  paginatedOrderRequests: PaginatedOrderRequests;
  paginatedOrderSales: PaginatedOrderSales;
  paginatedProducts: PaginatedProducts;
  paginatedResources: PaginatedResources;
  paginatedTransfers: PaginatedTransfers;
  users: Array<User>;
};


export type QueryGetAccountArgs = {
  AccountId: Scalars['Float'];
};


export type QueryGetAccountOpeningBalanceArgs = {
  AccountId: Scalars['Float'];
  From?: InputMaybe<Scalars['String']>;
};


export type QueryGetAccountProductsArgs = {
  AccountId: Scalars['Float'];
};


export type QueryGetAccountResourcesArgs = {
  AccountId: Scalars['Float'];
};


export type QueryGetAccountTransactionHistoryArgs = {
  AccountId: Scalars['Float'];
  From?: InputMaybe<Scalars['String']>;
  Until?: InputMaybe<Scalars['String']>;
};


export type QueryGetAccountTransfersArgs = {
  AccountId: Scalars['Float'];
  From?: InputMaybe<Scalars['String']>;
  Until?: InputMaybe<Scalars['String']>;
};


export type QueryGetAccountsArgs = {
  is_client?: InputMaybe<Scalars['Boolean']>;
  is_own?: InputMaybe<Scalars['Boolean']>;
  is_supplier?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetActivityArgs = {
  ActivityId: Scalars['Int'];
};


export type QueryGetEmployeeArgs = {
  EmployeeId: Scalars['Float'];
};


export type QueryGetEmployeeSummaryArgs = {
  ExpensesSummaryArgs: EmployeesSummaryArgs;
};


export type QueryGetEmployeesArgs = {
  exclude_discontinued?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetEntityActivitiesArgs = {
  EntityId: Scalars['Int'];
  EntityName: ActivityEntityName;
};


export type QueryGetExpenseArgs = {
  ExpenseId: Scalars['Float'];
};


export type QueryGetExpenseResourceArgs = {
  ExpenseResourceId: Scalars['Float'];
};


export type QueryGetExpensesArgs = {
  account_id?: InputMaybe<Scalars['Int']>;
  end_date?: InputMaybe<Scalars['String']>;
  is_canceled?: InputMaybe<Scalars['Boolean']>;
  receipt_type_id?: InputMaybe<Scalars['Int']>;
  sort_field?: InputMaybe<ExpensesSortableFields>;
  sort_order?: InputMaybe<ColumnOrder>;
  start_date?: InputMaybe<Scalars['String']>;
};


export type QueryGetExpensesSummaryArgs = {
  ExpensesSummaryArgs: ExpensesSummaryArgs;
};


export type QueryGetExpensesWithDisparitiesArgs = {
  monitor_supplier_expenses?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetMachineArgs = {
  MachineId: Scalars['Float'];
};


export type QueryGetMachineConsumptionRatesArgs = {
  fromDate?: InputMaybe<Scalars['String']>;
  machineIds: Array<Scalars['Int']>;
};


export type QueryGetMachineHourlyRunsArgs = {
  fromDate?: InputMaybe<Scalars['String']>;
  machineId?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
  toDate?: InputMaybe<Scalars['String']>;
};


export type QueryGetMachinePartArgs = {
  MachinePartId: Scalars['Float'];
};


export type QueryGetMachineProducedProductIdsArgs = {
  machineId: Scalars['Int'];
};


export type QueryGetMachineProductEmployeeRunsArgs = {
  fromDate?: InputMaybe<Scalars['String']>;
  machineId?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
  toDate?: InputMaybe<Scalars['String']>;
};


export type QueryGetMachineProductPerformanceSummaryArgs = {
  fromDate?: InputMaybe<Scalars['String']>;
  machineId: Scalars['Int'];
  toDate?: InputMaybe<Scalars['String']>;
};


export type QueryGetMachineProductRatesArgs = {
  fromDate?: InputMaybe<Scalars['String']>;
  pairs: Array<MachineProductRatePairInput>;
  singleProductOnly?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetMachineProductsArgs = {
  machineId: Scalars['Int'];
};


export type QueryGetMachineSectionArgs = {
  MachineSectionId: Scalars['Float'];
};


export type QueryGetMachineSectionsArgs = {
  MachineId: Scalars['Float'];
};


export type QueryGetMachinesArgs = {
  exclude_discontinued?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetMaterialBalanceByMachineArgs = {
  MaterialBalanceMachineArgs: MaterialBalanceMachineArgs;
};


export type QueryGetMaterialBalanceExceptionsArgs = {
  MaterialBalanceExceptionsArgs: MaterialBalanceExceptionsArgs;
};


export type QueryGetMaterialBalanceSummaryArgs = {
  MaterialBalanceSummaryArgs: MaterialBalanceSummaryArgs;
};


export type QueryGetOrderAdjustmentArgs = {
  OrderAdjustmentId: Scalars['Float'];
};


export type QueryGetOrderAdjustmentTypeArgs = {
  OrderAdjustmentTypeId: Scalars['Float'];
};


export type QueryGetOrderProductionArgs = {
  OrderProductionId: Scalars['Float'];
};


export type QueryGetOrderProductionEmployeeArgs = {
  OrderProductionEmployeeId: Scalars['Float'];
};


export type QueryGetOrderProductionTypeArgs = {
  OrderProductionTypeId: Scalars['Float'];
};


export type QueryGetOrderQuotationArgs = {
  OrderQuotationId: Scalars['Float'];
};


export type QueryGetOrderQuotationCatalogChangesArgs = {
  OrderQuotationId: Scalars['Int'];
};


export type QueryGetOrderQuotationsArgs = {
  order_quotation_status_ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type QueryGetOrderRequestArgs = {
  OrderRequestId: Scalars['Float'];
};


export type QueryGetOrderRequestSummaryArgs = {
  OrderRequestSummaryArgs: OrderRequestSummaryArgs;
};


export type QueryGetOrderRequestsArgs = {
  order_request_status_ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type QueryGetOrderSaleArgs = {
  OrderSaleId: Scalars['Float'];
};


export type QueryGetOrderSalesArgs = {
  account_id?: InputMaybe<Scalars['Int']>;
  end_date?: InputMaybe<Scalars['String']>;
  receipt_type_id?: InputMaybe<Scalars['Int']>;
  sort_field?: InputMaybe<OrderSalesSortableFields>;
  sort_order?: InputMaybe<ColumnOrder>;
  start_date?: InputMaybe<Scalars['String']>;
};


export type QueryGetPayrollEntriesArgs = {
  PayrollPeriodId: Scalars['Int'];
};


export type QueryGetPayrollEntryArgs = {
  PayrollEntryId: Scalars['Int'];
};


export type QueryGetPayrollPeriodArgs = {
  PayrollPeriodId: Scalars['Int'];
};


export type QueryGetPayrollPeriodsArgs = {
  branch_id?: InputMaybe<Scalars['Int']>;
};


export type QueryGetProductArgs = {
  ProductId: Scalars['Float'];
};


export type QueryGetProductInventoryMovementsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  includeAllSaleStatuses?: InputMaybe<Scalars['Boolean']>;
  product_id: Scalars['Int'];
  startDate?: InputMaybe<Scalars['DateTime']>;
};


export type QueryGetProductMachinePerformanceSummaryArgs = {
  fromDate?: InputMaybe<Scalars['String']>;
  productId: Scalars['Int'];
  toDate?: InputMaybe<Scalars['String']>;
};


export type QueryGetProductionPlanArgs = {
  branch_id?: InputMaybe<Scalars['Int']>;
  date: Scalars['DateTime'];
  shift: Scalars['Int'];
};


export type QueryGetProductionPlanActualsArgs = {
  branch_id?: InputMaybe<Scalars['Int']>;
  date: Scalars['DateTime'];
  shift: Scalars['Int'];
};


export type QueryGetProductionPlansArgs = {
  end_date?: InputMaybe<Scalars['DateTime']>;
  start_date?: InputMaybe<Scalars['DateTime']>;
};


export type QueryGetProductionResourcesSummaryArgs = {
  ProductionResourcesArgs: ProductionResourcesArgs;
};


export type QueryGetProductionSummaryArgs = {
  ProductionSummaryArgs: ProductionSummaryArgs;
};


export type QueryGetProductsArgs = {
  exclude_discontinued?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetRecurringExpenseCandidatesArgs = {
  month: Scalars['Int'];
  year: Scalars['Int'];
};


export type QueryGetResourceArgs = {
  ResourceId: Scalars['Float'];
};


export type QueryGetResourcesArgs = {
  resource_category_id?: InputMaybe<Array<Scalars['Int']>>;
};


export type QueryGetSalesSummaryArgs = {
  SalesSummaryArgs: SalesSummaryArgs;
};


export type QueryGetSimilarAccountNamesArgs = {
  ExcludeAccountId?: InputMaybe<Scalars['Float']>;
  Name: Scalars['String'];
};


export type QueryGetSpareArgs = {
  SpareId: Scalars['Float'];
};


export type QueryGetSpareCategoryArgs = {
  SpareCategoryId: Scalars['Float'];
};


export type QueryGetSpareOperationArgs = {
  SpareOperationId: Scalars['Float'];
};


export type QueryGetSpareTransactionsArgs = {
  end_date?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['String']>;
};


export type QueryGetThirdPartyAccountsTransferSummaryArgs = {
  monitor_supplier_expenses?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetTransferArgs = {
  TransferId: Scalars['Float'];
};


export type QueryGetTransfersArgs = {
  end_date?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['String']>;
};


export type QueryGetTransfersSummaryArgs = {
  TransfersSummaryArgs: TransfersSummaryArgs;
};


export type QueryGetUserArgs = {
  UserId: Scalars['Float'];
};


export type QueryGetWeeklyAuditRunsArgs = {
  orderProductionTypeId?: InputMaybe<Scalars['Int']>;
  weekEnd: Scalars['String'];
  weekStart: Scalars['String'];
};


export type QueryIsEmailOccupiedArgs = {
  Email: Scalars['String'];
  UserId?: InputMaybe<Scalars['Float']>;
};


export type QueryIsExpenseInternalCodeOccupiedArgs = {
  ExpenseId?: InputMaybe<Scalars['Int']>;
  InternalCode: Scalars['Float'];
};


export type QueryIsOrderQuotationCodeOccupiedArgs = {
  OrderCode: Scalars['Float'];
  OrderQuotationId?: InputMaybe<Scalars['Int']>;
};


export type QueryIsOrderRequestCodeOccupiedArgs = {
  OrderCode: Scalars['Float'];
  OrderRequestId?: InputMaybe<Scalars['Int']>;
};


export type QueryIsOrderSaleCodeOccupiedArgs = {
  OrderCode: Scalars['Float'];
  OrderSaleId?: InputMaybe<Scalars['Int']>;
};


export type QueryPaginatedAccountsArgs = {
  filter: Scalars['String'];
  is_client?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Float']>;
  sort_field?: InputMaybe<AccountsSortableFields>;
  sort_order?: InputMaybe<ColumnOrder>;
  take?: InputMaybe<Scalars['Float']>;
};


export type QueryPaginatedActivitiesArgs = {
  end_date?: InputMaybe<Scalars['String']>;
  entity_name?: InputMaybe<ActivityEntityName>;
  skip?: InputMaybe<Scalars['Float']>;
  start_date?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<ActivityTypeName>;
  user_id?: InputMaybe<Scalars['Int']>;
};


export type QueryPaginatedEmployeesArgs = {
  branch_id?: InputMaybe<Scalars['Int']>;
  filter: Scalars['String'];
  order_production_type_id?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Float']>;
  sort_field?: InputMaybe<PaginatedEmployeesSortableFields>;
  sort_order?: InputMaybe<ColumnOrder>;
  take?: InputMaybe<Scalars['Float']>;
};


export type QueryPaginatedExpenseResourcesArgs = {
  end_date?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Float']>;
  sort_field?: InputMaybe<ExpenseResourcesPaginatedSortableFields>;
  sort_order?: InputMaybe<ColumnOrder>;
  start_date?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Float']>;
};


export type QueryPaginatedExpensesArgs = {
  account_id?: InputMaybe<Scalars['Int']>;
  end_date?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['String']>;
  is_transfer_incomplete?: InputMaybe<Scalars['Boolean']>;
  no_receipt?: InputMaybe<Scalars['Boolean']>;
  no_supplement?: InputMaybe<Scalars['Boolean']>;
  receipt_type_id?: InputMaybe<Scalars['Int']>;
  resource_id?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Float']>;
  sort_field?: InputMaybe<ExpensesSortableFields>;
  sort_order?: InputMaybe<ColumnOrder>;
  start_date?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Float']>;
};


export type QueryPaginatedMachinesArgs = {
  branch_id?: InputMaybe<Scalars['Int']>;
  discontinued?: InputMaybe<Scalars['Boolean']>;
  filter: Scalars['String'];
  order_production_type_id?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Float']>;
  take?: InputMaybe<Scalars['Float']>;
};


export type QueryPaginatedOrderAdjustmentsArgs = {
  end_date?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['String']>;
  order_adjustment_type_id?: InputMaybe<Scalars['Int']>;
  product_id?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Float']>;
  start_date?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Float']>;
};


export type QueryPaginatedOrderProductionsArgs = {
  branch_id?: InputMaybe<Scalars['Int']>;
  end_date?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['String']>;
  machine_id?: InputMaybe<Scalars['Int']>;
  order_production_type_id?: InputMaybe<Scalars['Int']>;
  product_id?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Float']>;
  start_date?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Float']>;
};


export type QueryPaginatedOrderQuotationsArgs = {
  account_id?: InputMaybe<Scalars['Int']>;
  end_date?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['String']>;
  order_quotation_status_id?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Float']>;
  sort_field?: InputMaybe<OrderQuotationsSortableFields>;
  sort_order?: InputMaybe<ColumnOrder>;
  start_date?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Float']>;
};


export type QueryPaginatedOrderRequestsArgs = {
  account_id?: InputMaybe<Scalars['Int']>;
  end_date?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['String']>;
  order_request_status_id?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Float']>;
  sort_field?: InputMaybe<OrderRequestsSortableFields>;
  sort_order?: InputMaybe<ColumnOrder>;
  start_date?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Float']>;
};


export type QueryPaginatedOrderSalesArgs = {
  account_id?: InputMaybe<Scalars['Int']>;
  end_date?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['String']>;
  is_transfer_incomplete?: InputMaybe<Scalars['Boolean']>;
  no_credit_note?: InputMaybe<Scalars['Boolean']>;
  no_supplement?: InputMaybe<Scalars['Boolean']>;
  order_sale_status_id?: InputMaybe<Scalars['Int']>;
  product_id?: InputMaybe<Scalars['Int']>;
  receipt_type_id?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Float']>;
  sort_field?: InputMaybe<OrderSalesSortableFields>;
  sort_order?: InputMaybe<ColumnOrder>;
  start_date?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Float']>;
};


export type QueryPaginatedProductsArgs = {
  filter: Scalars['String'];
  include_discontinued: Scalars['Boolean'];
  only_missing_internal_description?: InputMaybe<Scalars['Boolean']>;
  product_category_id?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Float']>;
  sort_field?: InputMaybe<ProductsSortableFields>;
  sort_order?: InputMaybe<ColumnOrder>;
  take?: InputMaybe<Scalars['Float']>;
};


export type QueryPaginatedResourcesArgs = {
  end_date?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Float']>;
  sort_field?: InputMaybe<ResourcesSortableFields>;
  sort_order?: InputMaybe<ColumnOrder>;
  start_date?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Float']>;
};


export type QueryPaginatedTransfersArgs = {
  account_id?: InputMaybe<Scalars['Int']>;
  end_date?: InputMaybe<Scalars['String']>;
  exclude_reconciliation_only?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Scalars['String']>;
  from_account_id?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Float']>;
  sort_field?: InputMaybe<TransfersSortableFields>;
  sort_order?: InputMaybe<ColumnOrder>;
  start_date?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Float']>;
  to_account_id?: InputMaybe<Scalars['Int']>;
  transfer_type_id?: InputMaybe<Scalars['Int']>;
};

export type RawMaterialAddition = {
  __typename?: 'RawMaterialAddition';
  account_id?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['DateTime']>;
  id: Scalars['Float'];
};

export type ReceiptType = {
  __typename?: 'ReceiptType';
  applies_tax: Scalars['Boolean'];
  id: Scalars['Float'];
  is_informal_receipt: Scalars['Boolean'];
  name: Scalars['String'];
  tax_multiplier: Scalars['Float'];
  tax_rate: Scalars['Float'];
};

export type RecurringExpenseCandidate = {
  __typename?: 'RecurringExpenseCandidate';
  account_id: Scalars['Int'];
  account_name: Scalars['String'];
  already_generated: Scalars['Boolean'];
  date: Scalars['DateTime'];
  expense_id: Scalars['Int'];
  expense_resources: Array<ExpenseResource>;
  non_tax_retained: Scalars['Float'];
  notes: Scalars['String'];
  receipt_type_id?: Maybe<Scalars['Int']>;
  require_external_code: Scalars['Boolean'];
  require_supplement: Scalars['Boolean'];
  subtotal: Scalars['Float'];
  suggested_payment_date?: Maybe<Scalars['DateTime']>;
  tax: Scalars['Float'];
  tax_retained: Scalars['Float'];
};

export type Resource = {
  __typename?: 'Resource';
  created_by?: Maybe<User>;
  created_by_id?: Maybe<Scalars['Int']>;
  current_group_price?: Maybe<Scalars['Float']>;
  current_group_weight?: Maybe<Scalars['Float']>;
  current_unit_price?: Maybe<Scalars['Float']>;
  group_weight_strict?: Maybe<Scalars['Float']>;
  id: Scalars['Float'];
  include_units_in_summary: Scalars['Boolean'];
  is_deletable: Scalars['Boolean'];
  is_editable: Scalars['Boolean'];
  name: Scalars['String'];
  resource_category?: Maybe<ResourceCategory>;
  resource_category_id?: Maybe<Scalars['Int']>;
  unit_price_name?: Maybe<Scalars['String']>;
  updated_by?: Maybe<User>;
  updated_by_id?: Maybe<Scalars['Int']>;
};

export type ResourceCategory = {
  __typename?: 'ResourceCategory';
  id: Scalars['Float'];
  name: Scalars['String'];
};

export type ResourceUpsertInput = {
  current_group_price?: InputMaybe<Scalars['Float']>;
  current_group_weight?: InputMaybe<Scalars['Float']>;
  current_unit_price?: InputMaybe<Scalars['Float']>;
  group_weight_strict?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['Int']>;
  include_units_in_summary: Scalars['Boolean'];
  name: Scalars['String'];
  resource_category_id?: InputMaybe<Scalars['Int']>;
  unit_price_name?: InputMaybe<Scalars['String']>;
};

export enum ResourcesSortableFields {
  Name = 'name'
}

export type Role = {
  __typename?: 'Role';
  id: Scalars['Float'];
  name: Scalars['String'];
};

export enum RoleId {
  Admin = 'ADMIN',
  Expenses = 'EXPENSES',
  ExpensesAssistant = 'EXPENSES_ASSISTANT',
  Guest = 'GUEST',
  HumanResources = 'HUMAN_RESOURCES',
  HumanResourcesAssistant = 'HUMAN_RESOURCES_ASSISTANT',
  Production = 'PRODUCTION',
  ProductionAssistant = 'PRODUCTION_ASSISTANT',
  Sales = 'SALES',
  SalesAssistant = 'SALES_ASSISTANT',
  Super = 'SUPER'
}

export type RoleInput = {
  id: Scalars['Float'];
};

export type SalesRecord = {
  __typename?: 'SalesRecord';
  account_abbreviation?: Maybe<Scalars['String']>;
  account_id?: Maybe<Scalars['Int']>;
  account_name?: Maybe<Scalars['String']>;
  calibre?: Maybe<Scalars['Float']>;
  day?: Maybe<Scalars['Int']>;
  groups_sold: Scalars['Float'];
  invoice_code?: Maybe<Scalars['Int']>;
  kilos_sold: Scalars['Float'];
  length?: Maybe<Scalars['Float']>;
  month?: Maybe<Scalars['Int']>;
  order_code?: Maybe<Scalars['Int']>;
  order_production_type_id?: Maybe<Scalars['Int']>;
  order_production_type_name?: Maybe<Scalars['String']>;
  order_request_code?: Maybe<Scalars['Int']>;
  order_sale_id?: Maybe<Scalars['Int']>;
  product_category_id?: Maybe<Scalars['Int']>;
  product_category_name?: Maybe<Scalars['String']>;
  product_id?: Maybe<Scalars['Int']>;
  product_material_id?: Maybe<Scalars['Int']>;
  product_material_name?: Maybe<Scalars['String']>;
  product_name?: Maybe<Scalars['String']>;
  receipt_type_id?: Maybe<Scalars['Int']>;
  receipt_type_name?: Maybe<Scalars['String']>;
  status_id?: Maybe<Scalars['Int']>;
  status_name?: Maybe<Scalars['String']>;
  tax: Scalars['Float'];
  total: Scalars['Float'];
  total_with_tax: Scalars['Float'];
  width?: Maybe<Scalars['Float']>;
  year: Scalars['Int'];
};

export type SalesSummary = {
  __typename?: 'SalesSummary';
  sales: Array<SalesRecord>;
};

export type SalesSummaryArgs = {
  date_group_by: DateGroupBy;
  entity_groups: Array<SalesSummaryEntitiesGroup>;
  include_reconciliation_only?: InputMaybe<Scalars['Boolean']>;
  month?: InputMaybe<Scalars['Int']>;
  year?: InputMaybe<Scalars['Int']>;
};

export enum SalesSummaryEntitiesGroup {
  Account = 'account',
  OrderSale = 'orderSale',
  Product = 'product',
  ProductAccount = 'productAccount',
  ProductCategory = 'productCategory',
  ProductMaterial = 'productMaterial',
  Receipt = 'receipt'
}

export type SimilarAccountName = {
  __typename?: 'SimilarAccountName';
  abbreviation: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  reason: Scalars['String'];
  similarity: Scalars['Float'];
};

export type Spare = {
  __typename?: 'Spare';
  current_quantity: Scalars['Float'];
  id: Scalars['Float'];
  is_deletable: Scalars['Boolean'];
  name: Scalars['String'];
  spare_category?: Maybe<SpareCategory>;
  spare_category_id?: Maybe<Scalars['Int']>;
  spare_transactions: Array<SpareTransaction>;
  total_required_quantity: Scalars['Float'];
};

export type SpareAdjustmentUpsertInput = {
  date?: InputMaybe<Scalars['DateTime']>;
  description: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  spare_transactions: Array<SpareTransactionInput>;
};

export type SpareCategory = {
  __typename?: 'SpareCategory';
  id: Scalars['Float'];
  is_deletable: Scalars['Boolean'];
  name: Scalars['String'];
  spares: Array<Spare>;
};

export type SpareCategoryUpsertInput = {
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type SpareOperation = {
  __typename?: 'SpareOperation';
  date?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  id: Scalars['Float'];
  is_adjustment?: Maybe<Scalars['Int']>;
  is_deletable: Scalars['Boolean'];
  is_withdrawal?: Maybe<Scalars['Int']>;
  spare_transactions: Array<SpareTransaction>;
};

export type SpareTransaction = {
  __typename?: 'SpareTransaction';
  id: Scalars['Float'];
  quantity: Scalars['Float'];
  spare?: Maybe<Spare>;
  spare_id?: Maybe<Scalars['Int']>;
  spare_operation?: Maybe<SpareOperation>;
  spare_operation_id?: Maybe<Scalars['Int']>;
};

export type SpareTransactionInput = {
  quantity: Scalars['Float'];
  spare_id?: InputMaybe<Scalars['Int']>;
  spare_operation_id?: InputMaybe<Scalars['Int']>;
};

export type SpareUpsertInput = {
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  spare_category_id?: InputMaybe<Scalars['Int']>;
};

export type SpareWithdrawalUpsertInput = {
  date?: InputMaybe<Scalars['DateTime']>;
  description: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  spare_transactions: Array<SpareTransactionInput>;
};

export type Subscription = {
  __typename?: 'Subscription';
  account: Account;
  activity: Activity;
  employee: Employee;
  expense: Expense;
  expense_resource: ExpenseResource;
  machine: Machine;
  order_adjustment: OrderAdjustment;
  order_production: OrderProduction;
  order_quotation: OrderQuotation;
  order_request: OrderRequest;
  order_sale: OrderSale;
  product: Product;
  resource: Resource;
  transfer: Transfer;
  user: User;
};

export type ThirdPartyAccountTransferSummary = {
  __typename?: 'ThirdPartyAccountTransferSummary';
  account?: Maybe<Account>;
  account_id?: Maybe<Scalars['Int']>;
  expenses_total?: Maybe<Scalars['Float']>;
  transfer_receipts_total?: Maybe<Scalars['Float']>;
};

export type Transfer = {
  __typename?: 'Transfer';
  amount: Scalars['Float'];
  created_by?: Maybe<User>;
  created_by_id?: Maybe<Scalars['Int']>;
  expected_date?: Maybe<Scalars['DateTime']>;
  from_account?: Maybe<Account>;
  from_account_id?: Maybe<Scalars['Int']>;
  id: Scalars['Float'];
  is_deletable: Scalars['Boolean'];
  is_editable: Scalars['Boolean'];
  notes: Scalars['String'];
  to_account?: Maybe<Account>;
  to_account_id?: Maybe<Scalars['Int']>;
  transfer_receipts: Array<TransferReceipt>;
  transfer_receipts_total: Scalars['Float'];
  transfer_type?: Maybe<TransferType>;
  transfer_type_id?: Maybe<Scalars['Int']>;
  transferred: Scalars['Boolean'];
  transferred_date: Scalars['DateTime'];
  updated_by?: Maybe<User>;
  updated_by_id?: Maybe<Scalars['Int']>;
};

export type TransferReceipt = {
  __typename?: 'TransferReceipt';
  amount: Scalars['Float'];
  expense?: Maybe<Expense>;
  expense_id?: Maybe<Scalars['Int']>;
  id: Scalars['Float'];
  order_sale?: Maybe<OrderSale>;
  order_sale_id?: Maybe<Scalars['Int']>;
  transfer?: Maybe<Transfer>;
  transfer_id?: Maybe<Scalars['Int']>;
};

export type TransferReceiptInput = {
  amount: Scalars['Float'];
  expense_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  order_sale_id?: InputMaybe<Scalars['Int']>;
};

export type TransferType = {
  __typename?: 'TransferType';
  id: Scalars['Float'];
  name: Scalars['String'];
};

export type TransferUpsertInput = {
  amount: Scalars['Float'];
  expected_date?: InputMaybe<Scalars['DateTime']>;
  from_account_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  notes: Scalars['String'];
  to_account_id?: InputMaybe<Scalars['Int']>;
  transfer_receipts?: InputMaybe<Array<TransferReceiptInput>>;
  transfer_type_id?: InputMaybe<Scalars['Int']>;
  transferred: Scalars['Boolean'];
  transferred_date: Scalars['DateTime'];
};

export type TransfersRecord = {
  __typename?: 'TransfersRecord';
  account_abbreviation?: Maybe<Scalars['String']>;
  account_id?: Maybe<Scalars['Int']>;
  account_name?: Maybe<Scalars['String']>;
  day?: Maybe<Scalars['Int']>;
  month?: Maybe<Scalars['Int']>;
  total: Scalars['Float'];
  year: Scalars['Int'];
};

export enum TransfersSortableFields {
  TransferredDate = 'transferred_date'
}

export type TransfersSummary = {
  __typename?: 'TransfersSummary';
  transfers: Array<TransfersRecord>;
};

export type TransfersSummaryArgs = {
  date_group_by: DateGroupBy;
  entity_groups: Array<TransfersSummaryEntitiesGroup>;
  month?: InputMaybe<Scalars['Int']>;
  year?: InputMaybe<Scalars['Int']>;
};

export enum TransfersSummaryEntitiesGroup {
  Account = 'account'
}

export type UpdateUserInput = {
  email: Scalars['String'];
  first_name: Scalars['String'];
  id: Scalars['Float'];
  last_name: Scalars['String'];
  login_disabled?: InputMaybe<Scalars['Boolean']>;
  mfa_enabled?: InputMaybe<Scalars['Boolean']>;
  password?: InputMaybe<Scalars['String']>;
  roles: Array<RoleInput>;
};

export type User = {
  __typename?: 'User';
  email: Scalars['String'];
  first_name: Scalars['String'];
  fullname: Scalars['String'];
  id: Scalars['Float'];
  is_root: Scalars['Boolean'];
  last_name: Scalars['String'];
  login_disabled: Scalars['Boolean'];
  mfa_enabled: Scalars['Boolean'];
  role_ids: Array<RoleId>;
  roles: Array<Role>;
};

export type UserConfig = {
  __typename?: 'UserConfig';
  dark_mode: Scalars['Boolean'];
  id: Scalars['Int'];
  user_id: Scalars['Int'];
};

export type WasteRecord = {
  __typename?: 'WasteRecord';
  day?: Maybe<Scalars['Int']>;
  month: Scalars['Int'];
  order_production_type_id?: Maybe<Scalars['Int']>;
  order_production_type_name?: Maybe<Scalars['String']>;
  waste: Scalars['Float'];
  year: Scalars['Int'];
};

export type WeeklyAuditRun = {
  __typename?: 'WeeklyAuditRun';
  branch_id?: Maybe<Scalars['Int']>;
  branch_name: Scalars['String'];
  date?: Maybe<Scalars['DateTime']>;
  employee_names: Scalars['String'];
  groups: Scalars['Float'];
  hours: Scalars['Float'];
  kilos: Scalars['Float'];
  machine_id: Scalars['Int'];
  machine_name: Scalars['String'];
  order_production_id: Scalars['Int'];
  product_count: Scalars['Int'];
  product_description: Scalars['String'];
  product_id: Scalars['Int'];
  shift?: Maybe<Scalars['Int']>;
  waste_share: Scalars['Float'];
};

export const SalesVsExpensesHistoricExpensesFragmentFragmentDoc = gql`
    fragment SalesVsExpensesHistoricExpensesFragment on ExpensesSummary {
  expenses {
    year
    month
    total
    total_with_tax
  }
}
    `;
export const SalesVsExpensesHistoricSalesFragmentFragmentDoc = gql`
    fragment SalesVsExpensesHistoricSalesFragment on SalesSummary {
  sales {
    year
    month
    total
    total_with_tax
  }
}
    `;
export const ProductDocument = gql`
    subscription Product {
  product {
    id
  }
}
    `;

/**
 * __useProductSubscription__
 *
 * To run a query within a React component, call `useProductSubscription` and pass it any options that fit your needs.
 * When your component renders, `useProductSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductSubscription({
 *   variables: {
 *   },
 * });
 */
export function useProductSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ProductSubscription, ProductSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ProductSubscription, ProductSubscriptionVariables>(ProductDocument, options);
      }
export type ProductSubscriptionHookResult = ReturnType<typeof useProductSubscription>;
export type ProductSubscriptionResult = Apollo.SubscriptionResult<ProductSubscription>;
export const OrderProductionDocument = gql`
    subscription OrderProduction {
  order_production {
    id
  }
}
    `;

/**
 * __useOrderProductionSubscription__
 *
 * To run a query within a React component, call `useOrderProductionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOrderProductionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderProductionSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOrderProductionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OrderProductionSubscription, OrderProductionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OrderProductionSubscription, OrderProductionSubscriptionVariables>(OrderProductionDocument, options);
      }
export type OrderProductionSubscriptionHookResult = ReturnType<typeof useOrderProductionSubscription>;
export type OrderProductionSubscriptionResult = Apollo.SubscriptionResult<OrderProductionSubscription>;
export const MachineDocument = gql`
    subscription Machine {
  machine {
    id
  }
}
    `;

/**
 * __useMachineSubscription__
 *
 * To run a query within a React component, call `useMachineSubscription` and pass it any options that fit your needs.
 * When your component renders, `useMachineSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMachineSubscription({
 *   variables: {
 *   },
 * });
 */
export function useMachineSubscription(baseOptions?: Apollo.SubscriptionHookOptions<MachineSubscription, MachineSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<MachineSubscription, MachineSubscriptionVariables>(MachineDocument, options);
      }
export type MachineSubscriptionHookResult = ReturnType<typeof useMachineSubscription>;
export type MachineSubscriptionResult = Apollo.SubscriptionResult<MachineSubscription>;
export const OrderAdjustmentDocument = gql`
    subscription OrderAdjustment {
  order_adjustment {
    id
  }
}
    `;

/**
 * __useOrderAdjustmentSubscription__
 *
 * To run a query within a React component, call `useOrderAdjustmentSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOrderAdjustmentSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderAdjustmentSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOrderAdjustmentSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OrderAdjustmentSubscription, OrderAdjustmentSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OrderAdjustmentSubscription, OrderAdjustmentSubscriptionVariables>(OrderAdjustmentDocument, options);
      }
export type OrderAdjustmentSubscriptionHookResult = ReturnType<typeof useOrderAdjustmentSubscription>;
export type OrderAdjustmentSubscriptionResult = Apollo.SubscriptionResult<OrderAdjustmentSubscription>;
export const EmployeeDocument = gql`
    subscription Employee {
  employee {
    id
  }
}
    `;

/**
 * __useEmployeeSubscription__
 *
 * To run a query within a React component, call `useEmployeeSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeSubscription({
 *   variables: {
 *   },
 * });
 */
export function useEmployeeSubscription(baseOptions?: Apollo.SubscriptionHookOptions<EmployeeSubscription, EmployeeSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<EmployeeSubscription, EmployeeSubscriptionVariables>(EmployeeDocument, options);
      }
export type EmployeeSubscriptionHookResult = ReturnType<typeof useEmployeeSubscription>;
export type EmployeeSubscriptionResult = Apollo.SubscriptionResult<EmployeeSubscription>;
export const ExpensesDocument = gql`
    subscription Expenses {
  expense {
    id
  }
}
    `;

/**
 * __useExpensesSubscription__
 *
 * To run a query within a React component, call `useExpensesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useExpensesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpensesSubscription({
 *   variables: {
 *   },
 * });
 */
export function useExpensesSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ExpensesSubscription, ExpensesSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ExpensesSubscription, ExpensesSubscriptionVariables>(ExpensesDocument, options);
      }
export type ExpensesSubscriptionHookResult = ReturnType<typeof useExpensesSubscription>;
export type ExpensesSubscriptionResult = Apollo.SubscriptionResult<ExpensesSubscription>;
export const ResourcesDocument = gql`
    subscription Resources {
  resource {
    id
  }
}
    `;

/**
 * __useResourcesSubscription__
 *
 * To run a query within a React component, call `useResourcesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useResourcesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourcesSubscription({
 *   variables: {
 *   },
 * });
 */
export function useResourcesSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ResourcesSubscription, ResourcesSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ResourcesSubscription, ResourcesSubscriptionVariables>(ResourcesDocument, options);
      }
export type ResourcesSubscriptionHookResult = ReturnType<typeof useResourcesSubscription>;
export type ResourcesSubscriptionResult = Apollo.SubscriptionResult<ResourcesSubscription>;
export const OrderRequestDocument = gql`
    subscription OrderRequest {
  order_request {
    id
  }
}
    `;

/**
 * __useOrderRequestSubscription__
 *
 * To run a query within a React component, call `useOrderRequestSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOrderRequestSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderRequestSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOrderRequestSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OrderRequestSubscription, OrderRequestSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OrderRequestSubscription, OrderRequestSubscriptionVariables>(OrderRequestDocument, options);
      }
export type OrderRequestSubscriptionHookResult = ReturnType<typeof useOrderRequestSubscription>;
export type OrderRequestSubscriptionResult = Apollo.SubscriptionResult<OrderRequestSubscription>;
export const OrderQuotationDocument = gql`
    subscription OrderQuotation {
  order_quotation {
    id
  }
}
    `;

/**
 * __useOrderQuotationSubscription__
 *
 * To run a query within a React component, call `useOrderQuotationSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOrderQuotationSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderQuotationSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOrderQuotationSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OrderQuotationSubscription, OrderQuotationSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OrderQuotationSubscription, OrderQuotationSubscriptionVariables>(OrderQuotationDocument, options);
      }
export type OrderQuotationSubscriptionHookResult = ReturnType<typeof useOrderQuotationSubscription>;
export type OrderQuotationSubscriptionResult = Apollo.SubscriptionResult<OrderQuotationSubscription>;
export const OrderSaleDocument = gql`
    subscription OrderSale {
  order_sale {
    id
  }
}
    `;

/**
 * __useOrderSaleSubscription__
 *
 * To run a query within a React component, call `useOrderSaleSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOrderSaleSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderSaleSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOrderSaleSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OrderSaleSubscription, OrderSaleSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OrderSaleSubscription, OrderSaleSubscriptionVariables>(OrderSaleDocument, options);
      }
export type OrderSaleSubscriptionHookResult = ReturnType<typeof useOrderSaleSubscription>;
export type OrderSaleSubscriptionResult = Apollo.SubscriptionResult<OrderSaleSubscription>;
export const AccountDocument = gql`
    subscription Account {
  account {
    id
  }
}
    `;

/**
 * __useAccountSubscription__
 *
 * To run a query within a React component, call `useAccountSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAccountSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountSubscription({
 *   variables: {
 *   },
 * });
 */
export function useAccountSubscription(baseOptions?: Apollo.SubscriptionHookOptions<AccountSubscription, AccountSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<AccountSubscription, AccountSubscriptionVariables>(AccountDocument, options);
      }
export type AccountSubscriptionHookResult = ReturnType<typeof useAccountSubscription>;
export type AccountSubscriptionResult = Apollo.SubscriptionResult<AccountSubscription>;
export const ActivityDocument = gql`
    subscription Activity {
  activity {
    created_at
    type
    entity_name
    title
    snapshot_status
  }
}
    `;

/**
 * __useActivitySubscription__
 *
 * To run a query within a React component, call `useActivitySubscription` and pass it any options that fit your needs.
 * When your component renders, `useActivitySubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivitySubscription({
 *   variables: {
 *   },
 * });
 */
export function useActivitySubscription(baseOptions?: Apollo.SubscriptionHookOptions<ActivitySubscription, ActivitySubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ActivitySubscription, ActivitySubscriptionVariables>(ActivityDocument, options);
      }
export type ActivitySubscriptionHookResult = ReturnType<typeof useActivitySubscription>;
export type ActivitySubscriptionResult = Apollo.SubscriptionResult<ActivitySubscription>;
export const UserDocument = gql`
    subscription User {
  user {
    id
  }
}
    `;

/**
 * __useUserSubscription__
 *
 * To run a query within a React component, call `useUserSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUserSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSubscription({
 *   variables: {
 *   },
 * });
 */
export function useUserSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UserSubscription, UserSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UserSubscription, UserSubscriptionVariables>(UserDocument, options);
      }
export type UserSubscriptionHookResult = ReturnType<typeof useUserSubscription>;
export type UserSubscriptionResult = Apollo.SubscriptionResult<UserSubscription>;
export const TransferDocument = gql`
    subscription Transfer {
  transfer {
    id
  }
}
    `;

/**
 * __useTransferSubscription__
 *
 * To run a query within a React component, call `useTransferSubscription` and pass it any options that fit your needs.
 * When your component renders, `useTransferSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransferSubscription({
 *   variables: {
 *   },
 * });
 */
export function useTransferSubscription(baseOptions?: Apollo.SubscriptionHookOptions<TransferSubscription, TransferSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<TransferSubscription, TransferSubscriptionVariables>(TransferDocument, options);
      }
export type TransferSubscriptionHookResult = ReturnType<typeof useTransferSubscription>;
export type TransferSubscriptionResult = Apollo.SubscriptionResult<TransferSubscription>;
export const ExpenseResourceDocument = gql`
    subscription ExpenseResource {
  expense_resource {
    id
  }
}
    `;

/**
 * __useExpenseResourceSubscription__
 *
 * To run a query within a React component, call `useExpenseResourceSubscription` and pass it any options that fit your needs.
 * When your component renders, `useExpenseResourceSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpenseResourceSubscription({
 *   variables: {
 *   },
 * });
 */
export function useExpenseResourceSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ExpenseResourceSubscription, ExpenseResourceSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ExpenseResourceSubscription, ExpenseResourceSubscriptionVariables>(ExpenseResourceDocument, options);
      }
export type ExpenseResourceSubscriptionHookResult = ReturnType<typeof useExpenseResourceSubscription>;
export type ExpenseResourceSubscriptionResult = Apollo.SubscriptionResult<ExpenseResourceSubscription>;
export const ActivitiesPageDocument = gql`
    query ActivitiesPage($skip: Float!, $take: Float!, $startDate: String, $endDate: String, $entityName: ActivityEntityName, $type: ActivityTypeName, $userId: Int) {
  paginatedActivities(
    skip: $skip
    take: $take
    start_date: $startDate
    end_date: $endDate
    entity_name: $entityName
    type: $type
    user_id: $userId
  ) {
    docs {
      id
      created_at
      entity_name
      entity_id
      title
      type
      snapshot_status
      user {
        id
        fullname
      }
    }
    count
  }
  users {
    id
    fullname
  }
}
    `;

/**
 * __useActivitiesPageQuery__
 *
 * To run a query within a React component, call `useActivitiesPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivitiesPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivitiesPageQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      entityName: // value for 'entityName'
 *      type: // value for 'type'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useActivitiesPageQuery(baseOptions: Apollo.QueryHookOptions<ActivitiesPageQuery, ActivitiesPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivitiesPageQuery, ActivitiesPageQueryVariables>(ActivitiesPageDocument, options);
      }
export function useActivitiesPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivitiesPageQuery, ActivitiesPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivitiesPageQuery, ActivitiesPageQueryVariables>(ActivitiesPageDocument, options);
        }
export type ActivitiesPageQueryHookResult = ReturnType<typeof useActivitiesPageQuery>;
export type ActivitiesPageLazyQueryHookResult = ReturnType<typeof useActivitiesPageLazyQuery>;
export type ActivitiesPageQueryResult = Apollo.QueryResult<ActivitiesPageQuery, ActivitiesPageQueryVariables>;
export function refetchActivitiesPageQuery(variables: ActivitiesPageQueryVariables) {
      return { query: ActivitiesPageDocument, variables: variables }
    }
export const UsersPageDocument = gql`
    query UsersPage {
  users {
    id
    fullname
    email
    first_name
    last_name
    mfa_enabled
    is_root
    login_disabled
    roles {
      name
      id
    }
  }
}
    `;

/**
 * __useUsersPageQuery__
 *
 * To run a query within a React component, call `useUsersPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useUsersPageQuery(baseOptions?: Apollo.QueryHookOptions<UsersPageQuery, UsersPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersPageQuery, UsersPageQueryVariables>(UsersPageDocument, options);
      }
export function useUsersPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersPageQuery, UsersPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersPageQuery, UsersPageQueryVariables>(UsersPageDocument, options);
        }
export type UsersPageQueryHookResult = ReturnType<typeof useUsersPageQuery>;
export type UsersPageLazyQueryHookResult = ReturnType<typeof useUsersPageLazyQuery>;
export type UsersPageQueryResult = Apollo.QueryResult<UsersPageQuery, UsersPageQueryVariables>;
export function refetchUsersPageQuery(variables?: UsersPageQueryVariables) {
      return { query: UsersPageDocument, variables: variables }
    }
export const DashboardProductionChartDocument = gql`
    query DashboardProductionChart($yearA: Int!, $monthA: Int, $yearB: Int!, $monthB: Int, $dateGroupBy: DateGroupBy!) {
  summaryA: getProductionSummary(
    ProductionSummaryArgs: {year: $yearA, month: $monthA, date_group_by: $dateGroupBy}
  ) {
    production {
      order_production_type_id
      order_production_type_name
      kilos
      year
      month
      day
    }
  }
  summaryB: getProductionSummary(
    ProductionSummaryArgs: {year: $yearB, month: $monthB, date_group_by: $dateGroupBy}
  ) {
    production {
      order_production_type_id
      order_production_type_name
      kilos
      year
      month
      day
    }
  }
}
    `;

/**
 * __useDashboardProductionChartQuery__
 *
 * To run a query within a React component, call `useDashboardProductionChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardProductionChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardProductionChartQuery({
 *   variables: {
 *      yearA: // value for 'yearA'
 *      monthA: // value for 'monthA'
 *      yearB: // value for 'yearB'
 *      monthB: // value for 'monthB'
 *      dateGroupBy: // value for 'dateGroupBy'
 *   },
 * });
 */
export function useDashboardProductionChartQuery(baseOptions: Apollo.QueryHookOptions<DashboardProductionChartQuery, DashboardProductionChartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardProductionChartQuery, DashboardProductionChartQueryVariables>(DashboardProductionChartDocument, options);
      }
export function useDashboardProductionChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardProductionChartQuery, DashboardProductionChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardProductionChartQuery, DashboardProductionChartQueryVariables>(DashboardProductionChartDocument, options);
        }
export type DashboardProductionChartQueryHookResult = ReturnType<typeof useDashboardProductionChartQuery>;
export type DashboardProductionChartLazyQueryHookResult = ReturnType<typeof useDashboardProductionChartLazyQuery>;
export type DashboardProductionChartQueryResult = Apollo.QueryResult<DashboardProductionChartQuery, DashboardProductionChartQueryVariables>;
export function refetchDashboardProductionChartQuery(variables: DashboardProductionChartQueryVariables) {
      return { query: DashboardProductionChartDocument, variables: variables }
    }
export const MachinePartPageDocument = gql`
    query MachinePartPage($machinePartId: Float!) {
  getMachinePart(MachinePartId: $machinePartId) {
    id
    name
    machine_compatibilities {
      id
      spare_id
      spare {
        name
        current_quantity
        total_required_quantity
      }
      is_current_spare
    }
    current_spare_id
    current_spare_required_quantity
    machine_section_id
    machine_section {
      name
      machine_id
    }
    machine_id
    machine {
      id
      name
    }
  }
}
    `;

/**
 * __useMachinePartPageQuery__
 *
 * To run a query within a React component, call `useMachinePartPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useMachinePartPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMachinePartPageQuery({
 *   variables: {
 *      machinePartId: // value for 'machinePartId'
 *   },
 * });
 */
export function useMachinePartPageQuery(baseOptions: Apollo.QueryHookOptions<MachinePartPageQuery, MachinePartPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MachinePartPageQuery, MachinePartPageQueryVariables>(MachinePartPageDocument, options);
      }
export function useMachinePartPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MachinePartPageQuery, MachinePartPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MachinePartPageQuery, MachinePartPageQueryVariables>(MachinePartPageDocument, options);
        }
export type MachinePartPageQueryHookResult = ReturnType<typeof useMachinePartPageQuery>;
export type MachinePartPageLazyQueryHookResult = ReturnType<typeof useMachinePartPageLazyQuery>;
export type MachinePartPageQueryResult = Apollo.QueryResult<MachinePartPageQuery, MachinePartPageQueryVariables>;
export function refetchMachinePartPageQuery(variables: MachinePartPageQueryVariables) {
      return { query: MachinePartPageDocument, variables: variables }
    }
export const MachineSectionPageDocument = gql`
    query MachineSectionPage($MachineSectionId: Float!) {
  getMachineSection(MachineSectionId: $MachineSectionId) {
    id
    name
    machine_id
    is_deletable
    machine_parts {
      id
      name
      current_spare {
        name
        current_quantity
      }
      current_spare_id
      machine_id
      machine_section_id
      current_spare_required_quantity
      machine_section {
        machine_id
      }
      machine_compatibilities {
        id
        is_current_spare
        spare_id
        spare {
          id
          name
          current_quantity
          total_required_quantity
        }
      }
    }
  }
}
    `;

/**
 * __useMachineSectionPageQuery__
 *
 * To run a query within a React component, call `useMachineSectionPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useMachineSectionPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMachineSectionPageQuery({
 *   variables: {
 *      MachineSectionId: // value for 'MachineSectionId'
 *   },
 * });
 */
export function useMachineSectionPageQuery(baseOptions: Apollo.QueryHookOptions<MachineSectionPageQuery, MachineSectionPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MachineSectionPageQuery, MachineSectionPageQueryVariables>(MachineSectionPageDocument, options);
      }
export function useMachineSectionPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MachineSectionPageQuery, MachineSectionPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MachineSectionPageQuery, MachineSectionPageQueryVariables>(MachineSectionPageDocument, options);
        }
export type MachineSectionPageQueryHookResult = ReturnType<typeof useMachineSectionPageQuery>;
export type MachineSectionPageLazyQueryHookResult = ReturnType<typeof useMachineSectionPageLazyQuery>;
export type MachineSectionPageQueryResult = Apollo.QueryResult<MachineSectionPageQuery, MachineSectionPageQueryVariables>;
export function refetchMachineSectionPageQuery(variables: MachineSectionPageQueryVariables) {
      return { query: MachineSectionPageDocument, variables: variables }
    }
export const MachinePageDocument = gql`
    query MachinePage($machineId: Float!) {
  getMachine(MachineId: $machineId) {
    id
    name
    discontinued
    machine_sections {
      id
      name
      machine_id
      is_deletable
      machine_parts {
        id
        name
        current_spare {
          id
          name
          current_quantity
        }
        current_spare_required_quantity
        machine_compatibilities {
          spare_id
          spare {
            name
          }
        }
      }
    }
    unassigned_parts {
      id
      name
      current_spare {
        id
        name
        current_quantity
      }
      machine_id
      current_spare_required_quantity
      machine_compatibilities {
        spare_id
        spare {
          name
        }
      }
    }
  }
}
    `;

/**
 * __useMachinePageQuery__
 *
 * To run a query within a React component, call `useMachinePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useMachinePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMachinePageQuery({
 *   variables: {
 *      machineId: // value for 'machineId'
 *   },
 * });
 */
export function useMachinePageQuery(baseOptions: Apollo.QueryHookOptions<MachinePageQuery, MachinePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MachinePageQuery, MachinePageQueryVariables>(MachinePageDocument, options);
      }
export function useMachinePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MachinePageQuery, MachinePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MachinePageQuery, MachinePageQueryVariables>(MachinePageDocument, options);
        }
export type MachinePageQueryHookResult = ReturnType<typeof useMachinePageQuery>;
export type MachinePageLazyQueryHookResult = ReturnType<typeof useMachinePageLazyQuery>;
export type MachinePageQueryResult = Apollo.QueryResult<MachinePageQuery, MachinePageQueryVariables>;
export function refetchMachinePageQuery(variables: MachinePageQueryVariables) {
      return { query: MachinePageDocument, variables: variables }
    }
export const MachinesPageDocument = gql`
    query MachinesPage($skip: Float!, $take: Float!, $filter: String!, $branchId: Int, $orderProductionTypeId: Int, $discontinued: Boolean) {
  paginatedMachines(
    skip: $skip
    take: $take
    filter: $filter
    branch_id: $branchId
    order_production_type_id: $orderProductionTypeId
    discontinued: $discontinued
  ) {
    docs {
      id
      name
      completion
      discontinued
      order_production_type_id
      is_deletable
      order_production_type {
        name
      }
      branch {
        name
      }
      machine_parts {
        id
        name
        current_spare_required_quantity
        current_spare {
          id
          current_quantity
          name
        }
        machine_section_id
        machine_section {
          name
        }
        machine_compatibilities {
          spare_id
          spare {
            current_quantity
            name
          }
        }
      }
      updated_by {
        fullname
      }
    }
    count
  }
  getBranches {
    id
    name
  }
  getOrderProductionTypes {
    id
    name
  }
}
    `;

/**
 * __useMachinesPageQuery__
 *
 * To run a query within a React component, call `useMachinesPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useMachinesPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMachinesPageQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      filter: // value for 'filter'
 *      branchId: // value for 'branchId'
 *      orderProductionTypeId: // value for 'orderProductionTypeId'
 *      discontinued: // value for 'discontinued'
 *   },
 * });
 */
export function useMachinesPageQuery(baseOptions: Apollo.QueryHookOptions<MachinesPageQuery, MachinesPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MachinesPageQuery, MachinesPageQueryVariables>(MachinesPageDocument, options);
      }
export function useMachinesPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MachinesPageQuery, MachinesPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MachinesPageQuery, MachinesPageQueryVariables>(MachinesPageDocument, options);
        }
export type MachinesPageQueryHookResult = ReturnType<typeof useMachinesPageQuery>;
export type MachinesPageLazyQueryHookResult = ReturnType<typeof useMachinesPageLazyQuery>;
export type MachinesPageQueryResult = Apollo.QueryResult<MachinesPageQuery, MachinesPageQueryVariables>;
export function refetchMachinesPageQuery(variables: MachinesPageQueryVariables) {
      return { query: MachinesPageDocument, variables: variables }
    }
export const SpareAdjustmentPageDocument = gql`
    query SpareAdjustmentPage($SpareAdjustmentId: Float!) {
  getSpareOperation(SpareOperationId: $SpareAdjustmentId) {
    id
    date
    description
    is_deletable
    spare_transactions {
      spare_id
      quantity
      spare {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useSpareAdjustmentPageQuery__
 *
 * To run a query within a React component, call `useSpareAdjustmentPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpareAdjustmentPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpareAdjustmentPageQuery({
 *   variables: {
 *      SpareAdjustmentId: // value for 'SpareAdjustmentId'
 *   },
 * });
 */
export function useSpareAdjustmentPageQuery(baseOptions: Apollo.QueryHookOptions<SpareAdjustmentPageQuery, SpareAdjustmentPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SpareAdjustmentPageQuery, SpareAdjustmentPageQueryVariables>(SpareAdjustmentPageDocument, options);
      }
export function useSpareAdjustmentPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SpareAdjustmentPageQuery, SpareAdjustmentPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SpareAdjustmentPageQuery, SpareAdjustmentPageQueryVariables>(SpareAdjustmentPageDocument, options);
        }
export type SpareAdjustmentPageQueryHookResult = ReturnType<typeof useSpareAdjustmentPageQuery>;
export type SpareAdjustmentPageLazyQueryHookResult = ReturnType<typeof useSpareAdjustmentPageLazyQuery>;
export type SpareAdjustmentPageQueryResult = Apollo.QueryResult<SpareAdjustmentPageQuery, SpareAdjustmentPageQueryVariables>;
export function refetchSpareAdjustmentPageQuery(variables: SpareAdjustmentPageQueryVariables) {
      return { query: SpareAdjustmentPageDocument, variables: variables }
    }
export const SpareAdjustmentsPageDocument = gql`
    query SpareAdjustmentsPage {
  getSpareAdjustments {
    id
    date
    description
    is_deletable
    spare_transactions {
      spare_id
      quantity
      spare {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useSpareAdjustmentsPageQuery__
 *
 * To run a query within a React component, call `useSpareAdjustmentsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpareAdjustmentsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpareAdjustmentsPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useSpareAdjustmentsPageQuery(baseOptions?: Apollo.QueryHookOptions<SpareAdjustmentsPageQuery, SpareAdjustmentsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SpareAdjustmentsPageQuery, SpareAdjustmentsPageQueryVariables>(SpareAdjustmentsPageDocument, options);
      }
export function useSpareAdjustmentsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SpareAdjustmentsPageQuery, SpareAdjustmentsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SpareAdjustmentsPageQuery, SpareAdjustmentsPageQueryVariables>(SpareAdjustmentsPageDocument, options);
        }
export type SpareAdjustmentsPageQueryHookResult = ReturnType<typeof useSpareAdjustmentsPageQuery>;
export type SpareAdjustmentsPageLazyQueryHookResult = ReturnType<typeof useSpareAdjustmentsPageLazyQuery>;
export type SpareAdjustmentsPageQueryResult = Apollo.QueryResult<SpareAdjustmentsPageQuery, SpareAdjustmentsPageQueryVariables>;
export function refetchSpareAdjustmentsPageQuery(variables?: SpareAdjustmentsPageQueryVariables) {
      return { query: SpareAdjustmentsPageDocument, variables: variables }
    }
export const SpareTransactionsPageDocument = gql`
    query SpareTransactionsPage($start_date: String, $end_date: String) {
  getSpareTransactions(start_date: $start_date, end_date: $end_date) {
    id
    quantity
    spare {
      id
      name
    }
    spare_operation {
      id
      description
      date
      is_adjustment
      is_withdrawal
    }
  }
}
    `;

/**
 * __useSpareTransactionsPageQuery__
 *
 * To run a query within a React component, call `useSpareTransactionsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpareTransactionsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpareTransactionsPageQuery({
 *   variables: {
 *      start_date: // value for 'start_date'
 *      end_date: // value for 'end_date'
 *   },
 * });
 */
export function useSpareTransactionsPageQuery(baseOptions?: Apollo.QueryHookOptions<SpareTransactionsPageQuery, SpareTransactionsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SpareTransactionsPageQuery, SpareTransactionsPageQueryVariables>(SpareTransactionsPageDocument, options);
      }
export function useSpareTransactionsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SpareTransactionsPageQuery, SpareTransactionsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SpareTransactionsPageQuery, SpareTransactionsPageQueryVariables>(SpareTransactionsPageDocument, options);
        }
export type SpareTransactionsPageQueryHookResult = ReturnType<typeof useSpareTransactionsPageQuery>;
export type SpareTransactionsPageLazyQueryHookResult = ReturnType<typeof useSpareTransactionsPageLazyQuery>;
export type SpareTransactionsPageQueryResult = Apollo.QueryResult<SpareTransactionsPageQuery, SpareTransactionsPageQueryVariables>;
export function refetchSpareTransactionsPageQuery(variables?: SpareTransactionsPageQueryVariables) {
      return { query: SpareTransactionsPageDocument, variables: variables }
    }
export const SpareCategoriesPageDocument = gql`
    query SpareCategoriesPage {
  getSpareCategories {
    id
    name
  }
}
    `;

/**
 * __useSpareCategoriesPageQuery__
 *
 * To run a query within a React component, call `useSpareCategoriesPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpareCategoriesPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpareCategoriesPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useSpareCategoriesPageQuery(baseOptions?: Apollo.QueryHookOptions<SpareCategoriesPageQuery, SpareCategoriesPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SpareCategoriesPageQuery, SpareCategoriesPageQueryVariables>(SpareCategoriesPageDocument, options);
      }
export function useSpareCategoriesPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SpareCategoriesPageQuery, SpareCategoriesPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SpareCategoriesPageQuery, SpareCategoriesPageQueryVariables>(SpareCategoriesPageDocument, options);
        }
export type SpareCategoriesPageQueryHookResult = ReturnType<typeof useSpareCategoriesPageQuery>;
export type SpareCategoriesPageLazyQueryHookResult = ReturnType<typeof useSpareCategoriesPageLazyQuery>;
export type SpareCategoriesPageQueryResult = Apollo.QueryResult<SpareCategoriesPageQuery, SpareCategoriesPageQueryVariables>;
export function refetchSpareCategoriesPageQuery(variables?: SpareCategoriesPageQueryVariables) {
      return { query: SpareCategoriesPageDocument, variables: variables }
    }
export const SpareCategoryPageDocument = gql`
    query SpareCategoryPage($SpareCategoryId: Float!) {
  getSpareCategory(SpareCategoryId: $SpareCategoryId) {
    id
    name
    is_deletable
    spares {
      name
      current_quantity
    }
  }
}
    `;

/**
 * __useSpareCategoryPageQuery__
 *
 * To run a query within a React component, call `useSpareCategoryPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpareCategoryPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpareCategoryPageQuery({
 *   variables: {
 *      SpareCategoryId: // value for 'SpareCategoryId'
 *   },
 * });
 */
export function useSpareCategoryPageQuery(baseOptions: Apollo.QueryHookOptions<SpareCategoryPageQuery, SpareCategoryPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SpareCategoryPageQuery, SpareCategoryPageQueryVariables>(SpareCategoryPageDocument, options);
      }
export function useSpareCategoryPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SpareCategoryPageQuery, SpareCategoryPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SpareCategoryPageQuery, SpareCategoryPageQueryVariables>(SpareCategoryPageDocument, options);
        }
export type SpareCategoryPageQueryHookResult = ReturnType<typeof useSpareCategoryPageQuery>;
export type SpareCategoryPageLazyQueryHookResult = ReturnType<typeof useSpareCategoryPageLazyQuery>;
export type SpareCategoryPageQueryResult = Apollo.QueryResult<SpareCategoryPageQuery, SpareCategoryPageQueryVariables>;
export function refetchSpareCategoryPageQuery(variables: SpareCategoryPageQueryVariables) {
      return { query: SpareCategoryPageDocument, variables: variables }
    }
export const SparePageDocument = gql`
    query SparePage($SpareId: Float!) {
  getSpare(SpareId: $SpareId) {
    id
    name
    is_deletable
    spare_category_id
    spare_transactions {
      quantity
      spare_operation {
        description
        date
      }
    }
  }
}
    `;

/**
 * __useSparePageQuery__
 *
 * To run a query within a React component, call `useSparePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSparePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSparePageQuery({
 *   variables: {
 *      SpareId: // value for 'SpareId'
 *   },
 * });
 */
export function useSparePageQuery(baseOptions: Apollo.QueryHookOptions<SparePageQuery, SparePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SparePageQuery, SparePageQueryVariables>(SparePageDocument, options);
      }
export function useSparePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SparePageQuery, SparePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SparePageQuery, SparePageQueryVariables>(SparePageDocument, options);
        }
export type SparePageQueryHookResult = ReturnType<typeof useSparePageQuery>;
export type SparePageLazyQueryHookResult = ReturnType<typeof useSparePageLazyQuery>;
export type SparePageQueryResult = Apollo.QueryResult<SparePageQuery, SparePageQueryVariables>;
export function refetchSparePageQuery(variables: SparePageQueryVariables) {
      return { query: SparePageDocument, variables: variables }
    }
export const SparesPageDocument = gql`
    query SparesPage {
  getSpares {
    id
    name
    is_deletable
    total_required_quantity
    current_quantity
    spare_category {
      id
      name
    }
  }
}
    `;

/**
 * __useSparesPageQuery__
 *
 * To run a query within a React component, call `useSparesPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSparesPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSparesPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useSparesPageQuery(baseOptions?: Apollo.QueryHookOptions<SparesPageQuery, SparesPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SparesPageQuery, SparesPageQueryVariables>(SparesPageDocument, options);
      }
export function useSparesPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SparesPageQuery, SparesPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SparesPageQuery, SparesPageQueryVariables>(SparesPageDocument, options);
        }
export type SparesPageQueryHookResult = ReturnType<typeof useSparesPageQuery>;
export type SparesPageLazyQueryHookResult = ReturnType<typeof useSparesPageLazyQuery>;
export type SparesPageQueryResult = Apollo.QueryResult<SparesPageQuery, SparesPageQueryVariables>;
export function refetchSparesPageQuery(variables?: SparesPageQueryVariables) {
      return { query: SparesPageDocument, variables: variables }
    }
export const AccountingPageDocument = gql`
    query AccountingPage($startDate: String, $endDate: String) {
  getAccounts {
    id
    name
    is_client
    is_own
    is_supplier
    is_informal_account
  }
  getReceiptTypes {
    id
    is_informal_receipt
  }
  getTransfers(start_date: $startDate, end_date: $endDate) {
    transfer_type_id
    from_account {
      id
      name
      is_client
      is_own
      is_supplier
    }
    to_account {
      id
      name
      is_client
      is_own
      is_supplier
    }
    amount
    transferred_date
    transfer_receipts {
      amount
      order_sale {
        id
        date
        canceled
        receipt_type_id
        order_code
        invoice_code
        require_invoice_code
        require_tax
        subtotal
        total_with_tax
        notes
        require_credit_note
        require_supplement
        credit_note_code
        credit_note_amount
        supplement_code
        tax
      }
      expense {
        id
        date
        canceled
        receipt_type_id
        external_code
        require_external_code
        require_tax
        total_with_tax
        tax
        notes
        tax_retained
        non_tax_retained
        require_supplement
        supplement_code
      }
    }
  }
  getOrderSales(
    start_date: $startDate
    end_date: $endDate
    sort_field: date
    sort_order: asc
  ) {
    id
    date
    account {
      name
      is_client
      is_own
      is_supplier
    }
    order_code
    canceled
    invoice_code
    require_invoice_code
    require_tax
    tax
    receipt_type_id
    subtotal
    total_with_tax
    transfer_receipts_total
    require_supplement
    supplement_code
    require_credit_note
    credit_note_code
    credit_note_amount
    transfer_receipts {
      id
      amount
      transfer {
        to_account {
          abbreviation
        }
        transferred_date
      }
    }
    notes
  }
  getExpenses(
    start_date: $startDate
    end_date: $endDate
    sort_field: date
    sort_order: asc
  ) {
    id
    date
    account {
      id
      name
      is_client
      is_own
      is_supplier
    }
    tax
    external_code
    require_external_code
    require_tax
    receipt_type_id
    subtotal
    total_with_tax
    tax_retained
    non_tax_retained
    notes
    transfer_receipts_total
    require_supplement
    supplement_code
    notes
    canceled
    transfer_receipts {
      id
      amount
      transfer {
        from_account {
          id
          abbreviation
        }
        to_account {
          id
        }
        transferred_date
      }
    }
  }
}
    `;

/**
 * __useAccountingPageQuery__
 *
 * To run a query within a React component, call `useAccountingPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountingPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountingPageQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useAccountingPageQuery(baseOptions?: Apollo.QueryHookOptions<AccountingPageQuery, AccountingPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountingPageQuery, AccountingPageQueryVariables>(AccountingPageDocument, options);
      }
export function useAccountingPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountingPageQuery, AccountingPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountingPageQuery, AccountingPageQueryVariables>(AccountingPageDocument, options);
        }
export type AccountingPageQueryHookResult = ReturnType<typeof useAccountingPageQuery>;
export type AccountingPageLazyQueryHookResult = ReturnType<typeof useAccountingPageLazyQuery>;
export type AccountingPageQueryResult = Apollo.QueryResult<AccountingPageQuery, AccountingPageQueryVariables>;
export function refetchAccountingPageQuery(variables?: AccountingPageQueryVariables) {
      return { query: AccountingPageDocument, variables: variables }
    }
export const AccountPageDocument = gql`
    query AccountPage($AccountId: Float!, $From: String, $Until: String) {
  getReceiptTypes {
    id
    applies_tax
  }
  getAccountOpeningBalance(AccountId: $AccountId, From: $From)
  getAccount(AccountId: $AccountId) {
    id
    name
    abbreviation
    is_client
    is_supplier
    account_contacts {
      id
      last_name
      first_name
      cellphone
      email
    }
  }
  getAccountProducts(AccountId: $AccountId) {
    id
    kilo_price
    group_price
    group_weight
    product {
      id
      compound_description
      discontinued
      product_category {
        id
        name
      }
    }
  }
  getAccountResources(AccountId: $AccountId) {
    id
    unit_price
    notes
    resource {
      id
      name
    }
  }
  getAccountTransactionHistory(AccountId: $AccountId, From: $From, Until: $Until) {
    id
    type
    order_code
    invoice_code
    date
    notes
    receipt_type_id
    total_with_tax
    transfer_receipts_total
  }
  getAccountTransfers(AccountId: $AccountId, From: $From, Until: $Until) {
    amount
    transferred_date
    notes
    parent_type
    parent_order_code
    parent_invoice_code
    parent_receipt_type_id
    parent_date
  }
}
    `;

/**
 * __useAccountPageQuery__
 *
 * To run a query within a React component, call `useAccountPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountPageQuery({
 *   variables: {
 *      AccountId: // value for 'AccountId'
 *      From: // value for 'From'
 *      Until: // value for 'Until'
 *   },
 * });
 */
export function useAccountPageQuery(baseOptions: Apollo.QueryHookOptions<AccountPageQuery, AccountPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountPageQuery, AccountPageQueryVariables>(AccountPageDocument, options);
      }
export function useAccountPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountPageQuery, AccountPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountPageQuery, AccountPageQueryVariables>(AccountPageDocument, options);
        }
export type AccountPageQueryHookResult = ReturnType<typeof useAccountPageQuery>;
export type AccountPageLazyQueryHookResult = ReturnType<typeof useAccountPageLazyQuery>;
export type AccountPageQueryResult = Apollo.QueryResult<AccountPageQuery, AccountPageQueryVariables>;
export function refetchAccountPageQuery(variables: AccountPageQueryVariables) {
      return { query: AccountPageDocument, variables: variables }
    }
export const AccountsPageDocument = gql`
    query AccountsPage($take: Float!, $skip: Float!, $filter: String!, $sortField: AccountsSortableFields, $sortOrder: ColumnOrder, $isClient: Boolean) {
  paginatedAccounts(
    take: $take
    skip: $skip
    filter: $filter
    is_client: $isClient
    sort_order: $sortOrder
    sort_field: $sortField
  ) {
    docs {
      id
      name
      abbreviation
      is_deletable
      is_client
      is_supplier
      is_own
      updated_by {
        fullname
      }
    }
    count
  }
}
    `;

/**
 * __useAccountsPageQuery__
 *
 * To run a query within a React component, call `useAccountsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountsPageQuery({
 *   variables: {
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      filter: // value for 'filter'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      isClient: // value for 'isClient'
 *   },
 * });
 */
export function useAccountsPageQuery(baseOptions: Apollo.QueryHookOptions<AccountsPageQuery, AccountsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountsPageQuery, AccountsPageQueryVariables>(AccountsPageDocument, options);
      }
export function useAccountsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountsPageQuery, AccountsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountsPageQuery, AccountsPageQueryVariables>(AccountsPageDocument, options);
        }
export type AccountsPageQueryHookResult = ReturnType<typeof useAccountsPageQuery>;
export type AccountsPageLazyQueryHookResult = ReturnType<typeof useAccountsPageLazyQuery>;
export type AccountsPageQueryResult = Apollo.QueryResult<AccountsPageQuery, AccountsPageQueryVariables>;
export function refetchAccountsPageQuery(variables: AccountsPageQueryVariables) {
      return { query: AccountsPageDocument, variables: variables }
    }
export const SalesVsExpensesHistoricPageDocument = gql`
    query SalesVsExpensesHistoricPage($year: Int, $month: Int, $yearMinusOne: Int, $includeReconciliationOnly: Boolean) {
  getExpensesTotalSummaryYearMinusOne: getExpensesSummary(
    ExpensesSummaryArgs: {year: $yearMinusOne, month: $month, date_group_by: month, entity_groups: [], include_reconciliation_only: $includeReconciliationOnly}
  ) {
    ...SalesVsExpensesHistoricExpensesFragment
  }
  getExpensesTotalSummaryYear: getExpensesSummary(
    ExpensesSummaryArgs: {year: $year, month: $month, date_group_by: month, entity_groups: [], include_reconciliation_only: $includeReconciliationOnly}
  ) {
    ...SalesVsExpensesHistoricExpensesFragment
  }
  getSalesTotalSummaryYearMinusOne: getSalesSummary(
    SalesSummaryArgs: {year: $yearMinusOne, month: $month, date_group_by: month, entity_groups: [], include_reconciliation_only: $includeReconciliationOnly}
  ) {
    ...SalesVsExpensesHistoricSalesFragment
  }
  getSalesTotalSummaryYear: getSalesSummary(
    SalesSummaryArgs: {year: $year, month: $month, date_group_by: month, entity_groups: [], include_reconciliation_only: $includeReconciliationOnly}
  ) {
    ...SalesVsExpensesHistoricSalesFragment
  }
}
    ${SalesVsExpensesHistoricExpensesFragmentFragmentDoc}
${SalesVsExpensesHistoricSalesFragmentFragmentDoc}`;

/**
 * __useSalesVsExpensesHistoricPageQuery__
 *
 * To run a query within a React component, call `useSalesVsExpensesHistoricPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesVsExpensesHistoricPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesVsExpensesHistoricPageQuery({
 *   variables: {
 *      year: // value for 'year'
 *      month: // value for 'month'
 *      yearMinusOne: // value for 'yearMinusOne'
 *      includeReconciliationOnly: // value for 'includeReconciliationOnly'
 *   },
 * });
 */
export function useSalesVsExpensesHistoricPageQuery(baseOptions?: Apollo.QueryHookOptions<SalesVsExpensesHistoricPageQuery, SalesVsExpensesHistoricPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SalesVsExpensesHistoricPageQuery, SalesVsExpensesHistoricPageQueryVariables>(SalesVsExpensesHistoricPageDocument, options);
      }
export function useSalesVsExpensesHistoricPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SalesVsExpensesHistoricPageQuery, SalesVsExpensesHistoricPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SalesVsExpensesHistoricPageQuery, SalesVsExpensesHistoricPageQueryVariables>(SalesVsExpensesHistoricPageDocument, options);
        }
export type SalesVsExpensesHistoricPageQueryHookResult = ReturnType<typeof useSalesVsExpensesHistoricPageQuery>;
export type SalesVsExpensesHistoricPageLazyQueryHookResult = ReturnType<typeof useSalesVsExpensesHistoricPageLazyQuery>;
export type SalesVsExpensesHistoricPageQueryResult = Apollo.QueryResult<SalesVsExpensesHistoricPageQuery, SalesVsExpensesHistoricPageQueryVariables>;
export function refetchSalesVsExpensesHistoricPageQuery(variables?: SalesVsExpensesHistoricPageQueryVariables) {
      return { query: SalesVsExpensesHistoricPageDocument, variables: variables }
    }
export const SalesVsExpensesPageDocument = gql`
    query SalesVsExpensesPage($year: Int, $month: Int) {
  getExpensesProductsSummaryByResourceCategory: getExpensesSummary(
    ExpensesSummaryArgs: {year: $year, month: $month, date_group_by: month, entity_groups: [resource_category], include_reconciliation_only: false}
  ) {
    expenses {
      total_with_tax
      total
      tax
      resource_category_name
      resource_category_id
      year
      month
      units_sold
    }
  }
  getExpensesProductsSummaryByAll: getExpensesSummary(
    ExpensesSummaryArgs: {year: $year, month: $month, date_group_by: month, entity_groups: [resource, resource_category, account], include_reconciliation_only: false}
  ) {
    expenses {
      total_with_tax
      total
      tax
      resource_category_name
      resource_category_id
      resource_name
      resource_id
      account_id
      account_name
      year
      month
      units_sold
    }
  }
  getSalesSummaryByCategory: getSalesSummary(
    SalesSummaryArgs: {year: $year, month: $month, date_group_by: month, entity_groups: [productCategory], include_reconciliation_only: false}
  ) {
    sales {
      year
      month
      product_category_id
      product_category_name
      tax
      kilos_sold
      groups_sold
      total
      total_with_tax
    }
  }
  getSalesProductsSummaryByAll: getSalesSummary(
    SalesSummaryArgs: {year: $year, month: $month, date_group_by: month, entity_groups: [productCategory, account], include_reconciliation_only: false}
  ) {
    sales {
      year
      month
      product_category_id
      product_category_name
      account_id
      account_name
      kilos_sold
      groups_sold
      tax
      total
      total_with_tax
    }
  }
  getExpensesOperationalSummary: getExpensesSummary(
    ExpensesSummaryArgs: {year: $year, month: $month, date_group_by: month, entity_groups: [], include_reconciliation_only: false}
  ) {
    expenses {
      year
      month
      total
      total_with_tax
      tax
      tax_retained
      non_tax_retained
      units_sold
    }
  }
  getExpensesTaxSummary: getExpensesSummary(
    ExpensesSummaryArgs: {year: $year, month: $month, date_group_by: month, entity_groups: [], include_reconciliation_only: true}
  ) {
    expenses {
      year
      month
      tax
      tax_retained
      non_tax_retained
    }
  }
  getSalesOperationalSummary: getSalesSummary(
    SalesSummaryArgs: {year: $year, month: $month, date_group_by: month, entity_groups: [], include_reconciliation_only: false}
  ) {
    sales {
      year
      month
      product_category_id
      product_category_name
      total
      total_with_tax
      tax
      kilos_sold
      groups_sold
    }
  }
  getSalesTaxSummary: getSalesSummary(
    SalesSummaryArgs: {year: $year, month: $month, date_group_by: month, entity_groups: [], include_reconciliation_only: true}
  ) {
    sales {
      year
      month
      tax
    }
  }
}
    `;

/**
 * __useSalesVsExpensesPageQuery__
 *
 * To run a query within a React component, call `useSalesVsExpensesPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesVsExpensesPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesVsExpensesPageQuery({
 *   variables: {
 *      year: // value for 'year'
 *      month: // value for 'month'
 *   },
 * });
 */
export function useSalesVsExpensesPageQuery(baseOptions?: Apollo.QueryHookOptions<SalesVsExpensesPageQuery, SalesVsExpensesPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SalesVsExpensesPageQuery, SalesVsExpensesPageQueryVariables>(SalesVsExpensesPageDocument, options);
      }
export function useSalesVsExpensesPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SalesVsExpensesPageQuery, SalesVsExpensesPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SalesVsExpensesPageQuery, SalesVsExpensesPageQueryVariables>(SalesVsExpensesPageDocument, options);
        }
export type SalesVsExpensesPageQueryHookResult = ReturnType<typeof useSalesVsExpensesPageQuery>;
export type SalesVsExpensesPageLazyQueryHookResult = ReturnType<typeof useSalesVsExpensesPageLazyQuery>;
export type SalesVsExpensesPageQueryResult = Apollo.QueryResult<SalesVsExpensesPageQuery, SalesVsExpensesPageQueryVariables>;
export function refetchSalesVsExpensesPageQuery(variables?: SalesVsExpensesPageQueryVariables) {
      return { query: SalesVsExpensesPageDocument, variables: variables }
    }
export const BalancesPageDocument = gql`
    query BalancesPage {
  getOrderSalesWithDisparities {
    receipt_type_id
    id
    expected_payment_date
    date
    compound_order_code
    order_code
    subtotal
    total_with_tax
    net_total_with_tax
    transfer_receipts_total
    notes
    account {
      compound_name
      name
    }
    invoice_code
    order_sale_products {
      groups
      kilos
    }
  }
  getExpensesWithDisparities {
    id
    expected_payment_date
    date
    external_code
    subtotal
    transfer_receipts_total
    receipt_type_id
    total_with_tax
    notes
    is_draft
    account {
      name
      compound_name
    }
    expense_resources {
      id
      resource {
        id
        name
      }
    }
  }
  getOwnAccountsTransferSummary {
    account_id
    account {
      id
      name
      compound_name
      is_informal_account
    }
    current_amount
  }
  getReceiptTypes {
    id
    is_informal_receipt
  }
}
    `;

/**
 * __useBalancesPageQuery__
 *
 * To run a query within a React component, call `useBalancesPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useBalancesPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBalancesPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useBalancesPageQuery(baseOptions?: Apollo.QueryHookOptions<BalancesPageQuery, BalancesPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BalancesPageQuery, BalancesPageQueryVariables>(BalancesPageDocument, options);
      }
export function useBalancesPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BalancesPageQuery, BalancesPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BalancesPageQuery, BalancesPageQueryVariables>(BalancesPageDocument, options);
        }
export type BalancesPageQueryHookResult = ReturnType<typeof useBalancesPageQuery>;
export type BalancesPageLazyQueryHookResult = ReturnType<typeof useBalancesPageLazyQuery>;
export type BalancesPageQueryResult = Apollo.QueryResult<BalancesPageQuery, BalancesPageQueryVariables>;
export function refetchBalancesPageQuery(variables?: BalancesPageQueryVariables) {
      return { query: BalancesPageDocument, variables: variables }
    }
export const ExpensesSummaryPageDocument = gql`
    query ExpensesSummaryPage($year: Int, $previousYear: Int, $includeReconciliationOnly: Boolean, $includeCanceled: Boolean) {
  currentYearByAccount: getExpensesSummary(
    ExpensesSummaryArgs: {year: $year, month: null, date_group_by: month, entity_groups: [account, resource], include_reconciliation_only: $includeReconciliationOnly, include_canceled: $includeCanceled}
  ) {
    expenses {
      year
      month
      total
      account_id
      account_name
      resource_id
      resource_name
    }
  }
  currentYearByCategory: getExpensesSummary(
    ExpensesSummaryArgs: {year: $year, month: null, date_group_by: month, entity_groups: [resource_category, resource], include_reconciliation_only: $includeReconciliationOnly, include_canceled: $includeCanceled}
  ) {
    expenses {
      year
      month
      total
      resource_category_id
      resource_category_name
      resource_id
      resource_name
    }
  }
  previousYearByAccount: getExpensesSummary(
    ExpensesSummaryArgs: {year: $previousYear, month: null, date_group_by: month, entity_groups: [account, resource], include_reconciliation_only: $includeReconciliationOnly, include_canceled: $includeCanceled}
  ) {
    expenses {
      year
      month
      total
      account_id
      account_name
      resource_id
      resource_name
    }
  }
  previousYearByCategory: getExpensesSummary(
    ExpensesSummaryArgs: {year: $previousYear, month: null, date_group_by: month, entity_groups: [resource_category, resource], include_reconciliation_only: $includeReconciliationOnly, include_canceled: $includeCanceled}
  ) {
    expenses {
      year
      month
      total
      resource_category_id
      resource_category_name
      resource_id
      resource_name
    }
  }
}
    `;

/**
 * __useExpensesSummaryPageQuery__
 *
 * To run a query within a React component, call `useExpensesSummaryPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpensesSummaryPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpensesSummaryPageQuery({
 *   variables: {
 *      year: // value for 'year'
 *      previousYear: // value for 'previousYear'
 *      includeReconciliationOnly: // value for 'includeReconciliationOnly'
 *      includeCanceled: // value for 'includeCanceled'
 *   },
 * });
 */
export function useExpensesSummaryPageQuery(baseOptions?: Apollo.QueryHookOptions<ExpensesSummaryPageQuery, ExpensesSummaryPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExpensesSummaryPageQuery, ExpensesSummaryPageQueryVariables>(ExpensesSummaryPageDocument, options);
      }
export function useExpensesSummaryPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpensesSummaryPageQuery, ExpensesSummaryPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExpensesSummaryPageQuery, ExpensesSummaryPageQueryVariables>(ExpensesSummaryPageDocument, options);
        }
export type ExpensesSummaryPageQueryHookResult = ReturnType<typeof useExpensesSummaryPageQuery>;
export type ExpensesSummaryPageLazyQueryHookResult = ReturnType<typeof useExpensesSummaryPageLazyQuery>;
export type ExpensesSummaryPageQueryResult = Apollo.QueryResult<ExpensesSummaryPageQuery, ExpensesSummaryPageQueryVariables>;
export function refetchExpensesSummaryPageQuery(variables?: ExpensesSummaryPageQueryVariables) {
      return { query: ExpensesSummaryPageDocument, variables: variables }
    }
export const ExpensesSummarySuppliersDocument = gql`
    query ExpensesSummarySuppliers {
  getAccounts(is_supplier: true) {
    id
    name
    supplier_recurring_expenses
  }
}
    `;

/**
 * __useExpensesSummarySuppliersQuery__
 *
 * To run a query within a React component, call `useExpensesSummarySuppliersQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpensesSummarySuppliersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpensesSummarySuppliersQuery({
 *   variables: {
 *   },
 * });
 */
export function useExpensesSummarySuppliersQuery(baseOptions?: Apollo.QueryHookOptions<ExpensesSummarySuppliersQuery, ExpensesSummarySuppliersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExpensesSummarySuppliersQuery, ExpensesSummarySuppliersQueryVariables>(ExpensesSummarySuppliersDocument, options);
      }
export function useExpensesSummarySuppliersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpensesSummarySuppliersQuery, ExpensesSummarySuppliersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExpensesSummarySuppliersQuery, ExpensesSummarySuppliersQueryVariables>(ExpensesSummarySuppliersDocument, options);
        }
export type ExpensesSummarySuppliersQueryHookResult = ReturnType<typeof useExpensesSummarySuppliersQuery>;
export type ExpensesSummarySuppliersLazyQueryHookResult = ReturnType<typeof useExpensesSummarySuppliersLazyQuery>;
export type ExpensesSummarySuppliersQueryResult = Apollo.QueryResult<ExpensesSummarySuppliersQuery, ExpensesSummarySuppliersQueryVariables>;
export function refetchExpensesSummarySuppliersQuery(variables?: ExpensesSummarySuppliersQueryVariables) {
      return { query: ExpensesSummarySuppliersDocument, variables: variables }
    }
export const ExpensesPageDocument = gql`
    query ExpensesPage($skip: Float!, $take: Float!, $startDate: String, $endDate: String, $filter: String!, $accountId: Int, $resourceId: Int, $sortField: ExpensesSortableFields, $sortOrder: ColumnOrder, $noReceipt: Boolean!, $noSupplement: Boolean!, $isTransferComplete: Boolean!) {
  paginatedExpenses(
    skip: $skip
    take: $take
    start_date: $startDate
    end_date: $endDate
    filter: $filter
    sort_field: $sortField
    account_id: $accountId
    resource_id: $resourceId
    sort_order: $sortOrder
    no_receipt: $noReceipt
    no_supplement: $noSupplement
    is_transfer_incomplete: $isTransferComplete
  ) {
    docs {
      id
      locked
      canceled
      reconciliation_only
      generated_from_expense_id
      date
      expected_payment_date
      account_id
      supplement_code
      require_supplement
      is_deletable
      notes
      is_draft
      account {
        id
        compound_name
      }
      external_code
      require_external_code
      internal_code
      subtotal
      total_with_tax
      tax
      receipt_type {
        name
      }
      expense_resources {
        id
        units
        unit_price
        notes
        resource {
          id
          name
        }
      }
      transfer_receipts {
        amount
        transfer {
          transferred_date
        }
      }
      transfer_receipts_total
      transfer_receipts_total_no_adjustments
      updated_by {
        fullname
      }
    }
    count
  }
  getAccounts(is_supplier: true) {
    id
    name
    compound_name
  }
  getResources {
    id
    name
  }
}
    `;

/**
 * __useExpensesPageQuery__
 *
 * To run a query within a React component, call `useExpensesPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpensesPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpensesPageQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      filter: // value for 'filter'
 *      accountId: // value for 'accountId'
 *      resourceId: // value for 'resourceId'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      noReceipt: // value for 'noReceipt'
 *      noSupplement: // value for 'noSupplement'
 *      isTransferComplete: // value for 'isTransferComplete'
 *   },
 * });
 */
export function useExpensesPageQuery(baseOptions: Apollo.QueryHookOptions<ExpensesPageQuery, ExpensesPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExpensesPageQuery, ExpensesPageQueryVariables>(ExpensesPageDocument, options);
      }
export function useExpensesPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpensesPageQuery, ExpensesPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExpensesPageQuery, ExpensesPageQueryVariables>(ExpensesPageDocument, options);
        }
export type ExpensesPageQueryHookResult = ReturnType<typeof useExpensesPageQuery>;
export type ExpensesPageLazyQueryHookResult = ReturnType<typeof useExpensesPageLazyQuery>;
export type ExpensesPageQueryResult = Apollo.QueryResult<ExpensesPageQuery, ExpensesPageQueryVariables>;
export function refetchExpensesPageQuery(variables: ExpensesPageQueryVariables) {
      return { query: ExpensesPageDocument, variables: variables }
    }
export const ResourcesPageDocument = gql`
    query ResourcesPage($take: Float!, $skip: Float!, $filter: String!, $sortField: ResourcesSortableFields, $sortOrder: ColumnOrder) {
  paginatedResources(
    take: $take
    skip: $skip
    filter: $filter
    sort_order: $sortOrder
    sort_field: $sortField
  ) {
    docs {
      id
      name
      is_deletable
      is_editable
      resource_category {
        id
        name
      }
      updated_by {
        fullname
      }
    }
    count
  }
}
    `;

/**
 * __useResourcesPageQuery__
 *
 * To run a query within a React component, call `useResourcesPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourcesPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourcesPageQuery({
 *   variables: {
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      filter: // value for 'filter'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useResourcesPageQuery(baseOptions: Apollo.QueryHookOptions<ResourcesPageQuery, ResourcesPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourcesPageQuery, ResourcesPageQueryVariables>(ResourcesPageDocument, options);
      }
export function useResourcesPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourcesPageQuery, ResourcesPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourcesPageQuery, ResourcesPageQueryVariables>(ResourcesPageDocument, options);
        }
export type ResourcesPageQueryHookResult = ReturnType<typeof useResourcesPageQuery>;
export type ResourcesPageLazyQueryHookResult = ReturnType<typeof useResourcesPageLazyQuery>;
export type ResourcesPageQueryResult = Apollo.QueryResult<ResourcesPageQuery, ResourcesPageQueryVariables>;
export function refetchResourcesPageQuery(variables: ResourcesPageQueryVariables) {
      return { query: ResourcesPageDocument, variables: variables }
    }
export const ThirdPartyBalancesPageDocument = gql`
    query ThirdPartyBalancesPage {
  getReceiptTypes {
    id
    name
    applies_tax
  }
  getThirdPartyAccountsTransferSummary(monitor_supplier_expenses: true) {
    account_id
    account {
      id
      name
      compound_name
    }
    expenses_total
    transfer_receipts_total
  }
  getExpensesWithDisparities(monitor_supplier_expenses: true) {
    date
    external_code
    receipt_type_id
    resources_total
    total_with_tax
    id
    subtotal
    tax
    notes
    is_draft
    expense_resources {
      resource {
        name
      }
      units
      unit_price
      notes
      date
      id
    }
    transfer_receipts_total
    account_id
  }
}
    `;

/**
 * __useThirdPartyBalancesPageQuery__
 *
 * To run a query within a React component, call `useThirdPartyBalancesPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useThirdPartyBalancesPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThirdPartyBalancesPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useThirdPartyBalancesPageQuery(baseOptions?: Apollo.QueryHookOptions<ThirdPartyBalancesPageQuery, ThirdPartyBalancesPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ThirdPartyBalancesPageQuery, ThirdPartyBalancesPageQueryVariables>(ThirdPartyBalancesPageDocument, options);
      }
export function useThirdPartyBalancesPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ThirdPartyBalancesPageQuery, ThirdPartyBalancesPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ThirdPartyBalancesPageQuery, ThirdPartyBalancesPageQueryVariables>(ThirdPartyBalancesPageDocument, options);
        }
export type ThirdPartyBalancesPageQueryHookResult = ReturnType<typeof useThirdPartyBalancesPageQuery>;
export type ThirdPartyBalancesPageLazyQueryHookResult = ReturnType<typeof useThirdPartyBalancesPageLazyQuery>;
export type ThirdPartyBalancesPageQueryResult = Apollo.QueryResult<ThirdPartyBalancesPageQuery, ThirdPartyBalancesPageQueryVariables>;
export function refetchThirdPartyBalancesPageQuery(variables?: ThirdPartyBalancesPageQueryVariables) {
      return { query: ThirdPartyBalancesPageDocument, variables: variables }
    }
export const TransfersPageDocument = gql`
    query TransfersPage($skip: Float!, $take: Float!, $startDate: String, $endDate: String, $filter: String!, $sortField: TransfersSortableFields, $sortOrder: ColumnOrder, $accountId: Int, $transferTypeId: Int, $excludeReconciliationOnly: Boolean) {
  paginatedTransfers(
    skip: $skip
    take: $take
    start_date: $startDate
    end_date: $endDate
    filter: $filter
    sort_field: $sortField
    sort_order: $sortOrder
    account_id: $accountId
    transfer_type_id: $transferTypeId
    exclude_reconciliation_only: $excludeReconciliationOnly
  ) {
    docs {
      id
      amount
      to_account_id
      from_account_id
      transfer_type_id
      expected_date
      transferred_date
      transferred
      notes
      transfer_receipts_total
      transfer_receipts {
        order_sale {
          compound_order_code
        }
        expense {
          external_code
        }
      }
      from_account {
        id
        name
      }
      to_account {
        id
        name
      }
      transfer_type {
        id
        name
      }
      updated_by {
        fullname
      }
    }
    count
  }
  getAccounts {
    id
    name
    compound_name
  }
  getTransferTypes {
    id
    name
  }
  getOwnAccountsTransferSummary {
    account {
      id
      name
    }
    account_id
    current_amount
  }
}
    `;

/**
 * __useTransfersPageQuery__
 *
 * To run a query within a React component, call `useTransfersPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransfersPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransfersPageQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      filter: // value for 'filter'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      accountId: // value for 'accountId'
 *      transferTypeId: // value for 'transferTypeId'
 *      excludeReconciliationOnly: // value for 'excludeReconciliationOnly'
 *   },
 * });
 */
export function useTransfersPageQuery(baseOptions: Apollo.QueryHookOptions<TransfersPageQuery, TransfersPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransfersPageQuery, TransfersPageQueryVariables>(TransfersPageDocument, options);
      }
export function useTransfersPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransfersPageQuery, TransfersPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransfersPageQuery, TransfersPageQueryVariables>(TransfersPageDocument, options);
        }
export type TransfersPageQueryHookResult = ReturnType<typeof useTransfersPageQuery>;
export type TransfersPageLazyQueryHookResult = ReturnType<typeof useTransfersPageLazyQuery>;
export type TransfersPageQueryResult = Apollo.QueryResult<TransfersPageQuery, TransfersPageQueryVariables>;
export function refetchTransfersPageQuery(variables: TransfersPageQueryVariables) {
      return { query: TransfersPageDocument, variables: variables }
    }
export const GetPayrollPeriodsDocument = gql`
    query GetPayrollPeriods($branch_id: Int) {
  getPayrollPeriods(branch_id: $branch_id) {
    id
    start_date
    end_date
    week_number
    branch_id
    updated_at
  }
}
    `;

/**
 * __useGetPayrollPeriodsQuery__
 *
 * To run a query within a React component, call `useGetPayrollPeriodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayrollPeriodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayrollPeriodsQuery({
 *   variables: {
 *      branch_id: // value for 'branch_id'
 *   },
 * });
 */
export function useGetPayrollPeriodsQuery(baseOptions?: Apollo.QueryHookOptions<GetPayrollPeriodsQuery, GetPayrollPeriodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPayrollPeriodsQuery, GetPayrollPeriodsQueryVariables>(GetPayrollPeriodsDocument, options);
      }
export function useGetPayrollPeriodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPayrollPeriodsQuery, GetPayrollPeriodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPayrollPeriodsQuery, GetPayrollPeriodsQueryVariables>(GetPayrollPeriodsDocument, options);
        }
export type GetPayrollPeriodsQueryHookResult = ReturnType<typeof useGetPayrollPeriodsQuery>;
export type GetPayrollPeriodsLazyQueryHookResult = ReturnType<typeof useGetPayrollPeriodsLazyQuery>;
export type GetPayrollPeriodsQueryResult = Apollo.QueryResult<GetPayrollPeriodsQuery, GetPayrollPeriodsQueryVariables>;
export function refetchGetPayrollPeriodsQuery(variables?: GetPayrollPeriodsQueryVariables) {
      return { query: GetPayrollPeriodsDocument, variables: variables }
    }
export const GetPayrollEntriesDocument = gql`
    query GetPayrollEntries($PayrollPeriodId: Int!) {
  getPayrollEntries(PayrollPeriodId: $PayrollPeriodId) {
    id
    payroll_period_id
    employee_id
    employee_name
    estatus
    area
    is_leader
    control_bono_area
    control_deposito
    sueldo
    jo
    ht
    he
    he_override
    retardos
    faltas
    vac
    dias_festivos
    infonavit
    fonacot
    descuento_prestamos
    otros_menos
    entregas_especiales
    viajes
    bonos
    otros_mas
    bd
    observaciones
    he_effective
    hn
    he_pay
    fest_pay
    vac_pay
    prima_vac
    puntualidad
    asistencia
    bp
    total_plus
    total_minus
    total
  }
}
    `;

/**
 * __useGetPayrollEntriesQuery__
 *
 * To run a query within a React component, call `useGetPayrollEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayrollEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayrollEntriesQuery({
 *   variables: {
 *      PayrollPeriodId: // value for 'PayrollPeriodId'
 *   },
 * });
 */
export function useGetPayrollEntriesQuery(baseOptions: Apollo.QueryHookOptions<GetPayrollEntriesQuery, GetPayrollEntriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPayrollEntriesQuery, GetPayrollEntriesQueryVariables>(GetPayrollEntriesDocument, options);
      }
export function useGetPayrollEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPayrollEntriesQuery, GetPayrollEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPayrollEntriesQuery, GetPayrollEntriesQueryVariables>(GetPayrollEntriesDocument, options);
        }
export type GetPayrollEntriesQueryHookResult = ReturnType<typeof useGetPayrollEntriesQuery>;
export type GetPayrollEntriesLazyQueryHookResult = ReturnType<typeof useGetPayrollEntriesLazyQuery>;
export type GetPayrollEntriesQueryResult = Apollo.QueryResult<GetPayrollEntriesQuery, GetPayrollEntriesQueryVariables>;
export function refetchGetPayrollEntriesQuery(variables: GetPayrollEntriesQueryVariables) {
      return { query: GetPayrollEntriesDocument, variables: variables }
    }
export const UpsertPayrollPeriodDocument = gql`
    mutation UpsertPayrollPeriod($PayrollPeriodInput: PayrollPeriodInput!) {
  upsertPayrollPeriod(PayrollPeriodInput: $PayrollPeriodInput) {
    id
  }
}
    `;
export type UpsertPayrollPeriodMutationFn = Apollo.MutationFunction<UpsertPayrollPeriodMutation, UpsertPayrollPeriodMutationVariables>;

/**
 * __useUpsertPayrollPeriodMutation__
 *
 * To run a mutation, you first call `useUpsertPayrollPeriodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPayrollPeriodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPayrollPeriodMutation, { data, loading, error }] = useUpsertPayrollPeriodMutation({
 *   variables: {
 *      PayrollPeriodInput: // value for 'PayrollPeriodInput'
 *   },
 * });
 */
export function useUpsertPayrollPeriodMutation(baseOptions?: Apollo.MutationHookOptions<UpsertPayrollPeriodMutation, UpsertPayrollPeriodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertPayrollPeriodMutation, UpsertPayrollPeriodMutationVariables>(UpsertPayrollPeriodDocument, options);
      }
export type UpsertPayrollPeriodMutationHookResult = ReturnType<typeof useUpsertPayrollPeriodMutation>;
export type UpsertPayrollPeriodMutationResult = Apollo.MutationResult<UpsertPayrollPeriodMutation>;
export type UpsertPayrollPeriodMutationOptions = Apollo.BaseMutationOptions<UpsertPayrollPeriodMutation, UpsertPayrollPeriodMutationVariables>;
export const DeletePayrollPeriodDocument = gql`
    mutation DeletePayrollPeriod($PayrollPeriodId: Int!) {
  deletePayrollPeriod(PayrollPeriodId: $PayrollPeriodId)
}
    `;
export type DeletePayrollPeriodMutationFn = Apollo.MutationFunction<DeletePayrollPeriodMutation, DeletePayrollPeriodMutationVariables>;

/**
 * __useDeletePayrollPeriodMutation__
 *
 * To run a mutation, you first call `useDeletePayrollPeriodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePayrollPeriodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePayrollPeriodMutation, { data, loading, error }] = useDeletePayrollPeriodMutation({
 *   variables: {
 *      PayrollPeriodId: // value for 'PayrollPeriodId'
 *   },
 * });
 */
export function useDeletePayrollPeriodMutation(baseOptions?: Apollo.MutationHookOptions<DeletePayrollPeriodMutation, DeletePayrollPeriodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePayrollPeriodMutation, DeletePayrollPeriodMutationVariables>(DeletePayrollPeriodDocument, options);
      }
export type DeletePayrollPeriodMutationHookResult = ReturnType<typeof useDeletePayrollPeriodMutation>;
export type DeletePayrollPeriodMutationResult = Apollo.MutationResult<DeletePayrollPeriodMutation>;
export type DeletePayrollPeriodMutationOptions = Apollo.BaseMutationOptions<DeletePayrollPeriodMutation, DeletePayrollPeriodMutationVariables>;
export const UpsertPayrollEntryDocument = gql`
    mutation UpsertPayrollEntry($PayrollEntryInput: PayrollEntryInput!) {
  upsertPayrollEntry(PayrollEntryInput: $PayrollEntryInput) {
    id
  }
}
    `;
export type UpsertPayrollEntryMutationFn = Apollo.MutationFunction<UpsertPayrollEntryMutation, UpsertPayrollEntryMutationVariables>;

/**
 * __useUpsertPayrollEntryMutation__
 *
 * To run a mutation, you first call `useUpsertPayrollEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPayrollEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPayrollEntryMutation, { data, loading, error }] = useUpsertPayrollEntryMutation({
 *   variables: {
 *      PayrollEntryInput: // value for 'PayrollEntryInput'
 *   },
 * });
 */
export function useUpsertPayrollEntryMutation(baseOptions?: Apollo.MutationHookOptions<UpsertPayrollEntryMutation, UpsertPayrollEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertPayrollEntryMutation, UpsertPayrollEntryMutationVariables>(UpsertPayrollEntryDocument, options);
      }
export type UpsertPayrollEntryMutationHookResult = ReturnType<typeof useUpsertPayrollEntryMutation>;
export type UpsertPayrollEntryMutationResult = Apollo.MutationResult<UpsertPayrollEntryMutation>;
export type UpsertPayrollEntryMutationOptions = Apollo.BaseMutationOptions<UpsertPayrollEntryMutation, UpsertPayrollEntryMutationVariables>;
export const DeletePayrollEntryDocument = gql`
    mutation DeletePayrollEntry($PayrollEntryId: Int!) {
  deletePayrollEntry(PayrollEntryId: $PayrollEntryId)
}
    `;
export type DeletePayrollEntryMutationFn = Apollo.MutationFunction<DeletePayrollEntryMutation, DeletePayrollEntryMutationVariables>;

/**
 * __useDeletePayrollEntryMutation__
 *
 * To run a mutation, you first call `useDeletePayrollEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePayrollEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePayrollEntryMutation, { data, loading, error }] = useDeletePayrollEntryMutation({
 *   variables: {
 *      PayrollEntryId: // value for 'PayrollEntryId'
 *   },
 * });
 */
export function useDeletePayrollEntryMutation(baseOptions?: Apollo.MutationHookOptions<DeletePayrollEntryMutation, DeletePayrollEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePayrollEntryMutation, DeletePayrollEntryMutationVariables>(DeletePayrollEntryDocument, options);
      }
export type DeletePayrollEntryMutationHookResult = ReturnType<typeof useDeletePayrollEntryMutation>;
export type DeletePayrollEntryMutationResult = Apollo.MutationResult<DeletePayrollEntryMutation>;
export type DeletePayrollEntryMutationOptions = Apollo.BaseMutationOptions<DeletePayrollEntryMutation, DeletePayrollEntryMutationVariables>;
export const EmployeePageDocument = gql`
    query EmployeePage($EmployeeId: Float!) {
  getEmployee(EmployeeId: $EmployeeId) {
    id
    fullname
    first_name
    last_name
    order_production_type_id
    is_inactive
    branch_id
  }
}
    `;

/**
 * __useEmployeePageQuery__
 *
 * To run a query within a React component, call `useEmployeePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeePageQuery({
 *   variables: {
 *      EmployeeId: // value for 'EmployeeId'
 *   },
 * });
 */
export function useEmployeePageQuery(baseOptions: Apollo.QueryHookOptions<EmployeePageQuery, EmployeePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeePageQuery, EmployeePageQueryVariables>(EmployeePageDocument, options);
      }
export function useEmployeePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeePageQuery, EmployeePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeePageQuery, EmployeePageQueryVariables>(EmployeePageDocument, options);
        }
export type EmployeePageQueryHookResult = ReturnType<typeof useEmployeePageQuery>;
export type EmployeePageLazyQueryHookResult = ReturnType<typeof useEmployeePageLazyQuery>;
export type EmployeePageQueryResult = Apollo.QueryResult<EmployeePageQuery, EmployeePageQueryVariables>;
export function refetchEmployeePageQuery(variables: EmployeePageQueryVariables) {
      return { query: EmployeePageDocument, variables: variables }
    }
export const EmployeesPageDocument = gql`
    query EmployeesPage($take: Float!, $skip: Float!, $filter: String!, $sortField: PaginatedEmployeesSortableFields, $sortOrder: ColumnOrder, $branchId: Int, $orderProductionTypeId: Int) {
  paginatedEmployees(
    take: $take
    skip: $skip
    filter: $filter
    sort_order: $sortOrder
    sort_field: $sortField
    branch_id: $branchId
    order_production_type_id: $orderProductionTypeId
  ) {
    docs {
      id
      first_name
      last_name
      is_deletable
      is_leader
      order_production_type {
        id
        name
      }
      branch {
        id
        name
      }
      is_inactive
      updated_by {
        fullname
      }
    }
    count
  }
  getBranches {
    id
    name
  }
  getOrderProductionTypes {
    id
    name
  }
}
    `;

/**
 * __useEmployeesPageQuery__
 *
 * To run a query within a React component, call `useEmployeesPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeesPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeesPageQuery({
 *   variables: {
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      filter: // value for 'filter'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      branchId: // value for 'branchId'
 *      orderProductionTypeId: // value for 'orderProductionTypeId'
 *   },
 * });
 */
export function useEmployeesPageQuery(baseOptions: Apollo.QueryHookOptions<EmployeesPageQuery, EmployeesPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeesPageQuery, EmployeesPageQueryVariables>(EmployeesPageDocument, options);
      }
export function useEmployeesPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeesPageQuery, EmployeesPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeesPageQuery, EmployeesPageQueryVariables>(EmployeesPageDocument, options);
        }
export type EmployeesPageQueryHookResult = ReturnType<typeof useEmployeesPageQuery>;
export type EmployeesPageLazyQueryHookResult = ReturnType<typeof useEmployeesPageLazyQuery>;
export type EmployeesPageQueryResult = Apollo.QueryResult<EmployeesPageQuery, EmployeesPageQueryVariables>;
export function refetchEmployeesPageQuery(variables: EmployeesPageQueryVariables) {
      return { query: EmployeesPageDocument, variables: variables }
    }
export const MaterialBalancePageDocument = gql`
    query MaterialBalancePage($year: Int!, $month: Int, $branchId: Int, $groupBy: MaterialBalanceGroupBy!) {
  getMaterialBalanceSummary(
    MaterialBalanceSummaryArgs: {year: $year, month: $month, branch_id: $branchId, group_by: $groupBy}
  ) {
    year
    month
    week
    day
    branch_id
    branch_name
    kilos_produced
    kilos_waste
    kilos_consumed
    kilos_difference
    difference_percentage
    runs_count
    runs_without_consumption
    runs_without_production
  }
  getBranches {
    id
    name
  }
}
    `;

/**
 * __useMaterialBalancePageQuery__
 *
 * To run a query within a React component, call `useMaterialBalancePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaterialBalancePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaterialBalancePageQuery({
 *   variables: {
 *      year: // value for 'year'
 *      month: // value for 'month'
 *      branchId: // value for 'branchId'
 *      groupBy: // value for 'groupBy'
 *   },
 * });
 */
export function useMaterialBalancePageQuery(baseOptions: Apollo.QueryHookOptions<MaterialBalancePageQuery, MaterialBalancePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MaterialBalancePageQuery, MaterialBalancePageQueryVariables>(MaterialBalancePageDocument, options);
      }
export function useMaterialBalancePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MaterialBalancePageQuery, MaterialBalancePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MaterialBalancePageQuery, MaterialBalancePageQueryVariables>(MaterialBalancePageDocument, options);
        }
export type MaterialBalancePageQueryHookResult = ReturnType<typeof useMaterialBalancePageQuery>;
export type MaterialBalancePageLazyQueryHookResult = ReturnType<typeof useMaterialBalancePageLazyQuery>;
export type MaterialBalancePageQueryResult = Apollo.QueryResult<MaterialBalancePageQuery, MaterialBalancePageQueryVariables>;
export function refetchMaterialBalancePageQuery(variables: MaterialBalancePageQueryVariables) {
      return { query: MaterialBalancePageDocument, variables: variables }
    }
export const MaterialBalanceMachinesDocument = gql`
    query MaterialBalanceMachines($year: Int!, $month: Int, $week: Int, $branchId: Int) {
  getMaterialBalanceByMachine(
    MaterialBalanceMachineArgs: {year: $year, month: $month, week: $week, branch_id: $branchId}
  ) {
    machine_id
    machine_name
    kilos_produced
    kilos_consumed
    kilos_difference
    difference_percentage
  }
}
    `;

/**
 * __useMaterialBalanceMachinesQuery__
 *
 * To run a query within a React component, call `useMaterialBalanceMachinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaterialBalanceMachinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaterialBalanceMachinesQuery({
 *   variables: {
 *      year: // value for 'year'
 *      month: // value for 'month'
 *      week: // value for 'week'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useMaterialBalanceMachinesQuery(baseOptions: Apollo.QueryHookOptions<MaterialBalanceMachinesQuery, MaterialBalanceMachinesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MaterialBalanceMachinesQuery, MaterialBalanceMachinesQueryVariables>(MaterialBalanceMachinesDocument, options);
      }
export function useMaterialBalanceMachinesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MaterialBalanceMachinesQuery, MaterialBalanceMachinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MaterialBalanceMachinesQuery, MaterialBalanceMachinesQueryVariables>(MaterialBalanceMachinesDocument, options);
        }
export type MaterialBalanceMachinesQueryHookResult = ReturnType<typeof useMaterialBalanceMachinesQuery>;
export type MaterialBalanceMachinesLazyQueryHookResult = ReturnType<typeof useMaterialBalanceMachinesLazyQuery>;
export type MaterialBalanceMachinesQueryResult = Apollo.QueryResult<MaterialBalanceMachinesQuery, MaterialBalanceMachinesQueryVariables>;
export function refetchMaterialBalanceMachinesQuery(variables: MaterialBalanceMachinesQueryVariables) {
      return { query: MaterialBalanceMachinesDocument, variables: variables }
    }
export const MaterialBalanceExceptionsDocument = gql`
    query MaterialBalanceExceptions($year: Int!, $month: Int, $branchId: Int) {
  getMaterialBalanceExceptions(
    MaterialBalanceExceptionsArgs: {year: $year, month: $month, branch_id: $branchId}
  ) {
    runs_without_consumption {
      order_production_id
      start_date
      shift
      branch_name
      machine_names
      kilos_produced
      kilos_waste
      kilos_consumed
    }
    runs_without_production {
      order_production_id
      start_date
      shift
      branch_name
      machine_names
      kilos_produced
      kilos_waste
      kilos_consumed
    }
    products_packed {
      product_id
      product_description
      kilos_packed
      kilos_cut
      kilos_sold
    }
  }
}
    `;

/**
 * __useMaterialBalanceExceptionsQuery__
 *
 * To run a query within a React component, call `useMaterialBalanceExceptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaterialBalanceExceptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaterialBalanceExceptionsQuery({
 *   variables: {
 *      year: // value for 'year'
 *      month: // value for 'month'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useMaterialBalanceExceptionsQuery(baseOptions: Apollo.QueryHookOptions<MaterialBalanceExceptionsQuery, MaterialBalanceExceptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MaterialBalanceExceptionsQuery, MaterialBalanceExceptionsQueryVariables>(MaterialBalanceExceptionsDocument, options);
      }
export function useMaterialBalanceExceptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MaterialBalanceExceptionsQuery, MaterialBalanceExceptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MaterialBalanceExceptionsQuery, MaterialBalanceExceptionsQueryVariables>(MaterialBalanceExceptionsDocument, options);
        }
export type MaterialBalanceExceptionsQueryHookResult = ReturnType<typeof useMaterialBalanceExceptionsQuery>;
export type MaterialBalanceExceptionsLazyQueryHookResult = ReturnType<typeof useMaterialBalanceExceptionsLazyQuery>;
export type MaterialBalanceExceptionsQueryResult = Apollo.QueryResult<MaterialBalanceExceptionsQuery, MaterialBalanceExceptionsQueryVariables>;
export function refetchMaterialBalanceExceptionsQuery(variables: MaterialBalanceExceptionsQueryVariables) {
      return { query: MaterialBalanceExceptionsDocument, variables: variables }
    }
export const OrderAdjustmentPageDocument = gql`
    query OrderAdjustmentPage($OrderAdjustmentId: Float!) {
  getOrderAdjustment(OrderAdjustmentId: $OrderAdjustmentId) {
    id
    date
    order_adjustment_type_id
    order_adjustment_type {
      id
      name
    }
    order_adjustment_products {
      id
      kilos
      groups
      group_weight
      product {
        id
        compound_description
        current_group_weight
      }
    }
  }
}
    `;

/**
 * __useOrderAdjustmentPageQuery__
 *
 * To run a query within a React component, call `useOrderAdjustmentPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderAdjustmentPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderAdjustmentPageQuery({
 *   variables: {
 *      OrderAdjustmentId: // value for 'OrderAdjustmentId'
 *   },
 * });
 */
export function useOrderAdjustmentPageQuery(baseOptions: Apollo.QueryHookOptions<OrderAdjustmentPageQuery, OrderAdjustmentPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderAdjustmentPageQuery, OrderAdjustmentPageQueryVariables>(OrderAdjustmentPageDocument, options);
      }
export function useOrderAdjustmentPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderAdjustmentPageQuery, OrderAdjustmentPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderAdjustmentPageQuery, OrderAdjustmentPageQueryVariables>(OrderAdjustmentPageDocument, options);
        }
export type OrderAdjustmentPageQueryHookResult = ReturnType<typeof useOrderAdjustmentPageQuery>;
export type OrderAdjustmentPageLazyQueryHookResult = ReturnType<typeof useOrderAdjustmentPageLazyQuery>;
export type OrderAdjustmentPageQueryResult = Apollo.QueryResult<OrderAdjustmentPageQuery, OrderAdjustmentPageQueryVariables>;
export function refetchOrderAdjustmentPageQuery(variables: OrderAdjustmentPageQueryVariables) {
      return { query: OrderAdjustmentPageDocument, variables: variables }
    }
export const OrderAdjustmentsPageDocument = gql`
    query OrderAdjustmentsPage($skip: Float!, $take: Float!, $startDate: String, $endDate: String, $orderAdjustmentTypeId: Int, $productId: Int, $filter: String) {
  paginatedOrderAdjustments(
    skip: $skip
    take: $take
    start_date: $startDate
    end_date: $endDate
    order_adjustment_type_id: $orderAdjustmentTypeId
    product_id: $productId
    filter: $filter
  ) {
    count
    docs {
      id
      date
      updated_at
      is_deletable
      order_adjustment_type {
        id
        name
      }
      order_sale {
        order_code
        invoice_code
        subtotal
        tax
        order_sale_products {
          product_id
          kilo_price
          group_price
        }
        account {
          name
        }
      }
      order_adjustment_products {
        id
        kilos
        groups
        product_id
        product {
          compound_description
        }
      }
      updated_by {
        fullname
      }
    }
  }
  getOrderAdjustmentTypes {
    id
    name
  }
}
    `;

/**
 * __useOrderAdjustmentsPageQuery__
 *
 * To run a query within a React component, call `useOrderAdjustmentsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderAdjustmentsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderAdjustmentsPageQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      orderAdjustmentTypeId: // value for 'orderAdjustmentTypeId'
 *      productId: // value for 'productId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOrderAdjustmentsPageQuery(baseOptions: Apollo.QueryHookOptions<OrderAdjustmentsPageQuery, OrderAdjustmentsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderAdjustmentsPageQuery, OrderAdjustmentsPageQueryVariables>(OrderAdjustmentsPageDocument, options);
      }
export function useOrderAdjustmentsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderAdjustmentsPageQuery, OrderAdjustmentsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderAdjustmentsPageQuery, OrderAdjustmentsPageQueryVariables>(OrderAdjustmentsPageDocument, options);
        }
export type OrderAdjustmentsPageQueryHookResult = ReturnType<typeof useOrderAdjustmentsPageQuery>;
export type OrderAdjustmentsPageLazyQueryHookResult = ReturnType<typeof useOrderAdjustmentsPageLazyQuery>;
export type OrderAdjustmentsPageQueryResult = Apollo.QueryResult<OrderAdjustmentsPageQuery, OrderAdjustmentsPageQueryVariables>;
export function refetchOrderAdjustmentsPageQuery(variables: OrderAdjustmentsPageQueryVariables) {
      return { query: OrderAdjustmentsPageDocument, variables: variables }
    }
export const OrderProductionPageDocument = gql`
    query OrderProductionPage($OrderProductionId: Float!) {
  getOrderProduction(OrderProductionId: $OrderProductionId) {
    id
    start_date
    branch_id
    order_production_type_id
    order_production_products {
      product_id
      machine_id
      machine {
        id
        name
        branch_id
        order_production_type_id
      }
      product {
        id
        current_group_weight
        compound_description
        order_production_type_id
      }
      id
      kilos
      group_weight
      groups
    }
    order_production_employees {
      is_leader
      employee {
        id
        fullname
        is_inactive
        order_production_type_id
        branch_id
      }
    }
  }
}
    `;

/**
 * __useOrderProductionPageQuery__
 *
 * To run a query within a React component, call `useOrderProductionPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderProductionPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderProductionPageQuery({
 *   variables: {
 *      OrderProductionId: // value for 'OrderProductionId'
 *   },
 * });
 */
export function useOrderProductionPageQuery(baseOptions: Apollo.QueryHookOptions<OrderProductionPageQuery, OrderProductionPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderProductionPageQuery, OrderProductionPageQueryVariables>(OrderProductionPageDocument, options);
      }
export function useOrderProductionPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderProductionPageQuery, OrderProductionPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderProductionPageQuery, OrderProductionPageQueryVariables>(OrderProductionPageDocument, options);
        }
export type OrderProductionPageQueryHookResult = ReturnType<typeof useOrderProductionPageQuery>;
export type OrderProductionPageLazyQueryHookResult = ReturnType<typeof useOrderProductionPageLazyQuery>;
export type OrderProductionPageQueryResult = Apollo.QueryResult<OrderProductionPageQuery, OrderProductionPageQueryVariables>;
export function refetchOrderProductionPageQuery(variables: OrderProductionPageQueryVariables) {
      return { query: OrderProductionPageDocument, variables: variables }
    }
export const OrderProductionsPageDocument = gql`
    query OrderProductionsPage($skip: Float!, $take: Float!, $startDate: String, $endDate: String, $branchId: Int, $orderProductionTypeId: Int, $machineId: Int, $productId: Int, $filter: String) {
  paginatedOrderProductions(
    skip: $skip
    take: $take
    start_date: $startDate
    end_date: $endDate
    branch_id: $branchId
    order_production_type_id: $orderProductionTypeId
    machine_id: $machineId
    product_id: $productId
    filter: $filter
  ) {
    docs {
      updated_at
      id
      start_date
      waste
      is_deletable
      shift
      order_production_type {
        name
      }
      branch {
        name
      }
      order_production_products {
        machine {
          id
          name
        }
        kilos
        groups
        hours
        product {
          id
          compound_description
        }
      }
      order_production_employees {
        employee {
          fullname
        }
      }
      updated_by {
        fullname
      }
    }
    count
  }
  getBranches {
    id
    name
  }
  getOrderProductionTypes {
    id
    name
  }
  getMachines {
    id
    name
  }
}
    `;

/**
 * __useOrderProductionsPageQuery__
 *
 * To run a query within a React component, call `useOrderProductionsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderProductionsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderProductionsPageQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      branchId: // value for 'branchId'
 *      orderProductionTypeId: // value for 'orderProductionTypeId'
 *      machineId: // value for 'machineId'
 *      productId: // value for 'productId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOrderProductionsPageQuery(baseOptions: Apollo.QueryHookOptions<OrderProductionsPageQuery, OrderProductionsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderProductionsPageQuery, OrderProductionsPageQueryVariables>(OrderProductionsPageDocument, options);
      }
export function useOrderProductionsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderProductionsPageQuery, OrderProductionsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderProductionsPageQuery, OrderProductionsPageQueryVariables>(OrderProductionsPageDocument, options);
        }
export type OrderProductionsPageQueryHookResult = ReturnType<typeof useOrderProductionsPageQuery>;
export type OrderProductionsPageLazyQueryHookResult = ReturnType<typeof useOrderProductionsPageLazyQuery>;
export type OrderProductionsPageQueryResult = Apollo.QueryResult<OrderProductionsPageQuery, OrderProductionsPageQueryVariables>;
export function refetchOrderProductionsPageQuery(variables: OrderProductionsPageQueryVariables) {
      return { query: OrderProductionsPageDocument, variables: variables }
    }
export const ProductInventoryMovementsDocument = gql`
    query ProductInventoryMovements($product_id: Int!, $startDate: DateTime, $endDate: DateTime, $includeAllSaleStatuses: Boolean) {
  getProductInventoryMovements(
    product_id: $product_id
    startDate: $startDate
    endDate: $endDate
    includeAllSaleStatuses: $includeAllSaleStatuses
  ) {
    movement_type
    product_id
    date
    updated_at
    kilos
    groups
    affects_inventory
    balance_kilos
    balance_groups
    order_id
    order_code
    compound_order_code
    order_sale_status_id
  }
}
    `;

/**
 * __useProductInventoryMovementsQuery__
 *
 * To run a query within a React component, call `useProductInventoryMovementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductInventoryMovementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductInventoryMovementsQuery({
 *   variables: {
 *      product_id: // value for 'product_id'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      includeAllSaleStatuses: // value for 'includeAllSaleStatuses'
 *   },
 * });
 */
export function useProductInventoryMovementsQuery(baseOptions: Apollo.QueryHookOptions<ProductInventoryMovementsQuery, ProductInventoryMovementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductInventoryMovementsQuery, ProductInventoryMovementsQueryVariables>(ProductInventoryMovementsDocument, options);
      }
export function useProductInventoryMovementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductInventoryMovementsQuery, ProductInventoryMovementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductInventoryMovementsQuery, ProductInventoryMovementsQueryVariables>(ProductInventoryMovementsDocument, options);
        }
export type ProductInventoryMovementsQueryHookResult = ReturnType<typeof useProductInventoryMovementsQuery>;
export type ProductInventoryMovementsLazyQueryHookResult = ReturnType<typeof useProductInventoryMovementsLazyQuery>;
export type ProductInventoryMovementsQueryResult = Apollo.QueryResult<ProductInventoryMovementsQuery, ProductInventoryMovementsQueryVariables>;
export function refetchProductInventoryMovementsQuery(variables: ProductInventoryMovementsQueryVariables) {
      return { query: ProductInventoryMovementsDocument, variables: variables }
    }
export const ProductInventoryPageDocument = gql`
    query ProductInventoryPage {
  getProductsInventory {
    groups
    kilos
    last_update
    product_id
    product {
      id
      internal_description
      external_description
      compound_description
      product_category_id
      order_production_type_id
      product_category {
        name
      }
      discontinued
    }
  }
}
    `;

/**
 * __useProductInventoryPageQuery__
 *
 * To run a query within a React component, call `useProductInventoryPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductInventoryPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductInventoryPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductInventoryPageQuery(baseOptions?: Apollo.QueryHookOptions<ProductInventoryPageQuery, ProductInventoryPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductInventoryPageQuery, ProductInventoryPageQueryVariables>(ProductInventoryPageDocument, options);
      }
export function useProductInventoryPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductInventoryPageQuery, ProductInventoryPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductInventoryPageQuery, ProductInventoryPageQueryVariables>(ProductInventoryPageDocument, options);
        }
export type ProductInventoryPageQueryHookResult = ReturnType<typeof useProductInventoryPageQuery>;
export type ProductInventoryPageLazyQueryHookResult = ReturnType<typeof useProductInventoryPageLazyQuery>;
export type ProductInventoryPageQueryResult = Apollo.QueryResult<ProductInventoryPageQuery, ProductInventoryPageQueryVariables>;
export function refetchProductInventoryPageQuery(variables?: ProductInventoryPageQueryVariables) {
      return { query: ProductInventoryPageDocument, variables: variables }
    }
export const ProductionPerformanceMachinesDocument = gql`
    query ProductionPerformanceMachines {
  getMachines(exclude_discontinued: true) {
    id
    name
    order_production_type_id
  }
  getOrderProductionTypes {
    id
    name
  }
  getBranches {
    id
    name
  }
}
    `;

/**
 * __useProductionPerformanceMachinesQuery__
 *
 * To run a query within a React component, call `useProductionPerformanceMachinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductionPerformanceMachinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductionPerformanceMachinesQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductionPerformanceMachinesQuery(baseOptions?: Apollo.QueryHookOptions<ProductionPerformanceMachinesQuery, ProductionPerformanceMachinesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductionPerformanceMachinesQuery, ProductionPerformanceMachinesQueryVariables>(ProductionPerformanceMachinesDocument, options);
      }
export function useProductionPerformanceMachinesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductionPerformanceMachinesQuery, ProductionPerformanceMachinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductionPerformanceMachinesQuery, ProductionPerformanceMachinesQueryVariables>(ProductionPerformanceMachinesDocument, options);
        }
export type ProductionPerformanceMachinesQueryHookResult = ReturnType<typeof useProductionPerformanceMachinesQuery>;
export type ProductionPerformanceMachinesLazyQueryHookResult = ReturnType<typeof useProductionPerformanceMachinesLazyQuery>;
export type ProductionPerformanceMachinesQueryResult = Apollo.QueryResult<ProductionPerformanceMachinesQuery, ProductionPerformanceMachinesQueryVariables>;
export function refetchProductionPerformanceMachinesQuery(variables?: ProductionPerformanceMachinesQueryVariables) {
      return { query: ProductionPerformanceMachinesDocument, variables: variables }
    }
export const ProductionPerformanceProductsDocument = gql`
    query ProductionPerformanceProducts($machineId: Int!) {
  getMachineProducts(machineId: $machineId) {
    id
    description
  }
}
    `;

/**
 * __useProductionPerformanceProductsQuery__
 *
 * To run a query within a React component, call `useProductionPerformanceProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductionPerformanceProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductionPerformanceProductsQuery({
 *   variables: {
 *      machineId: // value for 'machineId'
 *   },
 * });
 */
export function useProductionPerformanceProductsQuery(baseOptions: Apollo.QueryHookOptions<ProductionPerformanceProductsQuery, ProductionPerformanceProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductionPerformanceProductsQuery, ProductionPerformanceProductsQueryVariables>(ProductionPerformanceProductsDocument, options);
      }
export function useProductionPerformanceProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductionPerformanceProductsQuery, ProductionPerformanceProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductionPerformanceProductsQuery, ProductionPerformanceProductsQueryVariables>(ProductionPerformanceProductsDocument, options);
        }
export type ProductionPerformanceProductsQueryHookResult = ReturnType<typeof useProductionPerformanceProductsQuery>;
export type ProductionPerformanceProductsLazyQueryHookResult = ReturnType<typeof useProductionPerformanceProductsLazyQuery>;
export type ProductionPerformanceProductsQueryResult = Apollo.QueryResult<ProductionPerformanceProductsQuery, ProductionPerformanceProductsQueryVariables>;
export function refetchProductionPerformanceProductsQuery(variables: ProductionPerformanceProductsQueryVariables) {
      return { query: ProductionPerformanceProductsDocument, variables: variables }
    }
export const ProductionPerformanceRunsDocument = gql`
    query ProductionPerformanceRuns($machineId: Int, $productId: Int, $fromDate: String, $toDate: String) {
  getMachineProductEmployeeRuns(
    machineId: $machineId
    productId: $productId
    fromDate: $fromDate
    toDate: $toDate
  ) {
    employee_id
    employee_name
    product_id
    product_description
    order_production_id
    date
    kilos
    hours
    waste_share
    branch_id
    order_production_type_id
    product_count
  }
}
    `;

/**
 * __useProductionPerformanceRunsQuery__
 *
 * To run a query within a React component, call `useProductionPerformanceRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductionPerformanceRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductionPerformanceRunsQuery({
 *   variables: {
 *      machineId: // value for 'machineId'
 *      productId: // value for 'productId'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *   },
 * });
 */
export function useProductionPerformanceRunsQuery(baseOptions?: Apollo.QueryHookOptions<ProductionPerformanceRunsQuery, ProductionPerformanceRunsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductionPerformanceRunsQuery, ProductionPerformanceRunsQueryVariables>(ProductionPerformanceRunsDocument, options);
      }
export function useProductionPerformanceRunsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductionPerformanceRunsQuery, ProductionPerformanceRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductionPerformanceRunsQuery, ProductionPerformanceRunsQueryVariables>(ProductionPerformanceRunsDocument, options);
        }
export type ProductionPerformanceRunsQueryHookResult = ReturnType<typeof useProductionPerformanceRunsQuery>;
export type ProductionPerformanceRunsLazyQueryHookResult = ReturnType<typeof useProductionPerformanceRunsLazyQuery>;
export type ProductionPerformanceRunsQueryResult = Apollo.QueryResult<ProductionPerformanceRunsQuery, ProductionPerformanceRunsQueryVariables>;
export function refetchProductionPerformanceRunsQuery(variables?: ProductionPerformanceRunsQueryVariables) {
      return { query: ProductionPerformanceRunsDocument, variables: variables }
    }
export const ProductionPerformanceHourlyRunsDocument = gql`
    query ProductionPerformanceHourlyRuns($machineId: Int, $productId: Int, $fromDate: String, $toDate: String) {
  getMachineHourlyRuns(
    machineId: $machineId
    productId: $productId
    fromDate: $fromDate
    toDate: $toDate
  ) {
    order_production_id
    date
    kilos_produced
    groups_produced
    hours_produced
    kilos_consumed
    hours_consumed
    product_count
  }
}
    `;

/**
 * __useProductionPerformanceHourlyRunsQuery__
 *
 * To run a query within a React component, call `useProductionPerformanceHourlyRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductionPerformanceHourlyRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductionPerformanceHourlyRunsQuery({
 *   variables: {
 *      machineId: // value for 'machineId'
 *      productId: // value for 'productId'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *   },
 * });
 */
export function useProductionPerformanceHourlyRunsQuery(baseOptions?: Apollo.QueryHookOptions<ProductionPerformanceHourlyRunsQuery, ProductionPerformanceHourlyRunsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductionPerformanceHourlyRunsQuery, ProductionPerformanceHourlyRunsQueryVariables>(ProductionPerformanceHourlyRunsDocument, options);
      }
export function useProductionPerformanceHourlyRunsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductionPerformanceHourlyRunsQuery, ProductionPerformanceHourlyRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductionPerformanceHourlyRunsQuery, ProductionPerformanceHourlyRunsQueryVariables>(ProductionPerformanceHourlyRunsDocument, options);
        }
export type ProductionPerformanceHourlyRunsQueryHookResult = ReturnType<typeof useProductionPerformanceHourlyRunsQuery>;
export type ProductionPerformanceHourlyRunsLazyQueryHookResult = ReturnType<typeof useProductionPerformanceHourlyRunsLazyQuery>;
export type ProductionPerformanceHourlyRunsQueryResult = Apollo.QueryResult<ProductionPerformanceHourlyRunsQuery, ProductionPerformanceHourlyRunsQueryVariables>;
export function refetchProductionPerformanceHourlyRunsQuery(variables?: ProductionPerformanceHourlyRunsQueryVariables) {
      return { query: ProductionPerformanceHourlyRunsDocument, variables: variables }
    }
export const ProductionPerformanceMachineProductSummaryDocument = gql`
    query ProductionPerformanceMachineProductSummary($machineId: Int!, $fromDate: String, $toDate: String) {
  getMachineProductPerformanceSummary(
    machineId: $machineId
    fromDate: $fromDate
    toDate: $toDate
  ) {
    product_id
    product_description
    runs
    kilos
    hours
    groups
    waste_share_total
    last_run_date
  }
}
    `;

/**
 * __useProductionPerformanceMachineProductSummaryQuery__
 *
 * To run a query within a React component, call `useProductionPerformanceMachineProductSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductionPerformanceMachineProductSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductionPerformanceMachineProductSummaryQuery({
 *   variables: {
 *      machineId: // value for 'machineId'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *   },
 * });
 */
export function useProductionPerformanceMachineProductSummaryQuery(baseOptions: Apollo.QueryHookOptions<ProductionPerformanceMachineProductSummaryQuery, ProductionPerformanceMachineProductSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductionPerformanceMachineProductSummaryQuery, ProductionPerformanceMachineProductSummaryQueryVariables>(ProductionPerformanceMachineProductSummaryDocument, options);
      }
export function useProductionPerformanceMachineProductSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductionPerformanceMachineProductSummaryQuery, ProductionPerformanceMachineProductSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductionPerformanceMachineProductSummaryQuery, ProductionPerformanceMachineProductSummaryQueryVariables>(ProductionPerformanceMachineProductSummaryDocument, options);
        }
export type ProductionPerformanceMachineProductSummaryQueryHookResult = ReturnType<typeof useProductionPerformanceMachineProductSummaryQuery>;
export type ProductionPerformanceMachineProductSummaryLazyQueryHookResult = ReturnType<typeof useProductionPerformanceMachineProductSummaryLazyQuery>;
export type ProductionPerformanceMachineProductSummaryQueryResult = Apollo.QueryResult<ProductionPerformanceMachineProductSummaryQuery, ProductionPerformanceMachineProductSummaryQueryVariables>;
export function refetchProductionPerformanceMachineProductSummaryQuery(variables: ProductionPerformanceMachineProductSummaryQueryVariables) {
      return { query: ProductionPerformanceMachineProductSummaryDocument, variables: variables }
    }
export const ProductionPerformanceProductMachineSummaryDocument = gql`
    query ProductionPerformanceProductMachineSummary($productId: Int!, $fromDate: String, $toDate: String) {
  getProductMachinePerformanceSummary(
    productId: $productId
    fromDate: $fromDate
    toDate: $toDate
  ) {
    machine_id
    machine_name
    runs
    kilos
    hours
    groups
    waste_share_total
    last_run_date
  }
}
    `;

/**
 * __useProductionPerformanceProductMachineSummaryQuery__
 *
 * To run a query within a React component, call `useProductionPerformanceProductMachineSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductionPerformanceProductMachineSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductionPerformanceProductMachineSummaryQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *   },
 * });
 */
export function useProductionPerformanceProductMachineSummaryQuery(baseOptions: Apollo.QueryHookOptions<ProductionPerformanceProductMachineSummaryQuery, ProductionPerformanceProductMachineSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductionPerformanceProductMachineSummaryQuery, ProductionPerformanceProductMachineSummaryQueryVariables>(ProductionPerformanceProductMachineSummaryDocument, options);
      }
export function useProductionPerformanceProductMachineSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductionPerformanceProductMachineSummaryQuery, ProductionPerformanceProductMachineSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductionPerformanceProductMachineSummaryQuery, ProductionPerformanceProductMachineSummaryQueryVariables>(ProductionPerformanceProductMachineSummaryDocument, options);
        }
export type ProductionPerformanceProductMachineSummaryQueryHookResult = ReturnType<typeof useProductionPerformanceProductMachineSummaryQuery>;
export type ProductionPerformanceProductMachineSummaryLazyQueryHookResult = ReturnType<typeof useProductionPerformanceProductMachineSummaryLazyQuery>;
export type ProductionPerformanceProductMachineSummaryQueryResult = Apollo.QueryResult<ProductionPerformanceProductMachineSummaryQuery, ProductionPerformanceProductMachineSummaryQueryVariables>;
export function refetchProductionPerformanceProductMachineSummaryQuery(variables: ProductionPerformanceProductMachineSummaryQueryVariables) {
      return { query: ProductionPerformanceProductMachineSummaryDocument, variables: variables }
    }
export const ProductionPerformanceProductsWithRunsDocument = gql`
    query ProductionPerformanceProductsWithRuns {
  getProductsWithRuns {
    id
    description
    product_category_name
  }
}
    `;

/**
 * __useProductionPerformanceProductsWithRunsQuery__
 *
 * To run a query within a React component, call `useProductionPerformanceProductsWithRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductionPerformanceProductsWithRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductionPerformanceProductsWithRunsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductionPerformanceProductsWithRunsQuery(baseOptions?: Apollo.QueryHookOptions<ProductionPerformanceProductsWithRunsQuery, ProductionPerformanceProductsWithRunsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductionPerformanceProductsWithRunsQuery, ProductionPerformanceProductsWithRunsQueryVariables>(ProductionPerformanceProductsWithRunsDocument, options);
      }
export function useProductionPerformanceProductsWithRunsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductionPerformanceProductsWithRunsQuery, ProductionPerformanceProductsWithRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductionPerformanceProductsWithRunsQuery, ProductionPerformanceProductsWithRunsQueryVariables>(ProductionPerformanceProductsWithRunsDocument, options);
        }
export type ProductionPerformanceProductsWithRunsQueryHookResult = ReturnType<typeof useProductionPerformanceProductsWithRunsQuery>;
export type ProductionPerformanceProductsWithRunsLazyQueryHookResult = ReturnType<typeof useProductionPerformanceProductsWithRunsLazyQuery>;
export type ProductionPerformanceProductsWithRunsQueryResult = Apollo.QueryResult<ProductionPerformanceProductsWithRunsQuery, ProductionPerformanceProductsWithRunsQueryVariables>;
export function refetchProductionPerformanceProductsWithRunsQuery(variables?: ProductionPerformanceProductsWithRunsQueryVariables) {
      return { query: ProductionPerformanceProductsWithRunsDocument, variables: variables }
    }
export const ProductionPerformanceWeeklyAuditRunsDocument = gql`
    query ProductionPerformanceWeeklyAuditRuns($weekStart: String!, $weekEnd: String!, $orderProductionTypeId: Int) {
  getWeeklyAuditRuns(
    weekStart: $weekStart
    weekEnd: $weekEnd
    orderProductionTypeId: $orderProductionTypeId
  ) {
    order_production_id
    date
    machine_id
    machine_name
    branch_id
    branch_name
    product_id
    product_description
    kilos
    hours
    groups
    waste_share
    product_count
    shift
    employee_names
  }
}
    `;

/**
 * __useProductionPerformanceWeeklyAuditRunsQuery__
 *
 * To run a query within a React component, call `useProductionPerformanceWeeklyAuditRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductionPerformanceWeeklyAuditRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductionPerformanceWeeklyAuditRunsQuery({
 *   variables: {
 *      weekStart: // value for 'weekStart'
 *      weekEnd: // value for 'weekEnd'
 *      orderProductionTypeId: // value for 'orderProductionTypeId'
 *   },
 * });
 */
export function useProductionPerformanceWeeklyAuditRunsQuery(baseOptions: Apollo.QueryHookOptions<ProductionPerformanceWeeklyAuditRunsQuery, ProductionPerformanceWeeklyAuditRunsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductionPerformanceWeeklyAuditRunsQuery, ProductionPerformanceWeeklyAuditRunsQueryVariables>(ProductionPerformanceWeeklyAuditRunsDocument, options);
      }
export function useProductionPerformanceWeeklyAuditRunsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductionPerformanceWeeklyAuditRunsQuery, ProductionPerformanceWeeklyAuditRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductionPerformanceWeeklyAuditRunsQuery, ProductionPerformanceWeeklyAuditRunsQueryVariables>(ProductionPerformanceWeeklyAuditRunsDocument, options);
        }
export type ProductionPerformanceWeeklyAuditRunsQueryHookResult = ReturnType<typeof useProductionPerformanceWeeklyAuditRunsQuery>;
export type ProductionPerformanceWeeklyAuditRunsLazyQueryHookResult = ReturnType<typeof useProductionPerformanceWeeklyAuditRunsLazyQuery>;
export type ProductionPerformanceWeeklyAuditRunsQueryResult = Apollo.QueryResult<ProductionPerformanceWeeklyAuditRunsQuery, ProductionPerformanceWeeklyAuditRunsQueryVariables>;
export function refetchProductionPerformanceWeeklyAuditRunsQuery(variables: ProductionPerformanceWeeklyAuditRunsQueryVariables) {
      return { query: ProductionPerformanceWeeklyAuditRunsDocument, variables: variables }
    }
export const ProductionPlanningPageDocument = gql`
    query ProductionPlanningPage($excludeDiscontinued: Boolean!) {
  getBranches {
    id
    name
  }
  getOrderProductionTypes {
    id
    name
  }
  getMachines(exclude_discontinued: $excludeDiscontinued) {
    id
    name
    branch_id
    order_production_type_id
  }
  getProducts(exclude_discontinued: $excludeDiscontinued) {
    id
    compound_description
    order_production_type_id
    current_group_weight
  }
  getEmployees(exclude_discontinued: $excludeDiscontinued) {
    id
    fullname
    order_production_type_id
    branch_id
    is_inactive
    is_leader
  }
  getProductsInventory {
    product_id
    kilos
    groups
    kilos_committed
    groups_committed
  }
  getOptimizedRequestProducts {
    order_request_id
    priority
    order_code
    order_request_date
    order_request_estimated_delivery_date
    order_request_status_id
    order_request_status_name
    account_name
    product_id
    product_description
    order_request_kilos
    order_request_groups
    order_sale_remaining_kilos
    order_sale_remaining_groups
  }
}
    `;

/**
 * __useProductionPlanningPageQuery__
 *
 * To run a query within a React component, call `useProductionPlanningPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductionPlanningPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductionPlanningPageQuery({
 *   variables: {
 *      excludeDiscontinued: // value for 'excludeDiscontinued'
 *   },
 * });
 */
export function useProductionPlanningPageQuery(baseOptions: Apollo.QueryHookOptions<ProductionPlanningPageQuery, ProductionPlanningPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductionPlanningPageQuery, ProductionPlanningPageQueryVariables>(ProductionPlanningPageDocument, options);
      }
export function useProductionPlanningPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductionPlanningPageQuery, ProductionPlanningPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductionPlanningPageQuery, ProductionPlanningPageQueryVariables>(ProductionPlanningPageDocument, options);
        }
export type ProductionPlanningPageQueryHookResult = ReturnType<typeof useProductionPlanningPageQuery>;
export type ProductionPlanningPageLazyQueryHookResult = ReturnType<typeof useProductionPlanningPageLazyQuery>;
export type ProductionPlanningPageQueryResult = Apollo.QueryResult<ProductionPlanningPageQuery, ProductionPlanningPageQueryVariables>;
export function refetchProductionPlanningPageQuery(variables: ProductionPlanningPageQueryVariables) {
      return { query: ProductionPlanningPageDocument, variables: variables }
    }
export const ProductionPlanForDateDocument = gql`
    query ProductionPlanForDate($date: DateTime!, $shift: Int!, $branchId: Int) {
  getProductionPlan(date: $date, shift: $shift, branch_id: $branchId) {
    id
    date
    shift
    shift_hours
    branch_id
    notes
    product_notes
    rows {
      id
      machine_id
      shift_hours
      notes
      position
      employees {
        id
        fullname
      }
      products {
        id
        product_id
        hours
        efficiency
        position
      }
    }
  }
}
    `;

/**
 * __useProductionPlanForDateQuery__
 *
 * To run a query within a React component, call `useProductionPlanForDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductionPlanForDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductionPlanForDateQuery({
 *   variables: {
 *      date: // value for 'date'
 *      shift: // value for 'shift'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useProductionPlanForDateQuery(baseOptions: Apollo.QueryHookOptions<ProductionPlanForDateQuery, ProductionPlanForDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductionPlanForDateQuery, ProductionPlanForDateQueryVariables>(ProductionPlanForDateDocument, options);
      }
export function useProductionPlanForDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductionPlanForDateQuery, ProductionPlanForDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductionPlanForDateQuery, ProductionPlanForDateQueryVariables>(ProductionPlanForDateDocument, options);
        }
export type ProductionPlanForDateQueryHookResult = ReturnType<typeof useProductionPlanForDateQuery>;
export type ProductionPlanForDateLazyQueryHookResult = ReturnType<typeof useProductionPlanForDateLazyQuery>;
export type ProductionPlanForDateQueryResult = Apollo.QueryResult<ProductionPlanForDateQuery, ProductionPlanForDateQueryVariables>;
export function refetchProductionPlanForDateQuery(variables: ProductionPlanForDateQueryVariables) {
      return { query: ProductionPlanForDateDocument, variables: variables }
    }
export const ProductionPlanRatesDocument = gql`
    query ProductionPlanRates($pairs: [MachineProductRatePairInput!]!, $fromDate: String, $singleProductOnly: Boolean) {
  getMachineProductRates(
    pairs: $pairs
    fromDate: $fromDate
    singleProductOnly: $singleProductOnly
  ) {
    machine_id
    product_id
    all_kilos
    all_hours
    all_runs
    all_waste
    all_groups
    all_groups_rate_mean
    all_groups_rate_std
    all_groups_rate_n
    all_kilos_rate_mean
    all_kilos_rate_std
    all_kilos_rate_n
  }
}
    `;

/**
 * __useProductionPlanRatesQuery__
 *
 * To run a query within a React component, call `useProductionPlanRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductionPlanRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductionPlanRatesQuery({
 *   variables: {
 *      pairs: // value for 'pairs'
 *      fromDate: // value for 'fromDate'
 *      singleProductOnly: // value for 'singleProductOnly'
 *   },
 * });
 */
export function useProductionPlanRatesQuery(baseOptions: Apollo.QueryHookOptions<ProductionPlanRatesQuery, ProductionPlanRatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductionPlanRatesQuery, ProductionPlanRatesQueryVariables>(ProductionPlanRatesDocument, options);
      }
export function useProductionPlanRatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductionPlanRatesQuery, ProductionPlanRatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductionPlanRatesQuery, ProductionPlanRatesQueryVariables>(ProductionPlanRatesDocument, options);
        }
export type ProductionPlanRatesQueryHookResult = ReturnType<typeof useProductionPlanRatesQuery>;
export type ProductionPlanRatesLazyQueryHookResult = ReturnType<typeof useProductionPlanRatesLazyQuery>;
export type ProductionPlanRatesQueryResult = Apollo.QueryResult<ProductionPlanRatesQuery, ProductionPlanRatesQueryVariables>;
export function refetchProductionPlanRatesQuery(variables: ProductionPlanRatesQueryVariables) {
      return { query: ProductionPlanRatesDocument, variables: variables }
    }
export const ProductionPlanActualsDocument = gql`
    query ProductionPlanActuals($date: DateTime!, $shift: Int!, $branchId: Int) {
  getProductionPlanActuals(date: $date, shift: $shift, branch_id: $branchId) {
    product_id
    machine_id
    kilos
    groups
  }
}
    `;

/**
 * __useProductionPlanActualsQuery__
 *
 * To run a query within a React component, call `useProductionPlanActualsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductionPlanActualsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductionPlanActualsQuery({
 *   variables: {
 *      date: // value for 'date'
 *      shift: // value for 'shift'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useProductionPlanActualsQuery(baseOptions: Apollo.QueryHookOptions<ProductionPlanActualsQuery, ProductionPlanActualsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductionPlanActualsQuery, ProductionPlanActualsQueryVariables>(ProductionPlanActualsDocument, options);
      }
export function useProductionPlanActualsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductionPlanActualsQuery, ProductionPlanActualsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductionPlanActualsQuery, ProductionPlanActualsQueryVariables>(ProductionPlanActualsDocument, options);
        }
export type ProductionPlanActualsQueryHookResult = ReturnType<typeof useProductionPlanActualsQuery>;
export type ProductionPlanActualsLazyQueryHookResult = ReturnType<typeof useProductionPlanActualsLazyQuery>;
export type ProductionPlanActualsQueryResult = Apollo.QueryResult<ProductionPlanActualsQuery, ProductionPlanActualsQueryVariables>;
export function refetchProductionPlanActualsQuery(variables: ProductionPlanActualsQueryVariables) {
      return { query: ProductionPlanActualsDocument, variables: variables }
    }
export const MachineProducedProductsDocument = gql`
    query MachineProducedProducts($machineId: Int!) {
  getMachineProducedProductIds(machineId: $machineId)
}
    `;

/**
 * __useMachineProducedProductsQuery__
 *
 * To run a query within a React component, call `useMachineProducedProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMachineProducedProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMachineProducedProductsQuery({
 *   variables: {
 *      machineId: // value for 'machineId'
 *   },
 * });
 */
export function useMachineProducedProductsQuery(baseOptions: Apollo.QueryHookOptions<MachineProducedProductsQuery, MachineProducedProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MachineProducedProductsQuery, MachineProducedProductsQueryVariables>(MachineProducedProductsDocument, options);
      }
export function useMachineProducedProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MachineProducedProductsQuery, MachineProducedProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MachineProducedProductsQuery, MachineProducedProductsQueryVariables>(MachineProducedProductsDocument, options);
        }
export type MachineProducedProductsQueryHookResult = ReturnType<typeof useMachineProducedProductsQuery>;
export type MachineProducedProductsLazyQueryHookResult = ReturnType<typeof useMachineProducedProductsLazyQuery>;
export type MachineProducedProductsQueryResult = Apollo.QueryResult<MachineProducedProductsQuery, MachineProducedProductsQueryVariables>;
export function refetchMachineProducedProductsQuery(variables: MachineProducedProductsQueryVariables) {
      return { query: MachineProducedProductsDocument, variables: variables }
    }
export const UpsertProductionPlanDocument = gql`
    mutation UpsertProductionPlan($ProductionPlanUpsertInput: ProductionPlanUpsertInput!) {
  upsertProductionPlan(ProductionPlanUpsertInput: $ProductionPlanUpsertInput) {
    id
  }
}
    `;
export type UpsertProductionPlanMutationFn = Apollo.MutationFunction<UpsertProductionPlanMutation, UpsertProductionPlanMutationVariables>;

/**
 * __useUpsertProductionPlanMutation__
 *
 * To run a mutation, you first call `useUpsertProductionPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertProductionPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertProductionPlanMutation, { data, loading, error }] = useUpsertProductionPlanMutation({
 *   variables: {
 *      ProductionPlanUpsertInput: // value for 'ProductionPlanUpsertInput'
 *   },
 * });
 */
export function useUpsertProductionPlanMutation(baseOptions?: Apollo.MutationHookOptions<UpsertProductionPlanMutation, UpsertProductionPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertProductionPlanMutation, UpsertProductionPlanMutationVariables>(UpsertProductionPlanDocument, options);
      }
export type UpsertProductionPlanMutationHookResult = ReturnType<typeof useUpsertProductionPlanMutation>;
export type UpsertProductionPlanMutationResult = Apollo.MutationResult<UpsertProductionPlanMutation>;
export type UpsertProductionPlanMutationOptions = Apollo.BaseMutationOptions<UpsertProductionPlanMutation, UpsertProductionPlanMutationVariables>;
export const DeleteProductionPlanDocument = gql`
    mutation DeleteProductionPlan($ProductionPlanId: Int!) {
  deleteProductionPlan(ProductionPlanId: $ProductionPlanId)
}
    `;
export type DeleteProductionPlanMutationFn = Apollo.MutationFunction<DeleteProductionPlanMutation, DeleteProductionPlanMutationVariables>;

/**
 * __useDeleteProductionPlanMutation__
 *
 * To run a mutation, you first call `useDeleteProductionPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductionPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductionPlanMutation, { data, loading, error }] = useDeleteProductionPlanMutation({
 *   variables: {
 *      ProductionPlanId: // value for 'ProductionPlanId'
 *   },
 * });
 */
export function useDeleteProductionPlanMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProductionPlanMutation, DeleteProductionPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProductionPlanMutation, DeleteProductionPlanMutationVariables>(DeleteProductionPlanDocument, options);
      }
export type DeleteProductionPlanMutationHookResult = ReturnType<typeof useDeleteProductionPlanMutation>;
export type DeleteProductionPlanMutationResult = Apollo.MutationResult<DeleteProductionPlanMutation>;
export type DeleteProductionPlanMutationOptions = Apollo.BaseMutationOptions<DeleteProductionPlanMutation, DeleteProductionPlanMutationVariables>;
export const ProductionSummaryPageDocument = gql`
    query ProductionSummaryPage($year: Int!, $month: Int, $orderProductionTypeId: Int!, $branchId: Int!, $entityGroup: ProductionSummaryEntitiesGroup!, $dateGroupBy: DateGroupBy!) {
  getProductionSummary(
    ProductionSummaryArgs: {year: $year, month: $month, order_production_type_id: $orderProductionTypeId, branch_id: $branchId, entity_group: $entityGroup, date_group_by: $dateGroupBy}
  ) {
    production {
      order_production_type_id
      order_production_type_name
      kilos
      branch_id
      branch_name
      machine_id
      machine_name
      machine_type_id
      product_category_id
      month
      year
      day
    }
    waste {
      waste
      order_production_type_id
      year
      month
      day
    }
  }
  getAllProductionSummary: getProductionSummary(
    ProductionSummaryArgs: {year: $year, date_group_by: day}
  ) {
    production {
      order_production_type_id
      order_production_type_name
      kilos
      branch_id
      branch_name
      machine_id
      machine_name
      machine_type_id
      product_category_id
      product_category_name
      product_id
      product_description
      month
      year
      day
      width
      length
      calibre
      hours
    }
    waste {
      waste
      order_production_type_id
      order_production_type_name
      year
      month
      day
    }
  }
  getMachines(exclude_discontinued: true) {
    order_production_type_id
    name
    id
  }
  getProductCategories {
    order_production_type_id
    name
    id
  }
  getOrderProductionTypes {
    id
    name
  }
  getBranches {
    id
    name
  }
  getEmployeeSummary(
    ExpensesSummaryArgs: {year: $year, month: $month, date_group_by: day}
  ) {
    Employees {
      year
      month
      day
      kilos
      groups
      hours
      employee_name
      machine_name
      product_name
      employee_id
      machine_id
      product_id
    }
  }
  getProductionResourcesSummary(
    ProductionResourcesArgs: {year: $year, month: $month, date_group_by: day}
  ) {
    ProductionResources {
      year
      month
      day
      kilos
      groups
      machine_name
      product_name
      machine_id
      product_id
      employee_name
      employee_id
      hours
    }
  }
}
    `;

/**
 * __useProductionSummaryPageQuery__
 *
 * To run a query within a React component, call `useProductionSummaryPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductionSummaryPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductionSummaryPageQuery({
 *   variables: {
 *      year: // value for 'year'
 *      month: // value for 'month'
 *      orderProductionTypeId: // value for 'orderProductionTypeId'
 *      branchId: // value for 'branchId'
 *      entityGroup: // value for 'entityGroup'
 *      dateGroupBy: // value for 'dateGroupBy'
 *   },
 * });
 */
export function useProductionSummaryPageQuery(baseOptions: Apollo.QueryHookOptions<ProductionSummaryPageQuery, ProductionSummaryPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductionSummaryPageQuery, ProductionSummaryPageQueryVariables>(ProductionSummaryPageDocument, options);
      }
export function useProductionSummaryPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductionSummaryPageQuery, ProductionSummaryPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductionSummaryPageQuery, ProductionSummaryPageQueryVariables>(ProductionSummaryPageDocument, options);
        }
export type ProductionSummaryPageQueryHookResult = ReturnType<typeof useProductionSummaryPageQuery>;
export type ProductionSummaryPageLazyQueryHookResult = ReturnType<typeof useProductionSummaryPageLazyQuery>;
export type ProductionSummaryPageQueryResult = Apollo.QueryResult<ProductionSummaryPageQuery, ProductionSummaryPageQueryVariables>;
export function refetchProductionSummaryPageQuery(variables: ProductionSummaryPageQueryVariables) {
      return { query: ProductionSummaryPageDocument, variables: variables }
    }
export const ProductPageDocument = gql`
    query ProductPage($ProductId: Float!) {
  getProduct(ProductId: $ProductId) {
    id
    compound_description
    order_production_type_id
    code
    calibre
    width
    length
    current_group_weight
    current_kilo_price
    order_production_products {
      id
      kilos
      groups
      machine_id
    }
  }
  getMachines {
    id
    name
  }
}
    `;

/**
 * __useProductPageQuery__
 *
 * To run a query within a React component, call `useProductPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductPageQuery({
 *   variables: {
 *      ProductId: // value for 'ProductId'
 *   },
 * });
 */
export function useProductPageQuery(baseOptions: Apollo.QueryHookOptions<ProductPageQuery, ProductPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductPageQuery, ProductPageQueryVariables>(ProductPageDocument, options);
      }
export function useProductPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductPageQuery, ProductPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductPageQuery, ProductPageQueryVariables>(ProductPageDocument, options);
        }
export type ProductPageQueryHookResult = ReturnType<typeof useProductPageQuery>;
export type ProductPageLazyQueryHookResult = ReturnType<typeof useProductPageLazyQuery>;
export type ProductPageQueryResult = Apollo.QueryResult<ProductPageQuery, ProductPageQueryVariables>;
export function refetchProductPageQuery(variables: ProductPageQueryVariables) {
      return { query: ProductPageDocument, variables: variables }
    }
export const ProductsPageDocument = gql`
    query ProductsPage($take: Float!, $skip: Float!, $filter: String!, $productCategoryId: Int, $includeDiscontinued: Boolean!, $onlyMissingInternal: Boolean, $sortField: ProductsSortableFields, $sortOrder: ColumnOrder) {
  paginatedProducts(
    take: $take
    skip: $skip
    filter: $filter
    product_category_id: $productCategoryId
    include_discontinued: $includeDiscontinued
    only_missing_internal_description: $onlyMissingInternal
    sort_order: $sortOrder
    sort_field: $sortField
  ) {
    docs {
      updated_at
      id
      external_description
      internal_description
      compound_description
      is_deletable
      product_category {
        name
      }
      product_material {
        name
      }
      order_production_type {
        name
      }
      discontinued
      updated_by {
        fullname
      }
    }
    count
  }
  getProductCategories {
    id
    name
  }
  getOrderProductionTypes {
    id
    name
  }
}
    `;

/**
 * __useProductsPageQuery__
 *
 * To run a query within a React component, call `useProductsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsPageQuery({
 *   variables: {
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      filter: // value for 'filter'
 *      productCategoryId: // value for 'productCategoryId'
 *      includeDiscontinued: // value for 'includeDiscontinued'
 *      onlyMissingInternal: // value for 'onlyMissingInternal'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useProductsPageQuery(baseOptions: Apollo.QueryHookOptions<ProductsPageQuery, ProductsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductsPageQuery, ProductsPageQueryVariables>(ProductsPageDocument, options);
      }
export function useProductsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductsPageQuery, ProductsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductsPageQuery, ProductsPageQueryVariables>(ProductsPageDocument, options);
        }
export type ProductsPageQueryHookResult = ReturnType<typeof useProductsPageQuery>;
export type ProductsPageLazyQueryHookResult = ReturnType<typeof useProductsPageLazyQuery>;
export type ProductsPageQueryResult = Apollo.QueryResult<ProductsPageQuery, ProductsPageQueryVariables>;
export function refetchProductsPageQuery(variables: ProductsPageQueryVariables) {
      return { query: ProductsPageDocument, variables: variables }
    }
export const ProductsToProducePageDocument = gql`
    query ProductsToProducePage {
  getOptimizedRequestProducts {
    order_request_status_id
    order_request_status_name
    order_code
    order_request_estimated_delivery_date
    order_sale_delivered_kilos
    order_sale_remaining_kilos
    order_request_kilos
    product_id
    account_name
    order_sale_delivered_groups
    order_sale_remaining_groups
    order_request_groups
  }
  getProductsInventory {
    kilos
    groups
    product {
      calibre
      width
      internal_description
      external_description
      compound_description
      id
      product_category_id
      order_production_type_id
      product_category {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useProductsToProducePageQuery__
 *
 * To run a query within a React component, call `useProductsToProducePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsToProducePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsToProducePageQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductsToProducePageQuery(baseOptions?: Apollo.QueryHookOptions<ProductsToProducePageQuery, ProductsToProducePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductsToProducePageQuery, ProductsToProducePageQueryVariables>(ProductsToProducePageDocument, options);
      }
export function useProductsToProducePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductsToProducePageQuery, ProductsToProducePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductsToProducePageQuery, ProductsToProducePageQueryVariables>(ProductsToProducePageDocument, options);
        }
export type ProductsToProducePageQueryHookResult = ReturnType<typeof useProductsToProducePageQuery>;
export type ProductsToProducePageLazyQueryHookResult = ReturnType<typeof useProductsToProducePageLazyQuery>;
export type ProductsToProducePageQueryResult = Apollo.QueryResult<ProductsToProducePageQuery, ProductsToProducePageQueryVariables>;
export function refetchProductsToProducePageQuery(variables?: ProductsToProducePageQueryVariables) {
      return { query: ProductsToProducePageDocument, variables: variables }
    }
export const PrintableQuotationDocument = gql`
    query PrintableQuotation($OrderQuotationId: Float!) {
  getProducts {
    id
    external_description
  }
  getOrderQuotation(OrderQuotationId: $OrderQuotationId) {
    id
    order_code
    date
    expiration_date
    estimated_delivery_date
    payment_terms
    require_tax
    notes
    subtotal
    tax
    total
    account {
      name
      rfc
      address
    }
    order_quotation_products {
      id
      product_id
      proposed_description
      groups
      kilos
      kilo_price
      group_price
      product {
        external_description
      }
    }
  }
}
    `;

/**
 * __usePrintableQuotationQuery__
 *
 * To run a query within a React component, call `usePrintableQuotationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrintableQuotationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrintableQuotationQuery({
 *   variables: {
 *      OrderQuotationId: // value for 'OrderQuotationId'
 *   },
 * });
 */
export function usePrintableQuotationQuery(baseOptions: Apollo.QueryHookOptions<PrintableQuotationQuery, PrintableQuotationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrintableQuotationQuery, PrintableQuotationQueryVariables>(PrintableQuotationDocument, options);
      }
export function usePrintableQuotationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrintableQuotationQuery, PrintableQuotationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrintableQuotationQuery, PrintableQuotationQueryVariables>(PrintableQuotationDocument, options);
        }
export type PrintableQuotationQueryHookResult = ReturnType<typeof usePrintableQuotationQuery>;
export type PrintableQuotationLazyQueryHookResult = ReturnType<typeof usePrintableQuotationLazyQuery>;
export type PrintableQuotationQueryResult = Apollo.QueryResult<PrintableQuotationQuery, PrintableQuotationQueryVariables>;
export function refetchPrintableQuotationQuery(variables: PrintableQuotationQueryVariables) {
      return { query: PrintableQuotationDocument, variables: variables }
    }
export const OrderQuotationsPageDocument = gql`
    query OrderQuotationsPage($skip: Float!, $take: Float!, $startDate: String, $endDate: String, $filter: String!, $accountId: Int, $sortOrder: ColumnOrder, $sortField: OrderQuotationsSortableFields, $orderQuotationStatusId: Int) {
  paginatedOrderQuotations(
    skip: $skip
    take: $take
    start_date: $startDate
    end_date: $endDate
    filter: $filter
    account_id: $accountId
    sort_order: $sortOrder
    sort_field: $sortField
    order_quotation_status_id: $orderQuotationStatusId
  ) {
    docs {
      id
      date
      updated_at
      estimated_delivery_date
      order_code
      notes
      expiration_date
      payment_terms
      require_tax
      is_deletable
      is_editable
      is_acceptable
      is_expired
      subtotal
      tax
      total
      catalog_step_done
      acceptance_complete
      account {
        id
        name
      }
      order_quotation_status {
        id
        name
      }
      order_quotation_products {
        id
        product_id
        proposed_description
        groups
        kilos
        kilo_price
        group_price
        product {
          external_description
        }
      }
      updated_by {
        fullname
      }
    }
    count
  }
  getAccounts(is_client: true) {
    id
    name
  }
}
    `;

/**
 * __useOrderQuotationsPageQuery__
 *
 * To run a query within a React component, call `useOrderQuotationsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderQuotationsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderQuotationsPageQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      filter: // value for 'filter'
 *      accountId: // value for 'accountId'
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      orderQuotationStatusId: // value for 'orderQuotationStatusId'
 *   },
 * });
 */
export function useOrderQuotationsPageQuery(baseOptions: Apollo.QueryHookOptions<OrderQuotationsPageQuery, OrderQuotationsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderQuotationsPageQuery, OrderQuotationsPageQueryVariables>(OrderQuotationsPageDocument, options);
      }
export function useOrderQuotationsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderQuotationsPageQuery, OrderQuotationsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderQuotationsPageQuery, OrderQuotationsPageQueryVariables>(OrderQuotationsPageDocument, options);
        }
export type OrderQuotationsPageQueryHookResult = ReturnType<typeof useOrderQuotationsPageQuery>;
export type OrderQuotationsPageLazyQueryHookResult = ReturnType<typeof useOrderQuotationsPageLazyQuery>;
export type OrderQuotationsPageQueryResult = Apollo.QueryResult<OrderQuotationsPageQuery, OrderQuotationsPageQueryVariables>;
export function refetchOrderQuotationsPageQuery(variables: OrderQuotationsPageQueryVariables) {
      return { query: OrderQuotationsPageDocument, variables: variables }
    }
export const OrderRequestsPageDocument = gql`
    query OrderRequestsPage($skip: Float!, $take: Float!, $startDate: String, $endDate: String, $filter: String!, $accountId: Int, $sortOrder: ColumnOrder, $sortField: OrderRequestsSortableFields, $orderRequestStatusId: Int) {
  paginatedOrderRequests(
    skip: $skip
    take: $take
    start_date: $startDate
    end_date: $endDate
    filter: $filter
    account_id: $accountId
    sort_order: $sortOrder
    sort_field: $sortField
    order_request_status_id: $orderRequestStatusId
  ) {
    docs {
      id
      date
      updated_at
      estimated_delivery_date
      order_code
      is_deletable
      is_editable
      notes
      account {
        id
        name
      }
      order_request_status {
        id
        name
      }
      order_request_products {
        product_id
        product {
          external_description
        }
        groups
        kilos
        total
      }
      order_sale_sold_products {
        product_id
        product {
          external_description
        }
        groups
        kilos
        total
      }
      updated_by {
        fullname
      }
    }
    count
  }
  getAccounts(is_client: true) {
    id
    name
  }
  getOrderRequestStatuses {
    id
    name
  }
}
    `;

/**
 * __useOrderRequestsPageQuery__
 *
 * To run a query within a React component, call `useOrderRequestsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderRequestsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderRequestsPageQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      filter: // value for 'filter'
 *      accountId: // value for 'accountId'
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      orderRequestStatusId: // value for 'orderRequestStatusId'
 *   },
 * });
 */
export function useOrderRequestsPageQuery(baseOptions: Apollo.QueryHookOptions<OrderRequestsPageQuery, OrderRequestsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderRequestsPageQuery, OrderRequestsPageQueryVariables>(OrderRequestsPageDocument, options);
      }
export function useOrderRequestsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderRequestsPageQuery, OrderRequestsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderRequestsPageQuery, OrderRequestsPageQueryVariables>(OrderRequestsPageDocument, options);
        }
export type OrderRequestsPageQueryHookResult = ReturnType<typeof useOrderRequestsPageQuery>;
export type OrderRequestsPageLazyQueryHookResult = ReturnType<typeof useOrderRequestsPageLazyQuery>;
export type OrderRequestsPageQueryResult = Apollo.QueryResult<OrderRequestsPageQuery, OrderRequestsPageQueryVariables>;
export function refetchOrderRequestsPageQuery(variables: OrderRequestsPageQueryVariables) {
      return { query: OrderRequestsPageDocument, variables: variables }
    }
export const UpdateOrderRequestDetailsDocument = gql`
    mutation UpdateOrderRequestDetails($OrderRequestDetailsInput: OrderRequestDetailsInput!) {
  updateOrderRequestDetails(OrderRequestDetailsInput: $OrderRequestDetailsInput) {
    id
    notes
    estimated_delivery_date
  }
}
    `;
export type UpdateOrderRequestDetailsMutationFn = Apollo.MutationFunction<UpdateOrderRequestDetailsMutation, UpdateOrderRequestDetailsMutationVariables>;

/**
 * __useUpdateOrderRequestDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateOrderRequestDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderRequestDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderRequestDetailsMutation, { data, loading, error }] = useUpdateOrderRequestDetailsMutation({
 *   variables: {
 *      OrderRequestDetailsInput: // value for 'OrderRequestDetailsInput'
 *   },
 * });
 */
export function useUpdateOrderRequestDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderRequestDetailsMutation, UpdateOrderRequestDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderRequestDetailsMutation, UpdateOrderRequestDetailsMutationVariables>(UpdateOrderRequestDetailsDocument, options);
      }
export type UpdateOrderRequestDetailsMutationHookResult = ReturnType<typeof useUpdateOrderRequestDetailsMutation>;
export type UpdateOrderRequestDetailsMutationResult = Apollo.MutationResult<UpdateOrderRequestDetailsMutation>;
export type UpdateOrderRequestDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateOrderRequestDetailsMutation, UpdateOrderRequestDetailsMutationVariables>;
export const OrderSalesPageDocument = gql`
    query OrderSalesPage($skip: Float!, $take: Float!, $startDate: String, $endDate: String, $filter: String!, $sortField: OrderSalesSortableFields, $sortOrder: ColumnOrder, $accountId: Int, $orderSaleReceiptTypeId: Int, $orderSaleStatusId: Int, $productId: Int, $noSupplement: Boolean!, $noCreditNote: Boolean!, $isTransferComplete: Boolean!) {
  paginatedOrderSales(
    skip: $skip
    take: $take
    start_date: $startDate
    end_date: $endDate
    filter: $filter
    sort_field: $sortField
    sort_order: $sortOrder
    account_id: $accountId
    receipt_type_id: $orderSaleReceiptTypeId
    order_sale_status_id: $orderSaleStatusId
    product_id: $productId
    no_supplement: $noSupplement
    no_credit_note: $noCreditNote
    is_transfer_incomplete: $isTransferComplete
  ) {
    docs {
      id
      order_code
      invoice_code
      date
      expected_payment_date
      require_supplement
      supplement_code
      require_credit_note
      credit_note_code
      credit_note_amount
      canceled
      reconciliation_only
      updated_at
      is_deletable
      is_editable
      notes
      updated_by {
        fullname
      }
      subtotal
      total_with_tax
      net_total_with_tax
      transfer_receipts_total
      transfer_receipts_total_no_adjustments
      account {
        name
      }
      receipt_type {
        name
        applies_tax
      }
      order_request {
        order_code
      }
      receipt_type_id
      order_sale_products {
        id
        product_id
        product {
          id
          code
          compound_description
          external_description
        }
        kilo_price
        group_price
        kilos
        groups
        total
      }
      order_sale_status {
        id
        name
      }
    }
    count
  }
  getAccounts(is_client: true) {
    id
    name
  }
  getReceiptTypes {
    id
    name
  }
  getOrderSaleStatuses {
    id
    name
  }
}
    `;

/**
 * __useOrderSalesPageQuery__
 *
 * To run a query within a React component, call `useOrderSalesPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderSalesPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderSalesPageQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      filter: // value for 'filter'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      accountId: // value for 'accountId'
 *      orderSaleReceiptTypeId: // value for 'orderSaleReceiptTypeId'
 *      orderSaleStatusId: // value for 'orderSaleStatusId'
 *      productId: // value for 'productId'
 *      noSupplement: // value for 'noSupplement'
 *      noCreditNote: // value for 'noCreditNote'
 *      isTransferComplete: // value for 'isTransferComplete'
 *   },
 * });
 */
export function useOrderSalesPageQuery(baseOptions: Apollo.QueryHookOptions<OrderSalesPageQuery, OrderSalesPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderSalesPageQuery, OrderSalesPageQueryVariables>(OrderSalesPageDocument, options);
      }
export function useOrderSalesPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderSalesPageQuery, OrderSalesPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderSalesPageQuery, OrderSalesPageQueryVariables>(OrderSalesPageDocument, options);
        }
export type OrderSalesPageQueryHookResult = ReturnType<typeof useOrderSalesPageQuery>;
export type OrderSalesPageLazyQueryHookResult = ReturnType<typeof useOrderSalesPageLazyQuery>;
export type OrderSalesPageQueryResult = Apollo.QueryResult<OrderSalesPageQuery, OrderSalesPageQueryVariables>;
export function refetchOrderSalesPageQuery(variables: OrderSalesPageQueryVariables) {
      return { query: OrderSalesPageDocument, variables: variables }
    }
export const OrdersToFulfillPageDocument = gql`
    query OrdersToFulfillPage {
  getOptimizedRequestProducts {
    order_request_id
    priority
    order_code
    order_request_date
    order_request_estimated_delivery_date
    order_request_status_id
    order_request_status_name
    account_name
    product_id
    product_description
    order_production_type_id
    order_request_kilos
    order_sale_delivered_kilos
    order_sale_committed_kilos
    order_sale_remaining_kilos
    order_request_groups
    order_sale_delivered_groups
    order_sale_committed_groups
    order_sale_remaining_groups
  }
  getProductsInventory {
    product_id
    kilos
    groups
    kilos_committed
    groups_committed
  }
}
    `;

/**
 * __useOrdersToFulfillPageQuery__
 *
 * To run a query within a React component, call `useOrdersToFulfillPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdersToFulfillPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdersToFulfillPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrdersToFulfillPageQuery(baseOptions?: Apollo.QueryHookOptions<OrdersToFulfillPageQuery, OrdersToFulfillPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrdersToFulfillPageQuery, OrdersToFulfillPageQueryVariables>(OrdersToFulfillPageDocument, options);
      }
export function useOrdersToFulfillPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrdersToFulfillPageQuery, OrdersToFulfillPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrdersToFulfillPageQuery, OrdersToFulfillPageQueryVariables>(OrdersToFulfillPageDocument, options);
        }
export type OrdersToFulfillPageQueryHookResult = ReturnType<typeof useOrdersToFulfillPageQuery>;
export type OrdersToFulfillPageLazyQueryHookResult = ReturnType<typeof useOrdersToFulfillPageLazyQuery>;
export type OrdersToFulfillPageQueryResult = Apollo.QueryResult<OrdersToFulfillPageQuery, OrdersToFulfillPageQueryVariables>;
export function refetchOrdersToFulfillPageQuery(variables?: OrdersToFulfillPageQueryVariables) {
      return { query: OrdersToFulfillPageDocument, variables: variables }
    }
export const UpdateOrderRequestPrioritiesDocument = gql`
    mutation UpdateOrderRequestPriorities($OrderRequestPrioritiesInput: [OrderRequestPriorityInput!]!) {
  updateOrderRequestPriorities(
    OrderRequestPrioritiesInput: $OrderRequestPrioritiesInput
  )
}
    `;
export type UpdateOrderRequestPrioritiesMutationFn = Apollo.MutationFunction<UpdateOrderRequestPrioritiesMutation, UpdateOrderRequestPrioritiesMutationVariables>;

/**
 * __useUpdateOrderRequestPrioritiesMutation__
 *
 * To run a mutation, you first call `useUpdateOrderRequestPrioritiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderRequestPrioritiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderRequestPrioritiesMutation, { data, loading, error }] = useUpdateOrderRequestPrioritiesMutation({
 *   variables: {
 *      OrderRequestPrioritiesInput: // value for 'OrderRequestPrioritiesInput'
 *   },
 * });
 */
export function useUpdateOrderRequestPrioritiesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderRequestPrioritiesMutation, UpdateOrderRequestPrioritiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderRequestPrioritiesMutation, UpdateOrderRequestPrioritiesMutationVariables>(UpdateOrderRequestPrioritiesDocument, options);
      }
export type UpdateOrderRequestPrioritiesMutationHookResult = ReturnType<typeof useUpdateOrderRequestPrioritiesMutation>;
export type UpdateOrderRequestPrioritiesMutationResult = Apollo.MutationResult<UpdateOrderRequestPrioritiesMutation>;
export type UpdateOrderRequestPrioritiesMutationOptions = Apollo.BaseMutationOptions<UpdateOrderRequestPrioritiesMutation, UpdateOrderRequestPrioritiesMutationVariables>;
export const SalesSummaryPageDocument = gql`
    query SalesSummaryPage($year: Int, $previousYear: Int, $includeReconciliationOnly: Boolean) {
  getTotalSalesSummary: getSalesSummary(
    SalesSummaryArgs: {year: $year, month: null, date_group_by: month, entity_groups: [], include_reconciliation_only: $includeReconciliationOnly}
  ) {
    sales {
      year
      month
      kilos_sold
      total
      tax
      total_with_tax
    }
  }
  getPreviousTotalSalesSummary: getSalesSummary(
    SalesSummaryArgs: {year: $previousYear, month: null, date_group_by: month, entity_groups: [], include_reconciliation_only: $includeReconciliationOnly}
  ) {
    sales {
      year
      month
      kilos_sold
      total
      tax
      total_with_tax
    }
  }
  getProductCategorySalesSummary: getSalesSummary(
    SalesSummaryArgs: {year: $year, month: null, date_group_by: month, entity_groups: [productCategory], include_reconciliation_only: $includeReconciliationOnly}
  ) {
    sales {
      year
      month
      total
      tax
      total_with_tax
      product_category_id
      kilos_sold
      order_production_type_id
    }
  }
  getPreviousProductCategorySalesSummary: getSalesSummary(
    SalesSummaryArgs: {year: $previousYear, month: null, date_group_by: month, entity_groups: [productCategory], include_reconciliation_only: $includeReconciliationOnly}
  ) {
    sales {
      year
      month
      total
      tax
      total_with_tax
      product_category_id
      kilos_sold
      order_production_type_id
    }
  }
  getProductMaterialSalesSummary: getSalesSummary(
    SalesSummaryArgs: {year: $year, month: null, date_group_by: month, entity_groups: [productMaterial], include_reconciliation_only: $includeReconciliationOnly}
  ) {
    sales {
      year
      month
      total
      tax
      total_with_tax
      product_material_id
      kilos_sold
    }
  }
  getPreviousProductMaterialSalesSummary: getSalesSummary(
    SalesSummaryArgs: {year: $previousYear, month: null, date_group_by: month, entity_groups: [productMaterial], include_reconciliation_only: $includeReconciliationOnly}
  ) {
    sales {
      year
      month
      total
      tax
      total_with_tax
      product_material_id
      kilos_sold
    }
  }
  getProductSalesSummary: getSalesSummary(
    SalesSummaryArgs: {year: $year, month: null, date_group_by: day, entity_groups: [orderSale, product, account, receipt], include_reconciliation_only: $includeReconciliationOnly}
  ) {
    sales {
      order_sale_id
      order_code
      invoice_code
      order_request_code
      account_id
      account_abbreviation
      account_name
      receipt_type_name
      product_name
      year
      day
      month
      total
      tax
      calibre
      width
      length
      total_with_tax
      product_category_id
      product_material_name
      kilos_sold
      groups_sold
      order_production_type_id
    }
  }
  getOrderRequestSummary(
    OrderRequestSummaryArgs: {year: $year, month: null, include_reconciliation_only: $includeReconciliationOnly}
  ) {
    records {
      order_request_id
      order_code
      account_id
      account_name
      account_abbreviation
      date
      product_id
      product_name
      product_material_name
      width
      length
      calibre
      kilos_requested
      groups_requested
      kilos_sold
      groups_sold
    }
  }
  getProductCategories {
    id
    name
    order_production_type_id
  }
  getProductMaterials {
    id
    name
  }
}
    `;

/**
 * __useSalesSummaryPageQuery__
 *
 * To run a query within a React component, call `useSalesSummaryPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesSummaryPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesSummaryPageQuery({
 *   variables: {
 *      year: // value for 'year'
 *      previousYear: // value for 'previousYear'
 *      includeReconciliationOnly: // value for 'includeReconciliationOnly'
 *   },
 * });
 */
export function useSalesSummaryPageQuery(baseOptions?: Apollo.QueryHookOptions<SalesSummaryPageQuery, SalesSummaryPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SalesSummaryPageQuery, SalesSummaryPageQueryVariables>(SalesSummaryPageDocument, options);
      }
export function useSalesSummaryPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SalesSummaryPageQuery, SalesSummaryPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SalesSummaryPageQuery, SalesSummaryPageQueryVariables>(SalesSummaryPageDocument, options);
        }
export type SalesSummaryPageQueryHookResult = ReturnType<typeof useSalesSummaryPageQuery>;
export type SalesSummaryPageLazyQueryHookResult = ReturnType<typeof useSalesSummaryPageLazyQuery>;
export type SalesSummaryPageQueryResult = Apollo.QueryResult<SalesSummaryPageQuery, SalesSummaryPageQueryVariables>;
export function refetchSalesSummaryPageQuery(variables?: SalesSummaryPageQueryVariables) {
      return { query: SalesSummaryPageDocument, variables: variables }
    }
export const GetActivityChangesDocument = gql`
    query GetActivityChanges($ActivityId: Int!) {
  getActivity(ActivityId: $ActivityId) {
    entity_name
    entity_id
    type
    title
    created_at
    old_data
    new_data
    snapshot_status
    user {
      id
      fullname
    }
  }
}
    `;

/**
 * __useGetActivityChangesQuery__
 *
 * To run a query within a React component, call `useGetActivityChangesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityChangesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityChangesQuery({
 *   variables: {
 *      ActivityId: // value for 'ActivityId'
 *   },
 * });
 */
export function useGetActivityChangesQuery(baseOptions: Apollo.QueryHookOptions<GetActivityChangesQuery, GetActivityChangesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActivityChangesQuery, GetActivityChangesQueryVariables>(GetActivityChangesDocument, options);
      }
export function useGetActivityChangesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActivityChangesQuery, GetActivityChangesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActivityChangesQuery, GetActivityChangesQueryVariables>(GetActivityChangesDocument, options);
        }
export type GetActivityChangesQueryHookResult = ReturnType<typeof useGetActivityChangesQuery>;
export type GetActivityChangesLazyQueryHookResult = ReturnType<typeof useGetActivityChangesLazyQuery>;
export type GetActivityChangesQueryResult = Apollo.QueryResult<GetActivityChangesQuery, GetActivityChangesQueryVariables>;
export function refetchGetActivityChangesQuery(variables: GetActivityChangesQueryVariables) {
      return { query: GetActivityChangesDocument, variables: variables }
    }
export const GetEntityActivitiesDocument = gql`
    query GetEntityActivities($EntityName: ActivityEntityName!, $EntityId: Int!) {
  getEntityActivities(EntityName: $EntityName, EntityId: $EntityId) {
    id
    type
    title
    created_at
    snapshot_status
    user {
      id
      fullname
    }
  }
}
    `;

/**
 * __useGetEntityActivitiesQuery__
 *
 * To run a query within a React component, call `useGetEntityActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityActivitiesQuery({
 *   variables: {
 *      EntityName: // value for 'EntityName'
 *      EntityId: // value for 'EntityId'
 *   },
 * });
 */
export function useGetEntityActivitiesQuery(baseOptions: Apollo.QueryHookOptions<GetEntityActivitiesQuery, GetEntityActivitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEntityActivitiesQuery, GetEntityActivitiesQueryVariables>(GetEntityActivitiesDocument, options);
      }
export function useGetEntityActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEntityActivitiesQuery, GetEntityActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEntityActivitiesQuery, GetEntityActivitiesQueryVariables>(GetEntityActivitiesDocument, options);
        }
export type GetEntityActivitiesQueryHookResult = ReturnType<typeof useGetEntityActivitiesQuery>;
export type GetEntityActivitiesLazyQueryHookResult = ReturnType<typeof useGetEntityActivitiesLazyQuery>;
export type GetEntityActivitiesQueryResult = Apollo.QueryResult<GetEntityActivitiesQuery, GetEntityActivitiesQueryVariables>;
export function refetchGetEntityActivitiesQuery(variables: GetEntityActivitiesQueryVariables) {
      return { query: GetEntityActivitiesDocument, variables: variables }
    }
export const DeleteMachinePartDocument = gql`
    mutation DeleteMachinePart($machinePartId: Float!) {
  deleteMachinePart(MachinePartId: $machinePartId)
}
    `;
export type DeleteMachinePartMutationFn = Apollo.MutationFunction<DeleteMachinePartMutation, DeleteMachinePartMutationVariables>;

/**
 * __useDeleteMachinePartMutation__
 *
 * To run a mutation, you first call `useDeleteMachinePartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMachinePartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMachinePartMutation, { data, loading, error }] = useDeleteMachinePartMutation({
 *   variables: {
 *      machinePartId: // value for 'machinePartId'
 *   },
 * });
 */
export function useDeleteMachinePartMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMachinePartMutation, DeleteMachinePartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMachinePartMutation, DeleteMachinePartMutationVariables>(DeleteMachinePartDocument, options);
      }
export type DeleteMachinePartMutationHookResult = ReturnType<typeof useDeleteMachinePartMutation>;
export type DeleteMachinePartMutationResult = Apollo.MutationResult<DeleteMachinePartMutation>;
export type DeleteMachinePartMutationOptions = Apollo.BaseMutationOptions<DeleteMachinePartMutation, DeleteMachinePartMutationVariables>;
export const DeleteMachineDocument = gql`
    mutation DeleteMachine($MachineId: Float!) {
  deleteMachine(MachineId: $MachineId)
}
    `;
export type DeleteMachineMutationFn = Apollo.MutationFunction<DeleteMachineMutation, DeleteMachineMutationVariables>;

/**
 * __useDeleteMachineMutation__
 *
 * To run a mutation, you first call `useDeleteMachineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMachineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMachineMutation, { data, loading, error }] = useDeleteMachineMutation({
 *   variables: {
 *      MachineId: // value for 'MachineId'
 *   },
 * });
 */
export function useDeleteMachineMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMachineMutation, DeleteMachineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMachineMutation, DeleteMachineMutationVariables>(DeleteMachineDocument, options);
      }
export type DeleteMachineMutationHookResult = ReturnType<typeof useDeleteMachineMutation>;
export type DeleteMachineMutationResult = Apollo.MutationResult<DeleteMachineMutation>;
export type DeleteMachineMutationOptions = Apollo.BaseMutationOptions<DeleteMachineMutation, DeleteMachineMutationVariables>;
export const DeleteSpareCategoryDocument = gql`
    mutation DeleteSpareCategory($SpareCategoryId: Float!) {
  deleteSpareCategory(SpareCategoryId: $SpareCategoryId)
}
    `;
export type DeleteSpareCategoryMutationFn = Apollo.MutationFunction<DeleteSpareCategoryMutation, DeleteSpareCategoryMutationVariables>;

/**
 * __useDeleteSpareCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteSpareCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSpareCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSpareCategoryMutation, { data, loading, error }] = useDeleteSpareCategoryMutation({
 *   variables: {
 *      SpareCategoryId: // value for 'SpareCategoryId'
 *   },
 * });
 */
export function useDeleteSpareCategoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSpareCategoryMutation, DeleteSpareCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSpareCategoryMutation, DeleteSpareCategoryMutationVariables>(DeleteSpareCategoryDocument, options);
      }
export type DeleteSpareCategoryMutationHookResult = ReturnType<typeof useDeleteSpareCategoryMutation>;
export type DeleteSpareCategoryMutationResult = Apollo.MutationResult<DeleteSpareCategoryMutation>;
export type DeleteSpareCategoryMutationOptions = Apollo.BaseMutationOptions<DeleteSpareCategoryMutation, DeleteSpareCategoryMutationVariables>;
export const DeleteSpareOperationDocument = gql`
    mutation DeleteSpareOperation($SpareOperationId: Float!) {
  deleteSpareOperation(SpareOperationId: $SpareOperationId)
}
    `;
export type DeleteSpareOperationMutationFn = Apollo.MutationFunction<DeleteSpareOperationMutation, DeleteSpareOperationMutationVariables>;

/**
 * __useDeleteSpareOperationMutation__
 *
 * To run a mutation, you first call `useDeleteSpareOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSpareOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSpareOperationMutation, { data, loading, error }] = useDeleteSpareOperationMutation({
 *   variables: {
 *      SpareOperationId: // value for 'SpareOperationId'
 *   },
 * });
 */
export function useDeleteSpareOperationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSpareOperationMutation, DeleteSpareOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSpareOperationMutation, DeleteSpareOperationMutationVariables>(DeleteSpareOperationDocument, options);
      }
export type DeleteSpareOperationMutationHookResult = ReturnType<typeof useDeleteSpareOperationMutation>;
export type DeleteSpareOperationMutationResult = Apollo.MutationResult<DeleteSpareOperationMutation>;
export type DeleteSpareOperationMutationOptions = Apollo.BaseMutationOptions<DeleteSpareOperationMutation, DeleteSpareOperationMutationVariables>;
export const DeleteSpareDocument = gql`
    mutation DeleteSpare($SpareId: Float!) {
  deleteSpare(SpareId: $SpareId)
}
    `;
export type DeleteSpareMutationFn = Apollo.MutationFunction<DeleteSpareMutation, DeleteSpareMutationVariables>;

/**
 * __useDeleteSpareMutation__
 *
 * To run a mutation, you first call `useDeleteSpareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSpareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSpareMutation, { data, loading, error }] = useDeleteSpareMutation({
 *   variables: {
 *      SpareId: // value for 'SpareId'
 *   },
 * });
 */
export function useDeleteSpareMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSpareMutation, DeleteSpareMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSpareMutation, DeleteSpareMutationVariables>(DeleteSpareDocument, options);
      }
export type DeleteSpareMutationHookResult = ReturnType<typeof useDeleteSpareMutation>;
export type DeleteSpareMutationResult = Apollo.MutationResult<DeleteSpareMutation>;
export type DeleteSpareMutationOptions = Apollo.BaseMutationOptions<DeleteSpareMutation, DeleteSpareMutationVariables>;
export const DeleteExpensesDocument = gql`
    mutation DeleteExpenses($ExpenseId: Float!) {
  deleteExpense(ExpenseId: $ExpenseId)
}
    `;
export type DeleteExpensesMutationFn = Apollo.MutationFunction<DeleteExpensesMutation, DeleteExpensesMutationVariables>;

/**
 * __useDeleteExpensesMutation__
 *
 * To run a mutation, you first call `useDeleteExpensesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExpensesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExpensesMutation, { data, loading, error }] = useDeleteExpensesMutation({
 *   variables: {
 *      ExpenseId: // value for 'ExpenseId'
 *   },
 * });
 */
export function useDeleteExpensesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteExpensesMutation, DeleteExpensesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteExpensesMutation, DeleteExpensesMutationVariables>(DeleteExpensesDocument, options);
      }
export type DeleteExpensesMutationHookResult = ReturnType<typeof useDeleteExpensesMutation>;
export type DeleteExpensesMutationResult = Apollo.MutationResult<DeleteExpensesMutation>;
export type DeleteExpensesMutationOptions = Apollo.BaseMutationOptions<DeleteExpensesMutation, DeleteExpensesMutationVariables>;
export const DeleteResourcesDocument = gql`
    mutation DeleteResources($ResourceId: Float!) {
  deleteResource(ResourceId: $ResourceId)
}
    `;
export type DeleteResourcesMutationFn = Apollo.MutationFunction<DeleteResourcesMutation, DeleteResourcesMutationVariables>;

/**
 * __useDeleteResourcesMutation__
 *
 * To run a mutation, you first call `useDeleteResourcesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteResourcesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteResourcesMutation, { data, loading, error }] = useDeleteResourcesMutation({
 *   variables: {
 *      ResourceId: // value for 'ResourceId'
 *   },
 * });
 */
export function useDeleteResourcesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteResourcesMutation, DeleteResourcesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteResourcesMutation, DeleteResourcesMutationVariables>(DeleteResourcesDocument, options);
      }
export type DeleteResourcesMutationHookResult = ReturnType<typeof useDeleteResourcesMutation>;
export type DeleteResourcesMutationResult = Apollo.MutationResult<DeleteResourcesMutation>;
export type DeleteResourcesMutationOptions = Apollo.BaseMutationOptions<DeleteResourcesMutation, DeleteResourcesMutationVariables>;
export const DeleteTransferDocument = gql`
    mutation DeleteTransfer($TransferId: Float!) {
  deleteTransfer(TransferId: $TransferId)
}
    `;
export type DeleteTransferMutationFn = Apollo.MutationFunction<DeleteTransferMutation, DeleteTransferMutationVariables>;

/**
 * __useDeleteTransferMutation__
 *
 * To run a mutation, you first call `useDeleteTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTransferMutation, { data, loading, error }] = useDeleteTransferMutation({
 *   variables: {
 *      TransferId: // value for 'TransferId'
 *   },
 * });
 */
export function useDeleteTransferMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTransferMutation, DeleteTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTransferMutation, DeleteTransferMutationVariables>(DeleteTransferDocument, options);
      }
export type DeleteTransferMutationHookResult = ReturnType<typeof useDeleteTransferMutation>;
export type DeleteTransferMutationResult = Apollo.MutationResult<DeleteTransferMutation>;
export type DeleteTransferMutationOptions = Apollo.BaseMutationOptions<DeleteTransferMutation, DeleteTransferMutationVariables>;
export const DeleteEmployeeDocument = gql`
    mutation DeleteEmployee($EmployeeId: Float!) {
  deleteEmployee(EmployeeId: $EmployeeId)
}
    `;
export type DeleteEmployeeMutationFn = Apollo.MutationFunction<DeleteEmployeeMutation, DeleteEmployeeMutationVariables>;

/**
 * __useDeleteEmployeeMutation__
 *
 * To run a mutation, you first call `useDeleteEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmployeeMutation, { data, loading, error }] = useDeleteEmployeeMutation({
 *   variables: {
 *      EmployeeId: // value for 'EmployeeId'
 *   },
 * });
 */
export function useDeleteEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEmployeeMutation, DeleteEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEmployeeMutation, DeleteEmployeeMutationVariables>(DeleteEmployeeDocument, options);
      }
export type DeleteEmployeeMutationHookResult = ReturnType<typeof useDeleteEmployeeMutation>;
export type DeleteEmployeeMutationResult = Apollo.MutationResult<DeleteEmployeeMutation>;
export type DeleteEmployeeMutationOptions = Apollo.BaseMutationOptions<DeleteEmployeeMutation, DeleteEmployeeMutationVariables>;
export const DeleteOrderAdjustmentDocument = gql`
    mutation DeleteOrderAdjustment($OrderAdjustmentId: Float!) {
  deleteOrderAdjustment(OrderAdjustmentId: $OrderAdjustmentId)
}
    `;
export type DeleteOrderAdjustmentMutationFn = Apollo.MutationFunction<DeleteOrderAdjustmentMutation, DeleteOrderAdjustmentMutationVariables>;

/**
 * __useDeleteOrderAdjustmentMutation__
 *
 * To run a mutation, you first call `useDeleteOrderAdjustmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrderAdjustmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrderAdjustmentMutation, { data, loading, error }] = useDeleteOrderAdjustmentMutation({
 *   variables: {
 *      OrderAdjustmentId: // value for 'OrderAdjustmentId'
 *   },
 * });
 */
export function useDeleteOrderAdjustmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrderAdjustmentMutation, DeleteOrderAdjustmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrderAdjustmentMutation, DeleteOrderAdjustmentMutationVariables>(DeleteOrderAdjustmentDocument, options);
      }
export type DeleteOrderAdjustmentMutationHookResult = ReturnType<typeof useDeleteOrderAdjustmentMutation>;
export type DeleteOrderAdjustmentMutationResult = Apollo.MutationResult<DeleteOrderAdjustmentMutation>;
export type DeleteOrderAdjustmentMutationOptions = Apollo.BaseMutationOptions<DeleteOrderAdjustmentMutation, DeleteOrderAdjustmentMutationVariables>;
export const DeleteOrderProductionDocument = gql`
    mutation DeleteOrderProduction($OrderProductionId: Float!) {
  deleteOrderProduction(OrderProductionId: $OrderProductionId)
}
    `;
export type DeleteOrderProductionMutationFn = Apollo.MutationFunction<DeleteOrderProductionMutation, DeleteOrderProductionMutationVariables>;

/**
 * __useDeleteOrderProductionMutation__
 *
 * To run a mutation, you first call `useDeleteOrderProductionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrderProductionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrderProductionMutation, { data, loading, error }] = useDeleteOrderProductionMutation({
 *   variables: {
 *      OrderProductionId: // value for 'OrderProductionId'
 *   },
 * });
 */
export function useDeleteOrderProductionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrderProductionMutation, DeleteOrderProductionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrderProductionMutation, DeleteOrderProductionMutationVariables>(DeleteOrderProductionDocument, options);
      }
export type DeleteOrderProductionMutationHookResult = ReturnType<typeof useDeleteOrderProductionMutation>;
export type DeleteOrderProductionMutationResult = Apollo.MutationResult<DeleteOrderProductionMutation>;
export type DeleteOrderProductionMutationOptions = Apollo.BaseMutationOptions<DeleteOrderProductionMutation, DeleteOrderProductionMutationVariables>;
export const DeleteProductDocument = gql`
    mutation DeleteProduct($ProductId: Float!) {
  deleteProduct(ProductId: $ProductId)
}
    `;
export type DeleteProductMutationFn = Apollo.MutationFunction<DeleteProductMutation, DeleteProductMutationVariables>;

/**
 * __useDeleteProductMutation__
 *
 * To run a mutation, you first call `useDeleteProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductMutation, { data, loading, error }] = useDeleteProductMutation({
 *   variables: {
 *      ProductId: // value for 'ProductId'
 *   },
 * });
 */
export function useDeleteProductMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProductMutation, DeleteProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProductMutation, DeleteProductMutationVariables>(DeleteProductDocument, options);
      }
export type DeleteProductMutationHookResult = ReturnType<typeof useDeleteProductMutation>;
export type DeleteProductMutationResult = Apollo.MutationResult<DeleteProductMutation>;
export type DeleteProductMutationOptions = Apollo.BaseMutationOptions<DeleteProductMutation, DeleteProductMutationVariables>;
export const DeleteAccountDocument = gql`
    mutation DeleteAccount($AccountId: Float!) {
  deleteAccount(AccountId: $AccountId)
}
    `;
export type DeleteAccountMutationFn = Apollo.MutationFunction<DeleteAccountMutation, DeleteAccountMutationVariables>;

/**
 * __useDeleteAccountMutation__
 *
 * To run a mutation, you first call `useDeleteAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccountMutation, { data, loading, error }] = useDeleteAccountMutation({
 *   variables: {
 *      AccountId: // value for 'AccountId'
 *   },
 * });
 */
export function useDeleteAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAccountMutation, DeleteAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAccountMutation, DeleteAccountMutationVariables>(DeleteAccountDocument, options);
      }
export type DeleteAccountMutationHookResult = ReturnType<typeof useDeleteAccountMutation>;
export type DeleteAccountMutationResult = Apollo.MutationResult<DeleteAccountMutation>;
export type DeleteAccountMutationOptions = Apollo.BaseMutationOptions<DeleteAccountMutation, DeleteAccountMutationVariables>;
export const DeleteOrderQuotationDocument = gql`
    mutation DeleteOrderQuotation($OrderQuotationId: Float!) {
  deleteOrderQuotation(OrderQuotationId: $OrderQuotationId)
}
    `;
export type DeleteOrderQuotationMutationFn = Apollo.MutationFunction<DeleteOrderQuotationMutation, DeleteOrderQuotationMutationVariables>;

/**
 * __useDeleteOrderQuotationMutation__
 *
 * To run a mutation, you first call `useDeleteOrderQuotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrderQuotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrderQuotationMutation, { data, loading, error }] = useDeleteOrderQuotationMutation({
 *   variables: {
 *      OrderQuotationId: // value for 'OrderQuotationId'
 *   },
 * });
 */
export function useDeleteOrderQuotationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrderQuotationMutation, DeleteOrderQuotationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrderQuotationMutation, DeleteOrderQuotationMutationVariables>(DeleteOrderQuotationDocument, options);
      }
export type DeleteOrderQuotationMutationHookResult = ReturnType<typeof useDeleteOrderQuotationMutation>;
export type DeleteOrderQuotationMutationResult = Apollo.MutationResult<DeleteOrderQuotationMutation>;
export type DeleteOrderQuotationMutationOptions = Apollo.BaseMutationOptions<DeleteOrderQuotationMutation, DeleteOrderQuotationMutationVariables>;
export const DeleteOrderRequestDocument = gql`
    mutation DeleteOrderRequest($OrderRequestId: Float!) {
  deleteOrderRequest(OrderRequestId: $OrderRequestId)
}
    `;
export type DeleteOrderRequestMutationFn = Apollo.MutationFunction<DeleteOrderRequestMutation, DeleteOrderRequestMutationVariables>;

/**
 * __useDeleteOrderRequestMutation__
 *
 * To run a mutation, you first call `useDeleteOrderRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrderRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrderRequestMutation, { data, loading, error }] = useDeleteOrderRequestMutation({
 *   variables: {
 *      OrderRequestId: // value for 'OrderRequestId'
 *   },
 * });
 */
export function useDeleteOrderRequestMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrderRequestMutation, DeleteOrderRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrderRequestMutation, DeleteOrderRequestMutationVariables>(DeleteOrderRequestDocument, options);
      }
export type DeleteOrderRequestMutationHookResult = ReturnType<typeof useDeleteOrderRequestMutation>;
export type DeleteOrderRequestMutationResult = Apollo.MutationResult<DeleteOrderRequestMutation>;
export type DeleteOrderRequestMutationOptions = Apollo.BaseMutationOptions<DeleteOrderRequestMutation, DeleteOrderRequestMutationVariables>;
export const DeleteOrderSaleDocument = gql`
    mutation DeleteOrderSale($OrderSaleId: Float!) {
  deleteOrderSale(OrderSaleId: $OrderSaleId)
}
    `;
export type DeleteOrderSaleMutationFn = Apollo.MutationFunction<DeleteOrderSaleMutation, DeleteOrderSaleMutationVariables>;

/**
 * __useDeleteOrderSaleMutation__
 *
 * To run a mutation, you first call `useDeleteOrderSaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrderSaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrderSaleMutation, { data, loading, error }] = useDeleteOrderSaleMutation({
 *   variables: {
 *      OrderSaleId: // value for 'OrderSaleId'
 *   },
 * });
 */
export function useDeleteOrderSaleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrderSaleMutation, DeleteOrderSaleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrderSaleMutation, DeleteOrderSaleMutationVariables>(DeleteOrderSaleDocument, options);
      }
export type DeleteOrderSaleMutationHookResult = ReturnType<typeof useDeleteOrderSaleMutation>;
export type DeleteOrderSaleMutationResult = Apollo.MutationResult<DeleteOrderSaleMutation>;
export type DeleteOrderSaleMutationOptions = Apollo.BaseMutationOptions<DeleteOrderSaleMutation, DeleteOrderSaleMutationVariables>;
export const CreateUserDocument = gql`
    mutation CreateUser($CreateUserInput: CreateUserInput!) {
  createUser(CreateUserInput: $CreateUserInput) {
    id
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      CreateUserInput: // value for 'CreateUserInput'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($UpdateUserInput: UpdateUserInput!) {
  updateUser(UpdateUserInput: $UpdateUserInput) {
    id
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      UpdateUserInput: // value for 'UpdateUserInput'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const ResetUserPasswordDocument = gql`
    mutation ResetUserPassword($UserId: Float!) {
  resetUserPassword(UserId: $UserId) {
    id
  }
}
    `;
export type ResetUserPasswordMutationFn = Apollo.MutationFunction<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>;

/**
 * __useResetUserPasswordMutation__
 *
 * To run a mutation, you first call `useResetUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetUserPasswordMutation, { data, loading, error }] = useResetUserPasswordMutation({
 *   variables: {
 *      UserId: // value for 'UserId'
 *   },
 * });
 */
export function useResetUserPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>(ResetUserPasswordDocument, options);
      }
export type ResetUserPasswordMutationHookResult = ReturnType<typeof useResetUserPasswordMutation>;
export type ResetUserPasswordMutationResult = Apollo.MutationResult<ResetUserPasswordMutation>;
export type ResetUserPasswordMutationOptions = Apollo.BaseMutationOptions<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>;
export const UserDialogDocument = gql`
    query UserDialog($UserId: Float!) {
  getUser(UserId: $UserId) {
    id
    first_name
    last_name
    email
    mfa_enabled
    is_root
    login_disabled
    roles {
      id
      name
    }
  }
}
    `;

/**
 * __useUserDialogQuery__
 *
 * To run a query within a React component, call `useUserDialogQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDialogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDialogQuery({
 *   variables: {
 *      UserId: // value for 'UserId'
 *   },
 * });
 */
export function useUserDialogQuery(baseOptions: Apollo.QueryHookOptions<UserDialogQuery, UserDialogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserDialogQuery, UserDialogQueryVariables>(UserDialogDocument, options);
      }
export function useUserDialogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserDialogQuery, UserDialogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserDialogQuery, UserDialogQueryVariables>(UserDialogDocument, options);
        }
export type UserDialogQueryHookResult = ReturnType<typeof useUserDialogQuery>;
export type UserDialogLazyQueryHookResult = ReturnType<typeof useUserDialogLazyQuery>;
export type UserDialogQueryResult = Apollo.QueryResult<UserDialogQuery, UserDialogQueryVariables>;
export function refetchUserDialogQuery(variables: UserDialogQueryVariables) {
      return { query: UserDialogDocument, variables: variables }
    }
export const UserRolesDocument = gql`
    query UserRoles {
  getRoles {
    id
    name
  }
}
    `;

/**
 * __useUserRolesQuery__
 *
 * To run a query within a React component, call `useUserRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserRolesQuery(baseOptions?: Apollo.QueryHookOptions<UserRolesQuery, UserRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserRolesQuery, UserRolesQueryVariables>(UserRolesDocument, options);
      }
export function useUserRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserRolesQuery, UserRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserRolesQuery, UserRolesQueryVariables>(UserRolesDocument, options);
        }
export type UserRolesQueryHookResult = ReturnType<typeof useUserRolesQuery>;
export type UserRolesLazyQueryHookResult = ReturnType<typeof useUserRolesLazyQuery>;
export type UserRolesQueryResult = Apollo.QueryResult<UserRolesQuery, UserRolesQueryVariables>;
export function refetchUserRolesQuery(variables?: UserRolesQueryVariables) {
      return { query: UserRolesDocument, variables: variables }
    }
export const IsEmailOccupiedDocument = gql`
    query IsEmailOccupied($Email: String!, $UserId: Float) {
  isEmailOccupied(Email: $Email, UserId: $UserId)
}
    `;

/**
 * __useIsEmailOccupiedQuery__
 *
 * To run a query within a React component, call `useIsEmailOccupiedQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsEmailOccupiedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsEmailOccupiedQuery({
 *   variables: {
 *      Email: // value for 'Email'
 *      UserId: // value for 'UserId'
 *   },
 * });
 */
export function useIsEmailOccupiedQuery(baseOptions: Apollo.QueryHookOptions<IsEmailOccupiedQuery, IsEmailOccupiedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsEmailOccupiedQuery, IsEmailOccupiedQueryVariables>(IsEmailOccupiedDocument, options);
      }
export function useIsEmailOccupiedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsEmailOccupiedQuery, IsEmailOccupiedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsEmailOccupiedQuery, IsEmailOccupiedQueryVariables>(IsEmailOccupiedDocument, options);
        }
export type IsEmailOccupiedQueryHookResult = ReturnType<typeof useIsEmailOccupiedQuery>;
export type IsEmailOccupiedLazyQueryHookResult = ReturnType<typeof useIsEmailOccupiedLazyQuery>;
export type IsEmailOccupiedQueryResult = Apollo.QueryResult<IsEmailOccupiedQuery, IsEmailOccupiedQueryVariables>;
export function refetchIsEmailOccupiedQuery(variables: IsEmailOccupiedQueryVariables) {
      return { query: IsEmailOccupiedDocument, variables: variables }
    }
export const UpsertMachinePartDocument = gql`
    mutation UpsertMachinePart($MachinePartUpsetInput: MachinePartUpsertInput!) {
  upsertMachinePart(MachinePartUpsertInput: $MachinePartUpsetInput) {
    id
    name
    machine_compatibilities {
      id
    }
  }
}
    `;
export type UpsertMachinePartMutationFn = Apollo.MutationFunction<UpsertMachinePartMutation, UpsertMachinePartMutationVariables>;

/**
 * __useUpsertMachinePartMutation__
 *
 * To run a mutation, you first call `useUpsertMachinePartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertMachinePartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertMachinePartMutation, { data, loading, error }] = useUpsertMachinePartMutation({
 *   variables: {
 *      MachinePartUpsetInput: // value for 'MachinePartUpsetInput'
 *   },
 * });
 */
export function useUpsertMachinePartMutation(baseOptions?: Apollo.MutationHookOptions<UpsertMachinePartMutation, UpsertMachinePartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertMachinePartMutation, UpsertMachinePartMutationVariables>(UpsertMachinePartDocument, options);
      }
export type UpsertMachinePartMutationHookResult = ReturnType<typeof useUpsertMachinePartMutation>;
export type UpsertMachinePartMutationResult = Apollo.MutationResult<UpsertMachinePartMutation>;
export type UpsertMachinePartMutationOptions = Apollo.BaseMutationOptions<UpsertMachinePartMutation, UpsertMachinePartMutationVariables>;
export const UpsertMachineSectionDocument = gql`
    mutation UpsertMachineSection($MachineSectionUpsertInput: MachineSectionUpsertInput!) {
  upsertMachineSection(MachineSectionUpsertInput: $MachineSectionUpsertInput) {
    id
    name
  }
}
    `;
export type UpsertMachineSectionMutationFn = Apollo.MutationFunction<UpsertMachineSectionMutation, UpsertMachineSectionMutationVariables>;

/**
 * __useUpsertMachineSectionMutation__
 *
 * To run a mutation, you first call `useUpsertMachineSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertMachineSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertMachineSectionMutation, { data, loading, error }] = useUpsertMachineSectionMutation({
 *   variables: {
 *      MachineSectionUpsertInput: // value for 'MachineSectionUpsertInput'
 *   },
 * });
 */
export function useUpsertMachineSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpsertMachineSectionMutation, UpsertMachineSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertMachineSectionMutation, UpsertMachineSectionMutationVariables>(UpsertMachineSectionDocument, options);
      }
export type UpsertMachineSectionMutationHookResult = ReturnType<typeof useUpsertMachineSectionMutation>;
export type UpsertMachineSectionMutationResult = Apollo.MutationResult<UpsertMachineSectionMutation>;
export type UpsertMachineSectionMutationOptions = Apollo.BaseMutationOptions<UpsertMachineSectionMutation, UpsertMachineSectionMutationVariables>;
export const MachineBranchInputDocument = gql`
    query MachineBranchInput {
  getBranches {
    id
    name
  }
}
    `;

/**
 * __useMachineBranchInputQuery__
 *
 * To run a query within a React component, call `useMachineBranchInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useMachineBranchInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMachineBranchInputQuery({
 *   variables: {
 *   },
 * });
 */
export function useMachineBranchInputQuery(baseOptions?: Apollo.QueryHookOptions<MachineBranchInputQuery, MachineBranchInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MachineBranchInputQuery, MachineBranchInputQueryVariables>(MachineBranchInputDocument, options);
      }
export function useMachineBranchInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MachineBranchInputQuery, MachineBranchInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MachineBranchInputQuery, MachineBranchInputQueryVariables>(MachineBranchInputDocument, options);
        }
export type MachineBranchInputQueryHookResult = ReturnType<typeof useMachineBranchInputQuery>;
export type MachineBranchInputLazyQueryHookResult = ReturnType<typeof useMachineBranchInputLazyQuery>;
export type MachineBranchInputQueryResult = Apollo.QueryResult<MachineBranchInputQuery, MachineBranchInputQueryVariables>;
export function refetchMachineBranchInputQuery(variables?: MachineBranchInputQueryVariables) {
      return { query: MachineBranchInputDocument, variables: variables }
    }
export const MachineOrderProductionTypeInputDocument = gql`
    query MachineOrderProductionTypeInput {
  getOrderProductionTypes {
    id
    name
  }
}
    `;

/**
 * __useMachineOrderProductionTypeInputQuery__
 *
 * To run a query within a React component, call `useMachineOrderProductionTypeInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useMachineOrderProductionTypeInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMachineOrderProductionTypeInputQuery({
 *   variables: {
 *   },
 * });
 */
export function useMachineOrderProductionTypeInputQuery(baseOptions?: Apollo.QueryHookOptions<MachineOrderProductionTypeInputQuery, MachineOrderProductionTypeInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MachineOrderProductionTypeInputQuery, MachineOrderProductionTypeInputQueryVariables>(MachineOrderProductionTypeInputDocument, options);
      }
export function useMachineOrderProductionTypeInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MachineOrderProductionTypeInputQuery, MachineOrderProductionTypeInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MachineOrderProductionTypeInputQuery, MachineOrderProductionTypeInputQueryVariables>(MachineOrderProductionTypeInputDocument, options);
        }
export type MachineOrderProductionTypeInputQueryHookResult = ReturnType<typeof useMachineOrderProductionTypeInputQuery>;
export type MachineOrderProductionTypeInputLazyQueryHookResult = ReturnType<typeof useMachineOrderProductionTypeInputLazyQuery>;
export type MachineOrderProductionTypeInputQueryResult = Apollo.QueryResult<MachineOrderProductionTypeInputQuery, MachineOrderProductionTypeInputQueryVariables>;
export function refetchMachineOrderProductionTypeInputQuery(variables?: MachineOrderProductionTypeInputQueryVariables) {
      return { query: MachineOrderProductionTypeInputDocument, variables: variables }
    }
export const UpsertMachineDocument = gql`
    mutation UpsertMachine($MachineUpsertInput: MachineUpsertInput!) {
  upsertMachine(MachineUpsertInput: $MachineUpsertInput) {
    id
    name
  }
}
    `;
export type UpsertMachineMutationFn = Apollo.MutationFunction<UpsertMachineMutation, UpsertMachineMutationVariables>;

/**
 * __useUpsertMachineMutation__
 *
 * To run a mutation, you first call `useUpsertMachineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertMachineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertMachineMutation, { data, loading, error }] = useUpsertMachineMutation({
 *   variables: {
 *      MachineUpsertInput: // value for 'MachineUpsertInput'
 *   },
 * });
 */
export function useUpsertMachineMutation(baseOptions?: Apollo.MutationHookOptions<UpsertMachineMutation, UpsertMachineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertMachineMutation, UpsertMachineMutationVariables>(UpsertMachineDocument, options);
      }
export type UpsertMachineMutationHookResult = ReturnType<typeof useUpsertMachineMutation>;
export type UpsertMachineMutationResult = Apollo.MutationResult<UpsertMachineMutation>;
export type UpsertMachineMutationOptions = Apollo.BaseMutationOptions<UpsertMachineMutation, UpsertMachineMutationVariables>;
export const MachineFormDocument = gql`
    query MachineForm($MachineId: Float!) {
  getMachine(MachineId: $MachineId) {
    id
    name
    order_production_type_id
    branch_id
    discontinued
    consumes_input
    created_by {
      fullname
    }
    updated_by {
      fullname
    }
  }
}
    `;

/**
 * __useMachineFormQuery__
 *
 * To run a query within a React component, call `useMachineFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useMachineFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMachineFormQuery({
 *   variables: {
 *      MachineId: // value for 'MachineId'
 *   },
 * });
 */
export function useMachineFormQuery(baseOptions: Apollo.QueryHookOptions<MachineFormQuery, MachineFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MachineFormQuery, MachineFormQueryVariables>(MachineFormDocument, options);
      }
export function useMachineFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MachineFormQuery, MachineFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MachineFormQuery, MachineFormQueryVariables>(MachineFormDocument, options);
        }
export type MachineFormQueryHookResult = ReturnType<typeof useMachineFormQuery>;
export type MachineFormLazyQueryHookResult = ReturnType<typeof useMachineFormLazyQuery>;
export type MachineFormQueryResult = Apollo.QueryResult<MachineFormQuery, MachineFormQueryVariables>;
export function refetchMachineFormQuery(variables: MachineFormQueryVariables) {
      return { query: MachineFormDocument, variables: variables }
    }
export const UpsertSpareAdjustmentDocument = gql`
    mutation UpsertSpareAdjustment($SpareAdjustmentUpsertInput: SpareAdjustmentUpsertInput!) {
  upsertSpareAdjustment(SpareAdjustmentUpsertInput: $SpareAdjustmentUpsertInput) {
    id
    description
  }
}
    `;
export type UpsertSpareAdjustmentMutationFn = Apollo.MutationFunction<UpsertSpareAdjustmentMutation, UpsertSpareAdjustmentMutationVariables>;

/**
 * __useUpsertSpareAdjustmentMutation__
 *
 * To run a mutation, you first call `useUpsertSpareAdjustmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertSpareAdjustmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertSpareAdjustmentMutation, { data, loading, error }] = useUpsertSpareAdjustmentMutation({
 *   variables: {
 *      SpareAdjustmentUpsertInput: // value for 'SpareAdjustmentUpsertInput'
 *   },
 * });
 */
export function useUpsertSpareAdjustmentMutation(baseOptions?: Apollo.MutationHookOptions<UpsertSpareAdjustmentMutation, UpsertSpareAdjustmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertSpareAdjustmentMutation, UpsertSpareAdjustmentMutationVariables>(UpsertSpareAdjustmentDocument, options);
      }
export type UpsertSpareAdjustmentMutationHookResult = ReturnType<typeof useUpsertSpareAdjustmentMutation>;
export type UpsertSpareAdjustmentMutationResult = Apollo.MutationResult<UpsertSpareAdjustmentMutation>;
export type UpsertSpareAdjustmentMutationOptions = Apollo.BaseMutationOptions<UpsertSpareAdjustmentMutation, UpsertSpareAdjustmentMutationVariables>;
export const UpsertSpareCategoryDocument = gql`
    mutation UpsertSpareCategory($SpareCategoryUpsertInput: SpareCategoryUpsertInput!) {
  upsertSpareCategory(SpareCategoryUpsertInput: $SpareCategoryUpsertInput) {
    id
    name
  }
}
    `;
export type UpsertSpareCategoryMutationFn = Apollo.MutationFunction<UpsertSpareCategoryMutation, UpsertSpareCategoryMutationVariables>;

/**
 * __useUpsertSpareCategoryMutation__
 *
 * To run a mutation, you first call `useUpsertSpareCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertSpareCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertSpareCategoryMutation, { data, loading, error }] = useUpsertSpareCategoryMutation({
 *   variables: {
 *      SpareCategoryUpsertInput: // value for 'SpareCategoryUpsertInput'
 *   },
 * });
 */
export function useUpsertSpareCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpsertSpareCategoryMutation, UpsertSpareCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertSpareCategoryMutation, UpsertSpareCategoryMutationVariables>(UpsertSpareCategoryDocument, options);
      }
export type UpsertSpareCategoryMutationHookResult = ReturnType<typeof useUpsertSpareCategoryMutation>;
export type UpsertSpareCategoryMutationResult = Apollo.MutationResult<UpsertSpareCategoryMutation>;
export type UpsertSpareCategoryMutationOptions = Apollo.BaseMutationOptions<UpsertSpareCategoryMutation, UpsertSpareCategoryMutationVariables>;
export const UpsertSpareWithdrawalDocument = gql`
    mutation UpsertSpareWithdrawal($SpareWithdrawalUpsertInput: SpareWithdrawalUpsertInput!) {
  upsertSpareWithdrawal(SpareWithdrawalUpsertInput: $SpareWithdrawalUpsertInput) {
    id
    description
  }
}
    `;
export type UpsertSpareWithdrawalMutationFn = Apollo.MutationFunction<UpsertSpareWithdrawalMutation, UpsertSpareWithdrawalMutationVariables>;

/**
 * __useUpsertSpareWithdrawalMutation__
 *
 * To run a mutation, you first call `useUpsertSpareWithdrawalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertSpareWithdrawalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertSpareWithdrawalMutation, { data, loading, error }] = useUpsertSpareWithdrawalMutation({
 *   variables: {
 *      SpareWithdrawalUpsertInput: // value for 'SpareWithdrawalUpsertInput'
 *   },
 * });
 */
export function useUpsertSpareWithdrawalMutation(baseOptions?: Apollo.MutationHookOptions<UpsertSpareWithdrawalMutation, UpsertSpareWithdrawalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertSpareWithdrawalMutation, UpsertSpareWithdrawalMutationVariables>(UpsertSpareWithdrawalDocument, options);
      }
export type UpsertSpareWithdrawalMutationHookResult = ReturnType<typeof useUpsertSpareWithdrawalMutation>;
export type UpsertSpareWithdrawalMutationResult = Apollo.MutationResult<UpsertSpareWithdrawalMutation>;
export type UpsertSpareWithdrawalMutationOptions = Apollo.BaseMutationOptions<UpsertSpareWithdrawalMutation, UpsertSpareWithdrawalMutationVariables>;
export const SpareCategoryInputDocument = gql`
    query SpareCategoryInput {
  getSpareCategories {
    id
    name
  }
}
    `;

/**
 * __useSpareCategoryInputQuery__
 *
 * To run a query within a React component, call `useSpareCategoryInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpareCategoryInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpareCategoryInputQuery({
 *   variables: {
 *   },
 * });
 */
export function useSpareCategoryInputQuery(baseOptions?: Apollo.QueryHookOptions<SpareCategoryInputQuery, SpareCategoryInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SpareCategoryInputQuery, SpareCategoryInputQueryVariables>(SpareCategoryInputDocument, options);
      }
export function useSpareCategoryInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SpareCategoryInputQuery, SpareCategoryInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SpareCategoryInputQuery, SpareCategoryInputQueryVariables>(SpareCategoryInputDocument, options);
        }
export type SpareCategoryInputQueryHookResult = ReturnType<typeof useSpareCategoryInputQuery>;
export type SpareCategoryInputLazyQueryHookResult = ReturnType<typeof useSpareCategoryInputLazyQuery>;
export type SpareCategoryInputQueryResult = Apollo.QueryResult<SpareCategoryInputQuery, SpareCategoryInputQueryVariables>;
export function refetchSpareCategoryInputQuery(variables?: SpareCategoryInputQueryVariables) {
      return { query: SpareCategoryInputDocument, variables: variables }
    }
export const UpsertSpareDocument = gql`
    mutation UpsertSpare($SpareUpsertInput: SpareUpsertInput!) {
  upsertSpare(SpareUpsertInput: $SpareUpsertInput) {
    id
    name
  }
}
    `;
export type UpsertSpareMutationFn = Apollo.MutationFunction<UpsertSpareMutation, UpsertSpareMutationVariables>;

/**
 * __useUpsertSpareMutation__
 *
 * To run a mutation, you first call `useUpsertSpareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertSpareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertSpareMutation, { data, loading, error }] = useUpsertSpareMutation({
 *   variables: {
 *      SpareUpsertInput: // value for 'SpareUpsertInput'
 *   },
 * });
 */
export function useUpsertSpareMutation(baseOptions?: Apollo.MutationHookOptions<UpsertSpareMutation, UpsertSpareMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertSpareMutation, UpsertSpareMutationVariables>(UpsertSpareDocument, options);
      }
export type UpsertSpareMutationHookResult = ReturnType<typeof useUpsertSpareMutation>;
export type UpsertSpareMutationResult = Apollo.MutationResult<UpsertSpareMutation>;
export type UpsertSpareMutationOptions = Apollo.BaseMutationOptions<UpsertSpareMutation, UpsertSpareMutationVariables>;
export const ResourceIdInputDocument = gql`
    query ResourceIdInput {
  getResources {
    id
    name
  }
}
    `;

/**
 * __useResourceIdInputQuery__
 *
 * To run a query within a React component, call `useResourceIdInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceIdInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceIdInputQuery({
 *   variables: {
 *   },
 * });
 */
export function useResourceIdInputQuery(baseOptions?: Apollo.QueryHookOptions<ResourceIdInputQuery, ResourceIdInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourceIdInputQuery, ResourceIdInputQueryVariables>(ResourceIdInputDocument, options);
      }
export function useResourceIdInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourceIdInputQuery, ResourceIdInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourceIdInputQuery, ResourceIdInputQueryVariables>(ResourceIdInputDocument, options);
        }
export type ResourceIdInputQueryHookResult = ReturnType<typeof useResourceIdInputQuery>;
export type ResourceIdInputLazyQueryHookResult = ReturnType<typeof useResourceIdInputLazyQuery>;
export type ResourceIdInputQueryResult = Apollo.QueryResult<ResourceIdInputQuery, ResourceIdInputQueryVariables>;
export function refetchResourceIdInputQuery(variables?: ResourceIdInputQueryVariables) {
      return { query: ResourceIdInputDocument, variables: variables }
    }
export const UpsertAccountDialogDocument = gql`
    mutation UpsertAccountDialog($AccountUpsertInput: AccountUpsertInput!) {
  upsertAccount(AccountUpsertInput: $AccountUpsertInput) {
    id
    abbreviation
    name
    resource_id
    account_contacts {
      id
      first_name
      last_name
      email
      cellphone
    }
  }
}
    `;
export type UpsertAccountDialogMutationFn = Apollo.MutationFunction<UpsertAccountDialogMutation, UpsertAccountDialogMutationVariables>;

/**
 * __useUpsertAccountDialogMutation__
 *
 * To run a mutation, you first call `useUpsertAccountDialogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertAccountDialogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertAccountDialogMutation, { data, loading, error }] = useUpsertAccountDialogMutation({
 *   variables: {
 *      AccountUpsertInput: // value for 'AccountUpsertInput'
 *   },
 * });
 */
export function useUpsertAccountDialogMutation(baseOptions?: Apollo.MutationHookOptions<UpsertAccountDialogMutation, UpsertAccountDialogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertAccountDialogMutation, UpsertAccountDialogMutationVariables>(UpsertAccountDialogDocument, options);
      }
export type UpsertAccountDialogMutationHookResult = ReturnType<typeof useUpsertAccountDialogMutation>;
export type UpsertAccountDialogMutationResult = Apollo.MutationResult<UpsertAccountDialogMutation>;
export type UpsertAccountDialogMutationOptions = Apollo.BaseMutationOptions<UpsertAccountDialogMutation, UpsertAccountDialogMutationVariables>;
export const AccountDialogDocument = gql`
    query AccountDialog($AccountId: Float!) {
  getAccount(AccountId: $AccountId) {
    id
    name
    abbreviation
    rfc
    address
    requires_order_request
    monitor_supplier_expenses
    resource_id
    client_credit_days
    supplier_credit_days
    client_require_credit_note
    client_require_supplement
    client_requires_invoice_code
    client_requires_tax
    supplier_require_supplement
    supplier_requires_external_code
    supplier_requires_tax
    supplier_recurring_expenses
    supplier_is_draft
    client_automatic_tax_calculation
    client_reconciliation_only
    supplier_reconciliation_only
    is_informal_account
    exclude_from_balances_summary
    account_contacts {
      id
      first_name
      last_name
      cellphone
      email
    }
    account_products {
      id
      kilo_price
      group_price
      group_weight
      product {
        id
        compound_description
        current_group_weight
        discontinued
        product_category {
          id
          name
        }
      }
    }
    account_resources {
      id
      unit_price
      notes
      resource {
        id
        name
      }
    }
    is_client
    is_supplier
    is_own
    created_by {
      fullname
    }
    updated_by {
      fullname
    }
  }
  getProducts(exclude_discontinued: true) {
    id
    compound_description
    current_group_weight
    product_category {
      id
      name
    }
  }
  getResources {
    id
    name
  }
}
    `;

/**
 * __useAccountDialogQuery__
 *
 * To run a query within a React component, call `useAccountDialogQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountDialogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountDialogQuery({
 *   variables: {
 *      AccountId: // value for 'AccountId'
 *   },
 * });
 */
export function useAccountDialogQuery(baseOptions: Apollo.QueryHookOptions<AccountDialogQuery, AccountDialogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountDialogQuery, AccountDialogQueryVariables>(AccountDialogDocument, options);
      }
export function useAccountDialogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountDialogQuery, AccountDialogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountDialogQuery, AccountDialogQueryVariables>(AccountDialogDocument, options);
        }
export type AccountDialogQueryHookResult = ReturnType<typeof useAccountDialogQuery>;
export type AccountDialogLazyQueryHookResult = ReturnType<typeof useAccountDialogLazyQuery>;
export type AccountDialogQueryResult = Apollo.QueryResult<AccountDialogQuery, AccountDialogQueryVariables>;
export function refetchAccountDialogQuery(variables: AccountDialogQueryVariables) {
      return { query: AccountDialogDocument, variables: variables }
    }
export const SimilarAccountNamesDocument = gql`
    query SimilarAccountNames($Name: String!, $ExcludeAccountId: Float) {
  getSimilarAccountNames(Name: $Name, ExcludeAccountId: $ExcludeAccountId) {
    id
    name
    abbreviation
    reason
    similarity
  }
}
    `;

/**
 * __useSimilarAccountNamesQuery__
 *
 * To run a query within a React component, call `useSimilarAccountNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSimilarAccountNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSimilarAccountNamesQuery({
 *   variables: {
 *      Name: // value for 'Name'
 *      ExcludeAccountId: // value for 'ExcludeAccountId'
 *   },
 * });
 */
export function useSimilarAccountNamesQuery(baseOptions: Apollo.QueryHookOptions<SimilarAccountNamesQuery, SimilarAccountNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SimilarAccountNamesQuery, SimilarAccountNamesQueryVariables>(SimilarAccountNamesDocument, options);
      }
export function useSimilarAccountNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SimilarAccountNamesQuery, SimilarAccountNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SimilarAccountNamesQuery, SimilarAccountNamesQueryVariables>(SimilarAccountNamesDocument, options);
        }
export type SimilarAccountNamesQueryHookResult = ReturnType<typeof useSimilarAccountNamesQuery>;
export type SimilarAccountNamesLazyQueryHookResult = ReturnType<typeof useSimilarAccountNamesLazyQuery>;
export type SimilarAccountNamesQueryResult = Apollo.QueryResult<SimilarAccountNamesQuery, SimilarAccountNamesQueryVariables>;
export function refetchSimilarAccountNamesQuery(variables: SimilarAccountNamesQueryVariables) {
      return { query: SimilarAccountNamesDocument, variables: variables }
    }
export const UpdateExpenseDetailsDocument = gql`
    mutation UpdateExpenseDetails($ExpenseDetailsInput: ExpenseDetailsInput!) {
  updateExpenseDetails(ExpenseDetailsInput: $ExpenseDetailsInput) {
    id
    notes
    expected_payment_date
    require_external_code
    external_code
    require_supplement
    supplement_code
    reconciliation_only
    is_draft
    canceled
  }
}
    `;
export type UpdateExpenseDetailsMutationFn = Apollo.MutationFunction<UpdateExpenseDetailsMutation, UpdateExpenseDetailsMutationVariables>;

/**
 * __useUpdateExpenseDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateExpenseDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExpenseDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExpenseDetailsMutation, { data, loading, error }] = useUpdateExpenseDetailsMutation({
 *   variables: {
 *      ExpenseDetailsInput: // value for 'ExpenseDetailsInput'
 *   },
 * });
 */
export function useUpdateExpenseDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExpenseDetailsMutation, UpdateExpenseDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExpenseDetailsMutation, UpdateExpenseDetailsMutationVariables>(UpdateExpenseDetailsDocument, options);
      }
export type UpdateExpenseDetailsMutationHookResult = ReturnType<typeof useUpdateExpenseDetailsMutation>;
export type UpdateExpenseDetailsMutationResult = Apollo.MutationResult<UpdateExpenseDetailsMutation>;
export type UpdateExpenseDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateExpenseDetailsMutation, UpdateExpenseDetailsMutationVariables>;
export const ExpenseAccountIdInputDocument = gql`
    query ExpenseAccountIdInput {
  getAccounts(is_supplier: true) {
    id
    name
    compound_name
    resource_id
    monitor_supplier_expenses
    supplier_credit_days
    supplier_require_supplement
    supplier_requires_external_code
    supplier_requires_tax
    supplier_reconciliation_only
    supplier_is_draft
  }
}
    `;

/**
 * __useExpenseAccountIdInputQuery__
 *
 * To run a query within a React component, call `useExpenseAccountIdInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpenseAccountIdInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpenseAccountIdInputQuery({
 *   variables: {
 *   },
 * });
 */
export function useExpenseAccountIdInputQuery(baseOptions?: Apollo.QueryHookOptions<ExpenseAccountIdInputQuery, ExpenseAccountIdInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExpenseAccountIdInputQuery, ExpenseAccountIdInputQueryVariables>(ExpenseAccountIdInputDocument, options);
      }
export function useExpenseAccountIdInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpenseAccountIdInputQuery, ExpenseAccountIdInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExpenseAccountIdInputQuery, ExpenseAccountIdInputQueryVariables>(ExpenseAccountIdInputDocument, options);
        }
export type ExpenseAccountIdInputQueryHookResult = ReturnType<typeof useExpenseAccountIdInputQuery>;
export type ExpenseAccountIdInputLazyQueryHookResult = ReturnType<typeof useExpenseAccountIdInputLazyQuery>;
export type ExpenseAccountIdInputQueryResult = Apollo.QueryResult<ExpenseAccountIdInputQuery, ExpenseAccountIdInputQueryVariables>;
export function refetchExpenseAccountIdInputQuery(variables?: ExpenseAccountIdInputQueryVariables) {
      return { query: ExpenseAccountIdInputDocument, variables: variables }
    }
export const ExpenseResourcesInputDocument = gql`
    query ExpenseResourcesInput {
  getResources {
    id
    name
  }
}
    `;

/**
 * __useExpenseResourcesInputQuery__
 *
 * To run a query within a React component, call `useExpenseResourcesInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpenseResourcesInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpenseResourcesInputQuery({
 *   variables: {
 *   },
 * });
 */
export function useExpenseResourcesInputQuery(baseOptions?: Apollo.QueryHookOptions<ExpenseResourcesInputQuery, ExpenseResourcesInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExpenseResourcesInputQuery, ExpenseResourcesInputQueryVariables>(ExpenseResourcesInputDocument, options);
      }
export function useExpenseResourcesInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpenseResourcesInputQuery, ExpenseResourcesInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExpenseResourcesInputQuery, ExpenseResourcesInputQueryVariables>(ExpenseResourcesInputDocument, options);
        }
export type ExpenseResourcesInputQueryHookResult = ReturnType<typeof useExpenseResourcesInputQuery>;
export type ExpenseResourcesInputLazyQueryHookResult = ReturnType<typeof useExpenseResourcesInputLazyQuery>;
export type ExpenseResourcesInputQueryResult = Apollo.QueryResult<ExpenseResourcesInputQuery, ExpenseResourcesInputQueryVariables>;
export function refetchExpenseResourcesInputQuery(variables?: ExpenseResourcesInputQueryVariables) {
      return { query: ExpenseResourcesInputDocument, variables: variables }
    }
export const ExpenseSupplierCatalogReferenceDocument = gql`
    query ExpenseSupplierCatalogReference($AccountId: Float!) {
  getAccountResources(AccountId: $AccountId) {
    id
    unit_price
    notes
    resource {
      id
      name
    }
  }
}
    `;

/**
 * __useExpenseSupplierCatalogReferenceQuery__
 *
 * To run a query within a React component, call `useExpenseSupplierCatalogReferenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpenseSupplierCatalogReferenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpenseSupplierCatalogReferenceQuery({
 *   variables: {
 *      AccountId: // value for 'AccountId'
 *   },
 * });
 */
export function useExpenseSupplierCatalogReferenceQuery(baseOptions: Apollo.QueryHookOptions<ExpenseSupplierCatalogReferenceQuery, ExpenseSupplierCatalogReferenceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExpenseSupplierCatalogReferenceQuery, ExpenseSupplierCatalogReferenceQueryVariables>(ExpenseSupplierCatalogReferenceDocument, options);
      }
export function useExpenseSupplierCatalogReferenceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpenseSupplierCatalogReferenceQuery, ExpenseSupplierCatalogReferenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExpenseSupplierCatalogReferenceQuery, ExpenseSupplierCatalogReferenceQueryVariables>(ExpenseSupplierCatalogReferenceDocument, options);
        }
export type ExpenseSupplierCatalogReferenceQueryHookResult = ReturnType<typeof useExpenseSupplierCatalogReferenceQuery>;
export type ExpenseSupplierCatalogReferenceLazyQueryHookResult = ReturnType<typeof useExpenseSupplierCatalogReferenceLazyQuery>;
export type ExpenseSupplierCatalogReferenceQueryResult = Apollo.QueryResult<ExpenseSupplierCatalogReferenceQuery, ExpenseSupplierCatalogReferenceQueryVariables>;
export function refetchExpenseSupplierCatalogReferenceQuery(variables: ExpenseSupplierCatalogReferenceQueryVariables) {
      return { query: ExpenseSupplierCatalogReferenceDocument, variables: variables }
    }
export const GetExpenseMaxInternalCodeDocument = gql`
    query GetExpenseMaxInternalCode {
  getExpenseMaxInternalCode
}
    `;

/**
 * __useGetExpenseMaxInternalCodeQuery__
 *
 * To run a query within a React component, call `useGetExpenseMaxInternalCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExpenseMaxInternalCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExpenseMaxInternalCodeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetExpenseMaxInternalCodeQuery(baseOptions?: Apollo.QueryHookOptions<GetExpenseMaxInternalCodeQuery, GetExpenseMaxInternalCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExpenseMaxInternalCodeQuery, GetExpenseMaxInternalCodeQueryVariables>(GetExpenseMaxInternalCodeDocument, options);
      }
export function useGetExpenseMaxInternalCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExpenseMaxInternalCodeQuery, GetExpenseMaxInternalCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExpenseMaxInternalCodeQuery, GetExpenseMaxInternalCodeQueryVariables>(GetExpenseMaxInternalCodeDocument, options);
        }
export type GetExpenseMaxInternalCodeQueryHookResult = ReturnType<typeof useGetExpenseMaxInternalCodeQuery>;
export type GetExpenseMaxInternalCodeLazyQueryHookResult = ReturnType<typeof useGetExpenseMaxInternalCodeLazyQuery>;
export type GetExpenseMaxInternalCodeQueryResult = Apollo.QueryResult<GetExpenseMaxInternalCodeQuery, GetExpenseMaxInternalCodeQueryVariables>;
export function refetchGetExpenseMaxInternalCodeQuery(variables?: GetExpenseMaxInternalCodeQueryVariables) {
      return { query: GetExpenseMaxInternalCodeDocument, variables: variables }
    }
export const ExpenseReceiptTypeIdInputDocument = gql`
    query ExpenseReceiptTypeIdInput {
  getReceiptTypes {
    id
    name
    applies_tax
    tax_rate
  }
}
    `;

/**
 * __useExpenseReceiptTypeIdInputQuery__
 *
 * To run a query within a React component, call `useExpenseReceiptTypeIdInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpenseReceiptTypeIdInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpenseReceiptTypeIdInputQuery({
 *   variables: {
 *   },
 * });
 */
export function useExpenseReceiptTypeIdInputQuery(baseOptions?: Apollo.QueryHookOptions<ExpenseReceiptTypeIdInputQuery, ExpenseReceiptTypeIdInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExpenseReceiptTypeIdInputQuery, ExpenseReceiptTypeIdInputQueryVariables>(ExpenseReceiptTypeIdInputDocument, options);
      }
export function useExpenseReceiptTypeIdInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpenseReceiptTypeIdInputQuery, ExpenseReceiptTypeIdInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExpenseReceiptTypeIdInputQuery, ExpenseReceiptTypeIdInputQueryVariables>(ExpenseReceiptTypeIdInputDocument, options);
        }
export type ExpenseReceiptTypeIdInputQueryHookResult = ReturnType<typeof useExpenseReceiptTypeIdInputQuery>;
export type ExpenseReceiptTypeIdInputLazyQueryHookResult = ReturnType<typeof useExpenseReceiptTypeIdInputLazyQuery>;
export type ExpenseReceiptTypeIdInputQueryResult = Apollo.QueryResult<ExpenseReceiptTypeIdInputQuery, ExpenseReceiptTypeIdInputQueryVariables>;
export function refetchExpenseReceiptTypeIdInputQuery(variables?: ExpenseReceiptTypeIdInputQueryVariables) {
      return { query: ExpenseReceiptTypeIdInputDocument, variables: variables }
    }
export const UpsertExpensesDialogDocument = gql`
    mutation UpsertExpensesDialog($ExpenseUpsertInput: ExpenseUpsertInput!) {
  upsertExpense(ExpenseUpsertInput: $ExpenseUpsertInput) {
    id
    notes
  }
}
    `;
export type UpsertExpensesDialogMutationFn = Apollo.MutationFunction<UpsertExpensesDialogMutation, UpsertExpensesDialogMutationVariables>;

/**
 * __useUpsertExpensesDialogMutation__
 *
 * To run a mutation, you first call `useUpsertExpensesDialogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertExpensesDialogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertExpensesDialogMutation, { data, loading, error }] = useUpsertExpensesDialogMutation({
 *   variables: {
 *      ExpenseUpsertInput: // value for 'ExpenseUpsertInput'
 *   },
 * });
 */
export function useUpsertExpensesDialogMutation(baseOptions?: Apollo.MutationHookOptions<UpsertExpensesDialogMutation, UpsertExpensesDialogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertExpensesDialogMutation, UpsertExpensesDialogMutationVariables>(UpsertExpensesDialogDocument, options);
      }
export type UpsertExpensesDialogMutationHookResult = ReturnType<typeof useUpsertExpensesDialogMutation>;
export type UpsertExpensesDialogMutationResult = Apollo.MutationResult<UpsertExpensesDialogMutation>;
export type UpsertExpensesDialogMutationOptions = Apollo.BaseMutationOptions<UpsertExpensesDialogMutation, UpsertExpensesDialogMutationVariables>;
export const ExpensesDialogDocument = gql`
    query ExpensesDialog($ExpenseId: Float!) {
  getExpense(ExpenseId: $ExpenseId) {
    id
    notes
    date
    locked
    external_code
    internal_code
    expected_payment_date
    account {
      id
      name
      compound_name
      resource_id
      monitor_supplier_expenses
      supplier_requires_external_code
      supplier_requires_tax
      supplier_is_draft
    }
    receipt_type_id
    tax
    tax_retained
    subtotal
    non_tax_retained
    resources_total
    expense_resources {
      id
      units
      expense_id
      resource_id
      unit_price
      notes
      date
    }
    total_with_tax
    require_supplement
    require_external_code
    require_tax
    supplement_code
    canceled
    reconciliation_only
    is_draft
    transfer_receipts {
      id
      transfer {
        transferred_date
        from_account {
          compound_name
        }
      }
      amount
    }
    transfer_receipts_total
    transfer_receipts_total_no_adjustments
    created_by {
      fullname
    }
    updated_by {
      fullname
    }
  }
}
    `;

/**
 * __useExpensesDialogQuery__
 *
 * To run a query within a React component, call `useExpensesDialogQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpensesDialogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpensesDialogQuery({
 *   variables: {
 *      ExpenseId: // value for 'ExpenseId'
 *   },
 * });
 */
export function useExpensesDialogQuery(baseOptions: Apollo.QueryHookOptions<ExpensesDialogQuery, ExpensesDialogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExpensesDialogQuery, ExpensesDialogQueryVariables>(ExpensesDialogDocument, options);
      }
export function useExpensesDialogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpensesDialogQuery, ExpensesDialogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExpensesDialogQuery, ExpensesDialogQueryVariables>(ExpensesDialogDocument, options);
        }
export type ExpensesDialogQueryHookResult = ReturnType<typeof useExpensesDialogQuery>;
export type ExpensesDialogLazyQueryHookResult = ReturnType<typeof useExpensesDialogLazyQuery>;
export type ExpensesDialogQueryResult = Apollo.QueryResult<ExpensesDialogQuery, ExpensesDialogQueryVariables>;
export function refetchExpensesDialogQuery(variables: ExpensesDialogQueryVariables) {
      return { query: ExpensesDialogDocument, variables: variables }
    }
export const IsExpenseInternalCodeOccupiedDocument = gql`
    query IsExpenseInternalCodeOccupied($InternalCode: Float!, $ExpenseId: Int) {
  isExpenseInternalCodeOccupied(
    InternalCode: $InternalCode
    ExpenseId: $ExpenseId
  )
}
    `;

/**
 * __useIsExpenseInternalCodeOccupiedQuery__
 *
 * To run a query within a React component, call `useIsExpenseInternalCodeOccupiedQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsExpenseInternalCodeOccupiedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsExpenseInternalCodeOccupiedQuery({
 *   variables: {
 *      InternalCode: // value for 'InternalCode'
 *      ExpenseId: // value for 'ExpenseId'
 *   },
 * });
 */
export function useIsExpenseInternalCodeOccupiedQuery(baseOptions: Apollo.QueryHookOptions<IsExpenseInternalCodeOccupiedQuery, IsExpenseInternalCodeOccupiedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsExpenseInternalCodeOccupiedQuery, IsExpenseInternalCodeOccupiedQueryVariables>(IsExpenseInternalCodeOccupiedDocument, options);
      }
export function useIsExpenseInternalCodeOccupiedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsExpenseInternalCodeOccupiedQuery, IsExpenseInternalCodeOccupiedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsExpenseInternalCodeOccupiedQuery, IsExpenseInternalCodeOccupiedQueryVariables>(IsExpenseInternalCodeOccupiedDocument, options);
        }
export type IsExpenseInternalCodeOccupiedQueryHookResult = ReturnType<typeof useIsExpenseInternalCodeOccupiedQuery>;
export type IsExpenseInternalCodeOccupiedLazyQueryHookResult = ReturnType<typeof useIsExpenseInternalCodeOccupiedLazyQuery>;
export type IsExpenseInternalCodeOccupiedQueryResult = Apollo.QueryResult<IsExpenseInternalCodeOccupiedQuery, IsExpenseInternalCodeOccupiedQueryVariables>;
export function refetchIsExpenseInternalCodeOccupiedQuery(variables: IsExpenseInternalCodeOccupiedQueryVariables) {
      return { query: IsExpenseInternalCodeOccupiedDocument, variables: variables }
    }
export const RecurringExpenseCandidatesDocument = gql`
    query RecurringExpenseCandidates($year: Int!, $month: Int!) {
  getRecurringExpenseCandidates(year: $year, month: $month) {
    expense_id
    account_id
    account_name
    date
    notes
    subtotal
    tax
    tax_retained
    non_tax_retained
    receipt_type_id
    suggested_payment_date
    require_supplement
    require_external_code
    expense_resources {
      id
      units
      unit_price
      resource_id
      notes
      date
    }
    already_generated
  }
}
    `;

/**
 * __useRecurringExpenseCandidatesQuery__
 *
 * To run a query within a React component, call `useRecurringExpenseCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecurringExpenseCandidatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecurringExpenseCandidatesQuery({
 *   variables: {
 *      year: // value for 'year'
 *      month: // value for 'month'
 *   },
 * });
 */
export function useRecurringExpenseCandidatesQuery(baseOptions: Apollo.QueryHookOptions<RecurringExpenseCandidatesQuery, RecurringExpenseCandidatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecurringExpenseCandidatesQuery, RecurringExpenseCandidatesQueryVariables>(RecurringExpenseCandidatesDocument, options);
      }
export function useRecurringExpenseCandidatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecurringExpenseCandidatesQuery, RecurringExpenseCandidatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecurringExpenseCandidatesQuery, RecurringExpenseCandidatesQueryVariables>(RecurringExpenseCandidatesDocument, options);
        }
export type RecurringExpenseCandidatesQueryHookResult = ReturnType<typeof useRecurringExpenseCandidatesQuery>;
export type RecurringExpenseCandidatesLazyQueryHookResult = ReturnType<typeof useRecurringExpenseCandidatesLazyQuery>;
export type RecurringExpenseCandidatesQueryResult = Apollo.QueryResult<RecurringExpenseCandidatesQuery, RecurringExpenseCandidatesQueryVariables>;
export function refetchRecurringExpenseCandidatesQuery(variables: RecurringExpenseCandidatesQueryVariables) {
      return { query: RecurringExpenseCandidatesDocument, variables: variables }
    }
export const GenerateRecurringExpensesDocument = gql`
    mutation GenerateRecurringExpenses($input: [GenerateRecurringExpenseInput!]!) {
  generateRecurringExpenses(input: $input) {
    created_ids
    skipped_ids
  }
}
    `;
export type GenerateRecurringExpensesMutationFn = Apollo.MutationFunction<GenerateRecurringExpensesMutation, GenerateRecurringExpensesMutationVariables>;

/**
 * __useGenerateRecurringExpensesMutation__
 *
 * To run a mutation, you first call `useGenerateRecurringExpensesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateRecurringExpensesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateRecurringExpensesMutation, { data, loading, error }] = useGenerateRecurringExpensesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateRecurringExpensesMutation(baseOptions?: Apollo.MutationHookOptions<GenerateRecurringExpensesMutation, GenerateRecurringExpensesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateRecurringExpensesMutation, GenerateRecurringExpensesMutationVariables>(GenerateRecurringExpensesDocument, options);
      }
export type GenerateRecurringExpensesMutationHookResult = ReturnType<typeof useGenerateRecurringExpensesMutation>;
export type GenerateRecurringExpensesMutationResult = Apollo.MutationResult<GenerateRecurringExpensesMutation>;
export type GenerateRecurringExpensesMutationOptions = Apollo.BaseMutationOptions<GenerateRecurringExpensesMutation, GenerateRecurringExpensesMutationVariables>;
export const ResourceCategoryIdInputDocument = gql`
    query ResourceCategoryIdInput {
  getResourceCategories {
    id
    name
  }
}
    `;

/**
 * __useResourceCategoryIdInputQuery__
 *
 * To run a query within a React component, call `useResourceCategoryIdInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceCategoryIdInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceCategoryIdInputQuery({
 *   variables: {
 *   },
 * });
 */
export function useResourceCategoryIdInputQuery(baseOptions?: Apollo.QueryHookOptions<ResourceCategoryIdInputQuery, ResourceCategoryIdInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourceCategoryIdInputQuery, ResourceCategoryIdInputQueryVariables>(ResourceCategoryIdInputDocument, options);
      }
export function useResourceCategoryIdInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourceCategoryIdInputQuery, ResourceCategoryIdInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourceCategoryIdInputQuery, ResourceCategoryIdInputQueryVariables>(ResourceCategoryIdInputDocument, options);
        }
export type ResourceCategoryIdInputQueryHookResult = ReturnType<typeof useResourceCategoryIdInputQuery>;
export type ResourceCategoryIdInputLazyQueryHookResult = ReturnType<typeof useResourceCategoryIdInputLazyQuery>;
export type ResourceCategoryIdInputQueryResult = Apollo.QueryResult<ResourceCategoryIdInputQuery, ResourceCategoryIdInputQueryVariables>;
export function refetchResourceCategoryIdInputQuery(variables?: ResourceCategoryIdInputQueryVariables) {
      return { query: ResourceCategoryIdInputDocument, variables: variables }
    }
export const UpsertResourceDialogDocument = gql`
    mutation UpsertResourceDialog($ResourceUpsertInput: ResourceUpsertInput!) {
  upsertResource(ResourceUpsertInput: $ResourceUpsertInput) {
    id
    name
  }
}
    `;
export type UpsertResourceDialogMutationFn = Apollo.MutationFunction<UpsertResourceDialogMutation, UpsertResourceDialogMutationVariables>;

/**
 * __useUpsertResourceDialogMutation__
 *
 * To run a mutation, you first call `useUpsertResourceDialogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertResourceDialogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertResourceDialogMutation, { data, loading, error }] = useUpsertResourceDialogMutation({
 *   variables: {
 *      ResourceUpsertInput: // value for 'ResourceUpsertInput'
 *   },
 * });
 */
export function useUpsertResourceDialogMutation(baseOptions?: Apollo.MutationHookOptions<UpsertResourceDialogMutation, UpsertResourceDialogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertResourceDialogMutation, UpsertResourceDialogMutationVariables>(UpsertResourceDialogDocument, options);
      }
export type UpsertResourceDialogMutationHookResult = ReturnType<typeof useUpsertResourceDialogMutation>;
export type UpsertResourceDialogMutationResult = Apollo.MutationResult<UpsertResourceDialogMutation>;
export type UpsertResourceDialogMutationOptions = Apollo.BaseMutationOptions<UpsertResourceDialogMutation, UpsertResourceDialogMutationVariables>;
export const ResourceDialogDocument = gql`
    query ResourceDialog($ResourceId: Float!) {
  getResource(ResourceId: $ResourceId) {
    id
    name
    resource_category_id
    current_group_price
    current_group_weight
    current_unit_price
    group_weight_strict
    include_units_in_summary
    unit_price_name
    created_by {
      fullname
    }
    updated_by {
      fullname
    }
  }
}
    `;

/**
 * __useResourceDialogQuery__
 *
 * To run a query within a React component, call `useResourceDialogQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceDialogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceDialogQuery({
 *   variables: {
 *      ResourceId: // value for 'ResourceId'
 *   },
 * });
 */
export function useResourceDialogQuery(baseOptions: Apollo.QueryHookOptions<ResourceDialogQuery, ResourceDialogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourceDialogQuery, ResourceDialogQueryVariables>(ResourceDialogDocument, options);
      }
export function useResourceDialogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourceDialogQuery, ResourceDialogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourceDialogQuery, ResourceDialogQueryVariables>(ResourceDialogDocument, options);
        }
export type ResourceDialogQueryHookResult = ReturnType<typeof useResourceDialogQuery>;
export type ResourceDialogLazyQueryHookResult = ReturnType<typeof useResourceDialogLazyQuery>;
export type ResourceDialogQueryResult = Apollo.QueryResult<ResourceDialogQuery, ResourceDialogQueryVariables>;
export function refetchResourceDialogQuery(variables: ResourceDialogQueryVariables) {
      return { query: ResourceDialogDocument, variables: variables }
    }
export const FromAccountIdInputDocument = gql`
    query FromAccountIdInput($isOwn: Boolean!, $isClient: Boolean!, $isSupplier: Boolean!) {
  getAccounts(is_own: $isOwn, is_client: $isClient, is_supplier: $isSupplier) {
    id
    name
    compound_name
    is_own
    is_supplier
    is_client
    is_informal_account
  }
}
    `;

/**
 * __useFromAccountIdInputQuery__
 *
 * To run a query within a React component, call `useFromAccountIdInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useFromAccountIdInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFromAccountIdInputQuery({
 *   variables: {
 *      isOwn: // value for 'isOwn'
 *      isClient: // value for 'isClient'
 *      isSupplier: // value for 'isSupplier'
 *   },
 * });
 */
export function useFromAccountIdInputQuery(baseOptions: Apollo.QueryHookOptions<FromAccountIdInputQuery, FromAccountIdInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FromAccountIdInputQuery, FromAccountIdInputQueryVariables>(FromAccountIdInputDocument, options);
      }
export function useFromAccountIdInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FromAccountIdInputQuery, FromAccountIdInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FromAccountIdInputQuery, FromAccountIdInputQueryVariables>(FromAccountIdInputDocument, options);
        }
export type FromAccountIdInputQueryHookResult = ReturnType<typeof useFromAccountIdInputQuery>;
export type FromAccountIdInputLazyQueryHookResult = ReturnType<typeof useFromAccountIdInputLazyQuery>;
export type FromAccountIdInputQueryResult = Apollo.QueryResult<FromAccountIdInputQuery, FromAccountIdInputQueryVariables>;
export function refetchFromAccountIdInputQuery(variables: FromAccountIdInputQueryVariables) {
      return { query: FromAccountIdInputDocument, variables: variables }
    }
export const UpsertTransferDialogDocument = gql`
    mutation UpsertTransferDialog($TransferUpsertInput: TransferUpsertInput!) {
  upsertTransfer(TransferUpsertInput: $TransferUpsertInput) {
    id
    amount
    to_account_id
    from_account_id
  }
}
    `;
export type UpsertTransferDialogMutationFn = Apollo.MutationFunction<UpsertTransferDialogMutation, UpsertTransferDialogMutationVariables>;

/**
 * __useUpsertTransferDialogMutation__
 *
 * To run a mutation, you first call `useUpsertTransferDialogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertTransferDialogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertTransferDialogMutation, { data, loading, error }] = useUpsertTransferDialogMutation({
 *   variables: {
 *      TransferUpsertInput: // value for 'TransferUpsertInput'
 *   },
 * });
 */
export function useUpsertTransferDialogMutation(baseOptions?: Apollo.MutationHookOptions<UpsertTransferDialogMutation, UpsertTransferDialogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertTransferDialogMutation, UpsertTransferDialogMutationVariables>(UpsertTransferDialogDocument, options);
      }
export type UpsertTransferDialogMutationHookResult = ReturnType<typeof useUpsertTransferDialogMutation>;
export type UpsertTransferDialogMutationResult = Apollo.MutationResult<UpsertTransferDialogMutation>;
export type UpsertTransferDialogMutationOptions = Apollo.BaseMutationOptions<UpsertTransferDialogMutation, UpsertTransferDialogMutationVariables>;
export const TransferDialogDocument = gql`
    query TransferDialog($TransferId: Float!) {
  getTransfer(TransferId: $TransferId) {
    id
    amount
    to_account_id
    transfer_type_id
    to_account {
      id
      name
      is_client
      is_supplier
      is_own
    }
    notes
    from_account_id
    from_account {
      id
      name
      is_client
      is_supplier
      is_own
    }
    transferred_date
    expected_date
    transferred
    transfer_receipts {
      id
      order_sale_id
      expense_id
      order_sale {
        id
        compound_order_code
        invoice_code
        order_code
        net_total_with_tax
        receipt_type {
          id
          is_informal_receipt
        }
      }
      expense {
        id
        external_code
        total_with_tax
        receipt_type {
          id
          is_informal_receipt
        }
      }
      amount
    }
    transfer_receipts_total
    created_by {
      fullname
    }
    updated_by {
      fullname
    }
  }
}
    `;

/**
 * __useTransferDialogQuery__
 *
 * To run a query within a React component, call `useTransferDialogQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransferDialogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransferDialogQuery({
 *   variables: {
 *      TransferId: // value for 'TransferId'
 *   },
 * });
 */
export function useTransferDialogQuery(baseOptions: Apollo.QueryHookOptions<TransferDialogQuery, TransferDialogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransferDialogQuery, TransferDialogQueryVariables>(TransferDialogDocument, options);
      }
export function useTransferDialogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransferDialogQuery, TransferDialogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransferDialogQuery, TransferDialogQueryVariables>(TransferDialogDocument, options);
        }
export type TransferDialogQueryHookResult = ReturnType<typeof useTransferDialogQuery>;
export type TransferDialogLazyQueryHookResult = ReturnType<typeof useTransferDialogLazyQuery>;
export type TransferDialogQueryResult = Apollo.QueryResult<TransferDialogQuery, TransferDialogQueryVariables>;
export function refetchTransferDialogQuery(variables: TransferDialogQueryVariables) {
      return { query: TransferDialogDocument, variables: variables }
    }
export const ToAccountIdInputDocument = gql`
    query ToAccountIdInput($isOwn: Boolean!, $isClient: Boolean!, $isSupplier: Boolean!) {
  getAccounts(is_own: $isOwn, is_client: $isClient, is_supplier: $isSupplier) {
    id
    name
    compound_name
    is_own
    is_supplier
    is_client
    is_informal_account
  }
}
    `;

/**
 * __useToAccountIdInputQuery__
 *
 * To run a query within a React component, call `useToAccountIdInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useToAccountIdInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useToAccountIdInputQuery({
 *   variables: {
 *      isOwn: // value for 'isOwn'
 *      isClient: // value for 'isClient'
 *      isSupplier: // value for 'isSupplier'
 *   },
 * });
 */
export function useToAccountIdInputQuery(baseOptions: Apollo.QueryHookOptions<ToAccountIdInputQuery, ToAccountIdInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ToAccountIdInputQuery, ToAccountIdInputQueryVariables>(ToAccountIdInputDocument, options);
      }
export function useToAccountIdInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ToAccountIdInputQuery, ToAccountIdInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ToAccountIdInputQuery, ToAccountIdInputQueryVariables>(ToAccountIdInputDocument, options);
        }
export type ToAccountIdInputQueryHookResult = ReturnType<typeof useToAccountIdInputQuery>;
export type ToAccountIdInputLazyQueryHookResult = ReturnType<typeof useToAccountIdInputLazyQuery>;
export type ToAccountIdInputQueryResult = Apollo.QueryResult<ToAccountIdInputQuery, ToAccountIdInputQueryVariables>;
export function refetchToAccountIdInputQuery(variables: ToAccountIdInputQueryVariables) {
      return { query: ToAccountIdInputDocument, variables: variables }
    }
export const TransferReceiptExpenseInputDocument = gql`
    query TransferReceiptExpenseInput($account_id: Int) {
  getExpenses(account_id: $account_id, sort_field: date, sort_order: desc) {
    id
    internal_code
    external_code
    compound_external_code
    total_with_tax
    transfer_receipts_total
    receipt_type_id
    receipt_type {
      id
      is_informal_receipt
    }
  }
}
    `;

/**
 * __useTransferReceiptExpenseInputQuery__
 *
 * To run a query within a React component, call `useTransferReceiptExpenseInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransferReceiptExpenseInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransferReceiptExpenseInputQuery({
 *   variables: {
 *      account_id: // value for 'account_id'
 *   },
 * });
 */
export function useTransferReceiptExpenseInputQuery(baseOptions?: Apollo.QueryHookOptions<TransferReceiptExpenseInputQuery, TransferReceiptExpenseInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransferReceiptExpenseInputQuery, TransferReceiptExpenseInputQueryVariables>(TransferReceiptExpenseInputDocument, options);
      }
export function useTransferReceiptExpenseInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransferReceiptExpenseInputQuery, TransferReceiptExpenseInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransferReceiptExpenseInputQuery, TransferReceiptExpenseInputQueryVariables>(TransferReceiptExpenseInputDocument, options);
        }
export type TransferReceiptExpenseInputQueryHookResult = ReturnType<typeof useTransferReceiptExpenseInputQuery>;
export type TransferReceiptExpenseInputLazyQueryHookResult = ReturnType<typeof useTransferReceiptExpenseInputLazyQuery>;
export type TransferReceiptExpenseInputQueryResult = Apollo.QueryResult<TransferReceiptExpenseInputQuery, TransferReceiptExpenseInputQueryVariables>;
export function refetchTransferReceiptExpenseInputQuery(variables?: TransferReceiptExpenseInputQueryVariables) {
      return { query: TransferReceiptExpenseInputDocument, variables: variables }
    }
export const TransferReceiptOrderSaleInputDocument = gql`
    query TransferReceiptOrderSaleInput($account_id: Int) {
  getOrderSales(account_id: $account_id, sort_field: date, sort_order: desc) {
    id
    compound_order_code
    invoice_code
    order_code
    net_total_with_tax
    transfer_receipts_total
    receipt_type_id
    receipt_type {
      id
      is_informal_receipt
    }
  }
}
    `;

/**
 * __useTransferReceiptOrderSaleInputQuery__
 *
 * To run a query within a React component, call `useTransferReceiptOrderSaleInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransferReceiptOrderSaleInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransferReceiptOrderSaleInputQuery({
 *   variables: {
 *      account_id: // value for 'account_id'
 *   },
 * });
 */
export function useTransferReceiptOrderSaleInputQuery(baseOptions?: Apollo.QueryHookOptions<TransferReceiptOrderSaleInputQuery, TransferReceiptOrderSaleInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransferReceiptOrderSaleInputQuery, TransferReceiptOrderSaleInputQueryVariables>(TransferReceiptOrderSaleInputDocument, options);
      }
export function useTransferReceiptOrderSaleInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransferReceiptOrderSaleInputQuery, TransferReceiptOrderSaleInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransferReceiptOrderSaleInputQuery, TransferReceiptOrderSaleInputQueryVariables>(TransferReceiptOrderSaleInputDocument, options);
        }
export type TransferReceiptOrderSaleInputQueryHookResult = ReturnType<typeof useTransferReceiptOrderSaleInputQuery>;
export type TransferReceiptOrderSaleInputLazyQueryHookResult = ReturnType<typeof useTransferReceiptOrderSaleInputLazyQuery>;
export type TransferReceiptOrderSaleInputQueryResult = Apollo.QueryResult<TransferReceiptOrderSaleInputQuery, TransferReceiptOrderSaleInputQueryVariables>;
export function refetchTransferReceiptOrderSaleInputQuery(variables?: TransferReceiptOrderSaleInputQueryVariables) {
      return { query: TransferReceiptOrderSaleInputDocument, variables: variables }
    }
export const TransferTransferTypeInputDocument = gql`
    query TransferTransferTypeInput {
  getTransferTypes {
    id
    name
  }
}
    `;

/**
 * __useTransferTransferTypeInputQuery__
 *
 * To run a query within a React component, call `useTransferTransferTypeInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransferTransferTypeInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransferTransferTypeInputQuery({
 *   variables: {
 *   },
 * });
 */
export function useTransferTransferTypeInputQuery(baseOptions?: Apollo.QueryHookOptions<TransferTransferTypeInputQuery, TransferTransferTypeInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransferTransferTypeInputQuery, TransferTransferTypeInputQueryVariables>(TransferTransferTypeInputDocument, options);
      }
export function useTransferTransferTypeInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransferTransferTypeInputQuery, TransferTransferTypeInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransferTransferTypeInputQuery, TransferTransferTypeInputQueryVariables>(TransferTransferTypeInputDocument, options);
        }
export type TransferTransferTypeInputQueryHookResult = ReturnType<typeof useTransferTransferTypeInputQuery>;
export type TransferTransferTypeInputLazyQueryHookResult = ReturnType<typeof useTransferTransferTypeInputLazyQuery>;
export type TransferTransferTypeInputQueryResult = Apollo.QueryResult<TransferTransferTypeInputQuery, TransferTransferTypeInputQueryVariables>;
export function refetchTransferTransferTypeInputQuery(variables?: TransferTransferTypeInputQueryVariables) {
      return { query: TransferTransferTypeInputDocument, variables: variables }
    }
export const EmployeeBranchInputDocument = gql`
    query EmployeeBranchInput {
  getBranches {
    id
    name
  }
}
    `;

/**
 * __useEmployeeBranchInputQuery__
 *
 * To run a query within a React component, call `useEmployeeBranchInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeBranchInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeBranchInputQuery({
 *   variables: {
 *   },
 * });
 */
export function useEmployeeBranchInputQuery(baseOptions?: Apollo.QueryHookOptions<EmployeeBranchInputQuery, EmployeeBranchInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeBranchInputQuery, EmployeeBranchInputQueryVariables>(EmployeeBranchInputDocument, options);
      }
export function useEmployeeBranchInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeBranchInputQuery, EmployeeBranchInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeBranchInputQuery, EmployeeBranchInputQueryVariables>(EmployeeBranchInputDocument, options);
        }
export type EmployeeBranchInputQueryHookResult = ReturnType<typeof useEmployeeBranchInputQuery>;
export type EmployeeBranchInputLazyQueryHookResult = ReturnType<typeof useEmployeeBranchInputLazyQuery>;
export type EmployeeBranchInputQueryResult = Apollo.QueryResult<EmployeeBranchInputQuery, EmployeeBranchInputQueryVariables>;
export function refetchEmployeeBranchInputQuery(variables?: EmployeeBranchInputQueryVariables) {
      return { query: EmployeeBranchInputDocument, variables: variables }
    }
export const EmployeeOrderProductionTypeInputDocument = gql`
    query EmployeeOrderProductionTypeInput {
  getOrderProductionTypes {
    id
    name
  }
}
    `;

/**
 * __useEmployeeOrderProductionTypeInputQuery__
 *
 * To run a query within a React component, call `useEmployeeOrderProductionTypeInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeOrderProductionTypeInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeOrderProductionTypeInputQuery({
 *   variables: {
 *   },
 * });
 */
export function useEmployeeOrderProductionTypeInputQuery(baseOptions?: Apollo.QueryHookOptions<EmployeeOrderProductionTypeInputQuery, EmployeeOrderProductionTypeInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeOrderProductionTypeInputQuery, EmployeeOrderProductionTypeInputQueryVariables>(EmployeeOrderProductionTypeInputDocument, options);
      }
export function useEmployeeOrderProductionTypeInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeOrderProductionTypeInputQuery, EmployeeOrderProductionTypeInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeOrderProductionTypeInputQuery, EmployeeOrderProductionTypeInputQueryVariables>(EmployeeOrderProductionTypeInputDocument, options);
        }
export type EmployeeOrderProductionTypeInputQueryHookResult = ReturnType<typeof useEmployeeOrderProductionTypeInputQuery>;
export type EmployeeOrderProductionTypeInputLazyQueryHookResult = ReturnType<typeof useEmployeeOrderProductionTypeInputLazyQuery>;
export type EmployeeOrderProductionTypeInputQueryResult = Apollo.QueryResult<EmployeeOrderProductionTypeInputQuery, EmployeeOrderProductionTypeInputQueryVariables>;
export function refetchEmployeeOrderProductionTypeInputQuery(variables?: EmployeeOrderProductionTypeInputQueryVariables) {
      return { query: EmployeeOrderProductionTypeInputDocument, variables: variables }
    }
export const UpsertEmployeeDialogDocument = gql`
    mutation UpsertEmployeeDialog($EmployeeUpsertInput: EmployeeUpsertInput!) {
  upsertEmployee(EmployeeUpsertInput: $EmployeeUpsertInput) {
    fullname
  }
}
    `;
export type UpsertEmployeeDialogMutationFn = Apollo.MutationFunction<UpsertEmployeeDialogMutation, UpsertEmployeeDialogMutationVariables>;

/**
 * __useUpsertEmployeeDialogMutation__
 *
 * To run a mutation, you first call `useUpsertEmployeeDialogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertEmployeeDialogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertEmployeeDialogMutation, { data, loading, error }] = useUpsertEmployeeDialogMutation({
 *   variables: {
 *      EmployeeUpsertInput: // value for 'EmployeeUpsertInput'
 *   },
 * });
 */
export function useUpsertEmployeeDialogMutation(baseOptions?: Apollo.MutationHookOptions<UpsertEmployeeDialogMutation, UpsertEmployeeDialogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertEmployeeDialogMutation, UpsertEmployeeDialogMutationVariables>(UpsertEmployeeDialogDocument, options);
      }
export type UpsertEmployeeDialogMutationHookResult = ReturnType<typeof useUpsertEmployeeDialogMutation>;
export type UpsertEmployeeDialogMutationResult = Apollo.MutationResult<UpsertEmployeeDialogMutation>;
export type UpsertEmployeeDialogMutationOptions = Apollo.BaseMutationOptions<UpsertEmployeeDialogMutation, UpsertEmployeeDialogMutationVariables>;
export const EmployeeFormDocument = gql`
    query EmployeeForm($EmployeeId: Float!) {
  getEmployee(EmployeeId: $EmployeeId) {
    id
    fullname
    is_leader
    first_name
    last_name
    order_production_type_id
    is_inactive
    branch_id
    base_salary
    hours_should_work
    created_by {
      fullname
    }
    updated_by {
      fullname
    }
  }
}
    `;

/**
 * __useEmployeeFormQuery__
 *
 * To run a query within a React component, call `useEmployeeFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeFormQuery({
 *   variables: {
 *      EmployeeId: // value for 'EmployeeId'
 *   },
 * });
 */
export function useEmployeeFormQuery(baseOptions: Apollo.QueryHookOptions<EmployeeFormQuery, EmployeeFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeFormQuery, EmployeeFormQueryVariables>(EmployeeFormDocument, options);
      }
export function useEmployeeFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeFormQuery, EmployeeFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeFormQuery, EmployeeFormQueryVariables>(EmployeeFormDocument, options);
        }
export type EmployeeFormQueryHookResult = ReturnType<typeof useEmployeeFormQuery>;
export type EmployeeFormLazyQueryHookResult = ReturnType<typeof useEmployeeFormLazyQuery>;
export type EmployeeFormQueryResult = Apollo.QueryResult<EmployeeFormQuery, EmployeeFormQueryVariables>;
export function refetchEmployeeFormQuery(variables: EmployeeFormQueryVariables) {
      return { query: EmployeeFormDocument, variables: variables }
    }
export const OrderAdjustmentProductInputDocument = gql`
    query OrderAdjustmentProductInput {
  getProducts {
    id
    compound_description
    current_group_weight
  }
}
    `;

/**
 * __useOrderAdjustmentProductInputQuery__
 *
 * To run a query within a React component, call `useOrderAdjustmentProductInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderAdjustmentProductInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderAdjustmentProductInputQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrderAdjustmentProductInputQuery(baseOptions?: Apollo.QueryHookOptions<OrderAdjustmentProductInputQuery, OrderAdjustmentProductInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderAdjustmentProductInputQuery, OrderAdjustmentProductInputQueryVariables>(OrderAdjustmentProductInputDocument, options);
      }
export function useOrderAdjustmentProductInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderAdjustmentProductInputQuery, OrderAdjustmentProductInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderAdjustmentProductInputQuery, OrderAdjustmentProductInputQueryVariables>(OrderAdjustmentProductInputDocument, options);
        }
export type OrderAdjustmentProductInputQueryHookResult = ReturnType<typeof useOrderAdjustmentProductInputQuery>;
export type OrderAdjustmentProductInputLazyQueryHookResult = ReturnType<typeof useOrderAdjustmentProductInputLazyQuery>;
export type OrderAdjustmentProductInputQueryResult = Apollo.QueryResult<OrderAdjustmentProductInputQuery, OrderAdjustmentProductInputQueryVariables>;
export function refetchOrderAdjustmentProductInputQuery(variables?: OrderAdjustmentProductInputQueryVariables) {
      return { query: OrderAdjustmentProductInputDocument, variables: variables }
    }
export const OrderAdjustmentOrderAdjustmentTypeInputDocument = gql`
    query OrderAdjustmentOrderAdjustmentTypeInput {
  getOrderAdjustmentTypes {
    id
    name
  }
}
    `;

/**
 * __useOrderAdjustmentOrderAdjustmentTypeInputQuery__
 *
 * To run a query within a React component, call `useOrderAdjustmentOrderAdjustmentTypeInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderAdjustmentOrderAdjustmentTypeInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderAdjustmentOrderAdjustmentTypeInputQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrderAdjustmentOrderAdjustmentTypeInputQuery(baseOptions?: Apollo.QueryHookOptions<OrderAdjustmentOrderAdjustmentTypeInputQuery, OrderAdjustmentOrderAdjustmentTypeInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderAdjustmentOrderAdjustmentTypeInputQuery, OrderAdjustmentOrderAdjustmentTypeInputQueryVariables>(OrderAdjustmentOrderAdjustmentTypeInputDocument, options);
      }
export function useOrderAdjustmentOrderAdjustmentTypeInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderAdjustmentOrderAdjustmentTypeInputQuery, OrderAdjustmentOrderAdjustmentTypeInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderAdjustmentOrderAdjustmentTypeInputQuery, OrderAdjustmentOrderAdjustmentTypeInputQueryVariables>(OrderAdjustmentOrderAdjustmentTypeInputDocument, options);
        }
export type OrderAdjustmentOrderAdjustmentTypeInputQueryHookResult = ReturnType<typeof useOrderAdjustmentOrderAdjustmentTypeInputQuery>;
export type OrderAdjustmentOrderAdjustmentTypeInputLazyQueryHookResult = ReturnType<typeof useOrderAdjustmentOrderAdjustmentTypeInputLazyQuery>;
export type OrderAdjustmentOrderAdjustmentTypeInputQueryResult = Apollo.QueryResult<OrderAdjustmentOrderAdjustmentTypeInputQuery, OrderAdjustmentOrderAdjustmentTypeInputQueryVariables>;
export function refetchOrderAdjustmentOrderAdjustmentTypeInputQuery(variables?: OrderAdjustmentOrderAdjustmentTypeInputQueryVariables) {
      return { query: OrderAdjustmentOrderAdjustmentTypeInputDocument, variables: variables }
    }
export const OrderAdjustmentOrderSaleInputDocument = gql`
    query OrderAdjustmentOrderSaleInput {
  getOrderSales {
    id
    compound_order_code
    total_with_tax
  }
}
    `;

/**
 * __useOrderAdjustmentOrderSaleInputQuery__
 *
 * To run a query within a React component, call `useOrderAdjustmentOrderSaleInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderAdjustmentOrderSaleInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderAdjustmentOrderSaleInputQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrderAdjustmentOrderSaleInputQuery(baseOptions?: Apollo.QueryHookOptions<OrderAdjustmentOrderSaleInputQuery, OrderAdjustmentOrderSaleInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderAdjustmentOrderSaleInputQuery, OrderAdjustmentOrderSaleInputQueryVariables>(OrderAdjustmentOrderSaleInputDocument, options);
      }
export function useOrderAdjustmentOrderSaleInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderAdjustmentOrderSaleInputQuery, OrderAdjustmentOrderSaleInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderAdjustmentOrderSaleInputQuery, OrderAdjustmentOrderSaleInputQueryVariables>(OrderAdjustmentOrderSaleInputDocument, options);
        }
export type OrderAdjustmentOrderSaleInputQueryHookResult = ReturnType<typeof useOrderAdjustmentOrderSaleInputQuery>;
export type OrderAdjustmentOrderSaleInputLazyQueryHookResult = ReturnType<typeof useOrderAdjustmentOrderSaleInputLazyQuery>;
export type OrderAdjustmentOrderSaleInputQueryResult = Apollo.QueryResult<OrderAdjustmentOrderSaleInputQuery, OrderAdjustmentOrderSaleInputQueryVariables>;
export function refetchOrderAdjustmentOrderSaleInputQuery(variables?: OrderAdjustmentOrderSaleInputQueryVariables) {
      return { query: OrderAdjustmentOrderSaleInputDocument, variables: variables }
    }
export const OrderAdjustmentGetOrderSaleDocument = gql`
    query OrderAdjustmentGetOrderSale($OrderSaleId: Float!) {
  getOrderSale(OrderSaleId: $OrderSaleId) {
    id
    compound_order_code
    order_adjustment_products {
      id
      product_id
      groups
      kilos
    }
    order_sale_products {
      id
      product_id
      groups
      kilos
    }
  }
}
    `;

/**
 * __useOrderAdjustmentGetOrderSaleQuery__
 *
 * To run a query within a React component, call `useOrderAdjustmentGetOrderSaleQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderAdjustmentGetOrderSaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderAdjustmentGetOrderSaleQuery({
 *   variables: {
 *      OrderSaleId: // value for 'OrderSaleId'
 *   },
 * });
 */
export function useOrderAdjustmentGetOrderSaleQuery(baseOptions: Apollo.QueryHookOptions<OrderAdjustmentGetOrderSaleQuery, OrderAdjustmentGetOrderSaleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderAdjustmentGetOrderSaleQuery, OrderAdjustmentGetOrderSaleQueryVariables>(OrderAdjustmentGetOrderSaleDocument, options);
      }
export function useOrderAdjustmentGetOrderSaleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderAdjustmentGetOrderSaleQuery, OrderAdjustmentGetOrderSaleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderAdjustmentGetOrderSaleQuery, OrderAdjustmentGetOrderSaleQueryVariables>(OrderAdjustmentGetOrderSaleDocument, options);
        }
export type OrderAdjustmentGetOrderSaleQueryHookResult = ReturnType<typeof useOrderAdjustmentGetOrderSaleQuery>;
export type OrderAdjustmentGetOrderSaleLazyQueryHookResult = ReturnType<typeof useOrderAdjustmentGetOrderSaleLazyQuery>;
export type OrderAdjustmentGetOrderSaleQueryResult = Apollo.QueryResult<OrderAdjustmentGetOrderSaleQuery, OrderAdjustmentGetOrderSaleQueryVariables>;
export function refetchOrderAdjustmentGetOrderSaleQuery(variables: OrderAdjustmentGetOrderSaleQueryVariables) {
      return { query: OrderAdjustmentGetOrderSaleDocument, variables: variables }
    }
export const UpsertOrderAdjustmentDocument = gql`
    mutation UpsertOrderAdjustment($OrderAdjustmentInput: OrderAdjustmentInput!) {
  upsertOrderAdjustment(OrderAdjustmentInput: $OrderAdjustmentInput) {
    id
  }
}
    `;
export type UpsertOrderAdjustmentMutationFn = Apollo.MutationFunction<UpsertOrderAdjustmentMutation, UpsertOrderAdjustmentMutationVariables>;

/**
 * __useUpsertOrderAdjustmentMutation__
 *
 * To run a mutation, you first call `useUpsertOrderAdjustmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertOrderAdjustmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertOrderAdjustmentMutation, { data, loading, error }] = useUpsertOrderAdjustmentMutation({
 *   variables: {
 *      OrderAdjustmentInput: // value for 'OrderAdjustmentInput'
 *   },
 * });
 */
export function useUpsertOrderAdjustmentMutation(baseOptions?: Apollo.MutationHookOptions<UpsertOrderAdjustmentMutation, UpsertOrderAdjustmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertOrderAdjustmentMutation, UpsertOrderAdjustmentMutationVariables>(UpsertOrderAdjustmentDocument, options);
      }
export type UpsertOrderAdjustmentMutationHookResult = ReturnType<typeof useUpsertOrderAdjustmentMutation>;
export type UpsertOrderAdjustmentMutationResult = Apollo.MutationResult<UpsertOrderAdjustmentMutation>;
export type UpsertOrderAdjustmentMutationOptions = Apollo.BaseMutationOptions<UpsertOrderAdjustmentMutation, UpsertOrderAdjustmentMutationVariables>;
export const OrderAdjustmentFormDocument = gql`
    query OrderAdjustmentForm($OrderAdjustmentId: Float!) {
  getOrderAdjustment(OrderAdjustmentId: $OrderAdjustmentId) {
    id
    date
    order_adjustment_type_id
    order_sale {
      id
      compound_order_code
    }
    order_adjustment_type {
      id
      name
    }
    order_sale_products {
      id
      kilos
      groups
      product_id
    }
    order_sale_adjustment_products {
      id
      kilos
      groups
      product_id
    }
    order_adjustment_products {
      id
      kilos
      groups
      group_weight
      product {
        id
        compound_description
        current_group_weight
      }
    }
    created_by {
      fullname
    }
    updated_by {
      fullname
    }
  }
}
    `;

/**
 * __useOrderAdjustmentFormQuery__
 *
 * To run a query within a React component, call `useOrderAdjustmentFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderAdjustmentFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderAdjustmentFormQuery({
 *   variables: {
 *      OrderAdjustmentId: // value for 'OrderAdjustmentId'
 *   },
 * });
 */
export function useOrderAdjustmentFormQuery(baseOptions: Apollo.QueryHookOptions<OrderAdjustmentFormQuery, OrderAdjustmentFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderAdjustmentFormQuery, OrderAdjustmentFormQueryVariables>(OrderAdjustmentFormDocument, options);
      }
export function useOrderAdjustmentFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderAdjustmentFormQuery, OrderAdjustmentFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderAdjustmentFormQuery, OrderAdjustmentFormQueryVariables>(OrderAdjustmentFormDocument, options);
        }
export type OrderAdjustmentFormQueryHookResult = ReturnType<typeof useOrderAdjustmentFormQuery>;
export type OrderAdjustmentFormLazyQueryHookResult = ReturnType<typeof useOrderAdjustmentFormLazyQuery>;
export type OrderAdjustmentFormQueryResult = Apollo.QueryResult<OrderAdjustmentFormQuery, OrderAdjustmentFormQueryVariables>;
export function refetchOrderAdjustmentFormQuery(variables: OrderAdjustmentFormQueryVariables) {
      return { query: OrderAdjustmentFormDocument, variables: variables }
    }
export const OrderProductionBranchInputDocument = gql`
    query OrderProductionBranchInput {
  getBranches {
    id
    name
  }
}
    `;

/**
 * __useOrderProductionBranchInputQuery__
 *
 * To run a query within a React component, call `useOrderProductionBranchInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderProductionBranchInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderProductionBranchInputQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrderProductionBranchInputQuery(baseOptions?: Apollo.QueryHookOptions<OrderProductionBranchInputQuery, OrderProductionBranchInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderProductionBranchInputQuery, OrderProductionBranchInputQueryVariables>(OrderProductionBranchInputDocument, options);
      }
export function useOrderProductionBranchInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderProductionBranchInputQuery, OrderProductionBranchInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderProductionBranchInputQuery, OrderProductionBranchInputQueryVariables>(OrderProductionBranchInputDocument, options);
        }
export type OrderProductionBranchInputQueryHookResult = ReturnType<typeof useOrderProductionBranchInputQuery>;
export type OrderProductionBranchInputLazyQueryHookResult = ReturnType<typeof useOrderProductionBranchInputLazyQuery>;
export type OrderProductionBranchInputQueryResult = Apollo.QueryResult<OrderProductionBranchInputQuery, OrderProductionBranchInputQueryVariables>;
export function refetchOrderProductionBranchInputQuery(variables?: OrderProductionBranchInputQueryVariables) {
      return { query: OrderProductionBranchInputDocument, variables: variables }
    }
export const OrderProductionEmployeeInputDocument = gql`
    query OrderProductionEmployeeInput($excludeDiscontinued: Boolean!) {
  getEmployees(exclude_discontinued: $excludeDiscontinued) {
    id
    fullname
    order_production_type_id
    is_inactive
    branch_id
    is_leader
    base_salary
    hours_should_work
  }
}
    `;

/**
 * __useOrderProductionEmployeeInputQuery__
 *
 * To run a query within a React component, call `useOrderProductionEmployeeInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderProductionEmployeeInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderProductionEmployeeInputQuery({
 *   variables: {
 *      excludeDiscontinued: // value for 'excludeDiscontinued'
 *   },
 * });
 */
export function useOrderProductionEmployeeInputQuery(baseOptions: Apollo.QueryHookOptions<OrderProductionEmployeeInputQuery, OrderProductionEmployeeInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderProductionEmployeeInputQuery, OrderProductionEmployeeInputQueryVariables>(OrderProductionEmployeeInputDocument, options);
      }
export function useOrderProductionEmployeeInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderProductionEmployeeInputQuery, OrderProductionEmployeeInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderProductionEmployeeInputQuery, OrderProductionEmployeeInputQueryVariables>(OrderProductionEmployeeInputDocument, options);
        }
export type OrderProductionEmployeeInputQueryHookResult = ReturnType<typeof useOrderProductionEmployeeInputQuery>;
export type OrderProductionEmployeeInputLazyQueryHookResult = ReturnType<typeof useOrderProductionEmployeeInputLazyQuery>;
export type OrderProductionEmployeeInputQueryResult = Apollo.QueryResult<OrderProductionEmployeeInputQuery, OrderProductionEmployeeInputQueryVariables>;
export function refetchOrderProductionEmployeeInputQuery(variables: OrderProductionEmployeeInputQueryVariables) {
      return { query: OrderProductionEmployeeInputDocument, variables: variables }
    }
export const OrderProductionProductConsumedMachineInputDocument = gql`
    query OrderProductionProductConsumedMachineInput($excludeDiscontinued: Boolean!) {
  getMachines(exclude_discontinued: $excludeDiscontinued) {
    id
    name
    branch_id
    order_production_type_id
  }
}
    `;

/**
 * __useOrderProductionProductConsumedMachineInputQuery__
 *
 * To run a query within a React component, call `useOrderProductionProductConsumedMachineInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderProductionProductConsumedMachineInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderProductionProductConsumedMachineInputQuery({
 *   variables: {
 *      excludeDiscontinued: // value for 'excludeDiscontinued'
 *   },
 * });
 */
export function useOrderProductionProductConsumedMachineInputQuery(baseOptions: Apollo.QueryHookOptions<OrderProductionProductConsumedMachineInputQuery, OrderProductionProductConsumedMachineInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderProductionProductConsumedMachineInputQuery, OrderProductionProductConsumedMachineInputQueryVariables>(OrderProductionProductConsumedMachineInputDocument, options);
      }
export function useOrderProductionProductConsumedMachineInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderProductionProductConsumedMachineInputQuery, OrderProductionProductConsumedMachineInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderProductionProductConsumedMachineInputQuery, OrderProductionProductConsumedMachineInputQueryVariables>(OrderProductionProductConsumedMachineInputDocument, options);
        }
export type OrderProductionProductConsumedMachineInputQueryHookResult = ReturnType<typeof useOrderProductionProductConsumedMachineInputQuery>;
export type OrderProductionProductConsumedMachineInputLazyQueryHookResult = ReturnType<typeof useOrderProductionProductConsumedMachineInputLazyQuery>;
export type OrderProductionProductConsumedMachineInputQueryResult = Apollo.QueryResult<OrderProductionProductConsumedMachineInputQuery, OrderProductionProductConsumedMachineInputQueryVariables>;
export function refetchOrderProductionProductConsumedMachineInputQuery(variables: OrderProductionProductConsumedMachineInputQueryVariables) {
      return { query: OrderProductionProductConsumedMachineInputDocument, variables: variables }
    }
export const OrderProductionProductConsumedProductInputDocument = gql`
    query OrderProductionProductConsumedProductInput($excludeDiscontinued: Boolean!) {
  getProducts(exclude_discontinued: $excludeDiscontinued) {
    id
    compound_description
    order_production_type_id
    current_group_weight
  }
}
    `;

/**
 * __useOrderProductionProductConsumedProductInputQuery__
 *
 * To run a query within a React component, call `useOrderProductionProductConsumedProductInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderProductionProductConsumedProductInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderProductionProductConsumedProductInputQuery({
 *   variables: {
 *      excludeDiscontinued: // value for 'excludeDiscontinued'
 *   },
 * });
 */
export function useOrderProductionProductConsumedProductInputQuery(baseOptions: Apollo.QueryHookOptions<OrderProductionProductConsumedProductInputQuery, OrderProductionProductConsumedProductInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderProductionProductConsumedProductInputQuery, OrderProductionProductConsumedProductInputQueryVariables>(OrderProductionProductConsumedProductInputDocument, options);
      }
export function useOrderProductionProductConsumedProductInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderProductionProductConsumedProductInputQuery, OrderProductionProductConsumedProductInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderProductionProductConsumedProductInputQuery, OrderProductionProductConsumedProductInputQueryVariables>(OrderProductionProductConsumedProductInputDocument, options);
        }
export type OrderProductionProductConsumedProductInputQueryHookResult = ReturnType<typeof useOrderProductionProductConsumedProductInputQuery>;
export type OrderProductionProductConsumedProductInputLazyQueryHookResult = ReturnType<typeof useOrderProductionProductConsumedProductInputLazyQuery>;
export type OrderProductionProductConsumedProductInputQueryResult = Apollo.QueryResult<OrderProductionProductConsumedProductInputQuery, OrderProductionProductConsumedProductInputQueryVariables>;
export function refetchOrderProductionProductConsumedProductInputQuery(variables: OrderProductionProductConsumedProductInputQueryVariables) {
      return { query: OrderProductionProductConsumedProductInputDocument, variables: variables }
    }
export const OrderProductionMachineInputDocument = gql`
    query OrderProductionMachineInput($excludeDiscontinued: Boolean!) {
  getMachines(exclude_discontinued: $excludeDiscontinued) {
    id
    name
    branch_id
    order_production_type_id
  }
}
    `;

/**
 * __useOrderProductionMachineInputQuery__
 *
 * To run a query within a React component, call `useOrderProductionMachineInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderProductionMachineInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderProductionMachineInputQuery({
 *   variables: {
 *      excludeDiscontinued: // value for 'excludeDiscontinued'
 *   },
 * });
 */
export function useOrderProductionMachineInputQuery(baseOptions: Apollo.QueryHookOptions<OrderProductionMachineInputQuery, OrderProductionMachineInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderProductionMachineInputQuery, OrderProductionMachineInputQueryVariables>(OrderProductionMachineInputDocument, options);
      }
export function useOrderProductionMachineInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderProductionMachineInputQuery, OrderProductionMachineInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderProductionMachineInputQuery, OrderProductionMachineInputQueryVariables>(OrderProductionMachineInputDocument, options);
        }
export type OrderProductionMachineInputQueryHookResult = ReturnType<typeof useOrderProductionMachineInputQuery>;
export type OrderProductionMachineInputLazyQueryHookResult = ReturnType<typeof useOrderProductionMachineInputLazyQuery>;
export type OrderProductionMachineInputQueryResult = Apollo.QueryResult<OrderProductionMachineInputQuery, OrderProductionMachineInputQueryVariables>;
export function refetchOrderProductionMachineInputQuery(variables: OrderProductionMachineInputQueryVariables) {
      return { query: OrderProductionMachineInputDocument, variables: variables }
    }
export const OrderProductionProductInputDocument = gql`
    query OrderProductionProductInput($excludeDiscontinued: Boolean!) {
  getProducts(exclude_discontinued: $excludeDiscontinued) {
    id
    compound_description
    order_production_type_id
    current_group_weight
  }
}
    `;

/**
 * __useOrderProductionProductInputQuery__
 *
 * To run a query within a React component, call `useOrderProductionProductInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderProductionProductInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderProductionProductInputQuery({
 *   variables: {
 *      excludeDiscontinued: // value for 'excludeDiscontinued'
 *   },
 * });
 */
export function useOrderProductionProductInputQuery(baseOptions: Apollo.QueryHookOptions<OrderProductionProductInputQuery, OrderProductionProductInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderProductionProductInputQuery, OrderProductionProductInputQueryVariables>(OrderProductionProductInputDocument, options);
      }
export function useOrderProductionProductInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderProductionProductInputQuery, OrderProductionProductInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderProductionProductInputQuery, OrderProductionProductInputQueryVariables>(OrderProductionProductInputDocument, options);
        }
export type OrderProductionProductInputQueryHookResult = ReturnType<typeof useOrderProductionProductInputQuery>;
export type OrderProductionProductInputLazyQueryHookResult = ReturnType<typeof useOrderProductionProductInputLazyQuery>;
export type OrderProductionProductInputQueryResult = Apollo.QueryResult<OrderProductionProductInputQuery, OrderProductionProductInputQueryVariables>;
export function refetchOrderProductionProductInputQuery(variables: OrderProductionProductInputQueryVariables) {
      return { query: OrderProductionProductInputDocument, variables: variables }
    }
export const OrderProductionOrderProductionTypeInputDocument = gql`
    query OrderProductionOrderProductionTypeInput {
  getOrderProductionTypes {
    id
    name
  }
}
    `;

/**
 * __useOrderProductionOrderProductionTypeInputQuery__
 *
 * To run a query within a React component, call `useOrderProductionOrderProductionTypeInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderProductionOrderProductionTypeInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderProductionOrderProductionTypeInputQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrderProductionOrderProductionTypeInputQuery(baseOptions?: Apollo.QueryHookOptions<OrderProductionOrderProductionTypeInputQuery, OrderProductionOrderProductionTypeInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderProductionOrderProductionTypeInputQuery, OrderProductionOrderProductionTypeInputQueryVariables>(OrderProductionOrderProductionTypeInputDocument, options);
      }
export function useOrderProductionOrderProductionTypeInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderProductionOrderProductionTypeInputQuery, OrderProductionOrderProductionTypeInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderProductionOrderProductionTypeInputQuery, OrderProductionOrderProductionTypeInputQueryVariables>(OrderProductionOrderProductionTypeInputDocument, options);
        }
export type OrderProductionOrderProductionTypeInputQueryHookResult = ReturnType<typeof useOrderProductionOrderProductionTypeInputQuery>;
export type OrderProductionOrderProductionTypeInputLazyQueryHookResult = ReturnType<typeof useOrderProductionOrderProductionTypeInputLazyQuery>;
export type OrderProductionOrderProductionTypeInputQueryResult = Apollo.QueryResult<OrderProductionOrderProductionTypeInputQuery, OrderProductionOrderProductionTypeInputQueryVariables>;
export function refetchOrderProductionOrderProductionTypeInputQuery(variables?: OrderProductionOrderProductionTypeInputQueryVariables) {
      return { query: OrderProductionOrderProductionTypeInputDocument, variables: variables }
    }
export const UpsertOrderProductionDocument = gql`
    mutation UpsertOrderProduction($OrderProductionInput: OrderProductionInput!) {
  upsertOrderProduction(OrderProductionInput: $OrderProductionInput) {
    id
    start_date
  }
}
    `;
export type UpsertOrderProductionMutationFn = Apollo.MutationFunction<UpsertOrderProductionMutation, UpsertOrderProductionMutationVariables>;

/**
 * __useUpsertOrderProductionMutation__
 *
 * To run a mutation, you first call `useUpsertOrderProductionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertOrderProductionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertOrderProductionMutation, { data, loading, error }] = useUpsertOrderProductionMutation({
 *   variables: {
 *      OrderProductionInput: // value for 'OrderProductionInput'
 *   },
 * });
 */
export function useUpsertOrderProductionMutation(baseOptions?: Apollo.MutationHookOptions<UpsertOrderProductionMutation, UpsertOrderProductionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertOrderProductionMutation, UpsertOrderProductionMutationVariables>(UpsertOrderProductionDocument, options);
      }
export type UpsertOrderProductionMutationHookResult = ReturnType<typeof useUpsertOrderProductionMutation>;
export type UpsertOrderProductionMutationResult = Apollo.MutationResult<UpsertOrderProductionMutation>;
export type UpsertOrderProductionMutationOptions = Apollo.BaseMutationOptions<UpsertOrderProductionMutation, UpsertOrderProductionMutationVariables>;
export const OrderProductionFormDocument = gql`
    query OrderProductionForm($OrderProductionId: Float!) {
  getOrderProduction(OrderProductionId: $OrderProductionId) {
    id
    start_date
    branch_id
    waste
    shift
    order_production_type_id
    order_production_products {
      product_id
      hours
      machine_id
      machine {
        id
        name
        branch_id
        order_production_type_id
      }
      product {
        id
        current_group_weight
        compound_description
        order_production_type_id
      }
      id
      kilos
      group_weight
      groups
    }
    order_production_products_consumed {
      product_id
      machine_id
      machine {
        id
        name
        branch_id
        order_production_type_id
      }
      product {
        id
        current_group_weight
        compound_description
        order_production_type_id
      }
      id
      kilos
      group_weight
      groups
      hours
    }
    order_production_employees {
      is_leader
      employee {
        id
        fullname
        is_inactive
        order_production_type_id
        branch_id
      }
    }
    created_by {
      fullname
    }
    updated_by {
      fullname
    }
  }
}
    `;

/**
 * __useOrderProductionFormQuery__
 *
 * To run a query within a React component, call `useOrderProductionFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderProductionFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderProductionFormQuery({
 *   variables: {
 *      OrderProductionId: // value for 'OrderProductionId'
 *   },
 * });
 */
export function useOrderProductionFormQuery(baseOptions: Apollo.QueryHookOptions<OrderProductionFormQuery, OrderProductionFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderProductionFormQuery, OrderProductionFormQueryVariables>(OrderProductionFormDocument, options);
      }
export function useOrderProductionFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderProductionFormQuery, OrderProductionFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderProductionFormQuery, OrderProductionFormQueryVariables>(OrderProductionFormDocument, options);
        }
export type OrderProductionFormQueryHookResult = ReturnType<typeof useOrderProductionFormQuery>;
export type OrderProductionFormLazyQueryHookResult = ReturnType<typeof useOrderProductionFormLazyQuery>;
export type OrderProductionFormQueryResult = Apollo.QueryResult<OrderProductionFormQuery, OrderProductionFormQueryVariables>;
export function refetchOrderProductionFormQuery(variables: OrderProductionFormQueryVariables) {
      return { query: OrderProductionFormDocument, variables: variables }
    }
export const OrderProductionTypeInputDocument = gql`
    query OrderProductionTypeInput {
  getOrderProductionTypes {
    id
    name
  }
}
    `;

/**
 * __useOrderProductionTypeInputQuery__
 *
 * To run a query within a React component, call `useOrderProductionTypeInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderProductionTypeInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderProductionTypeInputQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrderProductionTypeInputQuery(baseOptions?: Apollo.QueryHookOptions<OrderProductionTypeInputQuery, OrderProductionTypeInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderProductionTypeInputQuery, OrderProductionTypeInputQueryVariables>(OrderProductionTypeInputDocument, options);
      }
export function useOrderProductionTypeInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderProductionTypeInputQuery, OrderProductionTypeInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderProductionTypeInputQuery, OrderProductionTypeInputQueryVariables>(OrderProductionTypeInputDocument, options);
        }
export type OrderProductionTypeInputQueryHookResult = ReturnType<typeof useOrderProductionTypeInputQuery>;
export type OrderProductionTypeInputLazyQueryHookResult = ReturnType<typeof useOrderProductionTypeInputLazyQuery>;
export type OrderProductionTypeInputQueryResult = Apollo.QueryResult<OrderProductionTypeInputQuery, OrderProductionTypeInputQueryVariables>;
export function refetchOrderProductionTypeInputQuery(variables?: OrderProductionTypeInputQueryVariables) {
      return { query: OrderProductionTypeInputDocument, variables: variables }
    }
export const ProductCategoryInputDocument = gql`
    query ProductCategoryInput {
  getProductCategories {
    id
    name
    order_production_type_id
  }
}
    `;

/**
 * __useProductCategoryInputQuery__
 *
 * To run a query within a React component, call `useProductCategoryInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductCategoryInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductCategoryInputQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductCategoryInputQuery(baseOptions?: Apollo.QueryHookOptions<ProductCategoryInputQuery, ProductCategoryInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductCategoryInputQuery, ProductCategoryInputQueryVariables>(ProductCategoryInputDocument, options);
      }
export function useProductCategoryInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductCategoryInputQuery, ProductCategoryInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductCategoryInputQuery, ProductCategoryInputQueryVariables>(ProductCategoryInputDocument, options);
        }
export type ProductCategoryInputQueryHookResult = ReturnType<typeof useProductCategoryInputQuery>;
export type ProductCategoryInputLazyQueryHookResult = ReturnType<typeof useProductCategoryInputLazyQuery>;
export type ProductCategoryInputQueryResult = Apollo.QueryResult<ProductCategoryInputQuery, ProductCategoryInputQueryVariables>;
export function refetchProductCategoryInputQuery(variables?: ProductCategoryInputQueryVariables) {
      return { query: ProductCategoryInputDocument, variables: variables }
    }
export const ProductMaterialInputDocument = gql`
    query ProductMaterialInput {
  getProductMaterials {
    id
    name
  }
}
    `;

/**
 * __useProductMaterialInputQuery__
 *
 * To run a query within a React component, call `useProductMaterialInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductMaterialInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductMaterialInputQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductMaterialInputQuery(baseOptions?: Apollo.QueryHookOptions<ProductMaterialInputQuery, ProductMaterialInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductMaterialInputQuery, ProductMaterialInputQueryVariables>(ProductMaterialInputDocument, options);
      }
export function useProductMaterialInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductMaterialInputQuery, ProductMaterialInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductMaterialInputQuery, ProductMaterialInputQueryVariables>(ProductMaterialInputDocument, options);
        }
export type ProductMaterialInputQueryHookResult = ReturnType<typeof useProductMaterialInputQuery>;
export type ProductMaterialInputLazyQueryHookResult = ReturnType<typeof useProductMaterialInputLazyQuery>;
export type ProductMaterialInputQueryResult = Apollo.QueryResult<ProductMaterialInputQuery, ProductMaterialInputQueryVariables>;
export function refetchProductMaterialInputQuery(variables?: ProductMaterialInputQueryVariables) {
      return { query: ProductMaterialInputDocument, variables: variables }
    }
export const UpsertProductDialogDocument = gql`
    mutation UpsertProductDialog($ProductUpsertInput: ProductUpsertInput!) {
  upsertProduct(ProductUpsertInput: $ProductUpsertInput) {
    compound_description
  }
}
    `;
export type UpsertProductDialogMutationFn = Apollo.MutationFunction<UpsertProductDialogMutation, UpsertProductDialogMutationVariables>;

/**
 * __useUpsertProductDialogMutation__
 *
 * To run a mutation, you first call `useUpsertProductDialogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertProductDialogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertProductDialogMutation, { data, loading, error }] = useUpsertProductDialogMutation({
 *   variables: {
 *      ProductUpsertInput: // value for 'ProductUpsertInput'
 *   },
 * });
 */
export function useUpsertProductDialogMutation(baseOptions?: Apollo.MutationHookOptions<UpsertProductDialogMutation, UpsertProductDialogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertProductDialogMutation, UpsertProductDialogMutationVariables>(UpsertProductDialogDocument, options);
      }
export type UpsertProductDialogMutationHookResult = ReturnType<typeof useUpsertProductDialogMutation>;
export type UpsertProductDialogMutationResult = Apollo.MutationResult<UpsertProductDialogMutation>;
export type UpsertProductDialogMutationOptions = Apollo.BaseMutationOptions<UpsertProductDialogMutation, UpsertProductDialogMutationVariables>;
export const ProductFormDocument = gql`
    query ProductForm($ProductId: Float!) {
  getProduct(ProductId: $ProductId) {
    id
    compound_description
    internal_description
    external_description
    discontinued
    order_production_type_id
    product_category {
      id
      order_production_type_id
      name
    }
    code
    calibre
    width
    length
    pleat
    current_group_weight
    current_group_price
    current_kilo_price
    product_material_id
    product_category_id
    include_units_in_summary
    created_by {
      fullname
    }
    updated_by {
      fullname
    }
  }
}
    `;

/**
 * __useProductFormQuery__
 *
 * To run a query within a React component, call `useProductFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductFormQuery({
 *   variables: {
 *      ProductId: // value for 'ProductId'
 *   },
 * });
 */
export function useProductFormQuery(baseOptions: Apollo.QueryHookOptions<ProductFormQuery, ProductFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductFormQuery, ProductFormQueryVariables>(ProductFormDocument, options);
      }
export function useProductFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductFormQuery, ProductFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductFormQuery, ProductFormQueryVariables>(ProductFormDocument, options);
        }
export type ProductFormQueryHookResult = ReturnType<typeof useProductFormQuery>;
export type ProductFormLazyQueryHookResult = ReturnType<typeof useProductFormLazyQuery>;
export type ProductFormQueryResult = Apollo.QueryResult<ProductFormQuery, ProductFormQueryVariables>;
export function refetchProductFormQuery(variables: ProductFormQueryVariables) {
      return { query: ProductFormDocument, variables: variables }
    }
export const OrderQuotationAcceptanceDocument = gql`
    query OrderQuotationAcceptance($OrderQuotationIdInt: Int!, $OrderQuotationIdFloat: Float!) {
  getProducts {
    id
    external_description
  }
  getOrderQuotationCatalogChanges(OrderQuotationId: $OrderQuotationIdInt) {
    changes {
      product_id
      description
      current_kilo_price
      current_group_price
      proposed_kilo_price
      proposed_group_price
      action
    }
    blocking_reasons
    is_acceptable
  }
  getOrderQuotation(OrderQuotationId: $OrderQuotationIdFloat) {
    id
    order_code
    is_acceptable
    is_expired
    require_tax
    subtotal
    account_products_updated_at
    order_request_completed_at
    catalog_step_done
    order_request_step_done
    order_request_step_state
    status_step_done
    acceptance_complete
    account {
      id
      name
      rfc
      address
    }
    order_quotation_status {
      id
      name
    }
    order_request {
      id
      order_code
      date
      account {
        id
        name
      }
      order_request_products {
        id
        product_id
        kilos
        groups
        kilo_price
        group_price
        group_weight
        product {
          external_description
        }
      }
    }
    order_quotation_products {
      id
      product_id
      proposed_description
      groups
      kilos
      kilo_price
      group_price
      group_weight
      product {
        external_description
      }
    }
  }
}
    `;

/**
 * __useOrderQuotationAcceptanceQuery__
 *
 * To run a query within a React component, call `useOrderQuotationAcceptanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderQuotationAcceptanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderQuotationAcceptanceQuery({
 *   variables: {
 *      OrderQuotationIdInt: // value for 'OrderQuotationIdInt'
 *      OrderQuotationIdFloat: // value for 'OrderQuotationIdFloat'
 *   },
 * });
 */
export function useOrderQuotationAcceptanceQuery(baseOptions: Apollo.QueryHookOptions<OrderQuotationAcceptanceQuery, OrderQuotationAcceptanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderQuotationAcceptanceQuery, OrderQuotationAcceptanceQueryVariables>(OrderQuotationAcceptanceDocument, options);
      }
export function useOrderQuotationAcceptanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderQuotationAcceptanceQuery, OrderQuotationAcceptanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderQuotationAcceptanceQuery, OrderQuotationAcceptanceQueryVariables>(OrderQuotationAcceptanceDocument, options);
        }
export type OrderQuotationAcceptanceQueryHookResult = ReturnType<typeof useOrderQuotationAcceptanceQuery>;
export type OrderQuotationAcceptanceLazyQueryHookResult = ReturnType<typeof useOrderQuotationAcceptanceLazyQuery>;
export type OrderQuotationAcceptanceQueryResult = Apollo.QueryResult<OrderQuotationAcceptanceQuery, OrderQuotationAcceptanceQueryVariables>;
export function refetchOrderQuotationAcceptanceQuery(variables: OrderQuotationAcceptanceQueryVariables) {
      return { query: OrderQuotationAcceptanceDocument, variables: variables }
    }
export const AcceptOrderQuotationDocument = gql`
    mutation AcceptOrderQuotation($OrderQuotationId: Int!) {
  acceptOrderQuotation(OrderQuotationId: $OrderQuotationId) {
    id
    order_quotation_status_id
    account_products_updated_at
    order_request_completed_at
  }
}
    `;
export type AcceptOrderQuotationMutationFn = Apollo.MutationFunction<AcceptOrderQuotationMutation, AcceptOrderQuotationMutationVariables>;

/**
 * __useAcceptOrderQuotationMutation__
 *
 * To run a mutation, you first call `useAcceptOrderQuotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptOrderQuotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptOrderQuotationMutation, { data, loading, error }] = useAcceptOrderQuotationMutation({
 *   variables: {
 *      OrderQuotationId: // value for 'OrderQuotationId'
 *   },
 * });
 */
export function useAcceptOrderQuotationMutation(baseOptions?: Apollo.MutationHookOptions<AcceptOrderQuotationMutation, AcceptOrderQuotationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptOrderQuotationMutation, AcceptOrderQuotationMutationVariables>(AcceptOrderQuotationDocument, options);
      }
export type AcceptOrderQuotationMutationHookResult = ReturnType<typeof useAcceptOrderQuotationMutation>;
export type AcceptOrderQuotationMutationResult = Apollo.MutationResult<AcceptOrderQuotationMutation>;
export type AcceptOrderQuotationMutationOptions = Apollo.BaseMutationOptions<AcceptOrderQuotationMutation, AcceptOrderQuotationMutationVariables>;
export const OrderQuotationLinkProductDocument = gql`
    query OrderQuotationLinkProduct($OrderQuotationId: Float!) {
  getProducts(exclude_discontinued: true) {
    id
    compound_description
    current_group_weight
  }
  getOrderQuotation(OrderQuotationId: $OrderQuotationId) {
    id
    order_code
    order_quotation_products {
      id
      product_id
      proposed_description
      group_weight
      kilos
      groups
    }
  }
}
    `;

/**
 * __useOrderQuotationLinkProductQuery__
 *
 * To run a query within a React component, call `useOrderQuotationLinkProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderQuotationLinkProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderQuotationLinkProductQuery({
 *   variables: {
 *      OrderQuotationId: // value for 'OrderQuotationId'
 *   },
 * });
 */
export function useOrderQuotationLinkProductQuery(baseOptions: Apollo.QueryHookOptions<OrderQuotationLinkProductQuery, OrderQuotationLinkProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderQuotationLinkProductQuery, OrderQuotationLinkProductQueryVariables>(OrderQuotationLinkProductDocument, options);
      }
export function useOrderQuotationLinkProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderQuotationLinkProductQuery, OrderQuotationLinkProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderQuotationLinkProductQuery, OrderQuotationLinkProductQueryVariables>(OrderQuotationLinkProductDocument, options);
        }
export type OrderQuotationLinkProductQueryHookResult = ReturnType<typeof useOrderQuotationLinkProductQuery>;
export type OrderQuotationLinkProductLazyQueryHookResult = ReturnType<typeof useOrderQuotationLinkProductLazyQuery>;
export type OrderQuotationLinkProductQueryResult = Apollo.QueryResult<OrderQuotationLinkProductQuery, OrderQuotationLinkProductQueryVariables>;
export function refetchOrderQuotationLinkProductQuery(variables: OrderQuotationLinkProductQueryVariables) {
      return { query: OrderQuotationLinkProductDocument, variables: variables }
    }
export const LinkOrderQuotationProductDocument = gql`
    mutation LinkOrderQuotationProduct($OrderQuotationProductId: Int!, $ProductId: Int!) {
  linkOrderQuotationProduct(
    OrderQuotationProductId: $OrderQuotationProductId
    ProductId: $ProductId
  ) {
    id
  }
}
    `;
export type LinkOrderQuotationProductMutationFn = Apollo.MutationFunction<LinkOrderQuotationProductMutation, LinkOrderQuotationProductMutationVariables>;

/**
 * __useLinkOrderQuotationProductMutation__
 *
 * To run a mutation, you first call `useLinkOrderQuotationProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkOrderQuotationProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkOrderQuotationProductMutation, { data, loading, error }] = useLinkOrderQuotationProductMutation({
 *   variables: {
 *      OrderQuotationProductId: // value for 'OrderQuotationProductId'
 *      ProductId: // value for 'ProductId'
 *   },
 * });
 */
export function useLinkOrderQuotationProductMutation(baseOptions?: Apollo.MutationHookOptions<LinkOrderQuotationProductMutation, LinkOrderQuotationProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkOrderQuotationProductMutation, LinkOrderQuotationProductMutationVariables>(LinkOrderQuotationProductDocument, options);
      }
export type LinkOrderQuotationProductMutationHookResult = ReturnType<typeof useLinkOrderQuotationProductMutation>;
export type LinkOrderQuotationProductMutationResult = Apollo.MutationResult<LinkOrderQuotationProductMutation>;
export type LinkOrderQuotationProductMutationOptions = Apollo.BaseMutationOptions<LinkOrderQuotationProductMutation, LinkOrderQuotationProductMutationVariables>;
export const UpdateOrderQuotationStatusDocument = gql`
    mutation UpdateOrderQuotationStatus($OrderQuotationId: Int!, $OrderQuotationStatusId: Int!) {
  updateOrderQuotationStatus(
    OrderQuotationId: $OrderQuotationId
    OrderQuotationStatusId: $OrderQuotationStatusId
  ) {
    id
    order_quotation_status_id
    order_quotation_status {
      id
      name
    }
  }
}
    `;
export type UpdateOrderQuotationStatusMutationFn = Apollo.MutationFunction<UpdateOrderQuotationStatusMutation, UpdateOrderQuotationStatusMutationVariables>;

/**
 * __useUpdateOrderQuotationStatusMutation__
 *
 * To run a mutation, you first call `useUpdateOrderQuotationStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderQuotationStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderQuotationStatusMutation, { data, loading, error }] = useUpdateOrderQuotationStatusMutation({
 *   variables: {
 *      OrderQuotationId: // value for 'OrderQuotationId'
 *      OrderQuotationStatusId: // value for 'OrderQuotationStatusId'
 *   },
 * });
 */
export function useUpdateOrderQuotationStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderQuotationStatusMutation, UpdateOrderQuotationStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderQuotationStatusMutation, UpdateOrderQuotationStatusMutationVariables>(UpdateOrderQuotationStatusDocument, options);
      }
export type UpdateOrderQuotationStatusMutationHookResult = ReturnType<typeof useUpdateOrderQuotationStatusMutation>;
export type UpdateOrderQuotationStatusMutationResult = Apollo.MutationResult<UpdateOrderQuotationStatusMutation>;
export type UpdateOrderQuotationStatusMutationOptions = Apollo.BaseMutationOptions<UpdateOrderQuotationStatusMutation, UpdateOrderQuotationStatusMutationVariables>;
export const OrderQuotationAccountInputDocument = gql`
    query OrderQuotationAccountInput {
  getAccounts(is_client: true) {
    id
    name
  }
}
    `;

/**
 * __useOrderQuotationAccountInputQuery__
 *
 * To run a query within a React component, call `useOrderQuotationAccountInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderQuotationAccountInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderQuotationAccountInputQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrderQuotationAccountInputQuery(baseOptions?: Apollo.QueryHookOptions<OrderQuotationAccountInputQuery, OrderQuotationAccountInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderQuotationAccountInputQuery, OrderQuotationAccountInputQueryVariables>(OrderQuotationAccountInputDocument, options);
      }
export function useOrderQuotationAccountInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderQuotationAccountInputQuery, OrderQuotationAccountInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderQuotationAccountInputQuery, OrderQuotationAccountInputQueryVariables>(OrderQuotationAccountInputDocument, options);
        }
export type OrderQuotationAccountInputQueryHookResult = ReturnType<typeof useOrderQuotationAccountInputQuery>;
export type OrderQuotationAccountInputLazyQueryHookResult = ReturnType<typeof useOrderQuotationAccountInputLazyQuery>;
export type OrderQuotationAccountInputQueryResult = Apollo.QueryResult<OrderQuotationAccountInputQuery, OrderQuotationAccountInputQueryVariables>;
export function refetchOrderQuotationAccountInputQuery(variables?: OrderQuotationAccountInputQueryVariables) {
      return { query: OrderQuotationAccountInputDocument, variables: variables }
    }
export const OrderQuotationProductInputDocument = gql`
    query OrderQuotationProductInput {
  getProducts(exclude_discontinued: true) {
    id
    compound_description
    current_group_weight
  }
}
    `;

/**
 * __useOrderQuotationProductInputQuery__
 *
 * To run a query within a React component, call `useOrderQuotationProductInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderQuotationProductInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderQuotationProductInputQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrderQuotationProductInputQuery(baseOptions?: Apollo.QueryHookOptions<OrderQuotationProductInputQuery, OrderQuotationProductInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderQuotationProductInputQuery, OrderQuotationProductInputQueryVariables>(OrderQuotationProductInputDocument, options);
      }
export function useOrderQuotationProductInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderQuotationProductInputQuery, OrderQuotationProductInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderQuotationProductInputQuery, OrderQuotationProductInputQueryVariables>(OrderQuotationProductInputDocument, options);
        }
export type OrderQuotationProductInputQueryHookResult = ReturnType<typeof useOrderQuotationProductInputQuery>;
export type OrderQuotationProductInputLazyQueryHookResult = ReturnType<typeof useOrderQuotationProductInputLazyQuery>;
export type OrderQuotationProductInputQueryResult = Apollo.QueryResult<OrderQuotationProductInputQuery, OrderQuotationProductInputQueryVariables>;
export function refetchOrderQuotationProductInputQuery(variables?: OrderQuotationProductInputQueryVariables) {
      return { query: OrderQuotationProductInputDocument, variables: variables }
    }
export const GetOrderQuotationMaxOrderCodeDocument = gql`
    query GetOrderQuotationMaxOrderCode {
  getOrderQuotationMaxOrderCode
}
    `;

/**
 * __useGetOrderQuotationMaxOrderCodeQuery__
 *
 * To run a query within a React component, call `useGetOrderQuotationMaxOrderCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderQuotationMaxOrderCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderQuotationMaxOrderCodeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrderQuotationMaxOrderCodeQuery(baseOptions?: Apollo.QueryHookOptions<GetOrderQuotationMaxOrderCodeQuery, GetOrderQuotationMaxOrderCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderQuotationMaxOrderCodeQuery, GetOrderQuotationMaxOrderCodeQueryVariables>(GetOrderQuotationMaxOrderCodeDocument, options);
      }
export function useGetOrderQuotationMaxOrderCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderQuotationMaxOrderCodeQuery, GetOrderQuotationMaxOrderCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderQuotationMaxOrderCodeQuery, GetOrderQuotationMaxOrderCodeQueryVariables>(GetOrderQuotationMaxOrderCodeDocument, options);
        }
export type GetOrderQuotationMaxOrderCodeQueryHookResult = ReturnType<typeof useGetOrderQuotationMaxOrderCodeQuery>;
export type GetOrderQuotationMaxOrderCodeLazyQueryHookResult = ReturnType<typeof useGetOrderQuotationMaxOrderCodeLazyQuery>;
export type GetOrderQuotationMaxOrderCodeQueryResult = Apollo.QueryResult<GetOrderQuotationMaxOrderCodeQuery, GetOrderQuotationMaxOrderCodeQueryVariables>;
export function refetchGetOrderQuotationMaxOrderCodeQuery(variables?: GetOrderQuotationMaxOrderCodeQueryVariables) {
      return { query: GetOrderQuotationMaxOrderCodeDocument, variables: variables }
    }
export const UpsertOrderQuotationDocument = gql`
    mutation UpsertOrderQuotation($OrderQuotationInput: OrderQuotationInput!) {
  upsertOrderQuotation(OrderQuotationInput: $OrderQuotationInput) {
    id
    date
  }
}
    `;
export type UpsertOrderQuotationMutationFn = Apollo.MutationFunction<UpsertOrderQuotationMutation, UpsertOrderQuotationMutationVariables>;

/**
 * __useUpsertOrderQuotationMutation__
 *
 * To run a mutation, you first call `useUpsertOrderQuotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertOrderQuotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertOrderQuotationMutation, { data, loading, error }] = useUpsertOrderQuotationMutation({
 *   variables: {
 *      OrderQuotationInput: // value for 'OrderQuotationInput'
 *   },
 * });
 */
export function useUpsertOrderQuotationMutation(baseOptions?: Apollo.MutationHookOptions<UpsertOrderQuotationMutation, UpsertOrderQuotationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertOrderQuotationMutation, UpsertOrderQuotationMutationVariables>(UpsertOrderQuotationDocument, options);
      }
export type UpsertOrderQuotationMutationHookResult = ReturnType<typeof useUpsertOrderQuotationMutation>;
export type UpsertOrderQuotationMutationResult = Apollo.MutationResult<UpsertOrderQuotationMutation>;
export type UpsertOrderQuotationMutationOptions = Apollo.BaseMutationOptions<UpsertOrderQuotationMutation, UpsertOrderQuotationMutationVariables>;
export const OrderQuotationDialogDocument = gql`
    query OrderQuotationDialog($OrderQuotationId: Float!) {
  getOrderQuotation(OrderQuotationId: $OrderQuotationId) {
    is_editable
    id
    date
    estimated_delivery_date
    order_code
    order_quotation_status_id
    account_id
    products_total
    notes
    expiration_date
    payment_terms
    require_tax
    order_quotation_products {
      id
      kilos
      groups
      group_weight
      kilo_price
      group_price
      proposed_description
      product {
        id
        compound_description
        current_group_weight
      }
    }
    created_by {
      fullname
    }
    updated_by {
      fullname
    }
  }
}
    `;

/**
 * __useOrderQuotationDialogQuery__
 *
 * To run a query within a React component, call `useOrderQuotationDialogQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderQuotationDialogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderQuotationDialogQuery({
 *   variables: {
 *      OrderQuotationId: // value for 'OrderQuotationId'
 *   },
 * });
 */
export function useOrderQuotationDialogQuery(baseOptions: Apollo.QueryHookOptions<OrderQuotationDialogQuery, OrderQuotationDialogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderQuotationDialogQuery, OrderQuotationDialogQueryVariables>(OrderQuotationDialogDocument, options);
      }
export function useOrderQuotationDialogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderQuotationDialogQuery, OrderQuotationDialogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderQuotationDialogQuery, OrderQuotationDialogQueryVariables>(OrderQuotationDialogDocument, options);
        }
export type OrderQuotationDialogQueryHookResult = ReturnType<typeof useOrderQuotationDialogQuery>;
export type OrderQuotationDialogLazyQueryHookResult = ReturnType<typeof useOrderQuotationDialogLazyQuery>;
export type OrderQuotationDialogQueryResult = Apollo.QueryResult<OrderQuotationDialogQuery, OrderQuotationDialogQueryVariables>;
export function refetchOrderQuotationDialogQuery(variables: OrderQuotationDialogQueryVariables) {
      return { query: OrderQuotationDialogDocument, variables: variables }
    }
export const IsOrderQuotationCodeOccupiedDocument = gql`
    query IsOrderQuotationCodeOccupied($OrderCode: Float!, $OrderQuotationId: Int) {
  isOrderQuotationCodeOccupied(
    OrderCode: $OrderCode
    OrderQuotationId: $OrderQuotationId
  )
}
    `;

/**
 * __useIsOrderQuotationCodeOccupiedQuery__
 *
 * To run a query within a React component, call `useIsOrderQuotationCodeOccupiedQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsOrderQuotationCodeOccupiedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsOrderQuotationCodeOccupiedQuery({
 *   variables: {
 *      OrderCode: // value for 'OrderCode'
 *      OrderQuotationId: // value for 'OrderQuotationId'
 *   },
 * });
 */
export function useIsOrderQuotationCodeOccupiedQuery(baseOptions: Apollo.QueryHookOptions<IsOrderQuotationCodeOccupiedQuery, IsOrderQuotationCodeOccupiedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsOrderQuotationCodeOccupiedQuery, IsOrderQuotationCodeOccupiedQueryVariables>(IsOrderQuotationCodeOccupiedDocument, options);
      }
export function useIsOrderQuotationCodeOccupiedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsOrderQuotationCodeOccupiedQuery, IsOrderQuotationCodeOccupiedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsOrderQuotationCodeOccupiedQuery, IsOrderQuotationCodeOccupiedQueryVariables>(IsOrderQuotationCodeOccupiedDocument, options);
        }
export type IsOrderQuotationCodeOccupiedQueryHookResult = ReturnType<typeof useIsOrderQuotationCodeOccupiedQuery>;
export type IsOrderQuotationCodeOccupiedLazyQueryHookResult = ReturnType<typeof useIsOrderQuotationCodeOccupiedLazyQuery>;
export type IsOrderQuotationCodeOccupiedQueryResult = Apollo.QueryResult<IsOrderQuotationCodeOccupiedQuery, IsOrderQuotationCodeOccupiedQueryVariables>;
export function refetchIsOrderQuotationCodeOccupiedQuery(variables: IsOrderQuotationCodeOccupiedQueryVariables) {
      return { query: IsOrderQuotationCodeOccupiedDocument, variables: variables }
    }
export const UpdateOrderRequestStatusDocument = gql`
    mutation UpdateOrderRequestStatus($OrderRequestId: Int!, $OrderRequestStatusId: Int!) {
  updateOrderRequestStatus(
    OrderRequestId: $OrderRequestId
    OrderRequestStatusId: $OrderRequestStatusId
  ) {
    id
    order_request_status_id
    order_request_status {
      id
      name
    }
  }
}
    `;
export type UpdateOrderRequestStatusMutationFn = Apollo.MutationFunction<UpdateOrderRequestStatusMutation, UpdateOrderRequestStatusMutationVariables>;

/**
 * __useUpdateOrderRequestStatusMutation__
 *
 * To run a mutation, you first call `useUpdateOrderRequestStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderRequestStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderRequestStatusMutation, { data, loading, error }] = useUpdateOrderRequestStatusMutation({
 *   variables: {
 *      OrderRequestId: // value for 'OrderRequestId'
 *      OrderRequestStatusId: // value for 'OrderRequestStatusId'
 *   },
 * });
 */
export function useUpdateOrderRequestStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderRequestStatusMutation, UpdateOrderRequestStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderRequestStatusMutation, UpdateOrderRequestStatusMutationVariables>(UpdateOrderRequestStatusDocument, options);
      }
export type UpdateOrderRequestStatusMutationHookResult = ReturnType<typeof useUpdateOrderRequestStatusMutation>;
export type UpdateOrderRequestStatusMutationResult = Apollo.MutationResult<UpdateOrderRequestStatusMutation>;
export type UpdateOrderRequestStatusMutationOptions = Apollo.BaseMutationOptions<UpdateOrderRequestStatusMutation, UpdateOrderRequestStatusMutationVariables>;
export const OrderRequestAccountInputDocument = gql`
    query OrderRequestAccountInput {
  getAccounts(is_client: true) {
    id
    name
  }
}
    `;

/**
 * __useOrderRequestAccountInputQuery__
 *
 * To run a query within a React component, call `useOrderRequestAccountInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderRequestAccountInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderRequestAccountInputQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrderRequestAccountInputQuery(baseOptions?: Apollo.QueryHookOptions<OrderRequestAccountInputQuery, OrderRequestAccountInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderRequestAccountInputQuery, OrderRequestAccountInputQueryVariables>(OrderRequestAccountInputDocument, options);
      }
export function useOrderRequestAccountInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderRequestAccountInputQuery, OrderRequestAccountInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderRequestAccountInputQuery, OrderRequestAccountInputQueryVariables>(OrderRequestAccountInputDocument, options);
        }
export type OrderRequestAccountInputQueryHookResult = ReturnType<typeof useOrderRequestAccountInputQuery>;
export type OrderRequestAccountInputLazyQueryHookResult = ReturnType<typeof useOrderRequestAccountInputLazyQuery>;
export type OrderRequestAccountInputQueryResult = Apollo.QueryResult<OrderRequestAccountInputQuery, OrderRequestAccountInputQueryVariables>;
export function refetchOrderRequestAccountInputQuery(variables?: OrderRequestAccountInputQueryVariables) {
      return { query: OrderRequestAccountInputDocument, variables: variables }
    }
export const OrderRequestProductInputDocument = gql`
    query OrderRequestProductInput($accountId: Float!) {
  getAccountProducts(AccountId: $accountId) {
    id
    kilo_price
    group_price
    group_weight
    product {
      id
      compound_description
    }
  }
}
    `;

/**
 * __useOrderRequestProductInputQuery__
 *
 * To run a query within a React component, call `useOrderRequestProductInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderRequestProductInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderRequestProductInputQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useOrderRequestProductInputQuery(baseOptions: Apollo.QueryHookOptions<OrderRequestProductInputQuery, OrderRequestProductInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderRequestProductInputQuery, OrderRequestProductInputQueryVariables>(OrderRequestProductInputDocument, options);
      }
export function useOrderRequestProductInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderRequestProductInputQuery, OrderRequestProductInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderRequestProductInputQuery, OrderRequestProductInputQueryVariables>(OrderRequestProductInputDocument, options);
        }
export type OrderRequestProductInputQueryHookResult = ReturnType<typeof useOrderRequestProductInputQuery>;
export type OrderRequestProductInputLazyQueryHookResult = ReturnType<typeof useOrderRequestProductInputLazyQuery>;
export type OrderRequestProductInputQueryResult = Apollo.QueryResult<OrderRequestProductInputQuery, OrderRequestProductInputQueryVariables>;
export function refetchOrderRequestProductInputQuery(variables: OrderRequestProductInputQueryVariables) {
      return { query: OrderRequestProductInputDocument, variables: variables }
    }
export const OrderRequestOrderRequestStatusInputDocument = gql`
    query OrderRequestOrderRequestStatusInput {
  getOrderRequestStatuses {
    id
    name
  }
}
    `;

/**
 * __useOrderRequestOrderRequestStatusInputQuery__
 *
 * To run a query within a React component, call `useOrderRequestOrderRequestStatusInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderRequestOrderRequestStatusInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderRequestOrderRequestStatusInputQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrderRequestOrderRequestStatusInputQuery(baseOptions?: Apollo.QueryHookOptions<OrderRequestOrderRequestStatusInputQuery, OrderRequestOrderRequestStatusInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderRequestOrderRequestStatusInputQuery, OrderRequestOrderRequestStatusInputQueryVariables>(OrderRequestOrderRequestStatusInputDocument, options);
      }
export function useOrderRequestOrderRequestStatusInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderRequestOrderRequestStatusInputQuery, OrderRequestOrderRequestStatusInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderRequestOrderRequestStatusInputQuery, OrderRequestOrderRequestStatusInputQueryVariables>(OrderRequestOrderRequestStatusInputDocument, options);
        }
export type OrderRequestOrderRequestStatusInputQueryHookResult = ReturnType<typeof useOrderRequestOrderRequestStatusInputQuery>;
export type OrderRequestOrderRequestStatusInputLazyQueryHookResult = ReturnType<typeof useOrderRequestOrderRequestStatusInputLazyQuery>;
export type OrderRequestOrderRequestStatusInputQueryResult = Apollo.QueryResult<OrderRequestOrderRequestStatusInputQuery, OrderRequestOrderRequestStatusInputQueryVariables>;
export function refetchOrderRequestOrderRequestStatusInputQuery(variables?: OrderRequestOrderRequestStatusInputQueryVariables) {
      return { query: OrderRequestOrderRequestStatusInputDocument, variables: variables }
    }
export const GetOrderRequestMaxOrderCodeDocument = gql`
    query GetOrderRequestMaxOrderCode {
  getOrderRequestMaxOrderCode
}
    `;

/**
 * __useGetOrderRequestMaxOrderCodeQuery__
 *
 * To run a query within a React component, call `useGetOrderRequestMaxOrderCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderRequestMaxOrderCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderRequestMaxOrderCodeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrderRequestMaxOrderCodeQuery(baseOptions?: Apollo.QueryHookOptions<GetOrderRequestMaxOrderCodeQuery, GetOrderRequestMaxOrderCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderRequestMaxOrderCodeQuery, GetOrderRequestMaxOrderCodeQueryVariables>(GetOrderRequestMaxOrderCodeDocument, options);
      }
export function useGetOrderRequestMaxOrderCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderRequestMaxOrderCodeQuery, GetOrderRequestMaxOrderCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderRequestMaxOrderCodeQuery, GetOrderRequestMaxOrderCodeQueryVariables>(GetOrderRequestMaxOrderCodeDocument, options);
        }
export type GetOrderRequestMaxOrderCodeQueryHookResult = ReturnType<typeof useGetOrderRequestMaxOrderCodeQuery>;
export type GetOrderRequestMaxOrderCodeLazyQueryHookResult = ReturnType<typeof useGetOrderRequestMaxOrderCodeLazyQuery>;
export type GetOrderRequestMaxOrderCodeQueryResult = Apollo.QueryResult<GetOrderRequestMaxOrderCodeQuery, GetOrderRequestMaxOrderCodeQueryVariables>;
export function refetchGetOrderRequestMaxOrderCodeQuery(variables?: GetOrderRequestMaxOrderCodeQueryVariables) {
      return { query: GetOrderRequestMaxOrderCodeDocument, variables: variables }
    }
export const UpsertOrderRequestDocument = gql`
    mutation UpsertOrderRequest($OrderRequestInput: OrderRequestInput!) {
  upsertOrderRequest(OrderRequestInput: $OrderRequestInput) {
    id
    date
  }
}
    `;
export type UpsertOrderRequestMutationFn = Apollo.MutationFunction<UpsertOrderRequestMutation, UpsertOrderRequestMutationVariables>;

/**
 * __useUpsertOrderRequestMutation__
 *
 * To run a mutation, you first call `useUpsertOrderRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertOrderRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertOrderRequestMutation, { data, loading, error }] = useUpsertOrderRequestMutation({
 *   variables: {
 *      OrderRequestInput: // value for 'OrderRequestInput'
 *   },
 * });
 */
export function useUpsertOrderRequestMutation(baseOptions?: Apollo.MutationHookOptions<UpsertOrderRequestMutation, UpsertOrderRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertOrderRequestMutation, UpsertOrderRequestMutationVariables>(UpsertOrderRequestDocument, options);
      }
export type UpsertOrderRequestMutationHookResult = ReturnType<typeof useUpsertOrderRequestMutation>;
export type UpsertOrderRequestMutationResult = Apollo.MutationResult<UpsertOrderRequestMutation>;
export type UpsertOrderRequestMutationOptions = Apollo.BaseMutationOptions<UpsertOrderRequestMutation, UpsertOrderRequestMutationVariables>;
export const OrderRequestDialogDocument = gql`
    query OrderRequestDialog($OrderRequestId: Float!) {
  getOrderRequest(OrderRequestId: $OrderRequestId) {
    is_editable
    id
    date
    estimated_delivery_date
    order_code
    order_request_status_id
    account_id
    products_total
    notes
    order_request_products {
      id
      kilos
      groups
      group_weight
      kilo_price
      group_price
      product {
        id
        compound_description
        current_group_weight
        current_kilo_price
      }
    }
    order_sale_sold_products {
      id
      kilos
      groups
      group_weight
      kilo_price
      product_id
    }
    created_by {
      fullname
    }
    updated_by {
      fullname
    }
  }
}
    `;

/**
 * __useOrderRequestDialogQuery__
 *
 * To run a query within a React component, call `useOrderRequestDialogQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderRequestDialogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderRequestDialogQuery({
 *   variables: {
 *      OrderRequestId: // value for 'OrderRequestId'
 *   },
 * });
 */
export function useOrderRequestDialogQuery(baseOptions: Apollo.QueryHookOptions<OrderRequestDialogQuery, OrderRequestDialogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderRequestDialogQuery, OrderRequestDialogQueryVariables>(OrderRequestDialogDocument, options);
      }
export function useOrderRequestDialogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderRequestDialogQuery, OrderRequestDialogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderRequestDialogQuery, OrderRequestDialogQueryVariables>(OrderRequestDialogDocument, options);
        }
export type OrderRequestDialogQueryHookResult = ReturnType<typeof useOrderRequestDialogQuery>;
export type OrderRequestDialogLazyQueryHookResult = ReturnType<typeof useOrderRequestDialogLazyQuery>;
export type OrderRequestDialogQueryResult = Apollo.QueryResult<OrderRequestDialogQuery, OrderRequestDialogQueryVariables>;
export function refetchOrderRequestDialogQuery(variables: OrderRequestDialogQueryVariables) {
      return { query: OrderRequestDialogDocument, variables: variables }
    }
export const IsOrderRequestCodeOccupiedDocument = gql`
    query IsOrderRequestCodeOccupied($OrderCode: Float!, $OrderRequestId: Int) {
  isOrderRequestCodeOccupied(
    OrderCode: $OrderCode
    OrderRequestId: $OrderRequestId
  )
}
    `;

/**
 * __useIsOrderRequestCodeOccupiedQuery__
 *
 * To run a query within a React component, call `useIsOrderRequestCodeOccupiedQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsOrderRequestCodeOccupiedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsOrderRequestCodeOccupiedQuery({
 *   variables: {
 *      OrderCode: // value for 'OrderCode'
 *      OrderRequestId: // value for 'OrderRequestId'
 *   },
 * });
 */
export function useIsOrderRequestCodeOccupiedQuery(baseOptions: Apollo.QueryHookOptions<IsOrderRequestCodeOccupiedQuery, IsOrderRequestCodeOccupiedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsOrderRequestCodeOccupiedQuery, IsOrderRequestCodeOccupiedQueryVariables>(IsOrderRequestCodeOccupiedDocument, options);
      }
export function useIsOrderRequestCodeOccupiedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsOrderRequestCodeOccupiedQuery, IsOrderRequestCodeOccupiedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsOrderRequestCodeOccupiedQuery, IsOrderRequestCodeOccupiedQueryVariables>(IsOrderRequestCodeOccupiedDocument, options);
        }
export type IsOrderRequestCodeOccupiedQueryHookResult = ReturnType<typeof useIsOrderRequestCodeOccupiedQuery>;
export type IsOrderRequestCodeOccupiedLazyQueryHookResult = ReturnType<typeof useIsOrderRequestCodeOccupiedLazyQuery>;
export type IsOrderRequestCodeOccupiedQueryResult = Apollo.QueryResult<IsOrderRequestCodeOccupiedQuery, IsOrderRequestCodeOccupiedQueryVariables>;
export function refetchIsOrderRequestCodeOccupiedQuery(variables: IsOrderRequestCodeOccupiedQueryVariables) {
      return { query: IsOrderRequestCodeOccupiedDocument, variables: variables }
    }
export const UpdateOrderSaleDetailsDocument = gql`
    mutation UpdateOrderSaleDetails($OrderSaleDetailsInput: OrderSaleDetailsInput!) {
  updateOrderSaleDetails(OrderSaleDetailsInput: $OrderSaleDetailsInput) {
    id
    notes
    expected_payment_date
    require_supplement
    supplement_code
    require_credit_note
    credit_note_code
    credit_note_amount
    canceled
  }
}
    `;
export type UpdateOrderSaleDetailsMutationFn = Apollo.MutationFunction<UpdateOrderSaleDetailsMutation, UpdateOrderSaleDetailsMutationVariables>;

/**
 * __useUpdateOrderSaleDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateOrderSaleDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderSaleDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderSaleDetailsMutation, { data, loading, error }] = useUpdateOrderSaleDetailsMutation({
 *   variables: {
 *      OrderSaleDetailsInput: // value for 'OrderSaleDetailsInput'
 *   },
 * });
 */
export function useUpdateOrderSaleDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderSaleDetailsMutation, UpdateOrderSaleDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderSaleDetailsMutation, UpdateOrderSaleDetailsMutationVariables>(UpdateOrderSaleDetailsDocument, options);
      }
export type UpdateOrderSaleDetailsMutationHookResult = ReturnType<typeof useUpdateOrderSaleDetailsMutation>;
export type UpdateOrderSaleDetailsMutationResult = Apollo.MutationResult<UpdateOrderSaleDetailsMutation>;
export type UpdateOrderSaleDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateOrderSaleDetailsMutation, UpdateOrderSaleDetailsMutationVariables>;
export const UpdateOrderSaleStatusDocument = gql`
    mutation UpdateOrderSaleStatus($OrderSaleId: Int!, $OrderSaleStatusId: Int!) {
  updateOrderSaleStatus(
    OrderSaleId: $OrderSaleId
    OrderSaleStatusId: $OrderSaleStatusId
  ) {
    id
    order_sale_status_id
    order_sale_status {
      id
      name
    }
  }
}
    `;
export type UpdateOrderSaleStatusMutationFn = Apollo.MutationFunction<UpdateOrderSaleStatusMutation, UpdateOrderSaleStatusMutationVariables>;

/**
 * __useUpdateOrderSaleStatusMutation__
 *
 * To run a mutation, you first call `useUpdateOrderSaleStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderSaleStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderSaleStatusMutation, { data, loading, error }] = useUpdateOrderSaleStatusMutation({
 *   variables: {
 *      OrderSaleId: // value for 'OrderSaleId'
 *      OrderSaleStatusId: // value for 'OrderSaleStatusId'
 *   },
 * });
 */
export function useUpdateOrderSaleStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderSaleStatusMutation, UpdateOrderSaleStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderSaleStatusMutation, UpdateOrderSaleStatusMutationVariables>(UpdateOrderSaleStatusDocument, options);
      }
export type UpdateOrderSaleStatusMutationHookResult = ReturnType<typeof useUpdateOrderSaleStatusMutation>;
export type UpdateOrderSaleStatusMutationResult = Apollo.MutationResult<UpdateOrderSaleStatusMutation>;
export type UpdateOrderSaleStatusMutationOptions = Apollo.BaseMutationOptions<UpdateOrderSaleStatusMutation, UpdateOrderSaleStatusMutationVariables>;
export const OrderSaleAccountIdInputDocument = gql`
    query OrderSaleAccountIdInput {
  getAccounts(is_client: true) {
    id
    name
    requires_order_request
    client_credit_days
    client_require_credit_note
    client_require_supplement
    client_requires_invoice_code
    client_requires_tax
    client_automatic_tax_calculation
    client_reconciliation_only
  }
}
    `;

/**
 * __useOrderSaleAccountIdInputQuery__
 *
 * To run a query within a React component, call `useOrderSaleAccountIdInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderSaleAccountIdInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderSaleAccountIdInputQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrderSaleAccountIdInputQuery(baseOptions?: Apollo.QueryHookOptions<OrderSaleAccountIdInputQuery, OrderSaleAccountIdInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderSaleAccountIdInputQuery, OrderSaleAccountIdInputQueryVariables>(OrderSaleAccountIdInputDocument, options);
      }
export function useOrderSaleAccountIdInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderSaleAccountIdInputQuery, OrderSaleAccountIdInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderSaleAccountIdInputQuery, OrderSaleAccountIdInputQueryVariables>(OrderSaleAccountIdInputDocument, options);
        }
export type OrderSaleAccountIdInputQueryHookResult = ReturnType<typeof useOrderSaleAccountIdInputQuery>;
export type OrderSaleAccountIdInputLazyQueryHookResult = ReturnType<typeof useOrderSaleAccountIdInputLazyQuery>;
export type OrderSaleAccountIdInputQueryResult = Apollo.QueryResult<OrderSaleAccountIdInputQuery, OrderSaleAccountIdInputQueryVariables>;
export function refetchOrderSaleAccountIdInputQuery(variables?: OrderSaleAccountIdInputQueryVariables) {
      return { query: OrderSaleAccountIdInputDocument, variables: variables }
    }
export const OrderSaleOrderAdjustmentProductInputDocument = gql`
    query OrderSaleOrderAdjustmentProductInput {
  getProducts {
    id
    compound_description
    current_group_weight
    current_kilo_price
  }
}
    `;

/**
 * __useOrderSaleOrderAdjustmentProductInputQuery__
 *
 * To run a query within a React component, call `useOrderSaleOrderAdjustmentProductInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderSaleOrderAdjustmentProductInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderSaleOrderAdjustmentProductInputQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrderSaleOrderAdjustmentProductInputQuery(baseOptions?: Apollo.QueryHookOptions<OrderSaleOrderAdjustmentProductInputQuery, OrderSaleOrderAdjustmentProductInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderSaleOrderAdjustmentProductInputQuery, OrderSaleOrderAdjustmentProductInputQueryVariables>(OrderSaleOrderAdjustmentProductInputDocument, options);
      }
export function useOrderSaleOrderAdjustmentProductInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderSaleOrderAdjustmentProductInputQuery, OrderSaleOrderAdjustmentProductInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderSaleOrderAdjustmentProductInputQuery, OrderSaleOrderAdjustmentProductInputQueryVariables>(OrderSaleOrderAdjustmentProductInputDocument, options);
        }
export type OrderSaleOrderAdjustmentProductInputQueryHookResult = ReturnType<typeof useOrderSaleOrderAdjustmentProductInputQuery>;
export type OrderSaleOrderAdjustmentProductInputLazyQueryHookResult = ReturnType<typeof useOrderSaleOrderAdjustmentProductInputLazyQuery>;
export type OrderSaleOrderAdjustmentProductInputQueryResult = Apollo.QueryResult<OrderSaleOrderAdjustmentProductInputQuery, OrderSaleOrderAdjustmentProductInputQueryVariables>;
export function refetchOrderSaleOrderAdjustmentProductInputQuery(variables?: OrderSaleOrderAdjustmentProductInputQueryVariables) {
      return { query: OrderSaleOrderAdjustmentProductInputDocument, variables: variables }
    }
export const OrderSaleOrderRequestInputDocument = gql`
    query OrderSaleOrderRequestInput {
  getOrderRequests(order_request_status_ids: [2]) {
    id
    order_code
    account {
      id
      requires_order_request
      client_credit_days
      client_require_credit_note
      client_require_supplement
      client_requires_invoice_code
      client_requires_tax
      client_automatic_tax_calculation
    }
    order_request_products {
      product_id
      kilos
      groups
      group_price
      kilo_price
      total
    }
    order_request_remaining_products {
      product_id
      product {
        id
        compound_description
        current_group_weight
        current_kilo_price
      }
      kilos
      groups
      kilo_price
      group_weight
      group_price
      total
    }
  }
}
    `;

/**
 * __useOrderSaleOrderRequestInputQuery__
 *
 * To run a query within a React component, call `useOrderSaleOrderRequestInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderSaleOrderRequestInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderSaleOrderRequestInputQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrderSaleOrderRequestInputQuery(baseOptions?: Apollo.QueryHookOptions<OrderSaleOrderRequestInputQuery, OrderSaleOrderRequestInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderSaleOrderRequestInputQuery, OrderSaleOrderRequestInputQueryVariables>(OrderSaleOrderRequestInputDocument, options);
      }
export function useOrderSaleOrderRequestInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderSaleOrderRequestInputQuery, OrderSaleOrderRequestInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderSaleOrderRequestInputQuery, OrderSaleOrderRequestInputQueryVariables>(OrderSaleOrderRequestInputDocument, options);
        }
export type OrderSaleOrderRequestInputQueryHookResult = ReturnType<typeof useOrderSaleOrderRequestInputQuery>;
export type OrderSaleOrderRequestInputLazyQueryHookResult = ReturnType<typeof useOrderSaleOrderRequestInputLazyQuery>;
export type OrderSaleOrderRequestInputQueryResult = Apollo.QueryResult<OrderSaleOrderRequestInputQuery, OrderSaleOrderRequestInputQueryVariables>;
export function refetchOrderSaleOrderRequestInputQuery(variables?: OrderSaleOrderRequestInputQueryVariables) {
      return { query: OrderSaleOrderRequestInputDocument, variables: variables }
    }
export const OrderSaleProductInputDocument = gql`
    query OrderSaleProductInput($excludeDiscontinued: Boolean!) {
  getProducts(exclude_discontinued: $excludeDiscontinued) {
    id
    compound_description
    current_group_weight
    current_kilo_price
  }
}
    `;

/**
 * __useOrderSaleProductInputQuery__
 *
 * To run a query within a React component, call `useOrderSaleProductInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderSaleProductInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderSaleProductInputQuery({
 *   variables: {
 *      excludeDiscontinued: // value for 'excludeDiscontinued'
 *   },
 * });
 */
export function useOrderSaleProductInputQuery(baseOptions: Apollo.QueryHookOptions<OrderSaleProductInputQuery, OrderSaleProductInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderSaleProductInputQuery, OrderSaleProductInputQueryVariables>(OrderSaleProductInputDocument, options);
      }
export function useOrderSaleProductInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderSaleProductInputQuery, OrderSaleProductInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderSaleProductInputQuery, OrderSaleProductInputQueryVariables>(OrderSaleProductInputDocument, options);
        }
export type OrderSaleProductInputQueryHookResult = ReturnType<typeof useOrderSaleProductInputQuery>;
export type OrderSaleProductInputLazyQueryHookResult = ReturnType<typeof useOrderSaleProductInputLazyQuery>;
export type OrderSaleProductInputQueryResult = Apollo.QueryResult<OrderSaleProductInputQuery, OrderSaleProductInputQueryVariables>;
export function refetchOrderSaleProductInputQuery(variables: OrderSaleProductInputQueryVariables) {
      return { query: OrderSaleProductInputDocument, variables: variables }
    }
export const OrderSaleOrderSaleReceiptTypeInputDocument = gql`
    query OrderSaleOrderSaleReceiptTypeInput {
  getReceiptTypes {
    id
    name
    applies_tax
    tax_multiplier
  }
}
    `;

/**
 * __useOrderSaleOrderSaleReceiptTypeInputQuery__
 *
 * To run a query within a React component, call `useOrderSaleOrderSaleReceiptTypeInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderSaleOrderSaleReceiptTypeInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderSaleOrderSaleReceiptTypeInputQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrderSaleOrderSaleReceiptTypeInputQuery(baseOptions?: Apollo.QueryHookOptions<OrderSaleOrderSaleReceiptTypeInputQuery, OrderSaleOrderSaleReceiptTypeInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderSaleOrderSaleReceiptTypeInputQuery, OrderSaleOrderSaleReceiptTypeInputQueryVariables>(OrderSaleOrderSaleReceiptTypeInputDocument, options);
      }
export function useOrderSaleOrderSaleReceiptTypeInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderSaleOrderSaleReceiptTypeInputQuery, OrderSaleOrderSaleReceiptTypeInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderSaleOrderSaleReceiptTypeInputQuery, OrderSaleOrderSaleReceiptTypeInputQueryVariables>(OrderSaleOrderSaleReceiptTypeInputDocument, options);
        }
export type OrderSaleOrderSaleReceiptTypeInputQueryHookResult = ReturnType<typeof useOrderSaleOrderSaleReceiptTypeInputQuery>;
export type OrderSaleOrderSaleReceiptTypeInputLazyQueryHookResult = ReturnType<typeof useOrderSaleOrderSaleReceiptTypeInputLazyQuery>;
export type OrderSaleOrderSaleReceiptTypeInputQueryResult = Apollo.QueryResult<OrderSaleOrderSaleReceiptTypeInputQuery, OrderSaleOrderSaleReceiptTypeInputQueryVariables>;
export function refetchOrderSaleOrderSaleReceiptTypeInputQuery(variables?: OrderSaleOrderSaleReceiptTypeInputQueryVariables) {
      return { query: OrderSaleOrderSaleReceiptTypeInputDocument, variables: variables }
    }
export const OrderSaleOrderSaleStatusInputDocument = gql`
    query OrderSaleOrderSaleStatusInput {
  getOrderSaleStatuses {
    id
    name
  }
}
    `;

/**
 * __useOrderSaleOrderSaleStatusInputQuery__
 *
 * To run a query within a React component, call `useOrderSaleOrderSaleStatusInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderSaleOrderSaleStatusInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderSaleOrderSaleStatusInputQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrderSaleOrderSaleStatusInputQuery(baseOptions?: Apollo.QueryHookOptions<OrderSaleOrderSaleStatusInputQuery, OrderSaleOrderSaleStatusInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderSaleOrderSaleStatusInputQuery, OrderSaleOrderSaleStatusInputQueryVariables>(OrderSaleOrderSaleStatusInputDocument, options);
      }
export function useOrderSaleOrderSaleStatusInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderSaleOrderSaleStatusInputQuery, OrderSaleOrderSaleStatusInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderSaleOrderSaleStatusInputQuery, OrderSaleOrderSaleStatusInputQueryVariables>(OrderSaleOrderSaleStatusInputDocument, options);
        }
export type OrderSaleOrderSaleStatusInputQueryHookResult = ReturnType<typeof useOrderSaleOrderSaleStatusInputQuery>;
export type OrderSaleOrderSaleStatusInputLazyQueryHookResult = ReturnType<typeof useOrderSaleOrderSaleStatusInputLazyQuery>;
export type OrderSaleOrderSaleStatusInputQueryResult = Apollo.QueryResult<OrderSaleOrderSaleStatusInputQuery, OrderSaleOrderSaleStatusInputQueryVariables>;
export function refetchOrderSaleOrderSaleStatusInputQuery(variables?: OrderSaleOrderSaleStatusInputQueryVariables) {
      return { query: OrderSaleOrderSaleStatusInputDocument, variables: variables }
    }
export const GetOrderSaleMaxOrderCodeDocument = gql`
    query GetOrderSaleMaxOrderCode {
  getOrderSaleMaxOrderCode
}
    `;

/**
 * __useGetOrderSaleMaxOrderCodeQuery__
 *
 * To run a query within a React component, call `useGetOrderSaleMaxOrderCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderSaleMaxOrderCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderSaleMaxOrderCodeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrderSaleMaxOrderCodeQuery(baseOptions?: Apollo.QueryHookOptions<GetOrderSaleMaxOrderCodeQuery, GetOrderSaleMaxOrderCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderSaleMaxOrderCodeQuery, GetOrderSaleMaxOrderCodeQueryVariables>(GetOrderSaleMaxOrderCodeDocument, options);
      }
export function useGetOrderSaleMaxOrderCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderSaleMaxOrderCodeQuery, GetOrderSaleMaxOrderCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderSaleMaxOrderCodeQuery, GetOrderSaleMaxOrderCodeQueryVariables>(GetOrderSaleMaxOrderCodeDocument, options);
        }
export type GetOrderSaleMaxOrderCodeQueryHookResult = ReturnType<typeof useGetOrderSaleMaxOrderCodeQuery>;
export type GetOrderSaleMaxOrderCodeLazyQueryHookResult = ReturnType<typeof useGetOrderSaleMaxOrderCodeLazyQuery>;
export type GetOrderSaleMaxOrderCodeQueryResult = Apollo.QueryResult<GetOrderSaleMaxOrderCodeQuery, GetOrderSaleMaxOrderCodeQueryVariables>;
export function refetchGetOrderSaleMaxOrderCodeQuery(variables?: GetOrderSaleMaxOrderCodeQueryVariables) {
      return { query: GetOrderSaleMaxOrderCodeDocument, variables: variables }
    }
export const UpsertOrderSaleDocument = gql`
    mutation UpsertOrderSale($OrderSaleInput: OrderSaleInput!) {
  upsertOrderSale(OrderSaleInput: $OrderSaleInput) {
    id
    notes
    date
  }
}
    `;
export type UpsertOrderSaleMutationFn = Apollo.MutationFunction<UpsertOrderSaleMutation, UpsertOrderSaleMutationVariables>;

/**
 * __useUpsertOrderSaleMutation__
 *
 * To run a mutation, you first call `useUpsertOrderSaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertOrderSaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertOrderSaleMutation, { data, loading, error }] = useUpsertOrderSaleMutation({
 *   variables: {
 *      OrderSaleInput: // value for 'OrderSaleInput'
 *   },
 * });
 */
export function useUpsertOrderSaleMutation(baseOptions?: Apollo.MutationHookOptions<UpsertOrderSaleMutation, UpsertOrderSaleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertOrderSaleMutation, UpsertOrderSaleMutationVariables>(UpsertOrderSaleDocument, options);
      }
export type UpsertOrderSaleMutationHookResult = ReturnType<typeof useUpsertOrderSaleMutation>;
export type UpsertOrderSaleMutationResult = Apollo.MutationResult<UpsertOrderSaleMutation>;
export type UpsertOrderSaleMutationOptions = Apollo.BaseMutationOptions<UpsertOrderSaleMutation, UpsertOrderSaleMutationVariables>;
export const OrderSaleDialogDocument = gql`
    query OrderSaleDialog($OrderSaleId: Float!) {
  getOrderSale(OrderSaleId: $OrderSaleId) {
    is_editable
    id
    notes
    date
    expected_payment_date
    order_code
    invoice_code
    require_invoice_code
    require_tax
    order_sale_status_id
    receipt_type_id
    subtotal
    total_with_tax
    account {
      id
      requires_order_request
      client_requires_invoice_code
      client_requires_tax
    }
    require_supplement
    canceled
    reconciliation_only
    supplement_code
    require_credit_note
    credit_note_code
    credit_note_amount
    automatic_tax_calculation
    order_request {
      id
      order_code
      account {
        id
        requires_order_request
        client_requires_invoice_code
        client_requires_tax
      }
      order_request_status_id
      order_request_products {
        product_id
        kilos
        groups
        total
      }
      order_request_remaining_products {
        product_id
        product {
          id
          compound_description
          current_group_weight
          current_kilo_price
          current_group_price
        }
        kilos
        groups
        kilo_price
        group_weight
        group_price
        total
      }
    }
    order_sale_products {
      id
      kilos
      groups
      kilo_price
      group_price
      group_weight
      total
      product {
        id
        compound_description
        current_group_weight
        current_kilo_price
        current_group_price
      }
    }
    order_adjustment_products {
      product_id
      product {
        id
        compound_description
      }
      kilos
      groups
    }
    transfer_receipts {
      id
      transfer {
        id
        transferred_date
        amount
        from_account {
          id
        }
        to_account {
          id
          compound_name
        }
      }
      amount
    }
    subtotal
    tax
    transfer_receipts_total
    transfer_receipts_total_no_adjustments
    created_by {
      fullname
    }
    updated_by {
      fullname
    }
  }
}
    `;

/**
 * __useOrderSaleDialogQuery__
 *
 * To run a query within a React component, call `useOrderSaleDialogQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderSaleDialogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderSaleDialogQuery({
 *   variables: {
 *      OrderSaleId: // value for 'OrderSaleId'
 *   },
 * });
 */
export function useOrderSaleDialogQuery(baseOptions: Apollo.QueryHookOptions<OrderSaleDialogQuery, OrderSaleDialogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderSaleDialogQuery, OrderSaleDialogQueryVariables>(OrderSaleDialogDocument, options);
      }
export function useOrderSaleDialogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderSaleDialogQuery, OrderSaleDialogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderSaleDialogQuery, OrderSaleDialogQueryVariables>(OrderSaleDialogDocument, options);
        }
export type OrderSaleDialogQueryHookResult = ReturnType<typeof useOrderSaleDialogQuery>;
export type OrderSaleDialogLazyQueryHookResult = ReturnType<typeof useOrderSaleDialogLazyQuery>;
export type OrderSaleDialogQueryResult = Apollo.QueryResult<OrderSaleDialogQuery, OrderSaleDialogQueryVariables>;
export function refetchOrderSaleDialogQuery(variables: OrderSaleDialogQueryVariables) {
      return { query: OrderSaleDialogDocument, variables: variables }
    }
export const IsOrderSaleCodeOccupiedDocument = gql`
    query IsOrderSaleCodeOccupied($OrderCode: Float!, $OrderSaleId: Int) {
  isOrderSaleCodeOccupied(OrderCode: $OrderCode, OrderSaleId: $OrderSaleId)
}
    `;

/**
 * __useIsOrderSaleCodeOccupiedQuery__
 *
 * To run a query within a React component, call `useIsOrderSaleCodeOccupiedQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsOrderSaleCodeOccupiedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsOrderSaleCodeOccupiedQuery({
 *   variables: {
 *      OrderCode: // value for 'OrderCode'
 *      OrderSaleId: // value for 'OrderSaleId'
 *   },
 * });
 */
export function useIsOrderSaleCodeOccupiedQuery(baseOptions: Apollo.QueryHookOptions<IsOrderSaleCodeOccupiedQuery, IsOrderSaleCodeOccupiedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsOrderSaleCodeOccupiedQuery, IsOrderSaleCodeOccupiedQueryVariables>(IsOrderSaleCodeOccupiedDocument, options);
      }
export function useIsOrderSaleCodeOccupiedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsOrderSaleCodeOccupiedQuery, IsOrderSaleCodeOccupiedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsOrderSaleCodeOccupiedQuery, IsOrderSaleCodeOccupiedQueryVariables>(IsOrderSaleCodeOccupiedDocument, options);
        }
export type IsOrderSaleCodeOccupiedQueryHookResult = ReturnType<typeof useIsOrderSaleCodeOccupiedQuery>;
export type IsOrderSaleCodeOccupiedLazyQueryHookResult = ReturnType<typeof useIsOrderSaleCodeOccupiedLazyQuery>;
export type IsOrderSaleCodeOccupiedQueryResult = Apollo.QueryResult<IsOrderSaleCodeOccupiedQuery, IsOrderSaleCodeOccupiedQueryVariables>;
export function refetchIsOrderSaleCodeOccupiedQuery(variables: IsOrderSaleCodeOccupiedQueryVariables) {
      return { query: IsOrderSaleCodeOccupiedDocument, variables: variables }
    }
export const ProductsInputDocument = gql`
    query ProductsInput {
  getProducts {
    id
    compound_description
    current_group_weight
  }
}
    `;

/**
 * __useProductsInputQuery__
 *
 * To run a query within a React component, call `useProductsInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsInputQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductsInputQuery(baseOptions?: Apollo.QueryHookOptions<ProductsInputQuery, ProductsInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductsInputQuery, ProductsInputQueryVariables>(ProductsInputDocument, options);
      }
export function useProductsInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductsInputQuery, ProductsInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductsInputQuery, ProductsInputQueryVariables>(ProductsInputDocument, options);
        }
export type ProductsInputQueryHookResult = ReturnType<typeof useProductsInputQuery>;
export type ProductsInputLazyQueryHookResult = ReturnType<typeof useProductsInputLazyQuery>;
export type ProductsInputQueryResult = Apollo.QueryResult<ProductsInputQuery, ProductsInputQueryVariables>;
export function refetchProductsInputQuery(variables?: ProductsInputQueryVariables) {
      return { query: ProductsInputDocument, variables: variables }
    }
export const MachineSectionInputDocument = gql`
    query MachineSectionInput($MachineId: Float!) {
  getMachineSections(MachineId: $MachineId) {
    id
    name
  }
}
    `;

/**
 * __useMachineSectionInputQuery__
 *
 * To run a query within a React component, call `useMachineSectionInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useMachineSectionInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMachineSectionInputQuery({
 *   variables: {
 *      MachineId: // value for 'MachineId'
 *   },
 * });
 */
export function useMachineSectionInputQuery(baseOptions: Apollo.QueryHookOptions<MachineSectionInputQuery, MachineSectionInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MachineSectionInputQuery, MachineSectionInputQueryVariables>(MachineSectionInputDocument, options);
      }
export function useMachineSectionInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MachineSectionInputQuery, MachineSectionInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MachineSectionInputQuery, MachineSectionInputQueryVariables>(MachineSectionInputDocument, options);
        }
export type MachineSectionInputQueryHookResult = ReturnType<typeof useMachineSectionInputQuery>;
export type MachineSectionInputLazyQueryHookResult = ReturnType<typeof useMachineSectionInputLazyQuery>;
export type MachineSectionInputQueryResult = Apollo.QueryResult<MachineSectionInputQuery, MachineSectionInputQueryVariables>;
export function refetchMachineSectionInputQuery(variables: MachineSectionInputQueryVariables) {
      return { query: MachineSectionInputDocument, variables: variables }
    }
export const MachineInputDocument = gql`
    query MachineInput {
  getMachines {
    id
    name
  }
}
    `;

/**
 * __useMachineInputQuery__
 *
 * To run a query within a React component, call `useMachineInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useMachineInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMachineInputQuery({
 *   variables: {
 *   },
 * });
 */
export function useMachineInputQuery(baseOptions?: Apollo.QueryHookOptions<MachineInputQuery, MachineInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MachineInputQuery, MachineInputQueryVariables>(MachineInputDocument, options);
      }
export function useMachineInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MachineInputQuery, MachineInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MachineInputQuery, MachineInputQueryVariables>(MachineInputDocument, options);
        }
export type MachineInputQueryHookResult = ReturnType<typeof useMachineInputQuery>;
export type MachineInputLazyQueryHookResult = ReturnType<typeof useMachineInputLazyQuery>;
export type MachineInputQueryResult = Apollo.QueryResult<MachineInputQuery, MachineInputQueryVariables>;
export function refetchMachineInputQuery(variables?: MachineInputQueryVariables) {
      return { query: MachineInputDocument, variables: variables }
    }
export const SparesInputDocument = gql`
    query SparesInput {
  getSpares {
    id
    name
  }
}
    `;

/**
 * __useSparesInputQuery__
 *
 * To run a query within a React component, call `useSparesInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useSparesInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSparesInputQuery({
 *   variables: {
 *   },
 * });
 */
export function useSparesInputQuery(baseOptions?: Apollo.QueryHookOptions<SparesInputQuery, SparesInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SparesInputQuery, SparesInputQueryVariables>(SparesInputDocument, options);
      }
export function useSparesInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SparesInputQuery, SparesInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SparesInputQuery, SparesInputQueryVariables>(SparesInputDocument, options);
        }
export type SparesInputQueryHookResult = ReturnType<typeof useSparesInputQuery>;
export type SparesInputLazyQueryHookResult = ReturnType<typeof useSparesInputLazyQuery>;
export type SparesInputQueryResult = Apollo.QueryResult<SparesInputQuery, SparesInputQueryVariables>;
export function refetchSparesInputQuery(variables?: SparesInputQueryVariables) {
      return { query: SparesInputDocument, variables: variables }
    }
export const ProductionPerformanceConsumptionRatesDocument = gql`
    query ProductionPerformanceConsumptionRates($machineIds: [Int!]!, $fromDate: String) {
  getMachineConsumptionRates(machineIds: $machineIds, fromDate: $fromDate) {
    machine_id
    product_id
    product_name
    consumed_kilos
    consumed_hours
    packed_hours
    runs
  }
}
    `;

/**
 * __useProductionPerformanceConsumptionRatesQuery__
 *
 * To run a query within a React component, call `useProductionPerformanceConsumptionRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductionPerformanceConsumptionRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductionPerformanceConsumptionRatesQuery({
 *   variables: {
 *      machineIds: // value for 'machineIds'
 *      fromDate: // value for 'fromDate'
 *   },
 * });
 */
export function useProductionPerformanceConsumptionRatesQuery(baseOptions: Apollo.QueryHookOptions<ProductionPerformanceConsumptionRatesQuery, ProductionPerformanceConsumptionRatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductionPerformanceConsumptionRatesQuery, ProductionPerformanceConsumptionRatesQueryVariables>(ProductionPerformanceConsumptionRatesDocument, options);
      }
export function useProductionPerformanceConsumptionRatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductionPerformanceConsumptionRatesQuery, ProductionPerformanceConsumptionRatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductionPerformanceConsumptionRatesQuery, ProductionPerformanceConsumptionRatesQueryVariables>(ProductionPerformanceConsumptionRatesDocument, options);
        }
export type ProductionPerformanceConsumptionRatesQueryHookResult = ReturnType<typeof useProductionPerformanceConsumptionRatesQuery>;
export type ProductionPerformanceConsumptionRatesLazyQueryHookResult = ReturnType<typeof useProductionPerformanceConsumptionRatesLazyQuery>;
export type ProductionPerformanceConsumptionRatesQueryResult = Apollo.QueryResult<ProductionPerformanceConsumptionRatesQuery, ProductionPerformanceConsumptionRatesQueryVariables>;
export function refetchProductionPerformanceConsumptionRatesQuery(variables: ProductionPerformanceConsumptionRatesQueryVariables) {
      return { query: ProductionPerformanceConsumptionRatesDocument, variables: variables }
    }
export const GetUsersDocument = gql`
    query GetUsers {
  users {
    email
  }
}
    `;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export function refetchGetUsersQuery(variables?: GetUsersQueryVariables) {
      return { query: GetUsersDocument, variables: variables }
    }
export const CurrentUserDocument = gql`
    query CurrentUser {
  currentUser {
    email
    id
    role_ids
    roles {
      id
      name
    }
  }
}
    `;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export function refetchCurrentUserQuery(variables?: CurrentUserQueryVariables) {
      return { query: CurrentUserDocument, variables: variables }
    }
export const MyConfigDocument = gql`
    query MyConfig {
  myConfig {
    id
    user_id
    dark_mode
  }
}
    `;

/**
 * __useMyConfigQuery__
 *
 * To run a query within a React component, call `useMyConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyConfigQuery(baseOptions?: Apollo.QueryHookOptions<MyConfigQuery, MyConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyConfigQuery, MyConfigQueryVariables>(MyConfigDocument, options);
      }
export function useMyConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyConfigQuery, MyConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyConfigQuery, MyConfigQueryVariables>(MyConfigDocument, options);
        }
export type MyConfigQueryHookResult = ReturnType<typeof useMyConfigQuery>;
export type MyConfigLazyQueryHookResult = ReturnType<typeof useMyConfigLazyQuery>;
export type MyConfigQueryResult = Apollo.QueryResult<MyConfigQuery, MyConfigQueryVariables>;
export function refetchMyConfigQuery(variables?: MyConfigQueryVariables) {
      return { query: MyConfigDocument, variables: variables }
    }
export const SetDarkModeDocument = gql`
    mutation SetDarkMode($dark_mode: Boolean!) {
  setDarkMode(dark_mode: $dark_mode) {
    id
    user_id
    dark_mode
  }
}
    `;
export type SetDarkModeMutationFn = Apollo.MutationFunction<SetDarkModeMutation, SetDarkModeMutationVariables>;

/**
 * __useSetDarkModeMutation__
 *
 * To run a mutation, you first call `useSetDarkModeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDarkModeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDarkModeMutation, { data, loading, error }] = useSetDarkModeMutation({
 *   variables: {
 *      dark_mode: // value for 'dark_mode'
 *   },
 * });
 */
export function useSetDarkModeMutation(baseOptions?: Apollo.MutationHookOptions<SetDarkModeMutation, SetDarkModeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDarkModeMutation, SetDarkModeMutationVariables>(SetDarkModeDocument, options);
      }
export type SetDarkModeMutationHookResult = ReturnType<typeof useSetDarkModeMutation>;
export type SetDarkModeMutationResult = Apollo.MutationResult<SetDarkModeMutation>;
export type SetDarkModeMutationOptions = Apollo.BaseMutationOptions<SetDarkModeMutation, SetDarkModeMutationVariables>;
export type ProductSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ProductSubscription = { __typename?: 'Subscription', product: { __typename?: 'Product', id: number } };

export type OrderProductionSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OrderProductionSubscription = { __typename?: 'Subscription', order_production: { __typename?: 'OrderProduction', id: number } };

export type MachineSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type MachineSubscription = { __typename?: 'Subscription', machine: { __typename?: 'Machine', id: number } };

export type OrderAdjustmentSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OrderAdjustmentSubscription = { __typename?: 'Subscription', order_adjustment: { __typename?: 'OrderAdjustment', id: number } };

export type EmployeeSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type EmployeeSubscription = { __typename?: 'Subscription', employee: { __typename?: 'Employee', id: number } };

export type ExpensesSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ExpensesSubscription = { __typename?: 'Subscription', expense: { __typename?: 'Expense', id: number } };

export type ResourcesSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ResourcesSubscription = { __typename?: 'Subscription', resource: { __typename?: 'Resource', id: number } };

export type OrderRequestSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OrderRequestSubscription = { __typename?: 'Subscription', order_request: { __typename?: 'OrderRequest', id: number } };

export type OrderQuotationSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OrderQuotationSubscription = { __typename?: 'Subscription', order_quotation: { __typename?: 'OrderQuotation', id: number } };

export type OrderSaleSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OrderSaleSubscription = { __typename?: 'Subscription', order_sale: { __typename?: 'OrderSale', id: number } };

export type AccountSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type AccountSubscription = { __typename?: 'Subscription', account: { __typename?: 'Account', id: number } };

export type ActivitySubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ActivitySubscription = { __typename?: 'Subscription', activity: { __typename?: 'Activity', created_at?: any | null, type: ActivityTypeName, entity_name: ActivityEntityName, title: string, snapshot_status: ActivitySnapshotStatus } };

export type UserSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type UserSubscription = { __typename?: 'Subscription', user: { __typename?: 'User', id: number } };

export type TransferSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type TransferSubscription = { __typename?: 'Subscription', transfer: { __typename?: 'Transfer', id: number } };

export type ExpenseResourceSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ExpenseResourceSubscription = { __typename?: 'Subscription', expense_resource: { __typename?: 'ExpenseResource', id: number } };

export type ActivitiesPageQueryVariables = Exact<{
  skip: Scalars['Float'];
  take: Scalars['Float'];
  startDate?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  entityName?: InputMaybe<ActivityEntityName>;
  type?: InputMaybe<ActivityTypeName>;
  userId?: InputMaybe<Scalars['Int']>;
}>;


export type ActivitiesPageQuery = { __typename?: 'Query', paginatedActivities: { __typename?: 'PaginatedActivities', count: number, docs: Array<{ __typename?: 'Activity', id: number, created_at?: any | null, entity_name: ActivityEntityName, entity_id: number, title: string, type: ActivityTypeName, snapshot_status: ActivitySnapshotStatus, user?: { __typename?: 'User', id: number, fullname: string } | null }> }, users: Array<{ __typename?: 'User', id: number, fullname: string }> };

export type UsersPageQueryVariables = Exact<{ [key: string]: never; }>;


export type UsersPageQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', id: number, fullname: string, email: string, first_name: string, last_name: string, mfa_enabled: boolean, is_root: boolean, login_disabled: boolean, roles: Array<{ __typename?: 'Role', name: string, id: number }> }> };

export type DashboardProductionChartQueryVariables = Exact<{
  yearA: Scalars['Int'];
  monthA?: InputMaybe<Scalars['Int']>;
  yearB: Scalars['Int'];
  monthB?: InputMaybe<Scalars['Int']>;
  dateGroupBy: DateGroupBy;
}>;


export type DashboardProductionChartQuery = { __typename?: 'Query', summaryA: { __typename?: 'ProductionSummary', production: Array<{ __typename?: 'ProductionRecord', order_production_type_id?: number | null, order_production_type_name?: string | null, kilos: number, year: number, month: number, day?: number | null }> }, summaryB: { __typename?: 'ProductionSummary', production: Array<{ __typename?: 'ProductionRecord', order_production_type_id?: number | null, order_production_type_name?: string | null, kilos: number, year: number, month: number, day?: number | null }> } };

export type MachinePartPageQueryVariables = Exact<{
  machinePartId: Scalars['Float'];
}>;


export type MachinePartPageQuery = { __typename?: 'Query', getMachinePart: { __typename?: 'MachinePart', id: number, name: string, current_spare_id?: number | null, current_spare_required_quantity?: number | null, machine_section_id?: number | null, machine_id?: number | null, machine_compatibilities: Array<{ __typename?: 'MachineCompatibility', id: number, spare_id?: number | null, is_current_spare?: boolean | null, spare?: { __typename?: 'Spare', name: string, current_quantity: number, total_required_quantity: number } | null }>, machine_section?: { __typename?: 'MachineSection', name: string, machine_id?: number | null } | null, machine?: { __typename?: 'Machine', id: number, name: string } | null } };

export type MachineSectionPageQueryVariables = Exact<{
  MachineSectionId: Scalars['Float'];
}>;


export type MachineSectionPageQuery = { __typename?: 'Query', getMachineSection: { __typename?: 'MachineSection', id: number, name: string, machine_id?: number | null, is_deletable: boolean, machine_parts: Array<{ __typename?: 'MachinePart', id: number, name: string, current_spare_id?: number | null, machine_id?: number | null, machine_section_id?: number | null, current_spare_required_quantity?: number | null, current_spare?: { __typename?: 'Spare', name: string, current_quantity: number } | null, machine_section?: { __typename?: 'MachineSection', machine_id?: number | null } | null, machine_compatibilities: Array<{ __typename?: 'MachineCompatibility', id: number, is_current_spare?: boolean | null, spare_id?: number | null, spare?: { __typename?: 'Spare', id: number, name: string, current_quantity: number, total_required_quantity: number } | null }> }> } };

export type MachinePageQueryVariables = Exact<{
  machineId: Scalars['Float'];
}>;


export type MachinePageQuery = { __typename?: 'Query', getMachine?: { __typename?: 'Machine', id: number, name: string, discontinued: boolean, machine_sections: Array<{ __typename?: 'MachineSection', id: number, name: string, machine_id?: number | null, is_deletable: boolean, machine_parts: Array<{ __typename?: 'MachinePart', id: number, name: string, current_spare_required_quantity?: number | null, current_spare?: { __typename?: 'Spare', id: number, name: string, current_quantity: number } | null, machine_compatibilities: Array<{ __typename?: 'MachineCompatibility', spare_id?: number | null, spare?: { __typename?: 'Spare', name: string } | null }> }> }>, unassigned_parts: Array<{ __typename?: 'MachinePart', id: number, name: string, machine_id?: number | null, current_spare_required_quantity?: number | null, current_spare?: { __typename?: 'Spare', id: number, name: string, current_quantity: number } | null, machine_compatibilities: Array<{ __typename?: 'MachineCompatibility', spare_id?: number | null, spare?: { __typename?: 'Spare', name: string } | null }> }> } | null };

export type MachinesPageQueryVariables = Exact<{
  skip: Scalars['Float'];
  take: Scalars['Float'];
  filter: Scalars['String'];
  branchId?: InputMaybe<Scalars['Int']>;
  orderProductionTypeId?: InputMaybe<Scalars['Int']>;
  discontinued?: InputMaybe<Scalars['Boolean']>;
}>;


export type MachinesPageQuery = { __typename?: 'Query', paginatedMachines: { __typename?: 'PaginatedMachines', count: number, docs: Array<{ __typename?: 'Machine', id: number, name: string, completion: number, discontinued: boolean, order_production_type_id?: number | null, is_deletable: boolean, order_production_type?: { __typename?: 'OrderProductionType', name: string } | null, branch?: { __typename?: 'Branch', name: string } | null, machine_parts: Array<{ __typename?: 'MachinePart', id: number, name: string, current_spare_required_quantity?: number | null, machine_section_id?: number | null, current_spare?: { __typename?: 'Spare', id: number, current_quantity: number, name: string } | null, machine_section?: { __typename?: 'MachineSection', name: string } | null, machine_compatibilities: Array<{ __typename?: 'MachineCompatibility', spare_id?: number | null, spare?: { __typename?: 'Spare', current_quantity: number, name: string } | null }> }>, updated_by?: { __typename?: 'User', fullname: string } | null }> }, getBranches: Array<{ __typename?: 'Branch', id: number, name: string }>, getOrderProductionTypes: Array<{ __typename?: 'OrderProductionType', id: number, name: string }> };

export type SpareAdjustmentPageQueryVariables = Exact<{
  SpareAdjustmentId: Scalars['Float'];
}>;


export type SpareAdjustmentPageQuery = { __typename?: 'Query', getSpareOperation: { __typename?: 'SpareOperation', id: number, date?: any | null, description: string, is_deletable: boolean, spare_transactions: Array<{ __typename?: 'SpareTransaction', spare_id?: number | null, quantity: number, spare?: { __typename?: 'Spare', id: number, name: string } | null }> } };

export type SpareAdjustmentsPageQueryVariables = Exact<{ [key: string]: never; }>;


export type SpareAdjustmentsPageQuery = { __typename?: 'Query', getSpareAdjustments: Array<{ __typename?: 'SpareOperation', id: number, date?: any | null, description: string, is_deletable: boolean, spare_transactions: Array<{ __typename?: 'SpareTransaction', spare_id?: number | null, quantity: number, spare?: { __typename?: 'Spare', id: number, name: string } | null }> }> };

export type SpareTransactionsPageQueryVariables = Exact<{
  start_date?: InputMaybe<Scalars['String']>;
  end_date?: InputMaybe<Scalars['String']>;
}>;


export type SpareTransactionsPageQuery = { __typename?: 'Query', getSpareTransactions: Array<{ __typename?: 'SpareTransaction', id: number, quantity: number, spare?: { __typename?: 'Spare', id: number, name: string } | null, spare_operation?: { __typename?: 'SpareOperation', id: number, description: string, date?: any | null, is_adjustment?: number | null, is_withdrawal?: number | null } | null }> };

export type SpareCategoriesPageQueryVariables = Exact<{ [key: string]: never; }>;


export type SpareCategoriesPageQuery = { __typename?: 'Query', getSpareCategories: Array<{ __typename?: 'SpareCategory', id: number, name: string }> };

export type SpareCategoryPageQueryVariables = Exact<{
  SpareCategoryId: Scalars['Float'];
}>;


export type SpareCategoryPageQuery = { __typename?: 'Query', getSpareCategory: { __typename?: 'SpareCategory', id: number, name: string, is_deletable: boolean, spares: Array<{ __typename?: 'Spare', name: string, current_quantity: number }> } };

export type SparePageQueryVariables = Exact<{
  SpareId: Scalars['Float'];
}>;


export type SparePageQuery = { __typename?: 'Query', getSpare: { __typename?: 'Spare', id: number, name: string, is_deletable: boolean, spare_category_id?: number | null, spare_transactions: Array<{ __typename?: 'SpareTransaction', quantity: number, spare_operation?: { __typename?: 'SpareOperation', description: string, date?: any | null } | null }> } };

export type SparesPageQueryVariables = Exact<{ [key: string]: never; }>;


export type SparesPageQuery = { __typename?: 'Query', getSpares: Array<{ __typename?: 'Spare', id: number, name: string, is_deletable: boolean, total_required_quantity: number, current_quantity: number, spare_category?: { __typename?: 'SpareCategory', id: number, name: string } | null }> };

export type AccountingPageQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
}>;


export type AccountingPageQuery = { __typename?: 'Query', getAccounts: Array<{ __typename?: 'Account', id: number, name: string, is_client: boolean, is_own: boolean, is_supplier: boolean, is_informal_account: boolean }>, getReceiptTypes: Array<{ __typename?: 'ReceiptType', id: number, is_informal_receipt: boolean }>, getTransfers: Array<{ __typename?: 'Transfer', transfer_type_id?: number | null, amount: number, transferred_date: any, from_account?: { __typename?: 'Account', id: number, name: string, is_client: boolean, is_own: boolean, is_supplier: boolean } | null, to_account?: { __typename?: 'Account', id: number, name: string, is_client: boolean, is_own: boolean, is_supplier: boolean } | null, transfer_receipts: Array<{ __typename?: 'TransferReceipt', amount: number, order_sale?: { __typename?: 'OrderSale', id: number, date: any, canceled: boolean, receipt_type_id?: number | null, order_code: number, invoice_code: number, require_invoice_code: boolean, require_tax: boolean, subtotal: number, total_with_tax: number, notes: string, require_credit_note: boolean, require_supplement: boolean, credit_note_code: string, credit_note_amount: number, supplement_code: string, tax: number } | null, expense?: { __typename?: 'Expense', id: number, date: any, canceled: boolean, receipt_type_id?: number | null, external_code: string, require_external_code: boolean, require_tax: boolean, total_with_tax: number, tax: number, notes: string, tax_retained: number, non_tax_retained: number, require_supplement: boolean, supplement_code: string } | null }> }>, getOrderSales: Array<{ __typename?: 'OrderSale', id: number, date: any, order_code: number, canceled: boolean, invoice_code: number, require_invoice_code: boolean, require_tax: boolean, tax: number, receipt_type_id?: number | null, subtotal: number, total_with_tax: number, transfer_receipts_total: number, require_supplement: boolean, supplement_code: string, require_credit_note: boolean, credit_note_code: string, credit_note_amount: number, notes: string, account?: { __typename?: 'Account', name: string, is_client: boolean, is_own: boolean, is_supplier: boolean } | null, transfer_receipts: Array<{ __typename?: 'TransferReceipt', id: number, amount: number, transfer?: { __typename?: 'Transfer', transferred_date: any, to_account?: { __typename?: 'Account', abbreviation: string } | null } | null }> }>, getExpenses: Array<{ __typename?: 'Expense', id: number, date: any, tax: number, external_code: string, require_external_code: boolean, require_tax: boolean, receipt_type_id?: number | null, subtotal: number, total_with_tax: number, tax_retained: number, non_tax_retained: number, notes: string, transfer_receipts_total: number, require_supplement: boolean, supplement_code: string, canceled: boolean, account?: { __typename?: 'Account', id: number, name: string, is_client: boolean, is_own: boolean, is_supplier: boolean } | null, transfer_receipts: Array<{ __typename?: 'TransferReceipt', id: number, amount: number, transfer?: { __typename?: 'Transfer', transferred_date: any, from_account?: { __typename?: 'Account', id: number, abbreviation: string } | null, to_account?: { __typename?: 'Account', id: number } | null } | null }> }> };

export type AccountPageQueryVariables = Exact<{
  AccountId: Scalars['Float'];
  From?: InputMaybe<Scalars['String']>;
  Until?: InputMaybe<Scalars['String']>;
}>;


export type AccountPageQuery = { __typename?: 'Query', getAccountOpeningBalance: number, getReceiptTypes: Array<{ __typename?: 'ReceiptType', id: number, applies_tax: boolean }>, getAccount?: { __typename?: 'Account', id: number, name: string, abbreviation: string, is_client: boolean, is_supplier: boolean, account_contacts: Array<{ __typename?: 'AccountContact', id: number, last_name: string, first_name: string, cellphone: string, email: string }> } | null, getAccountProducts: Array<{ __typename?: 'AccountProduct', id: number, kilo_price: number, group_price: number, group_weight: number, product?: { __typename?: 'Product', id: number, compound_description: string, discontinued: boolean, product_category?: { __typename?: 'ProductCategory', id: number, name: string } | null } | null }>, getAccountResources: Array<{ __typename?: 'AccountResource', id: number, unit_price: number, notes: string, resource?: { __typename?: 'Resource', id: number, name: string } | null }>, getAccountTransactionHistory: Array<{ __typename?: 'AccountTransactionItem', id: number, type: string, order_code: string, invoice_code?: number | null, date: any, notes: string, receipt_type_id?: number | null, total_with_tax: number, transfer_receipts_total: number }>, getAccountTransfers: Array<{ __typename?: 'AccountTransferItem', amount: number, transferred_date?: any | null, notes: string, parent_type: string, parent_order_code: string, parent_invoice_code?: number | null, parent_receipt_type_id?: number | null, parent_date?: any | null }> };

export type AccountsPageQueryVariables = Exact<{
  take: Scalars['Float'];
  skip: Scalars['Float'];
  filter: Scalars['String'];
  sortField?: InputMaybe<AccountsSortableFields>;
  sortOrder?: InputMaybe<ColumnOrder>;
  isClient?: InputMaybe<Scalars['Boolean']>;
}>;


export type AccountsPageQuery = { __typename?: 'Query', paginatedAccounts: { __typename?: 'PaginatedAccounts', count: number, docs: Array<{ __typename?: 'Account', id: number, name: string, abbreviation: string, is_deletable: boolean, is_client: boolean, is_supplier: boolean, is_own: boolean, updated_by?: { __typename?: 'User', fullname: string } | null }> } };

export type SalesVsExpensesHistoricExpensesFragmentFragment = { __typename?: 'ExpensesSummary', expenses: Array<{ __typename?: 'ExpensesRecord', year: number, month?: number | null, total: number, total_with_tax: number }> };

export type SalesVsExpensesHistoricSalesFragmentFragment = { __typename?: 'SalesSummary', sales: Array<{ __typename?: 'SalesRecord', year: number, month?: number | null, total: number, total_with_tax: number }> };

export type SalesVsExpensesHistoricPageQueryVariables = Exact<{
  year?: InputMaybe<Scalars['Int']>;
  month?: InputMaybe<Scalars['Int']>;
  yearMinusOne?: InputMaybe<Scalars['Int']>;
  includeReconciliationOnly?: InputMaybe<Scalars['Boolean']>;
}>;


export type SalesVsExpensesHistoricPageQuery = { __typename?: 'Query', getExpensesTotalSummaryYearMinusOne: { __typename?: 'ExpensesSummary', expenses: Array<{ __typename?: 'ExpensesRecord', year: number, month?: number | null, total: number, total_with_tax: number }> }, getExpensesTotalSummaryYear: { __typename?: 'ExpensesSummary', expenses: Array<{ __typename?: 'ExpensesRecord', year: number, month?: number | null, total: number, total_with_tax: number }> }, getSalesTotalSummaryYearMinusOne: { __typename?: 'SalesSummary', sales: Array<{ __typename?: 'SalesRecord', year: number, month?: number | null, total: number, total_with_tax: number }> }, getSalesTotalSummaryYear: { __typename?: 'SalesSummary', sales: Array<{ __typename?: 'SalesRecord', year: number, month?: number | null, total: number, total_with_tax: number }> } };

export type SalesVsExpensesPageQueryVariables = Exact<{
  year?: InputMaybe<Scalars['Int']>;
  month?: InputMaybe<Scalars['Int']>;
}>;


export type SalesVsExpensesPageQuery = { __typename?: 'Query', getExpensesProductsSummaryByResourceCategory: { __typename?: 'ExpensesSummary', expenses: Array<{ __typename?: 'ExpensesRecord', total_with_tax: number, total: number, tax: number, resource_category_name?: string | null, resource_category_id?: number | null, year: number, month?: number | null, units_sold: number }> }, getExpensesProductsSummaryByAll: { __typename?: 'ExpensesSummary', expenses: Array<{ __typename?: 'ExpensesRecord', total_with_tax: number, total: number, tax: number, resource_category_name?: string | null, resource_category_id?: number | null, resource_name?: string | null, resource_id?: number | null, account_id?: number | null, account_name?: string | null, year: number, month?: number | null, units_sold: number }> }, getSalesSummaryByCategory: { __typename?: 'SalesSummary', sales: Array<{ __typename?: 'SalesRecord', year: number, month?: number | null, product_category_id?: number | null, product_category_name?: string | null, tax: number, kilos_sold: number, groups_sold: number, total: number, total_with_tax: number }> }, getSalesProductsSummaryByAll: { __typename?: 'SalesSummary', sales: Array<{ __typename?: 'SalesRecord', year: number, month?: number | null, product_category_id?: number | null, product_category_name?: string | null, account_id?: number | null, account_name?: string | null, kilos_sold: number, groups_sold: number, tax: number, total: number, total_with_tax: number }> }, getExpensesOperationalSummary: { __typename?: 'ExpensesSummary', expenses: Array<{ __typename?: 'ExpensesRecord', year: number, month?: number | null, total: number, total_with_tax: number, tax: number, tax_retained: number, non_tax_retained: number, units_sold: number }> }, getExpensesTaxSummary: { __typename?: 'ExpensesSummary', expenses: Array<{ __typename?: 'ExpensesRecord', year: number, month?: number | null, tax: number, tax_retained: number, non_tax_retained: number }> }, getSalesOperationalSummary: { __typename?: 'SalesSummary', sales: Array<{ __typename?: 'SalesRecord', year: number, month?: number | null, product_category_id?: number | null, product_category_name?: string | null, total: number, total_with_tax: number, tax: number, kilos_sold: number, groups_sold: number }> }, getSalesTaxSummary: { __typename?: 'SalesSummary', sales: Array<{ __typename?: 'SalesRecord', year: number, month?: number | null, tax: number }> } };

export type BalancesPageQueryVariables = Exact<{ [key: string]: never; }>;


export type BalancesPageQuery = { __typename?: 'Query', getOrderSalesWithDisparities: Array<{ __typename?: 'OrderSale', receipt_type_id?: number | null, id: number, expected_payment_date?: any | null, date: any, compound_order_code: string, order_code: number, subtotal: number, total_with_tax: number, net_total_with_tax: number, transfer_receipts_total: number, notes: string, invoice_code: number, account?: { __typename?: 'Account', compound_name: string, name: string } | null, order_sale_products: Array<{ __typename?: 'OrderSaleProduct', groups: number, kilos: number }> }>, getExpensesWithDisparities: Array<{ __typename?: 'Expense', id: number, expected_payment_date?: any | null, date: any, external_code: string, subtotal: number, transfer_receipts_total: number, receipt_type_id?: number | null, total_with_tax: number, notes: string, is_draft: boolean, account?: { __typename?: 'Account', name: string, compound_name: string } | null, expense_resources: Array<{ __typename?: 'ExpenseResource', id: number, resource?: { __typename?: 'Resource', id: number, name: string } | null }> }>, getOwnAccountsTransferSummary: Array<{ __typename?: 'OwnAccountTransferSummary', account_id?: number | null, current_amount?: number | null, account?: { __typename?: 'Account', id: number, name: string, compound_name: string, is_informal_account: boolean } | null }>, getReceiptTypes: Array<{ __typename?: 'ReceiptType', id: number, is_informal_receipt: boolean }> };

export type ExpensesSummaryPageQueryVariables = Exact<{
  year?: InputMaybe<Scalars['Int']>;
  previousYear?: InputMaybe<Scalars['Int']>;
  includeReconciliationOnly?: InputMaybe<Scalars['Boolean']>;
  includeCanceled?: InputMaybe<Scalars['Boolean']>;
}>;


export type ExpensesSummaryPageQuery = { __typename?: 'Query', currentYearByAccount: { __typename?: 'ExpensesSummary', expenses: Array<{ __typename?: 'ExpensesRecord', year: number, month?: number | null, total: number, account_id?: number | null, account_name?: string | null, resource_id?: number | null, resource_name?: string | null }> }, currentYearByCategory: { __typename?: 'ExpensesSummary', expenses: Array<{ __typename?: 'ExpensesRecord', year: number, month?: number | null, total: number, resource_category_id?: number | null, resource_category_name?: string | null, resource_id?: number | null, resource_name?: string | null }> }, previousYearByAccount: { __typename?: 'ExpensesSummary', expenses: Array<{ __typename?: 'ExpensesRecord', year: number, month?: number | null, total: number, account_id?: number | null, account_name?: string | null, resource_id?: number | null, resource_name?: string | null }> }, previousYearByCategory: { __typename?: 'ExpensesSummary', expenses: Array<{ __typename?: 'ExpensesRecord', year: number, month?: number | null, total: number, resource_category_id?: number | null, resource_category_name?: string | null, resource_id?: number | null, resource_name?: string | null }> } };

export type ExpensesSummarySuppliersQueryVariables = Exact<{ [key: string]: never; }>;


export type ExpensesSummarySuppliersQuery = { __typename?: 'Query', getAccounts: Array<{ __typename?: 'Account', id: number, name: string, supplier_recurring_expenses: boolean }> };

export type ExpensesPageQueryVariables = Exact<{
  skip: Scalars['Float'];
  take: Scalars['Float'];
  startDate?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  filter: Scalars['String'];
  accountId?: InputMaybe<Scalars['Int']>;
  resourceId?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<ExpensesSortableFields>;
  sortOrder?: InputMaybe<ColumnOrder>;
  noReceipt: Scalars['Boolean'];
  noSupplement: Scalars['Boolean'];
  isTransferComplete: Scalars['Boolean'];
}>;


export type ExpensesPageQuery = { __typename?: 'Query', paginatedExpenses: { __typename?: 'PaginatedExpenses', count: number, docs: Array<{ __typename?: 'Expense', id: number, locked: boolean, canceled: boolean, reconciliation_only: boolean, generated_from_expense_id?: number | null, date: any, expected_payment_date?: any | null, account_id?: number | null, supplement_code: string, require_supplement: boolean, is_deletable: boolean, notes: string, is_draft: boolean, external_code: string, require_external_code: boolean, internal_code: number, subtotal: number, total_with_tax: number, tax: number, transfer_receipts_total: number, transfer_receipts_total_no_adjustments: number, account?: { __typename?: 'Account', id: number, compound_name: string } | null, receipt_type?: { __typename?: 'ReceiptType', name: string } | null, expense_resources: Array<{ __typename?: 'ExpenseResource', id: number, units: number, unit_price?: number | null, notes: string, resource?: { __typename?: 'Resource', id: number, name: string } | null }>, transfer_receipts: Array<{ __typename?: 'TransferReceipt', amount: number, transfer?: { __typename?: 'Transfer', transferred_date: any } | null }>, updated_by?: { __typename?: 'User', fullname: string } | null }> }, getAccounts: Array<{ __typename?: 'Account', id: number, name: string, compound_name: string }>, getResources: Array<{ __typename?: 'Resource', id: number, name: string }> };

export type ResourcesPageQueryVariables = Exact<{
  take: Scalars['Float'];
  skip: Scalars['Float'];
  filter: Scalars['String'];
  sortField?: InputMaybe<ResourcesSortableFields>;
  sortOrder?: InputMaybe<ColumnOrder>;
}>;


export type ResourcesPageQuery = { __typename?: 'Query', paginatedResources: { __typename?: 'PaginatedResources', count: number, docs: Array<{ __typename?: 'Resource', id: number, name: string, is_deletable: boolean, is_editable: boolean, resource_category?: { __typename?: 'ResourceCategory', id: number, name: string } | null, updated_by?: { __typename?: 'User', fullname: string } | null }> } };

export type ThirdPartyBalancesPageQueryVariables = Exact<{ [key: string]: never; }>;


export type ThirdPartyBalancesPageQuery = { __typename?: 'Query', getReceiptTypes: Array<{ __typename?: 'ReceiptType', id: number, name: string, applies_tax: boolean }>, getThirdPartyAccountsTransferSummary: Array<{ __typename?: 'ThirdPartyAccountTransferSummary', account_id?: number | null, expenses_total?: number | null, transfer_receipts_total?: number | null, account?: { __typename?: 'Account', id: number, name: string, compound_name: string } | null }>, getExpensesWithDisparities: Array<{ __typename?: 'Expense', date: any, external_code: string, receipt_type_id?: number | null, resources_total?: number | null, total_with_tax: number, id: number, subtotal: number, tax: number, notes: string, is_draft: boolean, transfer_receipts_total: number, account_id?: number | null, expense_resources: Array<{ __typename?: 'ExpenseResource', units: number, unit_price?: number | null, notes: string, date?: any | null, id: number, resource?: { __typename?: 'Resource', name: string } | null }> }> };

export type TransfersPageQueryVariables = Exact<{
  skip: Scalars['Float'];
  take: Scalars['Float'];
  startDate?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  filter: Scalars['String'];
  sortField?: InputMaybe<TransfersSortableFields>;
  sortOrder?: InputMaybe<ColumnOrder>;
  accountId?: InputMaybe<Scalars['Int']>;
  transferTypeId?: InputMaybe<Scalars['Int']>;
  excludeReconciliationOnly?: InputMaybe<Scalars['Boolean']>;
}>;


export type TransfersPageQuery = { __typename?: 'Query', paginatedTransfers: { __typename?: 'PaginatedTransfers', count: number, docs: Array<{ __typename?: 'Transfer', id: number, amount: number, to_account_id?: number | null, from_account_id?: number | null, transfer_type_id?: number | null, expected_date?: any | null, transferred_date: any, transferred: boolean, notes: string, transfer_receipts_total: number, transfer_receipts: Array<{ __typename?: 'TransferReceipt', order_sale?: { __typename?: 'OrderSale', compound_order_code: string } | null, expense?: { __typename?: 'Expense', external_code: string } | null }>, from_account?: { __typename?: 'Account', id: number, name: string } | null, to_account?: { __typename?: 'Account', id: number, name: string } | null, transfer_type?: { __typename?: 'TransferType', id: number, name: string } | null, updated_by?: { __typename?: 'User', fullname: string } | null }> }, getAccounts: Array<{ __typename?: 'Account', id: number, name: string, compound_name: string }>, getTransferTypes: Array<{ __typename?: 'TransferType', id: number, name: string }>, getOwnAccountsTransferSummary: Array<{ __typename?: 'OwnAccountTransferSummary', account_id?: number | null, current_amount?: number | null, account?: { __typename?: 'Account', id: number, name: string } | null }> };

export type GetPayrollPeriodsQueryVariables = Exact<{
  branch_id?: InputMaybe<Scalars['Int']>;
}>;


export type GetPayrollPeriodsQuery = { __typename?: 'Query', getPayrollPeriods: Array<{ __typename?: 'PayrollPeriod', id: number, start_date?: any | null, end_date?: any | null, week_number: number, branch_id?: number | null, updated_at?: any | null }> };

export type GetPayrollEntriesQueryVariables = Exact<{
  PayrollPeriodId: Scalars['Int'];
}>;


export type GetPayrollEntriesQuery = { __typename?: 'Query', getPayrollEntries: Array<{ __typename?: 'PayrollEntry', id: number, payroll_period_id: number, employee_id: number, employee_name: string, estatus: string, area: string, is_leader: number, control_bono_area: boolean, control_deposito: boolean, sueldo: number, jo: number, ht: number, he: number, he_override: boolean, retardos: number, faltas: number, vac: number, dias_festivos: number, infonavit: number, fonacot: number, descuento_prestamos: number, otros_menos: number, entregas_especiales: number, viajes: number, bonos: number, otros_mas: number, bd: number, observaciones: string, he_effective: number, hn: number, he_pay: number, fest_pay: number, vac_pay: number, prima_vac: number, puntualidad: number, asistencia: number, bp: number, total_plus: number, total_minus: number, total: number }> };

export type UpsertPayrollPeriodMutationVariables = Exact<{
  PayrollPeriodInput: PayrollPeriodInput;
}>;


export type UpsertPayrollPeriodMutation = { __typename?: 'Mutation', upsertPayrollPeriod: { __typename?: 'PayrollPeriod', id: number } };

export type DeletePayrollPeriodMutationVariables = Exact<{
  PayrollPeriodId: Scalars['Int'];
}>;


export type DeletePayrollPeriodMutation = { __typename?: 'Mutation', deletePayrollPeriod: boolean };

export type UpsertPayrollEntryMutationVariables = Exact<{
  PayrollEntryInput: PayrollEntryInput;
}>;


export type UpsertPayrollEntryMutation = { __typename?: 'Mutation', upsertPayrollEntry: { __typename?: 'PayrollEntry', id: number } };

export type DeletePayrollEntryMutationVariables = Exact<{
  PayrollEntryId: Scalars['Int'];
}>;


export type DeletePayrollEntryMutation = { __typename?: 'Mutation', deletePayrollEntry: boolean };

export type EmployeePageQueryVariables = Exact<{
  EmployeeId: Scalars['Float'];
}>;


export type EmployeePageQuery = { __typename?: 'Query', getEmployee?: { __typename?: 'Employee', id: number, fullname: string, first_name: string, last_name: string, order_production_type_id?: number | null, is_inactive: boolean, branch_id?: number | null } | null };

export type EmployeesPageQueryVariables = Exact<{
  take: Scalars['Float'];
  skip: Scalars['Float'];
  filter: Scalars['String'];
  sortField?: InputMaybe<PaginatedEmployeesSortableFields>;
  sortOrder?: InputMaybe<ColumnOrder>;
  branchId?: InputMaybe<Scalars['Int']>;
  orderProductionTypeId?: InputMaybe<Scalars['Int']>;
}>;


export type EmployeesPageQuery = { __typename?: 'Query', paginatedEmployees: { __typename?: 'PaginatedEmployees', count: number, docs: Array<{ __typename?: 'Employee', id: number, first_name: string, last_name: string, is_deletable: boolean, is_leader: number, is_inactive: boolean, order_production_type?: { __typename?: 'OrderProductionType', id: number, name: string } | null, branch?: { __typename?: 'Branch', id: number, name: string } | null, updated_by?: { __typename?: 'User', fullname: string } | null }> }, getBranches: Array<{ __typename?: 'Branch', id: number, name: string }>, getOrderProductionTypes: Array<{ __typename?: 'OrderProductionType', id: number, name: string }> };

export type MaterialBalancePageQueryVariables = Exact<{
  year: Scalars['Int'];
  month?: InputMaybe<Scalars['Int']>;
  branchId?: InputMaybe<Scalars['Int']>;
  groupBy: MaterialBalanceGroupBy;
}>;


export type MaterialBalancePageQuery = { __typename?: 'Query', getMaterialBalanceSummary: Array<{ __typename?: 'MaterialBalanceRecord', year: number, month?: number | null, week?: number | null, day?: number | null, branch_id?: number | null, branch_name?: string | null, kilos_produced: number, kilos_waste: number, kilos_consumed: number, kilos_difference: number, difference_percentage?: number | null, runs_count: number, runs_without_consumption: number, runs_without_production: number }>, getBranches: Array<{ __typename?: 'Branch', id: number, name: string }> };

export type MaterialBalanceMachinesQueryVariables = Exact<{
  year: Scalars['Int'];
  month?: InputMaybe<Scalars['Int']>;
  week?: InputMaybe<Scalars['Int']>;
  branchId?: InputMaybe<Scalars['Int']>;
}>;


export type MaterialBalanceMachinesQuery = { __typename?: 'Query', getMaterialBalanceByMachine: Array<{ __typename?: 'MaterialBalanceMachineRecord', machine_id?: number | null, machine_name?: string | null, kilos_produced: number, kilos_consumed: number, kilos_difference: number, difference_percentage?: number | null }> };

export type MaterialBalanceExceptionsQueryVariables = Exact<{
  year: Scalars['Int'];
  month?: InputMaybe<Scalars['Int']>;
  branchId?: InputMaybe<Scalars['Int']>;
}>;


export type MaterialBalanceExceptionsQuery = { __typename?: 'Query', getMaterialBalanceExceptions: { __typename?: 'MaterialBalanceExceptions', runs_without_consumption: Array<{ __typename?: 'MaterialBalanceRunException', order_production_id: number, start_date: string, shift?: number | null, branch_name?: string | null, machine_names?: string | null, kilos_produced: number, kilos_waste: number, kilos_consumed: number }>, runs_without_production: Array<{ __typename?: 'MaterialBalanceRunException', order_production_id: number, start_date: string, shift?: number | null, branch_name?: string | null, machine_names?: string | null, kilos_produced: number, kilos_waste: number, kilos_consumed: number }>, products_packed: Array<{ __typename?: 'MaterialBalanceProductOrigin', product_id: number, product_description?: string | null, kilos_packed: number, kilos_cut: number, kilos_sold: number }> } };

export type OrderAdjustmentPageQueryVariables = Exact<{
  OrderAdjustmentId: Scalars['Float'];
}>;


export type OrderAdjustmentPageQuery = { __typename?: 'Query', getOrderAdjustment?: { __typename?: 'OrderAdjustment', id: number, date: any, order_adjustment_type_id?: number | null, order_adjustment_type?: { __typename?: 'OrderAdjustmentType', id: number, name: string } | null, order_adjustment_products: Array<{ __typename?: 'OrderAdjustmentProduct', id: number, kilos: number, groups: number, group_weight: number, product?: { __typename?: 'Product', id: number, compound_description: string, current_group_weight: number } | null }> } | null };

export type OrderAdjustmentsPageQueryVariables = Exact<{
  skip: Scalars['Float'];
  take: Scalars['Float'];
  startDate?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  orderAdjustmentTypeId?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Scalars['String']>;
}>;


export type OrderAdjustmentsPageQuery = { __typename?: 'Query', paginatedOrderAdjustments: { __typename?: 'PaginatedOrderAdjustments', count: number, docs: Array<{ __typename?: 'OrderAdjustment', id: number, date: any, updated_at?: any | null, is_deletable: boolean, order_adjustment_type?: { __typename?: 'OrderAdjustmentType', id: number, name: string } | null, order_sale?: { __typename?: 'OrderSale', order_code: number, invoice_code: number, subtotal: number, tax: number, order_sale_products: Array<{ __typename?: 'OrderSaleProduct', product_id?: number | null, kilo_price: number, group_price: number }>, account?: { __typename?: 'Account', name: string } | null } | null, order_adjustment_products: Array<{ __typename?: 'OrderAdjustmentProduct', id: number, kilos: number, groups: number, product_id?: number | null, product?: { __typename?: 'Product', compound_description: string } | null }>, updated_by?: { __typename?: 'User', fullname: string } | null }> }, getOrderAdjustmentTypes: Array<{ __typename?: 'OrderAdjustmentType', id: number, name: string }> };

export type OrderProductionPageQueryVariables = Exact<{
  OrderProductionId: Scalars['Float'];
}>;


export type OrderProductionPageQuery = { __typename?: 'Query', getOrderProduction: { __typename?: 'OrderProduction', id: number, start_date: any, branch_id?: number | null, order_production_type_id?: number | null, order_production_products: Array<{ __typename?: 'OrderProductionProduct', product_id?: number | null, machine_id: number, id: number, kilos: number, group_weight: number, groups: number, machine?: { __typename?: 'Machine', id: number, name: string, branch_id?: number | null, order_production_type_id?: number | null } | null, product?: { __typename?: 'Product', id: number, current_group_weight: number, compound_description: string, order_production_type_id?: number | null } | null }>, order_production_employees: Array<{ __typename?: 'OrderProductionEmployee', is_leader: number, employee?: { __typename?: 'Employee', id: number, fullname: string, is_inactive: boolean, order_production_type_id?: number | null, branch_id?: number | null } | null }> } };

export type OrderProductionsPageQueryVariables = Exact<{
  skip: Scalars['Float'];
  take: Scalars['Float'];
  startDate?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  branchId?: InputMaybe<Scalars['Int']>;
  orderProductionTypeId?: InputMaybe<Scalars['Int']>;
  machineId?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Scalars['String']>;
}>;


export type OrderProductionsPageQuery = { __typename?: 'Query', paginatedOrderProductions: { __typename?: 'PaginatedOrderProductions', count: number, docs: Array<{ __typename?: 'OrderProduction', updated_at?: any | null, id: number, start_date: any, waste: number, is_deletable: boolean, shift?: number | null, order_production_type?: { __typename?: 'OrderProductionType', name: string } | null, branch?: { __typename?: 'Branch', name: string } | null, order_production_products: Array<{ __typename?: 'OrderProductionProduct', kilos: number, groups: number, hours?: number | null, machine?: { __typename?: 'Machine', id: number, name: string } | null, product?: { __typename?: 'Product', id: number, compound_description: string } | null }>, order_production_employees: Array<{ __typename?: 'OrderProductionEmployee', employee?: { __typename?: 'Employee', fullname: string } | null }>, updated_by?: { __typename?: 'User', fullname: string } | null }> }, getBranches: Array<{ __typename?: 'Branch', id: number, name: string }>, getOrderProductionTypes: Array<{ __typename?: 'OrderProductionType', id: number, name: string }>, getMachines: Array<{ __typename?: 'Machine', id: number, name: string }> };

export type ProductInventoryMovementsQueryVariables = Exact<{
  product_id: Scalars['Int'];
  startDate?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  includeAllSaleStatuses?: InputMaybe<Scalars['Boolean']>;
}>;


export type ProductInventoryMovementsQuery = { __typename?: 'Query', getProductInventoryMovements: Array<{ __typename?: 'InventoryMovement', movement_type: string, product_id?: number | null, date: any, updated_at?: any | null, kilos: number, groups: number, affects_inventory: boolean, balance_kilos?: number | null, balance_groups?: number | null, order_id?: number | null, order_code?: number | null, compound_order_code?: string | null, order_sale_status_id?: number | null }> };

export type ProductInventoryPageQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductInventoryPageQuery = { __typename?: 'Query', getProductsInventory: Array<{ __typename?: 'ProductInventory', groups?: number | null, kilos?: number | null, last_update?: string | null, product_id?: number | null, product?: { __typename?: 'Product', id: number, internal_description: string, external_description: string, compound_description: string, product_category_id?: number | null, order_production_type_id?: number | null, discontinued: boolean, product_category?: { __typename?: 'ProductCategory', name: string } | null } | null }> };

export type ProductionPerformanceMachinesQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductionPerformanceMachinesQuery = { __typename?: 'Query', getMachines: Array<{ __typename?: 'Machine', id: number, name: string, order_production_type_id?: number | null }>, getOrderProductionTypes: Array<{ __typename?: 'OrderProductionType', id: number, name: string }>, getBranches: Array<{ __typename?: 'Branch', id: number, name: string }> };

export type ProductionPerformanceProductsQueryVariables = Exact<{
  machineId: Scalars['Int'];
}>;


export type ProductionPerformanceProductsQuery = { __typename?: 'Query', getMachineProducts: Array<{ __typename?: 'MachineProduct', id: number, description: string }> };

export type ProductionPerformanceRunsQueryVariables = Exact<{
  machineId?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
  fromDate?: InputMaybe<Scalars['String']>;
  toDate?: InputMaybe<Scalars['String']>;
}>;


export type ProductionPerformanceRunsQuery = { __typename?: 'Query', getMachineProductEmployeeRuns: Array<{ __typename?: 'MachineProductEmployeeRun', employee_id: number, employee_name: string, product_id: number, product_description: string, order_production_id: number, date?: any | null, kilos: number, hours?: number | null, waste_share: number, branch_id?: number | null, order_production_type_id?: number | null, product_count: number }> };

export type ProductionPerformanceHourlyRunsQueryVariables = Exact<{
  machineId?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
  fromDate?: InputMaybe<Scalars['String']>;
  toDate?: InputMaybe<Scalars['String']>;
}>;


export type ProductionPerformanceHourlyRunsQuery = { __typename?: 'Query', getMachineHourlyRuns: Array<{ __typename?: 'MachineHourlyRun', order_production_id: number, date?: any | null, kilos_produced: number, groups_produced: number, hours_produced: number, kilos_consumed: number, hours_consumed: number, product_count: number }> };

export type ProductionPerformanceMachineProductSummaryQueryVariables = Exact<{
  machineId: Scalars['Int'];
  fromDate?: InputMaybe<Scalars['String']>;
  toDate?: InputMaybe<Scalars['String']>;
}>;


export type ProductionPerformanceMachineProductSummaryQuery = { __typename?: 'Query', getMachineProductPerformanceSummary: Array<{ __typename?: 'MachineProductPerformanceSummary', product_id: number, product_description: string, runs: number, kilos: number, hours: number, groups: number, waste_share_total: number, last_run_date?: any | null }> };

export type ProductionPerformanceProductMachineSummaryQueryVariables = Exact<{
  productId: Scalars['Int'];
  fromDate?: InputMaybe<Scalars['String']>;
  toDate?: InputMaybe<Scalars['String']>;
}>;


export type ProductionPerformanceProductMachineSummaryQuery = { __typename?: 'Query', getProductMachinePerformanceSummary: Array<{ __typename?: 'ProductMachinePerformanceSummary', machine_id: number, machine_name: string, runs: number, kilos: number, hours: number, groups: number, waste_share_total: number, last_run_date?: any | null }> };

export type ProductionPerformanceProductsWithRunsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductionPerformanceProductsWithRunsQuery = { __typename?: 'Query', getProductsWithRuns: Array<{ __typename?: 'ProductWithRuns', id: number, description: string, product_category_name?: string | null }> };

export type ProductionPerformanceWeeklyAuditRunsQueryVariables = Exact<{
  weekStart: Scalars['String'];
  weekEnd: Scalars['String'];
  orderProductionTypeId?: InputMaybe<Scalars['Int']>;
}>;


export type ProductionPerformanceWeeklyAuditRunsQuery = { __typename?: 'Query', getWeeklyAuditRuns: Array<{ __typename?: 'WeeklyAuditRun', order_production_id: number, date?: any | null, machine_id: number, machine_name: string, branch_id?: number | null, branch_name: string, product_id: number, product_description: string, kilos: number, hours: number, groups: number, waste_share: number, product_count: number, shift?: number | null, employee_names: string }> };

export type ProductionPlanningPageQueryVariables = Exact<{
  excludeDiscontinued: Scalars['Boolean'];
}>;


export type ProductionPlanningPageQuery = { __typename?: 'Query', getBranches: Array<{ __typename?: 'Branch', id: number, name: string }>, getOrderProductionTypes: Array<{ __typename?: 'OrderProductionType', id: number, name: string }>, getMachines: Array<{ __typename?: 'Machine', id: number, name: string, branch_id?: number | null, order_production_type_id?: number | null }>, getProducts: Array<{ __typename?: 'Product', id: number, compound_description: string, order_production_type_id?: number | null, current_group_weight: number }>, getEmployees: Array<{ __typename?: 'Employee', id: number, fullname: string, order_production_type_id?: number | null, branch_id?: number | null, is_inactive: boolean, is_leader: number }>, getProductsInventory: Array<{ __typename?: 'ProductInventory', product_id?: number | null, kilos?: number | null, groups?: number | null, kilos_committed?: number | null, groups_committed?: number | null }>, getOptimizedRequestProducts: Array<{ __typename?: 'OptimizedRequestProduct', order_request_id?: number | null, priority?: number | null, order_code?: number | null, order_request_date?: any | null, order_request_estimated_delivery_date?: any | null, order_request_status_id?: number | null, order_request_status_name: string, account_name: string, product_id?: number | null, product_description?: string | null, order_request_kilos?: number | null, order_request_groups?: number | null, order_sale_remaining_kilos?: number | null, order_sale_remaining_groups?: number | null }> };

export type ProductionPlanForDateQueryVariables = Exact<{
  date: Scalars['DateTime'];
  shift: Scalars['Int'];
  branchId?: InputMaybe<Scalars['Int']>;
}>;


export type ProductionPlanForDateQuery = { __typename?: 'Query', getProductionPlan?: { __typename?: 'ProductionPlan', id: number, date: any, shift: number, shift_hours: number, branch_id?: number | null, notes: string, product_notes: string, rows: Array<{ __typename?: 'ProductionPlanRow', id: number, machine_id?: number | null, shift_hours?: number | null, notes: string, position: number, employees: Array<{ __typename?: 'Employee', id: number, fullname: string }>, products: Array<{ __typename?: 'ProductionPlanRowProduct', id: number, product_id?: number | null, hours: number, efficiency: number, position: number }> }> } | null };

export type ProductionPlanRatesQueryVariables = Exact<{
  pairs: Array<MachineProductRatePairInput> | MachineProductRatePairInput;
  fromDate?: InputMaybe<Scalars['String']>;
  singleProductOnly?: InputMaybe<Scalars['Boolean']>;
}>;


export type ProductionPlanRatesQuery = { __typename?: 'Query', getMachineProductRates: Array<{ __typename?: 'MachineProductRate', machine_id: number, product_id?: number | null, all_kilos: number, all_hours: number, all_runs: number, all_waste: number, all_groups: number, all_groups_rate_mean?: number | null, all_groups_rate_std?: number | null, all_groups_rate_n: number, all_kilos_rate_mean?: number | null, all_kilos_rate_std?: number | null, all_kilos_rate_n: number }> };

export type ProductionPlanActualsQueryVariables = Exact<{
  date: Scalars['DateTime'];
  shift: Scalars['Int'];
  branchId?: InputMaybe<Scalars['Int']>;
}>;


export type ProductionPlanActualsQuery = { __typename?: 'Query', getProductionPlanActuals: Array<{ __typename?: 'ProductionPlanActual', product_id?: number | null, machine_id?: number | null, kilos: number, groups: number }> };

export type MachineProducedProductsQueryVariables = Exact<{
  machineId: Scalars['Int'];
}>;


export type MachineProducedProductsQuery = { __typename?: 'Query', getMachineProducedProductIds: Array<number> };

export type UpsertProductionPlanMutationVariables = Exact<{
  ProductionPlanUpsertInput: ProductionPlanUpsertInput;
}>;


export type UpsertProductionPlanMutation = { __typename?: 'Mutation', upsertProductionPlan: { __typename?: 'ProductionPlan', id: number } };

export type DeleteProductionPlanMutationVariables = Exact<{
  ProductionPlanId: Scalars['Int'];
}>;


export type DeleteProductionPlanMutation = { __typename?: 'Mutation', deleteProductionPlan: boolean };

export type ProductionSummaryPageQueryVariables = Exact<{
  year: Scalars['Int'];
  month?: InputMaybe<Scalars['Int']>;
  orderProductionTypeId: Scalars['Int'];
  branchId: Scalars['Int'];
  entityGroup: ProductionSummaryEntitiesGroup;
  dateGroupBy: DateGroupBy;
}>;


export type ProductionSummaryPageQuery = { __typename?: 'Query', getProductionSummary: { __typename?: 'ProductionSummary', production: Array<{ __typename?: 'ProductionRecord', order_production_type_id?: number | null, order_production_type_name?: string | null, kilos: number, branch_id?: number | null, branch_name?: string | null, machine_id?: number | null, machine_name?: string | null, machine_type_id?: number | null, product_category_id?: number | null, month: number, year: number, day?: number | null }>, waste: Array<{ __typename?: 'WasteRecord', waste: number, order_production_type_id?: number | null, year: number, month: number, day?: number | null }> }, getAllProductionSummary: { __typename?: 'ProductionSummary', production: Array<{ __typename?: 'ProductionRecord', order_production_type_id?: number | null, order_production_type_name?: string | null, kilos: number, branch_id?: number | null, branch_name?: string | null, machine_id?: number | null, machine_name?: string | null, machine_type_id?: number | null, product_category_id?: number | null, product_category_name?: string | null, product_id?: number | null, product_description?: string | null, month: number, year: number, day?: number | null, width?: number | null, length?: number | null, calibre?: number | null, hours?: number | null }>, waste: Array<{ __typename?: 'WasteRecord', waste: number, order_production_type_id?: number | null, order_production_type_name?: string | null, year: number, month: number, day?: number | null }> }, getMachines: Array<{ __typename?: 'Machine', order_production_type_id?: number | null, name: string, id: number }>, getProductCategories: Array<{ __typename?: 'ProductCategory', order_production_type_id?: number | null, name: string, id: number }>, getOrderProductionTypes: Array<{ __typename?: 'OrderProductionType', id: number, name: string }>, getBranches: Array<{ __typename?: 'Branch', id: number, name: string }>, getEmployeeSummary: { __typename?: 'EmployeesSummary', Employees: Array<{ __typename?: 'EmployeesRecord', year: number, month?: number | null, day?: number | null, kilos: number, groups: number, hours?: number | null, employee_name?: string | null, machine_name?: string | null, product_name?: string | null, employee_id?: number | null, machine_id?: number | null, product_id?: number | null }> }, getProductionResourcesSummary: { __typename?: 'ProductionResourcesSummary', ProductionResources: Array<{ __typename?: 'ProductionResourcesRecord', year: number, month?: number | null, day?: number | null, kilos: number, groups: number, machine_name?: string | null, product_name?: string | null, machine_id?: number | null, product_id?: number | null, employee_name?: string | null, employee_id?: number | null, hours?: number | null }> } };

export type ProductPageQueryVariables = Exact<{
  ProductId: Scalars['Float'];
}>;


export type ProductPageQuery = { __typename?: 'Query', getProduct: { __typename?: 'Product', id: number, compound_description: string, order_production_type_id?: number | null, code: string, calibre?: number | null, width: number, length?: number | null, current_group_weight: number, current_kilo_price: number, order_production_products: Array<{ __typename?: 'OrderProductionProduct', id: number, kilos: number, groups: number, machine_id: number }> }, getMachines: Array<{ __typename?: 'Machine', id: number, name: string }> };

export type ProductsPageQueryVariables = Exact<{
  take: Scalars['Float'];
  skip: Scalars['Float'];
  filter: Scalars['String'];
  productCategoryId?: InputMaybe<Scalars['Int']>;
  includeDiscontinued: Scalars['Boolean'];
  onlyMissingInternal?: InputMaybe<Scalars['Boolean']>;
  sortField?: InputMaybe<ProductsSortableFields>;
  sortOrder?: InputMaybe<ColumnOrder>;
}>;


export type ProductsPageQuery = { __typename?: 'Query', paginatedProducts: { __typename?: 'PaginatedProducts', count: number, docs: Array<{ __typename?: 'Product', updated_at?: any | null, id: number, external_description: string, internal_description: string, compound_description: string, is_deletable: boolean, discontinued: boolean, product_category?: { __typename?: 'ProductCategory', name: string } | null, product_material?: { __typename?: 'ProductMaterial', name: string } | null, order_production_type?: { __typename?: 'OrderProductionType', name: string } | null, updated_by?: { __typename?: 'User', fullname: string } | null }> }, getProductCategories: Array<{ __typename?: 'ProductCategory', id: number, name: string }>, getOrderProductionTypes: Array<{ __typename?: 'OrderProductionType', id: number, name: string }> };

export type ProductsToProducePageQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductsToProducePageQuery = { __typename?: 'Query', getOptimizedRequestProducts: Array<{ __typename?: 'OptimizedRequestProduct', order_request_status_id?: number | null, order_request_status_name: string, order_code?: number | null, order_request_estimated_delivery_date?: any | null, order_sale_delivered_kilos?: number | null, order_sale_remaining_kilos?: number | null, order_request_kilos?: number | null, product_id?: number | null, account_name: string, order_sale_delivered_groups?: number | null, order_sale_remaining_groups?: number | null, order_request_groups?: number | null }>, getProductsInventory: Array<{ __typename?: 'ProductInventory', kilos?: number | null, groups?: number | null, product?: { __typename?: 'Product', calibre?: number | null, width: number, internal_description: string, external_description: string, compound_description: string, id: number, product_category_id?: number | null, order_production_type_id?: number | null, product_category?: { __typename?: 'ProductCategory', id: number, name: string } | null } | null }> };

export type PrintableQuotationQueryVariables = Exact<{
  OrderQuotationId: Scalars['Float'];
}>;


export type PrintableQuotationQuery = { __typename?: 'Query', getProducts: Array<{ __typename?: 'Product', id: number, external_description: string }>, getOrderQuotation?: { __typename?: 'OrderQuotation', id: number, order_code: number, date: any, expiration_date?: any | null, estimated_delivery_date?: any | null, payment_terms: string, require_tax: boolean, notes: string, subtotal: number, tax: number, total: number, account?: { __typename?: 'Account', name: string, rfc: string, address: string } | null, order_quotation_products: Array<{ __typename?: 'OrderQuotationProduct', id: number, product_id?: number | null, proposed_description: string, groups: number, kilos: number, kilo_price: number, group_price: number, product?: { __typename?: 'Product', external_description: string } | null }> } | null };

export type OrderQuotationsPageQueryVariables = Exact<{
  skip: Scalars['Float'];
  take: Scalars['Float'];
  startDate?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  filter: Scalars['String'];
  accountId?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<ColumnOrder>;
  sortField?: InputMaybe<OrderQuotationsSortableFields>;
  orderQuotationStatusId?: InputMaybe<Scalars['Int']>;
}>;


export type OrderQuotationsPageQuery = { __typename?: 'Query', paginatedOrderQuotations: { __typename?: 'PaginatedOrderQuotations', count: number, docs: Array<{ __typename?: 'OrderQuotation', id: number, date: any, updated_at?: any | null, estimated_delivery_date?: any | null, order_code: number, notes: string, expiration_date?: any | null, payment_terms: string, require_tax: boolean, is_deletable: boolean, is_editable: boolean, is_acceptable: boolean, is_expired: boolean, subtotal: number, tax: number, total: number, catalog_step_done: boolean, acceptance_complete: boolean, account?: { __typename?: 'Account', id: number, name: string } | null, order_quotation_status?: { __typename?: 'OrderQuotationStatus', id: number, name: string } | null, order_quotation_products: Array<{ __typename?: 'OrderQuotationProduct', id: number, product_id?: number | null, proposed_description: string, groups: number, kilos: number, kilo_price: number, group_price: number, product?: { __typename?: 'Product', external_description: string } | null }>, updated_by?: { __typename?: 'User', fullname: string } | null }> }, getAccounts: Array<{ __typename?: 'Account', id: number, name: string }> };

export type OrderRequestsPageQueryVariables = Exact<{
  skip: Scalars['Float'];
  take: Scalars['Float'];
  startDate?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  filter: Scalars['String'];
  accountId?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<ColumnOrder>;
  sortField?: InputMaybe<OrderRequestsSortableFields>;
  orderRequestStatusId?: InputMaybe<Scalars['Int']>;
}>;


export type OrderRequestsPageQuery = { __typename?: 'Query', paginatedOrderRequests: { __typename?: 'PaginatedOrderRequests', count: number, docs: Array<{ __typename?: 'OrderRequest', id: number, date: any, updated_at?: any | null, estimated_delivery_date?: any | null, order_code: number, is_deletable: boolean, is_editable: boolean, notes: string, account?: { __typename?: 'Account', id: number, name: string } | null, order_request_status?: { __typename?: 'OrderRequestStatus', id: number, name: string } | null, order_request_products: Array<{ __typename?: 'OrderRequestProduct', product_id?: number | null, groups: number, kilos: number, total: number, product: { __typename?: 'Product', external_description: string } }>, order_sale_sold_products: Array<{ __typename?: 'OrderSaleProduct', product_id?: number | null, groups: number, kilos: number, total: number, product?: { __typename?: 'Product', external_description: string } | null }>, updated_by?: { __typename?: 'User', fullname: string } | null }> }, getAccounts: Array<{ __typename?: 'Account', id: number, name: string }>, getOrderRequestStatuses: Array<{ __typename?: 'OrderRequestStatus', id: number, name: string }> };

export type UpdateOrderRequestDetailsMutationVariables = Exact<{
  OrderRequestDetailsInput: OrderRequestDetailsInput;
}>;


export type UpdateOrderRequestDetailsMutation = { __typename?: 'Mutation', updateOrderRequestDetails: { __typename?: 'OrderRequest', id: number, notes: string, estimated_delivery_date?: any | null } };

export type OrderSalesPageQueryVariables = Exact<{
  skip: Scalars['Float'];
  take: Scalars['Float'];
  startDate?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  filter: Scalars['String'];
  sortField?: InputMaybe<OrderSalesSortableFields>;
  sortOrder?: InputMaybe<ColumnOrder>;
  accountId?: InputMaybe<Scalars['Int']>;
  orderSaleReceiptTypeId?: InputMaybe<Scalars['Int']>;
  orderSaleStatusId?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
  noSupplement: Scalars['Boolean'];
  noCreditNote: Scalars['Boolean'];
  isTransferComplete: Scalars['Boolean'];
}>;


export type OrderSalesPageQuery = { __typename?: 'Query', paginatedOrderSales: { __typename?: 'PaginatedOrderSales', count: number, docs: Array<{ __typename?: 'OrderSale', id: number, order_code: number, invoice_code: number, date: any, expected_payment_date?: any | null, require_supplement: boolean, supplement_code: string, require_credit_note: boolean, credit_note_code: string, credit_note_amount: number, canceled: boolean, reconciliation_only: boolean, updated_at?: any | null, is_deletable: boolean, is_editable: boolean, notes: string, subtotal: number, total_with_tax: number, net_total_with_tax: number, transfer_receipts_total: number, transfer_receipts_total_no_adjustments: number, receipt_type_id?: number | null, updated_by?: { __typename?: 'User', fullname: string } | null, account?: { __typename?: 'Account', name: string } | null, receipt_type?: { __typename?: 'ReceiptType', name: string, applies_tax: boolean } | null, order_request?: { __typename?: 'OrderRequest', order_code: number } | null, order_sale_products: Array<{ __typename?: 'OrderSaleProduct', id: number, product_id?: number | null, kilo_price: number, group_price: number, kilos: number, groups: number, total: number, product?: { __typename?: 'Product', id: number, code: string, compound_description: string, external_description: string } | null }>, order_sale_status?: { __typename?: 'OrderSaleStatus', id: number, name: string } | null }> }, getAccounts: Array<{ __typename?: 'Account', id: number, name: string }>, getReceiptTypes: Array<{ __typename?: 'ReceiptType', id: number, name: string }>, getOrderSaleStatuses: Array<{ __typename?: 'OrderSaleStatus', id: number, name: string }> };

export type OrdersToFulfillPageQueryVariables = Exact<{ [key: string]: never; }>;


export type OrdersToFulfillPageQuery = { __typename?: 'Query', getOptimizedRequestProducts: Array<{ __typename?: 'OptimizedRequestProduct', order_request_id?: number | null, priority?: number | null, order_code?: number | null, order_request_date?: any | null, order_request_estimated_delivery_date?: any | null, order_request_status_id?: number | null, order_request_status_name: string, account_name: string, product_id?: number | null, product_description?: string | null, order_production_type_id?: number | null, order_request_kilos?: number | null, order_sale_delivered_kilos?: number | null, order_sale_committed_kilos?: number | null, order_sale_remaining_kilos?: number | null, order_request_groups?: number | null, order_sale_delivered_groups?: number | null, order_sale_committed_groups?: number | null, order_sale_remaining_groups?: number | null }>, getProductsInventory: Array<{ __typename?: 'ProductInventory', product_id?: number | null, kilos?: number | null, groups?: number | null, kilos_committed?: number | null, groups_committed?: number | null }> };

export type UpdateOrderRequestPrioritiesMutationVariables = Exact<{
  OrderRequestPrioritiesInput: Array<OrderRequestPriorityInput> | OrderRequestPriorityInput;
}>;


export type UpdateOrderRequestPrioritiesMutation = { __typename?: 'Mutation', updateOrderRequestPriorities: boolean };

export type SalesSummaryPageQueryVariables = Exact<{
  year?: InputMaybe<Scalars['Int']>;
  previousYear?: InputMaybe<Scalars['Int']>;
  includeReconciliationOnly?: InputMaybe<Scalars['Boolean']>;
}>;


export type SalesSummaryPageQuery = { __typename?: 'Query', getTotalSalesSummary: { __typename?: 'SalesSummary', sales: Array<{ __typename?: 'SalesRecord', year: number, month?: number | null, kilos_sold: number, total: number, tax: number, total_with_tax: number }> }, getPreviousTotalSalesSummary: { __typename?: 'SalesSummary', sales: Array<{ __typename?: 'SalesRecord', year: number, month?: number | null, kilos_sold: number, total: number, tax: number, total_with_tax: number }> }, getProductCategorySalesSummary: { __typename?: 'SalesSummary', sales: Array<{ __typename?: 'SalesRecord', year: number, month?: number | null, total: number, tax: number, total_with_tax: number, product_category_id?: number | null, kilos_sold: number, order_production_type_id?: number | null }> }, getPreviousProductCategorySalesSummary: { __typename?: 'SalesSummary', sales: Array<{ __typename?: 'SalesRecord', year: number, month?: number | null, total: number, tax: number, total_with_tax: number, product_category_id?: number | null, kilos_sold: number, order_production_type_id?: number | null }> }, getProductMaterialSalesSummary: { __typename?: 'SalesSummary', sales: Array<{ __typename?: 'SalesRecord', year: number, month?: number | null, total: number, tax: number, total_with_tax: number, product_material_id?: number | null, kilos_sold: number }> }, getPreviousProductMaterialSalesSummary: { __typename?: 'SalesSummary', sales: Array<{ __typename?: 'SalesRecord', year: number, month?: number | null, total: number, tax: number, total_with_tax: number, product_material_id?: number | null, kilos_sold: number }> }, getProductSalesSummary: { __typename?: 'SalesSummary', sales: Array<{ __typename?: 'SalesRecord', order_sale_id?: number | null, order_code?: number | null, invoice_code?: number | null, order_request_code?: number | null, account_id?: number | null, account_abbreviation?: string | null, account_name?: string | null, receipt_type_name?: string | null, product_name?: string | null, year: number, day?: number | null, month?: number | null, total: number, tax: number, calibre?: number | null, width?: number | null, length?: number | null, total_with_tax: number, product_category_id?: number | null, product_material_name?: string | null, kilos_sold: number, groups_sold: number, order_production_type_id?: number | null }> }, getOrderRequestSummary: { __typename?: 'OrderRequestSummary', records: Array<{ __typename?: 'OrderRequestSummaryRecord', order_request_id?: number | null, order_code?: number | null, account_id?: number | null, account_name?: string | null, account_abbreviation?: string | null, date?: any | null, product_id?: number | null, product_name?: string | null, product_material_name?: string | null, width?: number | null, length?: number | null, calibre?: number | null, kilos_requested: number, groups_requested: number, kilos_sold: number, groups_sold: number }> }, getProductCategories: Array<{ __typename?: 'ProductCategory', id: number, name: string, order_production_type_id?: number | null }>, getProductMaterials: Array<{ __typename?: 'ProductMaterial', id: number, name: string }> };

export type GetActivityChangesQueryVariables = Exact<{
  ActivityId: Scalars['Int'];
}>;


export type GetActivityChangesQuery = { __typename?: 'Query', getActivity?: { __typename?: 'Activity', entity_name: ActivityEntityName, entity_id: number, type: ActivityTypeName, title: string, created_at?: any | null, old_data?: string | null, new_data?: string | null, snapshot_status: ActivitySnapshotStatus, user?: { __typename?: 'User', id: number, fullname: string } | null } | null };

export type GetEntityActivitiesQueryVariables = Exact<{
  EntityName: ActivityEntityName;
  EntityId: Scalars['Int'];
}>;


export type GetEntityActivitiesQuery = { __typename?: 'Query', getEntityActivities: Array<{ __typename?: 'Activity', id: number, type: ActivityTypeName, title: string, created_at?: any | null, snapshot_status: ActivitySnapshotStatus, user?: { __typename?: 'User', id: number, fullname: string } | null }> };

export type DeleteMachinePartMutationVariables = Exact<{
  machinePartId: Scalars['Float'];
}>;


export type DeleteMachinePartMutation = { __typename?: 'Mutation', deleteMachinePart: boolean };

export type DeleteMachineMutationVariables = Exact<{
  MachineId: Scalars['Float'];
}>;


export type DeleteMachineMutation = { __typename?: 'Mutation', deleteMachine: boolean };

export type DeleteSpareCategoryMutationVariables = Exact<{
  SpareCategoryId: Scalars['Float'];
}>;


export type DeleteSpareCategoryMutation = { __typename?: 'Mutation', deleteSpareCategory: boolean };

export type DeleteSpareOperationMutationVariables = Exact<{
  SpareOperationId: Scalars['Float'];
}>;


export type DeleteSpareOperationMutation = { __typename?: 'Mutation', deleteSpareOperation: boolean };

export type DeleteSpareMutationVariables = Exact<{
  SpareId: Scalars['Float'];
}>;


export type DeleteSpareMutation = { __typename?: 'Mutation', deleteSpare: boolean };

export type DeleteExpensesMutationVariables = Exact<{
  ExpenseId: Scalars['Float'];
}>;


export type DeleteExpensesMutation = { __typename?: 'Mutation', deleteExpense: boolean };

export type DeleteResourcesMutationVariables = Exact<{
  ResourceId: Scalars['Float'];
}>;


export type DeleteResourcesMutation = { __typename?: 'Mutation', deleteResource: boolean };

export type DeleteTransferMutationVariables = Exact<{
  TransferId: Scalars['Float'];
}>;


export type DeleteTransferMutation = { __typename?: 'Mutation', deleteTransfer: boolean };

export type DeleteEmployeeMutationVariables = Exact<{
  EmployeeId: Scalars['Float'];
}>;


export type DeleteEmployeeMutation = { __typename?: 'Mutation', deleteEmployee: boolean };

export type DeleteOrderAdjustmentMutationVariables = Exact<{
  OrderAdjustmentId: Scalars['Float'];
}>;


export type DeleteOrderAdjustmentMutation = { __typename?: 'Mutation', deleteOrderAdjustment: boolean };

export type DeleteOrderProductionMutationVariables = Exact<{
  OrderProductionId: Scalars['Float'];
}>;


export type DeleteOrderProductionMutation = { __typename?: 'Mutation', deleteOrderProduction: boolean };

export type DeleteProductMutationVariables = Exact<{
  ProductId: Scalars['Float'];
}>;


export type DeleteProductMutation = { __typename?: 'Mutation', deleteProduct: boolean };

export type DeleteAccountMutationVariables = Exact<{
  AccountId: Scalars['Float'];
}>;


export type DeleteAccountMutation = { __typename?: 'Mutation', deleteAccount: boolean };

export type DeleteOrderQuotationMutationVariables = Exact<{
  OrderQuotationId: Scalars['Float'];
}>;


export type DeleteOrderQuotationMutation = { __typename?: 'Mutation', deleteOrderQuotation: boolean };

export type DeleteOrderRequestMutationVariables = Exact<{
  OrderRequestId: Scalars['Float'];
}>;


export type DeleteOrderRequestMutation = { __typename?: 'Mutation', deleteOrderRequest: boolean };

export type DeleteOrderSaleMutationVariables = Exact<{
  OrderSaleId: Scalars['Float'];
}>;


export type DeleteOrderSaleMutation = { __typename?: 'Mutation', deleteOrderSale: boolean };

export type CreateUserMutationVariables = Exact<{
  CreateUserInput: CreateUserInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'User', id: number } };

export type UpdateUserMutationVariables = Exact<{
  UpdateUserInput: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: number } };

export type ResetUserPasswordMutationVariables = Exact<{
  UserId: Scalars['Float'];
}>;


export type ResetUserPasswordMutation = { __typename?: 'Mutation', resetUserPassword?: { __typename?: 'User', id: number } | null };

export type UserDialogQueryVariables = Exact<{
  UserId: Scalars['Float'];
}>;


export type UserDialogQuery = { __typename?: 'Query', getUser?: { __typename?: 'User', id: number, first_name: string, last_name: string, email: string, mfa_enabled: boolean, is_root: boolean, login_disabled: boolean, roles: Array<{ __typename?: 'Role', id: number, name: string }> } | null };

export type UserRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type UserRolesQuery = { __typename?: 'Query', getRoles: Array<{ __typename?: 'Role', id: number, name: string }> };

export type IsEmailOccupiedQueryVariables = Exact<{
  Email: Scalars['String'];
  UserId?: InputMaybe<Scalars['Float']>;
}>;


export type IsEmailOccupiedQuery = { __typename?: 'Query', isEmailOccupied: boolean };

export type UpsertMachinePartMutationVariables = Exact<{
  MachinePartUpsetInput: MachinePartUpsertInput;
}>;


export type UpsertMachinePartMutation = { __typename?: 'Mutation', upsertMachinePart: { __typename?: 'MachinePart', id: number, name: string, machine_compatibilities: Array<{ __typename?: 'MachineCompatibility', id: number }> } };

export type UpsertMachineSectionMutationVariables = Exact<{
  MachineSectionUpsertInput: MachineSectionUpsertInput;
}>;


export type UpsertMachineSectionMutation = { __typename?: 'Mutation', upsertMachineSection: { __typename?: 'MachineSection', id: number, name: string } };

export type MachineBranchInputQueryVariables = Exact<{ [key: string]: never; }>;


export type MachineBranchInputQuery = { __typename?: 'Query', getBranches: Array<{ __typename?: 'Branch', id: number, name: string }> };

export type MachineOrderProductionTypeInputQueryVariables = Exact<{ [key: string]: never; }>;


export type MachineOrderProductionTypeInputQuery = { __typename?: 'Query', getOrderProductionTypes: Array<{ __typename?: 'OrderProductionType', id: number, name: string }> };

export type UpsertMachineMutationVariables = Exact<{
  MachineUpsertInput: MachineUpsertInput;
}>;


export type UpsertMachineMutation = { __typename?: 'Mutation', upsertMachine: { __typename?: 'Machine', id: number, name: string } };

export type MachineFormQueryVariables = Exact<{
  MachineId: Scalars['Float'];
}>;


export type MachineFormQuery = { __typename?: 'Query', getMachine?: { __typename?: 'Machine', id: number, name: string, order_production_type_id?: number | null, branch_id?: number | null, discontinued: boolean, consumes_input: boolean, created_by?: { __typename?: 'User', fullname: string } | null, updated_by?: { __typename?: 'User', fullname: string } | null } | null };

export type UpsertSpareAdjustmentMutationVariables = Exact<{
  SpareAdjustmentUpsertInput: SpareAdjustmentUpsertInput;
}>;


export type UpsertSpareAdjustmentMutation = { __typename?: 'Mutation', upsertSpareAdjustment: { __typename?: 'SpareOperation', id: number, description: string } };

export type UpsertSpareCategoryMutationVariables = Exact<{
  SpareCategoryUpsertInput: SpareCategoryUpsertInput;
}>;


export type UpsertSpareCategoryMutation = { __typename?: 'Mutation', upsertSpareCategory: { __typename?: 'SpareCategory', id: number, name: string } };

export type UpsertSpareWithdrawalMutationVariables = Exact<{
  SpareWithdrawalUpsertInput: SpareWithdrawalUpsertInput;
}>;


export type UpsertSpareWithdrawalMutation = { __typename?: 'Mutation', upsertSpareWithdrawal: { __typename?: 'SpareOperation', id: number, description: string } };

export type SpareCategoryInputQueryVariables = Exact<{ [key: string]: never; }>;


export type SpareCategoryInputQuery = { __typename?: 'Query', getSpareCategories: Array<{ __typename?: 'SpareCategory', id: number, name: string }> };

export type UpsertSpareMutationVariables = Exact<{
  SpareUpsertInput: SpareUpsertInput;
}>;


export type UpsertSpareMutation = { __typename?: 'Mutation', upsertSpare: { __typename?: 'Spare', id: number, name: string } };

export type ResourceIdInputQueryVariables = Exact<{ [key: string]: never; }>;


export type ResourceIdInputQuery = { __typename?: 'Query', getResources: Array<{ __typename?: 'Resource', id: number, name: string }> };

export type UpsertAccountDialogMutationVariables = Exact<{
  AccountUpsertInput: AccountUpsertInput;
}>;


export type UpsertAccountDialogMutation = { __typename?: 'Mutation', upsertAccount: { __typename?: 'Account', id: number, abbreviation: string, name: string, resource_id?: number | null, account_contacts: Array<{ __typename?: 'AccountContact', id: number, first_name: string, last_name: string, email: string, cellphone: string }> } };

export type AccountDialogQueryVariables = Exact<{
  AccountId: Scalars['Float'];
}>;


export type AccountDialogQuery = { __typename?: 'Query', getAccount?: { __typename?: 'Account', id: number, name: string, abbreviation: string, rfc: string, address: string, requires_order_request: boolean, monitor_supplier_expenses: boolean, resource_id?: number | null, client_credit_days: number, supplier_credit_days: number, client_require_credit_note: boolean, client_require_supplement: boolean, client_requires_invoice_code: boolean, client_requires_tax: boolean, supplier_require_supplement: boolean, supplier_requires_external_code: boolean, supplier_requires_tax: boolean, supplier_recurring_expenses: boolean, supplier_is_draft: boolean, client_automatic_tax_calculation: boolean, client_reconciliation_only: boolean, supplier_reconciliation_only: boolean, is_informal_account: boolean, exclude_from_balances_summary: boolean, is_client: boolean, is_supplier: boolean, is_own: boolean, account_contacts: Array<{ __typename?: 'AccountContact', id: number, first_name: string, last_name: string, cellphone: string, email: string }>, account_products: Array<{ __typename?: 'AccountProduct', id: number, kilo_price: number, group_price: number, group_weight: number, product?: { __typename?: 'Product', id: number, compound_description: string, current_group_weight: number, discontinued: boolean, product_category?: { __typename?: 'ProductCategory', id: number, name: string } | null } | null }>, account_resources: Array<{ __typename?: 'AccountResource', id: number, unit_price: number, notes: string, resource?: { __typename?: 'Resource', id: number, name: string } | null }>, created_by?: { __typename?: 'User', fullname: string } | null, updated_by?: { __typename?: 'User', fullname: string } | null } | null, getProducts: Array<{ __typename?: 'Product', id: number, compound_description: string, current_group_weight: number, product_category?: { __typename?: 'ProductCategory', id: number, name: string } | null }>, getResources: Array<{ __typename?: 'Resource', id: number, name: string }> };

export type SimilarAccountNamesQueryVariables = Exact<{
  Name: Scalars['String'];
  ExcludeAccountId?: InputMaybe<Scalars['Float']>;
}>;


export type SimilarAccountNamesQuery = { __typename?: 'Query', getSimilarAccountNames: Array<{ __typename?: 'SimilarAccountName', id: number, name: string, abbreviation: string, reason: string, similarity: number }> };

export type UpdateExpenseDetailsMutationVariables = Exact<{
  ExpenseDetailsInput: ExpenseDetailsInput;
}>;


export type UpdateExpenseDetailsMutation = { __typename?: 'Mutation', updateExpenseDetails: { __typename?: 'Expense', id: number, notes: string, expected_payment_date?: any | null, require_external_code: boolean, external_code: string, require_supplement: boolean, supplement_code: string, reconciliation_only: boolean, is_draft: boolean, canceled: boolean } };

export type ExpenseAccountIdInputQueryVariables = Exact<{ [key: string]: never; }>;


export type ExpenseAccountIdInputQuery = { __typename?: 'Query', getAccounts: Array<{ __typename?: 'Account', id: number, name: string, compound_name: string, resource_id?: number | null, monitor_supplier_expenses: boolean, supplier_credit_days: number, supplier_require_supplement: boolean, supplier_requires_external_code: boolean, supplier_requires_tax: boolean, supplier_reconciliation_only: boolean, supplier_is_draft: boolean }> };

export type ExpenseResourcesInputQueryVariables = Exact<{ [key: string]: never; }>;


export type ExpenseResourcesInputQuery = { __typename?: 'Query', getResources: Array<{ __typename?: 'Resource', id: number, name: string }> };

export type ExpenseSupplierCatalogReferenceQueryVariables = Exact<{
  AccountId: Scalars['Float'];
}>;


export type ExpenseSupplierCatalogReferenceQuery = { __typename?: 'Query', getAccountResources: Array<{ __typename?: 'AccountResource', id: number, unit_price: number, notes: string, resource?: { __typename?: 'Resource', id: number, name: string } | null }> };

export type GetExpenseMaxInternalCodeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetExpenseMaxInternalCodeQuery = { __typename?: 'Query', getExpenseMaxInternalCode: number };

export type ExpenseReceiptTypeIdInputQueryVariables = Exact<{ [key: string]: never; }>;


export type ExpenseReceiptTypeIdInputQuery = { __typename?: 'Query', getReceiptTypes: Array<{ __typename?: 'ReceiptType', id: number, name: string, applies_tax: boolean, tax_rate: number }> };

export type UpsertExpensesDialogMutationVariables = Exact<{
  ExpenseUpsertInput: ExpenseUpsertInput;
}>;


export type UpsertExpensesDialogMutation = { __typename?: 'Mutation', upsertExpense: { __typename?: 'Expense', id: number, notes: string } };

export type ExpensesDialogQueryVariables = Exact<{
  ExpenseId: Scalars['Float'];
}>;


export type ExpensesDialogQuery = { __typename?: 'Query', getExpense?: { __typename?: 'Expense', id: number, notes: string, date: any, locked: boolean, external_code: string, internal_code: number, expected_payment_date?: any | null, receipt_type_id?: number | null, tax: number, tax_retained: number, subtotal: number, non_tax_retained: number, resources_total?: number | null, total_with_tax: number, require_supplement: boolean, require_external_code: boolean, require_tax: boolean, supplement_code: string, canceled: boolean, reconciliation_only: boolean, is_draft: boolean, transfer_receipts_total: number, transfer_receipts_total_no_adjustments: number, account?: { __typename?: 'Account', id: number, name: string, compound_name: string, resource_id?: number | null, monitor_supplier_expenses: boolean, supplier_requires_external_code: boolean, supplier_requires_tax: boolean, supplier_is_draft: boolean } | null, expense_resources: Array<{ __typename?: 'ExpenseResource', id: number, units: number, expense_id?: number | null, resource_id?: number | null, unit_price?: number | null, notes: string, date?: any | null }>, transfer_receipts: Array<{ __typename?: 'TransferReceipt', id: number, amount: number, transfer?: { __typename?: 'Transfer', transferred_date: any, from_account?: { __typename?: 'Account', compound_name: string } | null } | null }>, created_by?: { __typename?: 'User', fullname: string } | null, updated_by?: { __typename?: 'User', fullname: string } | null } | null };

export type IsExpenseInternalCodeOccupiedQueryVariables = Exact<{
  InternalCode: Scalars['Float'];
  ExpenseId?: InputMaybe<Scalars['Int']>;
}>;


export type IsExpenseInternalCodeOccupiedQuery = { __typename?: 'Query', isExpenseInternalCodeOccupied: boolean };

export type RecurringExpenseCandidatesQueryVariables = Exact<{
  year: Scalars['Int'];
  month: Scalars['Int'];
}>;


export type RecurringExpenseCandidatesQuery = { __typename?: 'Query', getRecurringExpenseCandidates: Array<{ __typename?: 'RecurringExpenseCandidate', expense_id: number, account_id: number, account_name: string, date: any, notes: string, subtotal: number, tax: number, tax_retained: number, non_tax_retained: number, receipt_type_id?: number | null, suggested_payment_date?: any | null, require_supplement: boolean, require_external_code: boolean, already_generated: boolean, expense_resources: Array<{ __typename?: 'ExpenseResource', id: number, units: number, unit_price?: number | null, resource_id?: number | null, notes: string, date?: any | null }> }> };

export type GenerateRecurringExpensesMutationVariables = Exact<{
  input: Array<GenerateRecurringExpenseInput> | GenerateRecurringExpenseInput;
}>;


export type GenerateRecurringExpensesMutation = { __typename?: 'Mutation', generateRecurringExpenses: { __typename?: 'GenerateRecurringExpensesResult', created_ids: Array<number>, skipped_ids: Array<number> } };

export type ResourceCategoryIdInputQueryVariables = Exact<{ [key: string]: never; }>;


export type ResourceCategoryIdInputQuery = { __typename?: 'Query', getResourceCategories: Array<{ __typename?: 'ResourceCategory', id: number, name: string }> };

export type UpsertResourceDialogMutationVariables = Exact<{
  ResourceUpsertInput: ResourceUpsertInput;
}>;


export type UpsertResourceDialogMutation = { __typename?: 'Mutation', upsertResource: { __typename?: 'Resource', id: number, name: string } };

export type ResourceDialogQueryVariables = Exact<{
  ResourceId: Scalars['Float'];
}>;


export type ResourceDialogQuery = { __typename?: 'Query', getResource?: { __typename?: 'Resource', id: number, name: string, resource_category_id?: number | null, current_group_price?: number | null, current_group_weight?: number | null, current_unit_price?: number | null, group_weight_strict?: number | null, include_units_in_summary: boolean, unit_price_name?: string | null, created_by?: { __typename?: 'User', fullname: string } | null, updated_by?: { __typename?: 'User', fullname: string } | null } | null };

export type FromAccountIdInputQueryVariables = Exact<{
  isOwn: Scalars['Boolean'];
  isClient: Scalars['Boolean'];
  isSupplier: Scalars['Boolean'];
}>;


export type FromAccountIdInputQuery = { __typename?: 'Query', getAccounts: Array<{ __typename?: 'Account', id: number, name: string, compound_name: string, is_own: boolean, is_supplier: boolean, is_client: boolean, is_informal_account: boolean }> };

export type UpsertTransferDialogMutationVariables = Exact<{
  TransferUpsertInput: TransferUpsertInput;
}>;


export type UpsertTransferDialogMutation = { __typename?: 'Mutation', upsertTransfer: { __typename?: 'Transfer', id: number, amount: number, to_account_id?: number | null, from_account_id?: number | null } };

export type TransferDialogQueryVariables = Exact<{
  TransferId: Scalars['Float'];
}>;


export type TransferDialogQuery = { __typename?: 'Query', getTransfer?: { __typename?: 'Transfer', id: number, amount: number, to_account_id?: number | null, transfer_type_id?: number | null, notes: string, from_account_id?: number | null, transferred_date: any, expected_date?: any | null, transferred: boolean, transfer_receipts_total: number, to_account?: { __typename?: 'Account', id: number, name: string, is_client: boolean, is_supplier: boolean, is_own: boolean } | null, from_account?: { __typename?: 'Account', id: number, name: string, is_client: boolean, is_supplier: boolean, is_own: boolean } | null, transfer_receipts: Array<{ __typename?: 'TransferReceipt', id: number, order_sale_id?: number | null, expense_id?: number | null, amount: number, order_sale?: { __typename?: 'OrderSale', id: number, compound_order_code: string, invoice_code: number, order_code: number, net_total_with_tax: number, receipt_type?: { __typename?: 'ReceiptType', id: number, is_informal_receipt: boolean } | null } | null, expense?: { __typename?: 'Expense', id: number, external_code: string, total_with_tax: number, receipt_type?: { __typename?: 'ReceiptType', id: number, is_informal_receipt: boolean } | null } | null }>, created_by?: { __typename?: 'User', fullname: string } | null, updated_by?: { __typename?: 'User', fullname: string } | null } | null };

export type ToAccountIdInputQueryVariables = Exact<{
  isOwn: Scalars['Boolean'];
  isClient: Scalars['Boolean'];
  isSupplier: Scalars['Boolean'];
}>;


export type ToAccountIdInputQuery = { __typename?: 'Query', getAccounts: Array<{ __typename?: 'Account', id: number, name: string, compound_name: string, is_own: boolean, is_supplier: boolean, is_client: boolean, is_informal_account: boolean }> };

export type TransferReceiptExpenseInputQueryVariables = Exact<{
  account_id?: InputMaybe<Scalars['Int']>;
}>;


export type TransferReceiptExpenseInputQuery = { __typename?: 'Query', getExpenses: Array<{ __typename?: 'Expense', id: number, internal_code: number, external_code: string, compound_external_code: string, total_with_tax: number, transfer_receipts_total: number, receipt_type_id?: number | null, receipt_type?: { __typename?: 'ReceiptType', id: number, is_informal_receipt: boolean } | null }> };

export type TransferReceiptOrderSaleInputQueryVariables = Exact<{
  account_id?: InputMaybe<Scalars['Int']>;
}>;


export type TransferReceiptOrderSaleInputQuery = { __typename?: 'Query', getOrderSales: Array<{ __typename?: 'OrderSale', id: number, compound_order_code: string, invoice_code: number, order_code: number, net_total_with_tax: number, transfer_receipts_total: number, receipt_type_id?: number | null, receipt_type?: { __typename?: 'ReceiptType', id: number, is_informal_receipt: boolean } | null }> };

export type TransferTransferTypeInputQueryVariables = Exact<{ [key: string]: never; }>;


export type TransferTransferTypeInputQuery = { __typename?: 'Query', getTransferTypes: Array<{ __typename?: 'TransferType', id: number, name: string }> };

export type EmployeeBranchInputQueryVariables = Exact<{ [key: string]: never; }>;


export type EmployeeBranchInputQuery = { __typename?: 'Query', getBranches: Array<{ __typename?: 'Branch', id: number, name: string }> };

export type EmployeeOrderProductionTypeInputQueryVariables = Exact<{ [key: string]: never; }>;


export type EmployeeOrderProductionTypeInputQuery = { __typename?: 'Query', getOrderProductionTypes: Array<{ __typename?: 'OrderProductionType', id: number, name: string }> };

export type UpsertEmployeeDialogMutationVariables = Exact<{
  EmployeeUpsertInput: EmployeeUpsertInput;
}>;


export type UpsertEmployeeDialogMutation = { __typename?: 'Mutation', upsertEmployee: { __typename?: 'Employee', fullname: string } };

export type EmployeeFormQueryVariables = Exact<{
  EmployeeId: Scalars['Float'];
}>;


export type EmployeeFormQuery = { __typename?: 'Query', getEmployee?: { __typename?: 'Employee', id: number, fullname: string, is_leader: number, first_name: string, last_name: string, order_production_type_id?: number | null, is_inactive: boolean, branch_id?: number | null, base_salary: number, hours_should_work: number, created_by?: { __typename?: 'User', fullname: string } | null, updated_by?: { __typename?: 'User', fullname: string } | null } | null };

export type OrderAdjustmentProductInputQueryVariables = Exact<{ [key: string]: never; }>;


export type OrderAdjustmentProductInputQuery = { __typename?: 'Query', getProducts: Array<{ __typename?: 'Product', id: number, compound_description: string, current_group_weight: number }> };

export type OrderAdjustmentOrderAdjustmentTypeInputQueryVariables = Exact<{ [key: string]: never; }>;


export type OrderAdjustmentOrderAdjustmentTypeInputQuery = { __typename?: 'Query', getOrderAdjustmentTypes: Array<{ __typename?: 'OrderAdjustmentType', id: number, name: string }> };

export type OrderAdjustmentOrderSaleInputQueryVariables = Exact<{ [key: string]: never; }>;


export type OrderAdjustmentOrderSaleInputQuery = { __typename?: 'Query', getOrderSales: Array<{ __typename?: 'OrderSale', id: number, compound_order_code: string, total_with_tax: number }> };

export type OrderAdjustmentGetOrderSaleQueryVariables = Exact<{
  OrderSaleId: Scalars['Float'];
}>;


export type OrderAdjustmentGetOrderSaleQuery = { __typename?: 'Query', getOrderSale?: { __typename?: 'OrderSale', id: number, compound_order_code: string, order_adjustment_products: Array<{ __typename?: 'OrderAdjustmentProduct', id: number, product_id?: number | null, groups: number, kilos: number }>, order_sale_products: Array<{ __typename?: 'OrderSaleProduct', id: number, product_id?: number | null, groups: number, kilos: number }> } | null };

export type UpsertOrderAdjustmentMutationVariables = Exact<{
  OrderAdjustmentInput: OrderAdjustmentInput;
}>;


export type UpsertOrderAdjustmentMutation = { __typename?: 'Mutation', upsertOrderAdjustment: { __typename?: 'OrderAdjustment', id: number } };

export type OrderAdjustmentFormQueryVariables = Exact<{
  OrderAdjustmentId: Scalars['Float'];
}>;


export type OrderAdjustmentFormQuery = { __typename?: 'Query', getOrderAdjustment?: { __typename?: 'OrderAdjustment', id: number, date: any, order_adjustment_type_id?: number | null, order_sale?: { __typename?: 'OrderSale', id: number, compound_order_code: string } | null, order_adjustment_type?: { __typename?: 'OrderAdjustmentType', id: number, name: string } | null, order_sale_products: Array<{ __typename?: 'OrderSaleProduct', id: number, kilos: number, groups: number, product_id?: number | null }>, order_sale_adjustment_products: Array<{ __typename?: 'OrderAdjustmentProduct', id: number, kilos: number, groups: number, product_id?: number | null }>, order_adjustment_products: Array<{ __typename?: 'OrderAdjustmentProduct', id: number, kilos: number, groups: number, group_weight: number, product?: { __typename?: 'Product', id: number, compound_description: string, current_group_weight: number } | null }>, created_by?: { __typename?: 'User', fullname: string } | null, updated_by?: { __typename?: 'User', fullname: string } | null } | null };

export type OrderProductionBranchInputQueryVariables = Exact<{ [key: string]: never; }>;


export type OrderProductionBranchInputQuery = { __typename?: 'Query', getBranches: Array<{ __typename?: 'Branch', id: number, name: string }> };

export type OrderProductionEmployeeInputQueryVariables = Exact<{
  excludeDiscontinued: Scalars['Boolean'];
}>;


export type OrderProductionEmployeeInputQuery = { __typename?: 'Query', getEmployees: Array<{ __typename?: 'Employee', id: number, fullname: string, order_production_type_id?: number | null, is_inactive: boolean, branch_id?: number | null, is_leader: number, base_salary: number, hours_should_work: number }> };

export type OrderProductionProductConsumedMachineInputQueryVariables = Exact<{
  excludeDiscontinued: Scalars['Boolean'];
}>;


export type OrderProductionProductConsumedMachineInputQuery = { __typename?: 'Query', getMachines: Array<{ __typename?: 'Machine', id: number, name: string, branch_id?: number | null, order_production_type_id?: number | null }> };

export type OrderProductionProductConsumedProductInputQueryVariables = Exact<{
  excludeDiscontinued: Scalars['Boolean'];
}>;


export type OrderProductionProductConsumedProductInputQuery = { __typename?: 'Query', getProducts: Array<{ __typename?: 'Product', id: number, compound_description: string, order_production_type_id?: number | null, current_group_weight: number }> };

export type OrderProductionMachineInputQueryVariables = Exact<{
  excludeDiscontinued: Scalars['Boolean'];
}>;


export type OrderProductionMachineInputQuery = { __typename?: 'Query', getMachines: Array<{ __typename?: 'Machine', id: number, name: string, branch_id?: number | null, order_production_type_id?: number | null }> };

export type OrderProductionProductInputQueryVariables = Exact<{
  excludeDiscontinued: Scalars['Boolean'];
}>;


export type OrderProductionProductInputQuery = { __typename?: 'Query', getProducts: Array<{ __typename?: 'Product', id: number, compound_description: string, order_production_type_id?: number | null, current_group_weight: number }> };

export type OrderProductionOrderProductionTypeInputQueryVariables = Exact<{ [key: string]: never; }>;


export type OrderProductionOrderProductionTypeInputQuery = { __typename?: 'Query', getOrderProductionTypes: Array<{ __typename?: 'OrderProductionType', id: number, name: string }> };

export type UpsertOrderProductionMutationVariables = Exact<{
  OrderProductionInput: OrderProductionInput;
}>;


export type UpsertOrderProductionMutation = { __typename?: 'Mutation', upsertOrderProduction: { __typename?: 'OrderProduction', id: number, start_date: any } };

export type OrderProductionFormQueryVariables = Exact<{
  OrderProductionId: Scalars['Float'];
}>;


export type OrderProductionFormQuery = { __typename?: 'Query', getOrderProduction: { __typename?: 'OrderProduction', id: number, start_date: any, branch_id?: number | null, waste: number, shift?: number | null, order_production_type_id?: number | null, order_production_products: Array<{ __typename?: 'OrderProductionProduct', product_id?: number | null, hours?: number | null, machine_id: number, id: number, kilos: number, group_weight: number, groups: number, machine?: { __typename?: 'Machine', id: number, name: string, branch_id?: number | null, order_production_type_id?: number | null } | null, product?: { __typename?: 'Product', id: number, current_group_weight: number, compound_description: string, order_production_type_id?: number | null } | null }>, order_production_products_consumed: Array<{ __typename?: 'OrderProductionProductConsumed', product_id?: number | null, machine_id: number, id: number, kilos: number, group_weight: number, groups: number, hours?: number | null, machine?: { __typename?: 'Machine', id: number, name: string, branch_id?: number | null, order_production_type_id?: number | null } | null, product?: { __typename?: 'Product', id: number, current_group_weight: number, compound_description: string, order_production_type_id?: number | null } | null }>, order_production_employees: Array<{ __typename?: 'OrderProductionEmployee', is_leader: number, employee?: { __typename?: 'Employee', id: number, fullname: string, is_inactive: boolean, order_production_type_id?: number | null, branch_id?: number | null } | null }>, created_by?: { __typename?: 'User', fullname: string } | null, updated_by?: { __typename?: 'User', fullname: string } | null } };

export type OrderProductionTypeInputQueryVariables = Exact<{ [key: string]: never; }>;


export type OrderProductionTypeInputQuery = { __typename?: 'Query', getOrderProductionTypes: Array<{ __typename?: 'OrderProductionType', id: number, name: string }> };

export type ProductCategoryInputQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductCategoryInputQuery = { __typename?: 'Query', getProductCategories: Array<{ __typename?: 'ProductCategory', id: number, name: string, order_production_type_id?: number | null }> };

export type ProductMaterialInputQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductMaterialInputQuery = { __typename?: 'Query', getProductMaterials: Array<{ __typename?: 'ProductMaterial', id: number, name: string }> };

export type UpsertProductDialogMutationVariables = Exact<{
  ProductUpsertInput: ProductUpsertInput;
}>;


export type UpsertProductDialogMutation = { __typename?: 'Mutation', upsertProduct: { __typename?: 'Product', compound_description: string } };

export type ProductFormQueryVariables = Exact<{
  ProductId: Scalars['Float'];
}>;


export type ProductFormQuery = { __typename?: 'Query', getProduct: { __typename?: 'Product', id: number, compound_description: string, internal_description: string, external_description: string, discontinued: boolean, order_production_type_id?: number | null, code: string, calibre?: number | null, width: number, length?: number | null, pleat?: number | null, current_group_weight: number, current_group_price: number, current_kilo_price: number, product_material_id?: number | null, product_category_id?: number | null, include_units_in_summary: boolean, product_category?: { __typename?: 'ProductCategory', id: number, order_production_type_id?: number | null, name: string } | null, created_by?: { __typename?: 'User', fullname: string } | null, updated_by?: { __typename?: 'User', fullname: string } | null } };

export type OrderQuotationAcceptanceQueryVariables = Exact<{
  OrderQuotationIdInt: Scalars['Int'];
  OrderQuotationIdFloat: Scalars['Float'];
}>;


export type OrderQuotationAcceptanceQuery = { __typename?: 'Query', getProducts: Array<{ __typename?: 'Product', id: number, external_description: string }>, getOrderQuotationCatalogChanges: { __typename?: 'OrderQuotationCatalogPreview', blocking_reasons: Array<string>, is_acceptable: boolean, changes: Array<{ __typename?: 'OrderQuotationCatalogChange', product_id: number, description: string, current_kilo_price?: number | null, current_group_price?: number | null, proposed_kilo_price: number, proposed_group_price: number, action: OrderQuotationCatalogAction }> }, getOrderQuotation?: { __typename?: 'OrderQuotation', id: number, order_code: number, is_acceptable: boolean, is_expired: boolean, require_tax: boolean, subtotal: number, account_products_updated_at?: any | null, order_request_completed_at?: any | null, catalog_step_done: boolean, order_request_step_done: boolean, order_request_step_state: OrderQuotationPedidoStepState, status_step_done: boolean, acceptance_complete: boolean, account?: { __typename?: 'Account', id: number, name: string, rfc: string, address: string } | null, order_quotation_status?: { __typename?: 'OrderQuotationStatus', id: number, name: string } | null, order_request?: { __typename?: 'OrderRequest', id: number, order_code: number, date: any, account?: { __typename?: 'Account', id: number, name: string } | null, order_request_products: Array<{ __typename?: 'OrderRequestProduct', id: number, product_id?: number | null, kilos: number, groups: number, kilo_price: number, group_price: number, group_weight: number, product: { __typename?: 'Product', external_description: string } }> } | null, order_quotation_products: Array<{ __typename?: 'OrderQuotationProduct', id: number, product_id?: number | null, proposed_description: string, groups: number, kilos: number, kilo_price: number, group_price: number, group_weight: number, product?: { __typename?: 'Product', external_description: string } | null }> } | null };

export type AcceptOrderQuotationMutationVariables = Exact<{
  OrderQuotationId: Scalars['Int'];
}>;


export type AcceptOrderQuotationMutation = { __typename?: 'Mutation', acceptOrderQuotation: { __typename?: 'OrderQuotation', id: number, order_quotation_status_id?: number | null, account_products_updated_at?: any | null, order_request_completed_at?: any | null } };

export type OrderQuotationLinkProductQueryVariables = Exact<{
  OrderQuotationId: Scalars['Float'];
}>;


export type OrderQuotationLinkProductQuery = { __typename?: 'Query', getProducts: Array<{ __typename?: 'Product', id: number, compound_description: string, current_group_weight: number }>, getOrderQuotation?: { __typename?: 'OrderQuotation', id: number, order_code: number, order_quotation_products: Array<{ __typename?: 'OrderQuotationProduct', id: number, product_id?: number | null, proposed_description: string, group_weight: number, kilos: number, groups: number }> } | null };

export type LinkOrderQuotationProductMutationVariables = Exact<{
  OrderQuotationProductId: Scalars['Int'];
  ProductId: Scalars['Int'];
}>;


export type LinkOrderQuotationProductMutation = { __typename?: 'Mutation', linkOrderQuotationProduct: { __typename?: 'OrderQuotation', id: number } };

export type UpdateOrderQuotationStatusMutationVariables = Exact<{
  OrderQuotationId: Scalars['Int'];
  OrderQuotationStatusId: Scalars['Int'];
}>;


export type UpdateOrderQuotationStatusMutation = { __typename?: 'Mutation', updateOrderQuotationStatus: { __typename?: 'OrderQuotation', id: number, order_quotation_status_id?: number | null, order_quotation_status?: { __typename?: 'OrderQuotationStatus', id: number, name: string } | null } };

export type OrderQuotationAccountInputQueryVariables = Exact<{ [key: string]: never; }>;


export type OrderQuotationAccountInputQuery = { __typename?: 'Query', getAccounts: Array<{ __typename?: 'Account', id: number, name: string }> };

export type OrderQuotationProductInputQueryVariables = Exact<{ [key: string]: never; }>;


export type OrderQuotationProductInputQuery = { __typename?: 'Query', getProducts: Array<{ __typename?: 'Product', id: number, compound_description: string, current_group_weight: number }> };

export type GetOrderQuotationMaxOrderCodeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrderQuotationMaxOrderCodeQuery = { __typename?: 'Query', getOrderQuotationMaxOrderCode: number };

export type UpsertOrderQuotationMutationVariables = Exact<{
  OrderQuotationInput: OrderQuotationInput;
}>;


export type UpsertOrderQuotationMutation = { __typename?: 'Mutation', upsertOrderQuotation: { __typename?: 'OrderQuotation', id: number, date: any } };

export type OrderQuotationDialogQueryVariables = Exact<{
  OrderQuotationId: Scalars['Float'];
}>;


export type OrderQuotationDialogQuery = { __typename?: 'Query', getOrderQuotation?: { __typename?: 'OrderQuotation', is_editable: boolean, id: number, date: any, estimated_delivery_date?: any | null, order_code: number, order_quotation_status_id?: number | null, account_id?: number | null, products_total: number, notes: string, expiration_date?: any | null, payment_terms: string, require_tax: boolean, order_quotation_products: Array<{ __typename?: 'OrderQuotationProduct', id: number, kilos: number, groups: number, group_weight: number, kilo_price: number, group_price: number, proposed_description: string, product?: { __typename?: 'Product', id: number, compound_description: string, current_group_weight: number } | null }>, created_by?: { __typename?: 'User', fullname: string } | null, updated_by?: { __typename?: 'User', fullname: string } | null } | null };

export type IsOrderQuotationCodeOccupiedQueryVariables = Exact<{
  OrderCode: Scalars['Float'];
  OrderQuotationId?: InputMaybe<Scalars['Int']>;
}>;


export type IsOrderQuotationCodeOccupiedQuery = { __typename?: 'Query', isOrderQuotationCodeOccupied: boolean };

export type UpdateOrderRequestStatusMutationVariables = Exact<{
  OrderRequestId: Scalars['Int'];
  OrderRequestStatusId: Scalars['Int'];
}>;


export type UpdateOrderRequestStatusMutation = { __typename?: 'Mutation', updateOrderRequestStatus: { __typename?: 'OrderRequest', id: number, order_request_status_id?: number | null, order_request_status?: { __typename?: 'OrderRequestStatus', id: number, name: string } | null } };

export type OrderRequestAccountInputQueryVariables = Exact<{ [key: string]: never; }>;


export type OrderRequestAccountInputQuery = { __typename?: 'Query', getAccounts: Array<{ __typename?: 'Account', id: number, name: string }> };

export type OrderRequestProductInputQueryVariables = Exact<{
  accountId: Scalars['Float'];
}>;


export type OrderRequestProductInputQuery = { __typename?: 'Query', getAccountProducts: Array<{ __typename?: 'AccountProduct', id: number, kilo_price: number, group_price: number, group_weight: number, product?: { __typename?: 'Product', id: number, compound_description: string } | null }> };

export type OrderRequestOrderRequestStatusInputQueryVariables = Exact<{ [key: string]: never; }>;


export type OrderRequestOrderRequestStatusInputQuery = { __typename?: 'Query', getOrderRequestStatuses: Array<{ __typename?: 'OrderRequestStatus', id: number, name: string }> };

export type GetOrderRequestMaxOrderCodeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrderRequestMaxOrderCodeQuery = { __typename?: 'Query', getOrderRequestMaxOrderCode: number };

export type UpsertOrderRequestMutationVariables = Exact<{
  OrderRequestInput: OrderRequestInput;
}>;


export type UpsertOrderRequestMutation = { __typename?: 'Mutation', upsertOrderRequest: { __typename?: 'OrderRequest', id: number, date: any } };

export type OrderRequestDialogQueryVariables = Exact<{
  OrderRequestId: Scalars['Float'];
}>;


export type OrderRequestDialogQuery = { __typename?: 'Query', getOrderRequest?: { __typename?: 'OrderRequest', is_editable: boolean, id: number, date: any, estimated_delivery_date?: any | null, order_code: number, order_request_status_id?: number | null, account_id?: number | null, products_total: number, notes: string, order_request_products: Array<{ __typename?: 'OrderRequestProduct', id: number, kilos: number, groups: number, group_weight: number, kilo_price: number, group_price: number, product: { __typename?: 'Product', id: number, compound_description: string, current_group_weight: number, current_kilo_price: number } }>, order_sale_sold_products: Array<{ __typename?: 'OrderSaleProduct', id: number, kilos: number, groups: number, group_weight: number, kilo_price: number, product_id?: number | null }>, created_by?: { __typename?: 'User', fullname: string } | null, updated_by?: { __typename?: 'User', fullname: string } | null } | null };

export type IsOrderRequestCodeOccupiedQueryVariables = Exact<{
  OrderCode: Scalars['Float'];
  OrderRequestId?: InputMaybe<Scalars['Int']>;
}>;


export type IsOrderRequestCodeOccupiedQuery = { __typename?: 'Query', isOrderRequestCodeOccupied: boolean };

export type UpdateOrderSaleDetailsMutationVariables = Exact<{
  OrderSaleDetailsInput: OrderSaleDetailsInput;
}>;


export type UpdateOrderSaleDetailsMutation = { __typename?: 'Mutation', updateOrderSaleDetails: { __typename?: 'OrderSale', id: number, notes: string, expected_payment_date?: any | null, require_supplement: boolean, supplement_code: string, require_credit_note: boolean, credit_note_code: string, credit_note_amount: number, canceled: boolean } };

export type UpdateOrderSaleStatusMutationVariables = Exact<{
  OrderSaleId: Scalars['Int'];
  OrderSaleStatusId: Scalars['Int'];
}>;


export type UpdateOrderSaleStatusMutation = { __typename?: 'Mutation', updateOrderSaleStatus: { __typename?: 'OrderSale', id: number, order_sale_status_id?: number | null, order_sale_status?: { __typename?: 'OrderSaleStatus', id: number, name: string } | null } };

export type OrderSaleAccountIdInputQueryVariables = Exact<{ [key: string]: never; }>;


export type OrderSaleAccountIdInputQuery = { __typename?: 'Query', getAccounts: Array<{ __typename?: 'Account', id: number, name: string, requires_order_request: boolean, client_credit_days: number, client_require_credit_note: boolean, client_require_supplement: boolean, client_requires_invoice_code: boolean, client_requires_tax: boolean, client_automatic_tax_calculation: boolean, client_reconciliation_only: boolean }> };

export type OrderSaleOrderAdjustmentProductInputQueryVariables = Exact<{ [key: string]: never; }>;


export type OrderSaleOrderAdjustmentProductInputQuery = { __typename?: 'Query', getProducts: Array<{ __typename?: 'Product', id: number, compound_description: string, current_group_weight: number, current_kilo_price: number }> };

export type OrderSaleOrderRequestInputQueryVariables = Exact<{ [key: string]: never; }>;


export type OrderSaleOrderRequestInputQuery = { __typename?: 'Query', getOrderRequests: Array<{ __typename?: 'OrderRequest', id: number, order_code: number, account?: { __typename?: 'Account', id: number, requires_order_request: boolean, client_credit_days: number, client_require_credit_note: boolean, client_require_supplement: boolean, client_requires_invoice_code: boolean, client_requires_tax: boolean, client_automatic_tax_calculation: boolean } | null, order_request_products: Array<{ __typename?: 'OrderRequestProduct', product_id?: number | null, kilos: number, groups: number, group_price: number, kilo_price: number, total: number }>, order_request_remaining_products: Array<{ __typename?: 'OrderRequestProduct', product_id?: number | null, kilos: number, groups: number, kilo_price: number, group_weight: number, group_price: number, total: number, product: { __typename?: 'Product', id: number, compound_description: string, current_group_weight: number, current_kilo_price: number } }> }> };

export type OrderSaleProductInputQueryVariables = Exact<{
  excludeDiscontinued: Scalars['Boolean'];
}>;


export type OrderSaleProductInputQuery = { __typename?: 'Query', getProducts: Array<{ __typename?: 'Product', id: number, compound_description: string, current_group_weight: number, current_kilo_price: number }> };

export type OrderSaleOrderSaleReceiptTypeInputQueryVariables = Exact<{ [key: string]: never; }>;


export type OrderSaleOrderSaleReceiptTypeInputQuery = { __typename?: 'Query', getReceiptTypes: Array<{ __typename?: 'ReceiptType', id: number, name: string, applies_tax: boolean, tax_multiplier: number }> };

export type OrderSaleOrderSaleStatusInputQueryVariables = Exact<{ [key: string]: never; }>;


export type OrderSaleOrderSaleStatusInputQuery = { __typename?: 'Query', getOrderSaleStatuses: Array<{ __typename?: 'OrderSaleStatus', id: number, name: string }> };

export type GetOrderSaleMaxOrderCodeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrderSaleMaxOrderCodeQuery = { __typename?: 'Query', getOrderSaleMaxOrderCode: number };

export type UpsertOrderSaleMutationVariables = Exact<{
  OrderSaleInput: OrderSaleInput;
}>;


export type UpsertOrderSaleMutation = { __typename?: 'Mutation', upsertOrderSale: { __typename?: 'OrderSale', id: number, notes: string, date: any } };

export type OrderSaleDialogQueryVariables = Exact<{
  OrderSaleId: Scalars['Float'];
}>;


export type OrderSaleDialogQuery = { __typename?: 'Query', getOrderSale?: { __typename?: 'OrderSale', is_editable: boolean, id: number, notes: string, date: any, expected_payment_date?: any | null, order_code: number, invoice_code: number, require_invoice_code: boolean, require_tax: boolean, order_sale_status_id?: number | null, receipt_type_id?: number | null, subtotal: number, total_with_tax: number, require_supplement: boolean, canceled: boolean, reconciliation_only: boolean, supplement_code: string, require_credit_note: boolean, credit_note_code: string, credit_note_amount: number, automatic_tax_calculation: boolean, tax: number, transfer_receipts_total: number, transfer_receipts_total_no_adjustments: number, account?: { __typename?: 'Account', id: number, requires_order_request: boolean, client_requires_invoice_code: boolean, client_requires_tax: boolean } | null, order_request?: { __typename?: 'OrderRequest', id: number, order_code: number, order_request_status_id?: number | null, account?: { __typename?: 'Account', id: number, requires_order_request: boolean, client_requires_invoice_code: boolean, client_requires_tax: boolean } | null, order_request_products: Array<{ __typename?: 'OrderRequestProduct', product_id?: number | null, kilos: number, groups: number, total: number }>, order_request_remaining_products: Array<{ __typename?: 'OrderRequestProduct', product_id?: number | null, kilos: number, groups: number, kilo_price: number, group_weight: number, group_price: number, total: number, product: { __typename?: 'Product', id: number, compound_description: string, current_group_weight: number, current_kilo_price: number, current_group_price: number } }> } | null, order_sale_products: Array<{ __typename?: 'OrderSaleProduct', id: number, kilos: number, groups: number, kilo_price: number, group_price: number, group_weight: number, total: number, product?: { __typename?: 'Product', id: number, compound_description: string, current_group_weight: number, current_kilo_price: number, current_group_price: number } | null }>, order_adjustment_products: Array<{ __typename?: 'OrderAdjustmentProduct', product_id?: number | null, kilos: number, groups: number, product?: { __typename?: 'Product', id: number, compound_description: string } | null }>, transfer_receipts: Array<{ __typename?: 'TransferReceipt', id: number, amount: number, transfer?: { __typename?: 'Transfer', id: number, transferred_date: any, amount: number, from_account?: { __typename?: 'Account', id: number } | null, to_account?: { __typename?: 'Account', id: number, compound_name: string } | null } | null }>, created_by?: { __typename?: 'User', fullname: string } | null, updated_by?: { __typename?: 'User', fullname: string } | null } | null };

export type IsOrderSaleCodeOccupiedQueryVariables = Exact<{
  OrderCode: Scalars['Float'];
  OrderSaleId?: InputMaybe<Scalars['Int']>;
}>;


export type IsOrderSaleCodeOccupiedQuery = { __typename?: 'Query', isOrderSaleCodeOccupied: boolean };

export type ProductsInputQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductsInputQuery = { __typename?: 'Query', getProducts: Array<{ __typename?: 'Product', id: number, compound_description: string, current_group_weight: number }> };

export type MachineSectionInputQueryVariables = Exact<{
  MachineId: Scalars['Float'];
}>;


export type MachineSectionInputQuery = { __typename?: 'Query', getMachineSections: Array<{ __typename?: 'MachineSection', id: number, name: string }> };

export type MachineInputQueryVariables = Exact<{ [key: string]: never; }>;


export type MachineInputQuery = { __typename?: 'Query', getMachines: Array<{ __typename?: 'Machine', id: number, name: string }> };

export type SparesInputQueryVariables = Exact<{ [key: string]: never; }>;


export type SparesInputQuery = { __typename?: 'Query', getSpares: Array<{ __typename?: 'Spare', id: number, name: string }> };

export type ProductionPerformanceConsumptionRatesQueryVariables = Exact<{
  machineIds: Array<Scalars['Int']> | Scalars['Int'];
  fromDate?: InputMaybe<Scalars['String']>;
}>;


export type ProductionPerformanceConsumptionRatesQuery = { __typename?: 'Query', getMachineConsumptionRates: Array<{ __typename?: 'MachineConsumptionRate', machine_id: number, product_id?: number | null, product_name?: string | null, consumed_kilos: number, consumed_hours: number, packed_hours: number, runs: number }> };

export type GetUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUsersQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', email: string }> };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', email: string, id: number, role_ids: Array<RoleId>, roles: Array<{ __typename?: 'Role', id: number, name: string }> } };

export type MyConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type MyConfigQuery = { __typename?: 'Query', myConfig: { __typename?: 'UserConfig', id: number, user_id: number, dark_mode: boolean } };

export type SetDarkModeMutationVariables = Exact<{
  dark_mode: Scalars['Boolean'];
}>;


export type SetDarkModeMutation = { __typename?: 'Mutation', setDarkMode: { __typename?: 'UserConfig', id: number, user_id: number, dark_mode: boolean } };

export const namedOperations = {
  Query: {
    ActivitiesPage: 'ActivitiesPage',
    UsersPage: 'UsersPage',
    DashboardProductionChart: 'DashboardProductionChart',
    MachinePartPage: 'MachinePartPage',
    MachineSectionPage: 'MachineSectionPage',
    MachinePage: 'MachinePage',
    MachinesPage: 'MachinesPage',
    SpareAdjustmentPage: 'SpareAdjustmentPage',
    SpareAdjustmentsPage: 'SpareAdjustmentsPage',
    SpareTransactionsPage: 'SpareTransactionsPage',
    SpareCategoriesPage: 'SpareCategoriesPage',
    SpareCategoryPage: 'SpareCategoryPage',
    SparePage: 'SparePage',
    SparesPage: 'SparesPage',
    AccountingPage: 'AccountingPage',
    AccountPage: 'AccountPage',
    AccountsPage: 'AccountsPage',
    SalesVsExpensesHistoricPage: 'SalesVsExpensesHistoricPage',
    SalesVsExpensesPage: 'SalesVsExpensesPage',
    BalancesPage: 'BalancesPage',
    ExpensesSummaryPage: 'ExpensesSummaryPage',
    ExpensesSummarySuppliers: 'ExpensesSummarySuppliers',
    ExpensesPage: 'ExpensesPage',
    ResourcesPage: 'ResourcesPage',
    ThirdPartyBalancesPage: 'ThirdPartyBalancesPage',
    TransfersPage: 'TransfersPage',
    GetPayrollPeriods: 'GetPayrollPeriods',
    GetPayrollEntries: 'GetPayrollEntries',
    EmployeePage: 'EmployeePage',
    EmployeesPage: 'EmployeesPage',
    MaterialBalancePage: 'MaterialBalancePage',
    MaterialBalanceMachines: 'MaterialBalanceMachines',
    MaterialBalanceExceptions: 'MaterialBalanceExceptions',
    OrderAdjustmentPage: 'OrderAdjustmentPage',
    OrderAdjustmentsPage: 'OrderAdjustmentsPage',
    OrderProductionPage: 'OrderProductionPage',
    OrderProductionsPage: 'OrderProductionsPage',
    ProductInventoryMovements: 'ProductInventoryMovements',
    ProductInventoryPage: 'ProductInventoryPage',
    ProductionPerformanceMachines: 'ProductionPerformanceMachines',
    ProductionPerformanceProducts: 'ProductionPerformanceProducts',
    ProductionPerformanceRuns: 'ProductionPerformanceRuns',
    ProductionPerformanceHourlyRuns: 'ProductionPerformanceHourlyRuns',
    ProductionPerformanceMachineProductSummary: 'ProductionPerformanceMachineProductSummary',
    ProductionPerformanceProductMachineSummary: 'ProductionPerformanceProductMachineSummary',
    ProductionPerformanceProductsWithRuns: 'ProductionPerformanceProductsWithRuns',
    ProductionPerformanceWeeklyAuditRuns: 'ProductionPerformanceWeeklyAuditRuns',
    ProductionPlanningPage: 'ProductionPlanningPage',
    ProductionPlanForDate: 'ProductionPlanForDate',
    ProductionPlanRates: 'ProductionPlanRates',
    ProductionPlanActuals: 'ProductionPlanActuals',
    MachineProducedProducts: 'MachineProducedProducts',
    ProductionSummaryPage: 'ProductionSummaryPage',
    ProductPage: 'ProductPage',
    ProductsPage: 'ProductsPage',
    ProductsToProducePage: 'ProductsToProducePage',
    PrintableQuotation: 'PrintableQuotation',
    OrderQuotationsPage: 'OrderQuotationsPage',
    OrderRequestsPage: 'OrderRequestsPage',
    OrderSalesPage: 'OrderSalesPage',
    OrdersToFulfillPage: 'OrdersToFulfillPage',
    SalesSummaryPage: 'SalesSummaryPage',
    GetActivityChanges: 'GetActivityChanges',
    GetEntityActivities: 'GetEntityActivities',
    UserDialog: 'UserDialog',
    UserRoles: 'UserRoles',
    IsEmailOccupied: 'IsEmailOccupied',
    MachineBranchInput: 'MachineBranchInput',
    MachineOrderProductionTypeInput: 'MachineOrderProductionTypeInput',
    MachineForm: 'MachineForm',
    SpareCategoryInput: 'SpareCategoryInput',
    ResourceIdInput: 'ResourceIdInput',
    AccountDialog: 'AccountDialog',
    SimilarAccountNames: 'SimilarAccountNames',
    ExpenseAccountIdInput: 'ExpenseAccountIdInput',
    ExpenseResourcesInput: 'ExpenseResourcesInput',
    ExpenseSupplierCatalogReference: 'ExpenseSupplierCatalogReference',
    GetExpenseMaxInternalCode: 'GetExpenseMaxInternalCode',
    ExpenseReceiptTypeIdInput: 'ExpenseReceiptTypeIdInput',
    ExpensesDialog: 'ExpensesDialog',
    IsExpenseInternalCodeOccupied: 'IsExpenseInternalCodeOccupied',
    RecurringExpenseCandidates: 'RecurringExpenseCandidates',
    ResourceCategoryIdInput: 'ResourceCategoryIdInput',
    ResourceDialog: 'ResourceDialog',
    FromAccountIdInput: 'FromAccountIdInput',
    TransferDialog: 'TransferDialog',
    ToAccountIdInput: 'ToAccountIdInput',
    TransferReceiptExpenseInput: 'TransferReceiptExpenseInput',
    TransferReceiptOrderSaleInput: 'TransferReceiptOrderSaleInput',
    TransferTransferTypeInput: 'TransferTransferTypeInput',
    EmployeeBranchInput: 'EmployeeBranchInput',
    EmployeeOrderProductionTypeInput: 'EmployeeOrderProductionTypeInput',
    EmployeeForm: 'EmployeeForm',
    OrderAdjustmentProductInput: 'OrderAdjustmentProductInput',
    OrderAdjustmentOrderAdjustmentTypeInput: 'OrderAdjustmentOrderAdjustmentTypeInput',
    OrderAdjustmentOrderSaleInput: 'OrderAdjustmentOrderSaleInput',
    OrderAdjustmentGetOrderSale: 'OrderAdjustmentGetOrderSale',
    OrderAdjustmentForm: 'OrderAdjustmentForm',
    OrderProductionBranchInput: 'OrderProductionBranchInput',
    OrderProductionEmployeeInput: 'OrderProductionEmployeeInput',
    OrderProductionProductConsumedMachineInput: 'OrderProductionProductConsumedMachineInput',
    OrderProductionProductConsumedProductInput: 'OrderProductionProductConsumedProductInput',
    OrderProductionMachineInput: 'OrderProductionMachineInput',
    OrderProductionProductInput: 'OrderProductionProductInput',
    OrderProductionOrderProductionTypeInput: 'OrderProductionOrderProductionTypeInput',
    OrderProductionForm: 'OrderProductionForm',
    OrderProductionTypeInput: 'OrderProductionTypeInput',
    ProductCategoryInput: 'ProductCategoryInput',
    ProductMaterialInput: 'ProductMaterialInput',
    ProductForm: 'ProductForm',
    OrderQuotationAcceptance: 'OrderQuotationAcceptance',
    OrderQuotationLinkProduct: 'OrderQuotationLinkProduct',
    OrderQuotationAccountInput: 'OrderQuotationAccountInput',
    OrderQuotationProductInput: 'OrderQuotationProductInput',
    GetOrderQuotationMaxOrderCode: 'GetOrderQuotationMaxOrderCode',
    OrderQuotationDialog: 'OrderQuotationDialog',
    IsOrderQuotationCodeOccupied: 'IsOrderQuotationCodeOccupied',
    OrderRequestAccountInput: 'OrderRequestAccountInput',
    OrderRequestProductInput: 'OrderRequestProductInput',
    OrderRequestOrderRequestStatusInput: 'OrderRequestOrderRequestStatusInput',
    GetOrderRequestMaxOrderCode: 'GetOrderRequestMaxOrderCode',
    OrderRequestDialog: 'OrderRequestDialog',
    IsOrderRequestCodeOccupied: 'IsOrderRequestCodeOccupied',
    OrderSaleAccountIdInput: 'OrderSaleAccountIdInput',
    OrderSaleOrderAdjustmentProductInput: 'OrderSaleOrderAdjustmentProductInput',
    OrderSaleOrderRequestInput: 'OrderSaleOrderRequestInput',
    OrderSaleProductInput: 'OrderSaleProductInput',
    OrderSaleOrderSaleReceiptTypeInput: 'OrderSaleOrderSaleReceiptTypeInput',
    OrderSaleOrderSaleStatusInput: 'OrderSaleOrderSaleStatusInput',
    GetOrderSaleMaxOrderCode: 'GetOrderSaleMaxOrderCode',
    OrderSaleDialog: 'OrderSaleDialog',
    IsOrderSaleCodeOccupied: 'IsOrderSaleCodeOccupied',
    ProductsInput: 'ProductsInput',
    MachineSectionInput: 'MachineSectionInput',
    MachineInput: 'MachineInput',
    SparesInput: 'SparesInput',
    ProductionPerformanceConsumptionRates: 'ProductionPerformanceConsumptionRates',
    GetUsers: 'GetUsers',
    CurrentUser: 'CurrentUser',
    MyConfig: 'MyConfig'
  },
  Mutation: {
    UpsertPayrollPeriod: 'UpsertPayrollPeriod',
    DeletePayrollPeriod: 'DeletePayrollPeriod',
    UpsertPayrollEntry: 'UpsertPayrollEntry',
    DeletePayrollEntry: 'DeletePayrollEntry',
    UpsertProductionPlan: 'UpsertProductionPlan',
    DeleteProductionPlan: 'DeleteProductionPlan',
    UpdateOrderRequestDetails: 'UpdateOrderRequestDetails',
    UpdateOrderRequestPriorities: 'UpdateOrderRequestPriorities',
    DeleteMachinePart: 'DeleteMachinePart',
    DeleteMachine: 'DeleteMachine',
    DeleteSpareCategory: 'DeleteSpareCategory',
    DeleteSpareOperation: 'DeleteSpareOperation',
    DeleteSpare: 'DeleteSpare',
    DeleteExpenses: 'DeleteExpenses',
    DeleteResources: 'DeleteResources',
    DeleteTransfer: 'DeleteTransfer',
    DeleteEmployee: 'DeleteEmployee',
    DeleteOrderAdjustment: 'DeleteOrderAdjustment',
    DeleteOrderProduction: 'DeleteOrderProduction',
    DeleteProduct: 'DeleteProduct',
    DeleteAccount: 'DeleteAccount',
    DeleteOrderQuotation: 'DeleteOrderQuotation',
    DeleteOrderRequest: 'DeleteOrderRequest',
    DeleteOrderSale: 'DeleteOrderSale',
    CreateUser: 'CreateUser',
    UpdateUser: 'UpdateUser',
    ResetUserPassword: 'ResetUserPassword',
    UpsertMachinePart: 'UpsertMachinePart',
    UpsertMachineSection: 'UpsertMachineSection',
    UpsertMachine: 'UpsertMachine',
    UpsertSpareAdjustment: 'UpsertSpareAdjustment',
    UpsertSpareCategory: 'UpsertSpareCategory',
    UpsertSpareWithdrawal: 'UpsertSpareWithdrawal',
    UpsertSpare: 'UpsertSpare',
    UpsertAccountDialog: 'UpsertAccountDialog',
    UpdateExpenseDetails: 'UpdateExpenseDetails',
    UpsertExpensesDialog: 'UpsertExpensesDialog',
    GenerateRecurringExpenses: 'GenerateRecurringExpenses',
    UpsertResourceDialog: 'UpsertResourceDialog',
    UpsertTransferDialog: 'UpsertTransferDialog',
    UpsertEmployeeDialog: 'UpsertEmployeeDialog',
    UpsertOrderAdjustment: 'UpsertOrderAdjustment',
    UpsertOrderProduction: 'UpsertOrderProduction',
    UpsertProductDialog: 'UpsertProductDialog',
    AcceptOrderQuotation: 'AcceptOrderQuotation',
    LinkOrderQuotationProduct: 'LinkOrderQuotationProduct',
    UpdateOrderQuotationStatus: 'UpdateOrderQuotationStatus',
    UpsertOrderQuotation: 'UpsertOrderQuotation',
    UpdateOrderRequestStatus: 'UpdateOrderRequestStatus',
    UpsertOrderRequest: 'UpsertOrderRequest',
    UpdateOrderSaleDetails: 'UpdateOrderSaleDetails',
    UpdateOrderSaleStatus: 'UpdateOrderSaleStatus',
    UpsertOrderSale: 'UpsertOrderSale',
    SetDarkMode: 'SetDarkMode'
  },
  Subscription: {
    Product: 'Product',
    OrderProduction: 'OrderProduction',
    Machine: 'Machine',
    OrderAdjustment: 'OrderAdjustment',
    Employee: 'Employee',
    Expenses: 'Expenses',
    Resources: 'Resources',
    OrderRequest: 'OrderRequest',
    OrderQuotation: 'OrderQuotation',
    OrderSale: 'OrderSale',
    Account: 'Account',
    Activity: 'Activity',
    User: 'User',
    Transfer: 'Transfer',
    ExpenseResource: 'ExpenseResource'
  },
  Fragment: {
    SalesVsExpensesHistoricExpensesFragment: 'SalesVsExpensesHistoricExpensesFragment',
    SalesVsExpensesHistoricSalesFragment: 'SalesVsExpensesHistoricSalesFragment'
  }
}